export const Centroid=
[
    {
     "ProvName": "Beijing",
     "zoomlevel": 5.8,
     "X": 116.412284,
     "Y": 40.185543
    },
    {
     "ProvName": "TIanjin",
     "zoomlevel": 5.8,
     "X": 117.334038,
     "Y": 39.293426
    },
    {
     "ProvName": "Hebei",
     "zoomlevel": 5.8,
     "X": 115.933392,
     "Y": 39.272188
    },
    {
     "ProvName": "Shanxi",
     "zoomlevel": 4.55,
     "X": 112.289509,
     "Y": 37.571746
    },
    {
     "ProvName": "Liaoning",
     "zoomlevel": 5.8,
     "X": 122.259513,
     "Y": 41.267496
    },
    {
     "ProvName": "Jilin",
     "zoomlevel": 5.8,
     "X": 125.33461,
     "Y": 43.82175
    },
    {
     "ProvName": "Heilongjiang",
     "zoomlevel": 4.08,
     "X": 127.812885,
     "Y": 47.878936
    },
    {
     "ProvName": "Shanghai",
     "zoomlevel": 4.55,
     "X": 121.469065,
     "Y": 31.240093
    },
    {
     "ProvName": "Jiangsu",
     "zoomlevel": 4.55,
     "X": 119.475494,
     "Y": 32.963309
    },
    {
     "ProvName": "Zhejiang",
     "zoomlevel": 4.55,
     "X": 120.120119,
     "Y": 29.220276
    },
    {
     "ProvName": "Anhui",
     "zoomlevel": 4.55,
     "X": 117.226457,
     "Y": 31.826025
    },
    {
     "ProvName": "Fujian",
     "zoomlevel": 4.55,
     "X": 117.989565,
     "Y": 26.075996
    },
    {
     "ProvName": "Jiangxi",
     "zoomlevel": 4.55,
     "X": 115.722222,
     "Y": 27.614072
    },
    {
     "ProvName": "Shandong",
     "zoomlevel": 4.55,
     "X": 118.153174,
     "Y": 36.34917
    },
    {
     "ProvName": "Henan",
     "zoomlevel": 4.55,
     "X": 113.614563,
     "Y": 33.882332
    },
    {
     "ProvName": "Hubei",
     "zoomlevel": 4.55,
     "X": 112.741884,
     "Y": 31.118032
    },
    {
     "ProvName": "Hunan",
     "zoomlevel": 4.55,
     "X": 112.011452,
     "Y": 27.614279
    },
    {
     "ProvName": "Guangdong",
     "zoomlevel": 5.8,
     "X": 113.442909,
     "Y": 23.302799
    },
    {
     "ProvName": "Hainan",
     "zoomlevel": 5.8,
     "X": 109.901743,
     "Y": 19.337899
    },
    {
     "ProvName": "Chongqing",
     "zoomlevel": 5.4,
     "X": 107.723975,
     "Y": 30.237769
    },
    {
     "ProvName": "Sichuan",
     "zoomlevel": 5.8,
     "X": 105.070108,
     "Y": 30.45071
    },
    {
     "ProvName": "Guizhou",
     "zoomlevel": 5.8,
     "X": 106.449764,
     "Y": 27.324809
    },
    {
     "ProvName": "Yunnan",
     "zoomlevel": 5.8,
     "X": 102.079385,
     "Y": 25.621385
    },
    {
     "ProvName": "Shaanxi",
     "zoomlevel": 4.55,
     "X": 108.868663,
     "Y": 35.19055
    },
    {
     "ProvName": "Gansu",
     "zoomlevel": 5.8,
     "X": 101.824968,
     "Y": 37.637964
    },
    {
     "ProvName": "Qinghai",
     "zoomlevel": 5.8,
     "X": 101.806072,
     "Y": 36.549338
    },
    {
     "ProvName": "Hong Kong SAR",
     "zoomlevel": 5.8,
     "X": 114.134324,
     "Y": 22.381274
    },
    {
     "ProvName": "Macau SAR",
     "zoomlevel": 5.8,
     "X": 113.561375,
     "Y": 22.163023
    },
    {
     "ProvName": "Inner Mongolia Autonomous Region",
     "zoomlevel": 4.08,
     "X": 113.116797,
     "Y": 43.587945
    },
    {
     "ProvName": "Guangxi Zhuang Autonomous Region",
     "zoomlevel": 5.4,
     "X": 108.818158,
     "Y": 23.652805
    },
    {
     "ProvName": "Tibet Autonomous Region",
     "zoomlevel": 5.8,
     "X": 88.099694,
     "Y": 31.685937
    },
    {
     "ProvName": "Ningxia Hui Autonomous Region",
     "zoomlevel": 4.55,
     "X": 106.163714,
     "Y": 37.271582
    },
    {
     "ProvName": "Xinjiang Uygur Autonomous Region",
     "zoomlevel": 5.8,
     "X": 84.551397,
     "Y": 41.330367
    },
    {
     "ProvName": "Qinglong Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 119.127663,
     "Y": 40.346904
    },
    {
     "ProvName": "Fengning Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 116.612093,
     "Y": 41.416367
    },
    {
     "ProvName": "Kuancheng Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 118.622921,
     "Y": 40.57029
    },
    {
     "ProvName": "Weichang Manchu and Mongolian Autonomous County",
     "zoomlevel": 5.8,
     "X": 117.534072,
     "Y": 42.101965
    },
    {
     "ProvName": "Mengcun Hui Autonomous County",
     "zoomlevel": 4.55,
     "X": 117.144081,
     "Y": 38.083462
    },
    {
     "ProvName": "Dachang Hui Autonomous County",
     "zoomlevel": 5.8,
     "X": 116.935468,
     "Y": 39.892529
    },
    {
     "ProvName": "Moridawa Daur Autonomous Banner",
     "zoomlevel": 4.08,
     "X": 124.458995,
     "Y": 49.099586
    },
    {
     "ProvName": "Oroqen Autonomous Banner",
     "zoomlevel": 4.08,
     "X": 123.797166,
     "Y": 50.332678
    },
    {
     "ProvName": "Evenki Autonomous Banner",
     "zoomlevel": 4.08,
     "X": 120.056294,
     "Y": 48.486338
    },
    {
     "ProvName": "Xiuyan Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 123.333754,
     "Y": 40.394577
    },
    {
     "ProvName": "Xinbin Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 124.830043,
     "Y": 41.623303
    },
    {
     "ProvName": "Qingyuan Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 124.912721,
     "Y": 42.110624
    },
    {
     "ProvName": "Benxi Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 124.168263,
     "Y": 41.197109
    },
    {
     "ProvName": "Huanren Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 125.277506,
     "Y": 41.253448
    },
    {
     "ProvName": "Kuandian Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 124.918076,
     "Y": 40.761774
    },
    {
     "ProvName": "Fuxin Mongolian Autonomous County",
     "zoomlevel": 5.8,
     "X": 121.682564,
     "Y": 42.164908
    },
    {
     "ProvName": "Karaqin left wing Mongolian Autonomous County",
     "zoomlevel": 5.8,
     "X": 119.762984,
     "Y": 41.13564
    },
    {
     "ProvName": "Yitong Manchu Autonomous County",
     "zoomlevel": 5.8,
     "X": 125.258445,
     "Y": 43.338724
    },
    {
     "ProvName": "Changbai Korean Autonomous County",
     "zoomlevel": 5.8,
     "X": 127.851013,
     "Y": 41.575661
    },
    {
     "ProvName": "Qiangorros Mongolian Autonomous County",
     "zoomlevel": 4.08,
     "X": 124.461695,
     "Y": 44.858791
    },
    {
     "ProvName": "Durbert Mongolian Autonomous County",
     "zoomlevel": 4.08,
     "X": 124.23095,
     "Y": 46.553751
    },
    {
     "ProvName": "Jingning She Autonomous County",
     "zoomlevel": 4.55,
     "X": 119.608811,
     "Y": 27.89429
    },
    {
     "ProvName": "changyang tujia autonomous county",
     "zoomlevel": 5.8,
     "X": 110.842027,
     "Y": 30.478992
    },
    {
     "ProvName": "Wufeng Tujia Autonomous County",
     "zoomlevel": 5.8,
     "X": 110.698319,
     "Y": 30.169596
    },
    {
     "ProvName": "Chengbu Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 110.312433,
     "Y": 26.320709
    },
    {
     "ProvName": "Jianghua Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 111.739408,
     "Y": 24.975375
    },
    {
     "ProvName": "Mayang Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.717619,
     "Y": 27.78857
    },
    {
     "ProvName": "Xinhuang Dong Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.157853,
     "Y": 27.231685
    },
    {
     "ProvName": "Zhijiang Dong Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.599019,
     "Y": 27.399101
    },
    {
     "ProvName": "Jingzhou Miao and Dong Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.579729,
     "Y": 26.547487
    },
    {
     "ProvName": "Tongdao Dong Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.733307,
     "Y": 26.212446
    },
    {
     "ProvName": "Ruyuan Yao Autonomous County",
     "zoomlevel": 5.8,
     "X": 113.163932,
     "Y": 24.808049
    },
    {
     "ProvName": "Lianshan Zhuang Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 112.089875,
     "Y": 24.514033
    },
    {
     "ProvName": "Liannan Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 112.256213,
     "Y": 24.561042
    },
    {
     "ProvName": "Rongshui Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.046851,
     "Y": 25.339778
    },
    {
     "ProvName": "Sanjiang Dong Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.497777,
     "Y": 25.744148
    },
    {
     "ProvName": "Longsheng Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.997876,
     "Y": 25.86406
    },
    {
     "ProvName": "Gongcheng Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 110.898045,
     "Y": 24.945644
    },
    {
     "ProvName": "Longlin Autonomous County",
     "zoomlevel": 5.4,
     "X": 105.297676,
     "Y": 24.677665
    },
    {
     "ProvName": "Fuchuan Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 111.301707,
     "Y": 24.888123
    },
    {
     "ProvName": "Luocheng Mulao Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.816266,
     "Y": 24.900707
    },
    {
     "ProvName": "Huanjiang Maonan Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.281759,
     "Y": 25.100922
    },
    {
     "ProvName": "Bama Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 107.197742,
     "Y": 24.153955
    },
    {
     "ProvName": "Du'an Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.107867,
     "Y": 24.166926
    },
    {
     "ProvName": "Dahua Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 107.703011,
     "Y": 23.967217
    },
    {
     "ProvName": "Jinxiu Yao Autonomous County",
     "zoomlevel": 5.4,
     "X": 110.126917,
     "Y": 24.086727
    },
    {
     "ProvName": "Baisha Li Autonomous County",
     "zoomlevel": 5.8,
     "X": 109.347925,
     "Y": 19.211405
    },
    {
     "ProvName": "Changjiang Li Autonomous County",
     "zoomlevel": 5.8,
     "X": 109.000611,
     "Y": 19.217738
    },
    {
     "ProvName": "Ledong Li Autonomous County",
     "zoomlevel": 5.8,
     "X": 109.052307,
     "Y": 18.6542
    },
    {
     "ProvName": "Lingshui Li Autonomous County",
     "zoomlevel": 5.8,
     "X": 109.937903,
     "Y": 18.571572
    },
    {
     "ProvName": "Baoting Li and Miao Autonomous County",
     "zoomlevel": 5.8,
     "X": 109.646578,
     "Y": 18.59141
    },
    {
     "ProvName": "Qiongzhong Li and Miao Autonomous County",
     "zoomlevel": 5.8,
     "X": 109.850945,
     "Y": 19.035169
    },
    {
     "ProvName": "Shizhu Tujia Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.294042,
     "Y": 30.095801
    },
    {
     "ProvName": "Xiushan Tujia and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.013281,
     "Y": 28.494678
    },
    {
     "ProvName": "Youyang Tujia and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.795605,
     "Y": 28.902354
    },
    {
     "ProvName": "pengshui miao and tujia autonomous county",
     "zoomlevel": 5.4,
     "X": 108.262214,
     "Y": 29.356126
    },
    {
     "ProvName": "Beichuan Qiang Autonomous County",
     "zoomlevel": 5.8,
     "X": 104.263684,
     "Y": 31.938363
    },
    {
     "ProvName": "Ebian Yi Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.206781,
     "Y": 29.048464
    },
    {
     "ProvName": "Mabian Yi Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.478357,
     "Y": 28.786101
    },
    {
     "ProvName": "Muli Tibetan Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.945549,
     "Y": 28.35671
    },
    {
     "ProvName": "Daozhen Gelao and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 107.606027,
     "Y": 28.9308
    },
    {
     "ProvName": "Wuchuan Gelao and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 107.908772,
     "Y": 28.658246
    },
    {
     "ProvName": "Zhenning Buyi and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 105.823205,
     "Y": 25.840683
    },
    {
     "ProvName": "Guanling Buyi and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 105.558258,
     "Y": 25.859331
    },
    {
     "ProvName": "Ziyun Miao Buyi Autonomous County",
     "zoomlevel": 5.4,
     "X": 106.178666,
     "Y": 25.697558
    },
    {
     "ProvName": "Weining Yi, Hui and Miao Autonomous County",
     "zoomlevel": 5.8,
     "X": 104.128553,
     "Y": 26.909648
    },
    {
     "ProvName": "Yuping Dong Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.980346,
     "Y": 27.332766
    },
    {
     "ProvName": "Yinjiang Tujia and Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.521634,
     "Y": 27.995935
    },
    {
     "ProvName": "Yanhe Tujia Autonomous County",
     "zoomlevel": 5.4,
     "X": 108.33349,
     "Y": 28.62116
    },
    {
     "ProvName": "Songtao Miao Autonomous County",
     "zoomlevel": 5.4,
     "X": 109.031332,
     "Y": 28.12642
    },
    {
     "ProvName": "Sandu Autonomous County",
     "zoomlevel": 5.4,
     "X": 107.946179,
     "Y": 25.848165
    },
    {
     "ProvName": "Shilin Yi Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.416973,
     "Y": 24.743603
    },
    {
     "ProvName": "Luquan Yi and Miao Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.585426,
     "Y": 25.940499
    },
    {
     "ProvName": "XUNDIAN Hui and Yi Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.120261,
     "Y": 25.663072
    },
    {
     "ProvName": "Eshan Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 102.211867,
     "Y": 24.242289
    },
    {
     "ProvName": "Xinping Yi Dai Autonomous County",
     "zoomlevel": 5.4,
     "X": 101.731307,
     "Y": 24.02578
    },
    {
     "ProvName": "Yuanjiang Hani Yi Dai Autonomous County",
     "zoomlevel": 5.4,
     "X": 102.00964,
     "Y": 23.581246
    },
    {
     "ProvName": "Yulong Naxi Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.940864,
     "Y": 27.101356
    },
    {
     "ProvName": "Ninglang Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.769828,
     "Y": 27.263157
    },
    {
     "ProvName": "Ning'er Hani and Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 101.188518,
     "Y": 23.093886
    },
    {
     "ProvName": "Mojiang Hani Autonomous County",
     "zoomlevel": 5.4,
     "X": 101.547307,
     "Y": 23.359467
    },
    {
     "ProvName": "Jingdong Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.787308,
     "Y": 24.393219
    },
    {
     "ProvName": "Jinggu Dai and Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.556519,
     "Y": 23.364713
    },
    {
     "ProvName": "Zhenyuan Yi Hani Lahu Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.973981,
     "Y": 23.944966
    },
    {
     "ProvName": "Jiangcheng Hani and Yi Autonomous County",
     "zoomlevel": 5.8,
     "X": 101.783746,
     "Y": 22.626302
    },
    {
     "ProvName": "Menglian Dai Lahu Wa Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.469207,
     "Y": 22.29078
    },
    {
     "ProvName": "Lancang Lahu Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.97464,
     "Y": 22.662713
    },
    {
     "ProvName": "Ximeng Vazu Zizhixian",
     "zoomlevel": 5.4,
     "X": 99.509527,
     "Y": 22.697239
    },
    {
     "ProvName": "Shuangjiang Lahu, WA, Bulang and Dai Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.878073,
     "Y": 23.46655
    },
    {
     "ProvName": "Gengma Dai and Wa Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.426935,
     "Y": 23.639185
    },
    {
     "ProvName": "Cangyuan Wa Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.265162,
     "Y": 23.271902
    },
    {
     "ProvName": "Pingbian Miao Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.740331,
     "Y": 23.099704
    },
    {
     "ProvName": "Jinping Miao Yao Dai Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.087894,
     "Y": 22.783041
    },
    {
     "ProvName": "Hekou Yao Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.804293,
     "Y": 22.793467
    },
    {
     "ProvName": "Yangbi Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.8908,
     "Y": 25.602556
    },
    {
     "ProvName": "Jiannan Yi Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.416463,
     "Y": 24.899571
    },
    {
     "ProvName": "Weishan Yi and Hui Autonomous County",
     "zoomlevel": 5.4,
     "X": 100.170795,
     "Y": 25.244075
    },
    {
     "ProvName": "Gongshan Dulong Nu Autonomous County",
     "zoomlevel": 5.4,
     "X": 98.501642,
     "Y": 27.888531
    },
    {
     "ProvName": "Lanping Bai Pumi Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.257496,
     "Y": 26.629032
    },
    {
     "ProvName": "Weixi Lisu Autonomous County",
     "zoomlevel": 5.4,
     "X": 99.145998,
     "Y": 27.445106
    },
    {
     "ProvName": "Zhangjiachuan Hui Autonomous County",
     "zoomlevel": 4.55,
     "X": 106.272276,
     "Y": 34.98728
    },
    {
     "ProvName": "Tianzhu Tibetan Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.762656,
     "Y": 37.25018
    },
    {
     "ProvName": "Sunan Yugur Autonomous County",
     "zoomlevel": 5.8,
     "X": 99.245659,
     "Y": 38.947536
    },
    {
     "ProvName": "Subei Mongolian Autonomous County",
     "zoomlevel": 5.8,
     "X": 96.538249,
     "Y": 40.660486
    },
    {
     "ProvName": "Aksai Kazak Autonomous County",
     "zoomlevel": 5.8,
     "X": 94.426285,
     "Y": 39.025542
    },
    {
     "ProvName": "Dongxiang Autonomous County",
     "zoomlevel": 5.8,
     "X": 103.44244,
     "Y": 35.692989
    },
    {
     "ProvName": "Jishishan Baoan Dongxiang Salar Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.894884,
     "Y": 35.713502
    },
    {
     "ProvName": "Datong Hui and Tu Autonomous County",
     "zoomlevel": 5.8,
     "X": 101.457556,
     "Y": 37.130713
    },
    {
     "ProvName": "Minhe Hui and Tu Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.767853,
     "Y": 36.138298
    },
    {
     "ProvName": "Huzhu Tu Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.156324,
     "Y": 36.841723
    },
    {
     "ProvName": "Hualong Hui Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.21166,
     "Y": 36.080035
    },
    {
     "ProvName": "Xunhua Salar Autonomous County",
     "zoomlevel": 5.8,
     "X": 102.467348,
     "Y": 35.717685
    },
    {
     "ProvName": "Menyuan Hui Autonomous County",
     "zoomlevel": 5.8,
     "X": 101.730608,
     "Y": 37.453817
    },
    {
     "ProvName": "Henan Mongolian Autonomous County",
     "zoomlevel": 5.8,
     "X": 101.552003,
     "Y": 34.506485
    },
    {
     "ProvName": "Balikun Kazakh Autonomous County",
     "zoomlevel": 5.8,
     "X": 92.792254,
     "Y": 44.262099
    },
    {
     "ProvName": "Mulei Kazakh Autonomous County",
     "zoomlevel": 5.8,
     "X": 90.800998,
     "Y": 44.090941
    },
    {
     "ProvName": "Yanqi Hui Autonomous County",
     "zoomlevel": 5.8,
     "X": 86.069094,
     "Y": 42.086212
    },
    {
     "ProvName": "Tashkurgan Tajik Autonomous County",
     "zoomlevel": 5.8,
     "X": 75.845299,
     "Y": 37.004545
    },
    {
     "ProvName": "Qapqal Xibe Autonomous County",
     "zoomlevel": 5.8,
     "X": 81.129752,
     "Y": 43.614068
    },
    {
     "ProvName": "Hebukeser Mongolian Autonomous County",
     "zoomlevel": 5.8,
     "X": 86.208528,
     "Y": 46.244146
    },
    {
     "ProvName": "Yanbian Korean Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 129.123717,
     "Y": 43.141931
    },
    {
     "ProvName": "Enshi Tujia and Miao Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 109.549026,
     "Y": 30.191572
    },
    {
     "ProvName": "Xiangxi Tujia and Miao Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 109.726928,
     "Y": 28.694692
    },
    {
     "ProvName": "Aba Tibetan and Qiang Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 102.608156,
     "Y": 32.4003
    },
    {
     "ProvName": "Ganzi Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 99.997018,
     "Y": 30.94856
    },
    {
     "ProvName": "Liangshan Yi Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 102.39988,
     "Y": 27.753803
    },
    {
     "ProvName": "Qianxinan Buyei and Miao Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 105.464383,
     "Y": 25.265522
    },
    {
     "ProvName": "Qiandongnan Miao and Dong Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 108.557547,
     "Y": 26.505726
    },
    {
     "ProvName": "Qiannan Buyi and Miao Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 107.180814,
     "Y": 26.029519
    },
    {
     "ProvName": "Chuxiong Yi Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 101.568071,
     "Y": 25.35191
    },
    {
     "ProvName": "Honghe Hani and Yi Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 102.936126,
     "Y": 23.593767
    },
    {
     "ProvName": "Wenshan Zhuang and Miao Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 104.714032,
     "Y": 23.690641
    },
    {
     "ProvName": "Xishuangbanna Dai Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 100.93109,
     "Y": 21.934312
    },
    {
     "ProvName": "Dali Bai Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 100.009877,
     "Y": 25.848407
    },
    {
     "ProvName": "Dehong Dai Jingpo Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 98.085021,
     "Y": 24.559001
    },
    {
     "ProvName": "Nujiang Lisu Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 98.858439,
     "Y": 26.501649
    },
    {
     "ProvName": "Diqing Tibetan Autonomous Prefecture",
     "zoomlevel": 5.4,
     "X": 99.509558,
     "Y": 28.078588
    },
    {
     "ProvName": "Linxia Hui Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 103.298258,
     "Y": 35.600203
    },
    {
     "ProvName": "Gannan Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 102.766565,
     "Y": 34.32233
    },
    {
     "ProvName": "Haibei Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 99.979278,
     "Y": 37.828087
    },
    {
     "ProvName": "Huangnan Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 101.674804,
     "Y": 35.324346
    },
    {
     "ProvName": "Hainan Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 100.257671,
     "Y": 35.899982
    },
    {
     "ProvName": "Golog Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 99.419937,
     "Y": 34.115743
    },
    {
     "ProvName": "Yushu Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 94.321388,
     "Y": 34.210856
    },
    {
     "ProvName": "Haixi Mongol and Tibetan Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 94.531065,
     "Y": 36.71236
    },
    {
     "ProvName": "Changji Hui Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 88.146647,
     "Y": 44.402779
    },
    {
     "ProvName": "Bortala Mongolian Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 82.105913,
     "Y": 44.731171
    },
    {
     "ProvName": "Bayingolin Mongolian Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 87.473691,
     "Y": 39.47682
    },
    {
     "ProvName": "Kizilsu Kirgiz Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 75.945543,
     "Y": 39.65619
    },
    {
     "ProvName": "Yili Kazakh Autonomous Prefecture",
     "zoomlevel": 5.8,
     "X": 82.20386,
     "Y": 43.432435
    },
    {
     "ProvName": "Durazno",
     "zoomlevel": 5.8,
     "X": -56.016523,
     "Y": -33.031356
    },
    {
     "ProvName": "Rocha",
     "zoomlevel": 5.8,
     "X": -54.004049,
     "Y": -33.95114
    },
    {
     "ProvName": "Rivera",
     "zoomlevel": 5.8,
     "X": -55.260392,
     "Y": -31.483471
    },
    {
     "ProvName": "Treinta y Tres",
     "zoomlevel": 5.8,
     "X": -54.250686,
     "Y": -33.06096
    },
    {
     "ProvName": "Tivat",
     "zoomlevel": 5.8,
     "X": 18.69825,
     "Y": 42.415474
    },
    {
     "ProvName": "Tacuarembó",
     "zoomlevel": 5.8,
     "X": -55.777651,
     "Y": -32.122801
    },
    {
     "ProvName": "Canelones",
     "zoomlevel": 5.8,
     "X": -55.919188,
     "Y": -34.547018
    },
    {
     "ProvName": "Savnik",
     "zoomlevel": 5.8,
     "X": 19.131992,
     "Y": 42.977676
    },
    {
     "ProvName": "Florida",
     "zoomlevel": 5.8,
     "X": -55.857539,
     "Y": -33.779524
    },
    {
     "ProvName": "Montevideo",
     "zoomlevel": 5.8,
     "X": -56.218337,
     "Y": -34.823988
    },
    {
     "ProvName": "Colonia",
     "zoomlevel": 5.8,
     "X": -57.647405,
     "Y": -34.137184
    },
    {
     "ProvName": "Lavalleja",
     "zoomlevel": 5.8,
     "X": -54.971614,
     "Y": -33.92458
    },
    {
     "ProvName": "Maldonado",
     "zoomlevel": 5.8,
     "X": -54.852963,
     "Y": -34.566685
    },
    {
     "ProvName": "Bin Arus",
     "zoomlevel": 5.8,
     "X": 10.228342,
     "Y": 36.623044
    },
    {
     "ProvName": "Falcón",
     "zoomlevel": 5.8,
     "X": -69.795134,
     "Y": 11.075781
    },
    {
     "ProvName": "Likoma",
     "zoomlevel": 5.8,
     "X": 34.66207,
     "Y": -12.044175
    },
    {
     "ProvName": "Bari",
     "zoomlevel": 5.8,
     "X": 50.022104,
     "Y": 10.223691
    },
    {
     "ProvName": "Wallonia",
     "zoomlevel": 5.8,
     "X": 4.984324,
     "Y": 50.31386
    },
    {
     "ProvName": "San José",
     "zoomlevel": 5.8,
     "X": -56.717575,
     "Y": -34.321075
    },
    {
     "ProvName": "Zabljak",
     "zoomlevel": 5.8,
     "X": 19.176998,
     "Y": 43.117843
    },
    {
     "ProvName": "Flanders",
     "zoomlevel": 5.8,
     "X": 4.21639,
     "Y": 51.035791
    },
    {
     "ProvName": "Donduseni",
     "zoomlevel": 5.8,
     "X": 27.745893,
     "Y": 48.231833
    },
    {
     "ProvName": "Artigas",
     "zoomlevel": 5.8,
     "X": -56.969368,
     "Y": -30.622084
    },
    {
     "ProvName": "Flores",
     "zoomlevel": 5.8,
     "X": -56.887499,
     "Y": -33.576976
    },
    {
     "ProvName": "Prey Veaeng",
     "zoomlevel": 5.8,
     "X": 105.432791,
     "Y": 11.402605
    },
    {
     "ProvName": "Paysandú",
     "zoomlevel": 5.8,
     "X": -57.345403,
     "Y": -32.083217
    },
    {
     "ProvName": "Carabobo",
     "zoomlevel": 5.8,
     "X": -68.019741,
     "Y": 10.176297
    },
    {
     "ProvName": "Río Negro",
     "zoomlevel": 5.8,
     "X": -57.426844,
     "Y": -32.783357
    },
    {
     "ProvName": "Kaliningrad",
     "zoomlevel": 5.8,
     "X": 21.386251,
     "Y": 54.719391
    },
    {
     "ProvName": "Lampang",
     "zoomlevel": 5.8,
     "X": 99.525536,
     "Y": 18.352286
    },
    {
     "ProvName": "Salto",
     "zoomlevel": 5.8,
     "X": -57.028197,
     "Y": -31.332858
    },
    {
     "ProvName": "Niamey",
     "zoomlevel": 5.8,
     "X": 2.142651,
     "Y": 13.511359
    },
    {
     "ProvName": "Soriano",
     "zoomlevel": 5.8,
     "X": -57.747306,
     "Y": -33.517924
    },
    {
     "ProvName": "Cerro Largo",
     "zoomlevel": 5.8,
     "X": -54.336748,
     "Y": -32.441532
    },
    {
     "ProvName": "Apure",
     "zoomlevel": 5.8,
     "X": -68.803922,
     "Y": 7.149177
    },
    {
     "ProvName": "Barinas",
     "zoomlevel": 5.8,
     "X": -69.922771,
     "Y": 8.164638
    },
    {
     "ProvName": "Couva\/Tabaquite\/Talparo",
     "zoomlevel": 5.8,
     "X": -61.337563,
     "Y": 10.439187
    },
    {
     "ProvName": "Penal\/Debe",
     "zoomlevel": 5.8,
     "X": -61.434898,
     "Y": 10.16116
    },
    {
     "ProvName": "Point Fortin",
     "zoomlevel": 5.8,
     "X": -61.666633,
     "Y": 10.172324
    },
    {
     "ProvName": "ash-Shamal",
     "zoomlevel": 5.8,
     "X": 51.194474,
     "Y": 25.980089
    },
    {
     "ProvName": "Mérida",
     "zoomlevel": 5.8,
     "X": -71.271819,
     "Y": 8.565468
    },
    {
     "ProvName": "Algarve",
     "zoomlevel": 5.8,
     "X": -8.143761,
     "Y": 37.246145
    },
    {
     "ProvName": "Táchira",
     "zoomlevel": 5.8,
     "X": -72.019805,
     "Y": 7.91419
    },
    {
     "ProvName": "Savinjska",
     "zoomlevel": 5.8,
     "X": 15.196982,
     "Y": 46.26576
    },
    {
     "ProvName": "Trujillo",
     "zoomlevel": 5.8,
     "X": -70.502973,
     "Y": 9.443573
    },
    {
     "ProvName": "Zulia",
     "zoomlevel": 5.8,
     "X": -72.106301,
     "Y": 9.926109
    },
    {
     "ProvName": "Yaracuy",
     "zoomlevel": 5.8,
     "X": -68.731591,
     "Y": 10.292372
    },
    {
     "ProvName": "Cojedes",
     "zoomlevel": 5.8,
     "X": -68.34801,
     "Y": 9.350473
    },
    {
     "ProvName": "Nickerie",
     "zoomlevel": 5.8,
     "X": -56.879725,
     "Y": 5.601943
    },
    {
     "ProvName": "Amazonas",
     "zoomlevel": 3.38,
     "X": -65.953415,
     "Y": 3.366537
    },
    {
     "ProvName": "Bolívar",
     "zoomlevel": 5.8,
     "X": -63.527848,
     "Y": 6.238698
    },
    {
     "ProvName": "Anzoátegui",
     "zoomlevel": 5.8,
     "X": -64.413365,
     "Y": 8.941617
    },
    {
     "ProvName": "Lara",
     "zoomlevel": 5.8,
     "X": -69.779486,
     "Y": 10.157785
    },
    {
     "ProvName": "North Western Upolu",
     "zoomlevel": 5.8,
     "X": -171.847308,
     "Y": -13.865538
    },
    {
     "ProvName": "Apia Urban Area",
     "zoomlevel": 5.8,
     "X": -171.71354,
     "Y": -13.896994
    },
    {
     "ProvName": "Portuguesa",
     "zoomlevel": 5.8,
     "X": -69.271338,
     "Y": 9.040779
    },
    {
     "ProvName": "Dependencias Federales",
     "zoomlevel": 5.8,
     "X": -65.449802,
     "Y": 11.35765
    },
    {
     "ProvName": "Guarico",
     "zoomlevel": 5.8,
     "X": -66.528675,
     "Y": 8.834782
    },
    {
     "ProvName": "Aragua",
     "zoomlevel": 5.8,
     "X": -67.158972,
     "Y": 10.015475
    },
    {
     "ProvName": "Diego Martin",
     "zoomlevel": 5.8,
     "X": -61.566585,
     "Y": 10.713226
    },
    {
     "ProvName": "Siparia",
     "zoomlevel": 5.8,
     "X": -61.637832,
     "Y": 10.135908
    },
    {
     "ProvName": "Arima",
     "zoomlevel": 5.8,
     "X": -61.279166,
     "Y": 10.62533
    },
    {
     "ProvName": "Umm Salal",
     "zoomlevel": 5.8,
     "X": 51.338419,
     "Y": 25.457446
    },
    {
     "ProvName": "Vargas",
     "zoomlevel": 5.8,
     "X": -66.900208,
     "Y": 10.547602
    },
    {
     "ProvName": "Distrito Federal",
     "zoomlevel": 5.8,
     "X": -66.987867,
     "Y": 10.476061
    },
    {
     "ProvName": "Sangre Grande",
     "zoomlevel": 5.8,
     "X": -61.098207,
     "Y": 10.657932
    },
    {
     "ProvName": "Mayaro\/Rio Claro",
     "zoomlevel": 5.8,
     "X": -61.108395,
     "Y": 10.286546
    },
    {
     "ProvName": "Monagas",
     "zoomlevel": 5.8,
     "X": -63.024617,
     "Y": 9.409829
    },
    {
     "ProvName": "Miranda",
     "zoomlevel": 5.8,
     "X": -66.379213,
     "Y": 10.23461
    },
    {
     "ProvName": "San Juan\/Laventille",
     "zoomlevel": 5.8,
     "X": -61.437734,
     "Y": 10.685607
    },
    {
     "ProvName": "Kassalâ (Kassala)",
     "zoomlevel": 5.8,
     "X": 35.736273,
     "Y": 15.898259
    },
    {
     "ProvName": "Steiermark",
     "zoomlevel": 5.8,
     "X": 15.002221,
     "Y": 47.273895
    },
    {
     "ProvName": "Nueva Esparta",
     "zoomlevel": 5.8,
     "X": -64.056394,
     "Y": 10.98791
    },
    {
     "ProvName": "Sucre",
     "zoomlevel": 5.8,
     "X": -63.360122,
     "Y": 10.420066
    },
    {
     "ProvName": "Tobago",
     "zoomlevel": 5.8,
     "X": -60.670397,
     "Y": 11.24714
    },
    {
     "ProvName": "Lamphun",
     "zoomlevel": 5.8,
     "X": 98.965401,
     "Y": 18.141675
    },
    {
     "ProvName": "Paramaribo",
     "zoomlevel": 5.8,
     "X": -55.17529,
     "Y": 5.847538
    },
    {
     "ProvName": "Tunis",
     "zoomlevel": 5.8,
     "X": 10.155779,
     "Y": 36.778687
    },
    {
     "ProvName": "Nan",
     "zoomlevel": 5.8,
     "X": 100.825243,
     "Y": 18.844862
    },
    {
     "ProvName": "Princes Town",
     "zoomlevel": 5.8,
     "X": -61.297785,
     "Y": 10.200652
    },
    {
     "ProvName": "Vojvodina",
     "zoomlevel": 5.8,
     "X": 20.063889,
     "Y": 45.39914
    },
    {
     "ProvName": "Finnmark",
     "zoomlevel": 4,
     "X": 25.887265,
     "Y": 69.938712
    },
    {
     "ProvName": "Jugovzhodna Slovenija",
     "zoomlevel": 5.8,
     "X": 15.013015,
     "Y": 45.705234
    },
    {
     "ProvName": "Osrednjeslovenska",
     "zoomlevel": 5.8,
     "X": 14.598399,
     "Y": 46.029612
    },
    {
     "ProvName": "Extremadura",
     "zoomlevel": 5.8,
     "X": -6.162711,
     "Y": 39.190837
    },
    {
     "ProvName": "Alentejo",
     "zoomlevel": 5.8,
     "X": -7.982336,
     "Y": 38.617514
    },
    {
     "ProvName": "Bubanza",
     "zoomlevel": 5.8,
     "X": 29.400244,
     "Y": -3.126544
    },
    {
     "ProvName": "Lisboa e Vale do Tejo",
     "zoomlevel": 5.8,
     "X": -8.836882,
     "Y": 38.554369
    },
    {
     "ProvName": "Rest of Upolu",
     "zoomlevel": 5.8,
     "X": -171.724201,
     "Y": -13.970706
    },
    {
     "ProvName": "Norte",
     "zoomlevel": 5.8,
     "X": -7.667502,
     "Y": 41.540955
    },
    {
     "ProvName": "al-Kaf",
     "zoomlevel": 5.8,
     "X": 8.663173,
     "Y": 36.034172
    },
    {
     "ProvName": "Rodrigues",
     "zoomlevel": 5.8,
     "X": 63.012946,
     "Y": -19.171253
    },
    {
     "ProvName": "Centro",
     "zoomlevel": 5.8,
     "X": -7.905097,
     "Y": 40.33958
    },
    {
     "ProvName": "Príncipe",
     "zoomlevel": 5.8,
     "X": 7.396466,
     "Y": 1.620071
    },
    {
     "ProvName": "Janûb Kurdufân (South Kordufan)",
     "zoomlevel": 3.8,
     "X": 29.833683,
     "Y": 11.070233
    },
    {
     "ProvName": "Shamâl Kurdufân (North Kordufan)",
     "zoomlevel": 3.8,
     "X": 29.382008,
     "Y": 14.438243
    },
    {
     "ProvName": "Phayao",
     "zoomlevel": 5.8,
     "X": 100.185274,
     "Y": 19.227971
    },
    {
     "ProvName": "Al-Baha",
     "zoomlevel": 4.5,
     "X": 41.415542,
     "Y": 20.10593
    },
    {
     "ProvName": "Aseer",
     "zoomlevel": 4.5,
     "X": 42.995481,
     "Y": 19.269405
    },
    {
     "ProvName": "El Oro",
     "zoomlevel": 5.8,
     "X": -79.845583,
     "Y": -3.506087
    },
    {
     "ProvName": "Jazan",
     "zoomlevel": 5.8,
     "X": 42.594509,
     "Y": 17.380228
    },
    {
     "ProvName": "Makkah Al-Mokarramah",
     "zoomlevel": 4.5,
     "X": 41.206438,
     "Y": 21.625548
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 37.905357,
     "Y": 1.126516
    },
    {
     "ProvName": "Rift Valley",
     "zoomlevel": 5.8,
     "X": 35.90644,
     "Y": 1.220153
    },
    {
     "ProvName": "Ambeno (Oecussi)",
     "zoomlevel": 5.8,
     "X": 124.266763,
     "Y": -9.327324
    },
    {
     "ProvName": "Salta",
     "zoomlevel": 5.8,
     "X": -64.81856,
     "Y": -24.28911
    },
    {
     "ProvName": "Zilina",
     "zoomlevel": 5.8,
     "X": 19.174419,
     "Y": 49.172002
    },
    {
     "ProvName": "Famagusta",
     "zoomlevel": 5.8,
     "X": 33.934161,
     "Y": 35.023283
    },
    {
     "ProvName": "Nitra",
     "zoomlevel": 5.8,
     "X": 18.311829,
     "Y": 48.152742
    },
    {
     "ProvName": "Trencin",
     "zoomlevel": 5.8,
     "X": 18.221116,
     "Y": 48.862465
    },
    {
     "ProvName": "Trnava",
     "zoomlevel": 5.8,
     "X": 17.540581,
     "Y": 48.357813
    },
    {
     "ProvName": "Tafiela",
     "zoomlevel": 5.8,
     "X": 35.627519,
     "Y": 30.778549
    },
    {
     "ProvName": "Kosice",
     "zoomlevel": 5.8,
     "X": 21.255103,
     "Y": 48.693605
    },
    {
     "ProvName": "Presov",
     "zoomlevel": 5.8,
     "X": 21.214338,
     "Y": 49.117406
    },
    {
     "ProvName": "Loja",
     "zoomlevel": 5.8,
     "X": -79.664919,
     "Y": -4.09528
    },
    {
     "ProvName": "Bolívar",
     "zoomlevel": 5.8,
     "X": -79.104267,
     "Y": -1.600331
    },
    {
     "ProvName": "St. Joseph",
     "zoomlevel": 5.8,
     "X": -61.385739,
     "Y": 15.441455
    },
    {
     "ProvName": "Zamora Chinchipe",
     "zoomlevel": 5.8,
     "X": -78.913589,
     "Y": -4.165315
    },
    {
     "ProvName": "Kandal",
     "zoomlevel": 5.8,
     "X": 105.006907,
     "Y": 11.434039
    },
    {
     "ProvName": "Galápagos",
     "zoomlevel": 5.8,
     "X": -90.905691,
     "Y": -0.55171
    },
    {
     "ProvName": "Santa Cruz",
     "zoomlevel": 3.38,
     "X": -69.958821,
     "Y": -48.802941
    },
    {
     "ProvName": "Tierra del Fuego",
     "zoomlevel": 3.38,
     "X": -67.430019,
     "Y": -54.32311
    },
    {
     "ProvName": "San Juan",
     "zoomlevel": 3.38,
     "X": -68.879233,
     "Y": -30.828021
    },
    {
     "ProvName": "Chubut",
     "zoomlevel": 3.38,
     "X": -68.53345,
     "Y": -43.7872
    },
    {
     "ProvName": "Mendoza",
     "zoomlevel": 3.38,
     "X": -68.611493,
     "Y": -34.607462
    },
    {
     "ProvName": "Neuquén",
     "zoomlevel": 3.38,
     "X": -70.122922,
     "Y": -38.643133
    },
    {
     "ProvName": "Dhamar",
     "zoomlevel": 5.8,
     "X": 44.261333,
     "Y": 14.600261
    },
    {
     "ProvName": "Kampong Cham",
     "zoomlevel": 5.8,
     "X": 105.589794,
     "Y": 12.034402
    },
    {
     "ProvName": "Kampong Chhnang",
     "zoomlevel": 5.8,
     "X": 104.567159,
     "Y": 12.165226
    },
    {
     "ProvName": "Kampong Spueu",
     "zoomlevel": 5.8,
     "X": 104.293246,
     "Y": 11.562159
    },
    {
     "ProvName": "Kampong Thum",
     "zoomlevel": 5.8,
     "X": 105.042394,
     "Y": 12.839246
    },
    {
     "ProvName": "Phnom Penh",
     "zoomlevel": 5.8,
     "X": 104.870237,
     "Y": 11.550949
    },
    {
     "ProvName": "Preah Vihear",
     "zoomlevel": 5.8,
     "X": 105.005736,
     "Y": 13.816836
    },
    {
     "ProvName": "Essex",
     "zoomlevel": 5.8,
     "X": 0.55481,
     "Y": 51.790897
    },
    {
     "ProvName": "Stueng Traeng",
     "zoomlevel": 5.8,
     "X": 106.144956,
     "Y": 13.785041
    },
    {
     "ProvName": "Brokopondo",
     "zoomlevel": 5.8,
     "X": -55.118784,
     "Y": 4.725788
    },
    {
     "ProvName": "Marowijne",
     "zoomlevel": 5.8,
     "X": -54.378212,
     "Y": 5.625281
    },
    {
     "ProvName": "Kracheh",
     "zoomlevel": 5.8,
     "X": 106.167632,
     "Y": 12.633517
    },
    {
     "ProvName": "Gibraltar",
     "zoomlevel": 5.8,
     "X": -5.371947,
     "Y": 36.12958
    },
    {
     "ProvName": "Castilla La Mancha",
     "zoomlevel": 5.8,
     "X": -3.003231,
     "Y": 39.583006
    },
    {
     "ProvName": "Zaghwan",
     "zoomlevel": 5.8,
     "X": 9.995925,
     "Y": 36.316549
    },
    {
     "ProvName": "Serbia",
     "zoomlevel": 5.8,
     "X": 21.068654,
     "Y": 43.76954
    },
    {
     "ProvName": "Mondol Kiri",
     "zoomlevel": 5.8,
     "X": 106.979801,
     "Y": 12.766798
    },
    {
     "ProvName": "Jubbada Dhexe",
     "zoomlevel": 5.8,
     "X": 42.539904,
     "Y": 1.223257
    },
    {
     "ProvName": "Shabeellaha Hoose",
     "zoomlevel": 5.8,
     "X": 44.325422,
     "Y": 1.903311
    },
    {
     "ProvName": "Hajjah",
     "zoomlevel": 5.8,
     "X": 43.311672,
     "Y": 16.112429
    },
    {
     "ProvName": "East Anglia",
     "zoomlevel": 5.8,
     "X": 0.738384,
     "Y": 52.447635
    },
    {
     "ProvName": "Vorarlberg",
     "zoomlevel": 5.8,
     "X": 9.880724,
     "Y": 47.237312
    },
    {
     "ProvName": "Sakha",
     "zoomlevel": 2.37,
     "X": 114.251963,
     "Y": 66.5235
    },
    {
     "ProvName": "Moscow City",
     "zoomlevel": 4.3,
     "X": 37.648431,
     "Y": 55.655884
    },
    {
     "ProvName": "Appenzell Ausser-Rhoden",
     "zoomlevel": 5.8,
     "X": 9.352316,
     "Y": 47.367286
    },
    {
     "ProvName": "Burgenland",
     "zoomlevel": 5.8,
     "X": 16.512482,
     "Y": 47.546643
    },
    {
     "ProvName": "Tunapuna\/Piarco",
     "zoomlevel": 5.8,
     "X": -61.305187,
     "Y": 10.686606
    },
    {
     "ProvName": "San Fernando",
     "zoomlevel": 5.8,
     "X": -61.452481,
     "Y": 10.279738
    },
    {
     "ProvName": "Chaguanas",
     "zoomlevel": 5.8,
     "X": -61.409472,
     "Y": 10.537105
    },
    {
     "ProvName": "Port-of-Spain",
     "zoomlevel": 5.8,
     "X": -61.514707,
     "Y": 10.661211
    },
    {
     "ProvName": "Delta Amacuro",
     "zoomlevel": 5.8,
     "X": -61.34373,
     "Y": 8.791529
    },
    {
     "ProvName": "Para",
     "zoomlevel": 5.8,
     "X": -55.318786,
     "Y": 5.342033
    },
    {
     "ProvName": "Sipaliwini",
     "zoomlevel": 5.8,
     "X": -56.035368,
     "Y": 3.751227
    },
    {
     "ProvName": "Commewijne",
     "zoomlevel": 5.8,
     "X": -54.904767,
     "Y": 5.767583
    },
    {
     "ProvName": "Coronie",
     "zoomlevel": 5.8,
     "X": -56.279871,
     "Y": 5.644995
    },
    {
     "ProvName": "Edinet",
     "zoomlevel": 5.8,
     "X": 27.304068,
     "Y": 48.120727
    },
    {
     "ProvName": "Västmanland",
     "zoomlevel": 5.8,
     "X": 16.333905,
     "Y": 59.831606
    },
    {
     "ProvName": "Maradi",
     "zoomlevel": 3.8,
     "X": 7.288552,
     "Y": 14.121984
    },
    {
     "ProvName": "Balti",
     "zoomlevel": 5.8,
     "X": 27.959574,
     "Y": 47.764155
    },
    {
     "ProvName": "Halland",
     "zoomlevel": 5.8,
     "X": 12.826498,
     "Y": 56.975292
    },
    {
     "ProvName": "Saramacca",
     "zoomlevel": 5.8,
     "X": -55.62868,
     "Y": 5.70435
    },
    {
     "ProvName": "Wanica",
     "zoomlevel": 5.8,
     "X": -55.232821,
     "Y": 5.744691
    },
    {
     "ProvName": "Nordland",
     "zoomlevel": 4,
     "X": 14.469847,
     "Y": 66.968747
    },
    {
     "ProvName": "Munster",
     "zoomlevel": 5.8,
     "X": -8.771695,
     "Y": 52.296878
    },
    {
     "ProvName": "Leinster",
     "zoomlevel": 5.8,
     "X": -6.968687,
     "Y": 53.136905
    },
    {
     "ProvName": "Ulster",
     "zoomlevel": 5.8,
     "X": -7.616796,
     "Y": 54.582
    },
    {
     "ProvName": "Andalucia",
     "zoomlevel": 5.8,
     "X": -4.57944,
     "Y": 37.467426
    },
    {
     "ProvName": "Cantabria",
     "zoomlevel": 5.8,
     "X": -4.027215,
     "Y": 43.209087
    },
    {
     "ProvName": "Castilla y Leon",
     "zoomlevel": 5.8,
     "X": -4.786954,
     "Y": 41.754445
    },
    {
     "ProvName": "Covasna",
     "zoomlevel": 5.8,
     "X": 25.988141,
     "Y": 45.930785
    },
    {
     "ProvName": "Madrid",
     "zoomlevel": 5.8,
     "X": -3.71592,
     "Y": 40.494688
    },
    {
     "ProvName": "Ma'an",
     "zoomlevel": 5.8,
     "X": 36.538641,
     "Y": 30.342741
    },
    {
     "ProvName": "Des Plateaux",
     "zoomlevel": 5.8,
     "X": 1.115382,
     "Y": 7.43678
    },
    {
     "ProvName": "Maritime",
     "zoomlevel": 5.8,
     "X": 1.26747,
     "Y": 6.487489
    },
    {
     "ProvName": "Glarus",
     "zoomlevel": 5.8,
     "X": 9.057135,
     "Y": 46.9841
    },
    {
     "ProvName": "De la Kara",
     "zoomlevel": 5.8,
     "X": 0.85456,
     "Y": 9.583203
    },
    {
     "ProvName": "Tahoua",
     "zoomlevel": 3.8,
     "X": 5.232603,
     "Y": 15.758639
    },
    {
     "ProvName": "Centrale",
     "zoomlevel": 5.8,
     "X": 1.054224,
     "Y": 8.611623
    },
    {
     "ProvName": "Des Savanes",
     "zoomlevel": 5.8,
     "X": 0.446352,
     "Y": 10.578164
    },
    {
     "ProvName": "Zinder",
     "zoomlevel": 3.8,
     "X": 10.016642,
     "Y": 14.99054
    },
    {
     "ProvName": "Dosso",
     "zoomlevel": 5.8,
     "X": 3.55129,
     "Y": 13.20348
    },
    {
     "ProvName": "Madaniyin",
     "zoomlevel": 5.8,
     "X": 10.861276,
     "Y": 33.193264
    },
    {
     "ProvName": "Qibili",
     "zoomlevel": 5.8,
     "X": 8.879288,
     "Y": 33.290671
    },
    {
     "ProvName": "Tatauin",
     "zoomlevel": 5.8,
     "X": 9.942787,
     "Y": 31.99966
    },
    {
     "ProvName": "Cataluña",
     "zoomlevel": 5.8,
     "X": 1.539204,
     "Y": 41.797633
    },
    {
     "ProvName": "Tawzar",
     "zoomlevel": 5.8,
     "X": 7.961336,
     "Y": 33.945425
    },
    {
     "ProvName": "Bajah",
     "zoomlevel": 5.8,
     "X": 9.314571,
     "Y": 36.68314
    },
    {
     "ProvName": "Banzart",
     "zoomlevel": 5.8,
     "X": 9.6053,
     "Y": 37.080429
    },
    {
     "ProvName": "Värmland",
     "zoomlevel": 5.8,
     "X": 13.153663,
     "Y": 59.784436
    },
    {
     "ProvName": "Drochia",
     "zoomlevel": 5.8,
     "X": 27.90956,
     "Y": 48.027778
    },
    {
     "ProvName": "Jämtland",
     "zoomlevel": 4,
     "X": 14.330802,
     "Y": 63.264434
    },
    {
     "ProvName": "Norrbotten",
     "zoomlevel": 4,
     "X": 20.106543,
     "Y": 66.949123
    },
    {
     "ProvName": "Västernorrland",
     "zoomlevel": 4,
     "X": 17.278064,
     "Y": 63.111602
    },
    {
     "ProvName": "Jundubah",
     "zoomlevel": 5.8,
     "X": 8.684993,
     "Y": 36.640393
    },
    {
     "ProvName": "Nabul",
     "zoomlevel": 5.8,
     "X": 10.707381,
     "Y": 36.69801
    },
    {
     "ProvName": "al-Qasrayn",
     "zoomlevel": 5.8,
     "X": 8.74102,
     "Y": 35.22391
    },
    {
     "ProvName": "Qabis",
     "zoomlevel": 5.8,
     "X": 9.796674,
     "Y": 33.784366
    },
    {
     "ProvName": "Teleorman",
     "zoomlevel": 5.8,
     "X": 25.227999,
     "Y": 44.05065
    },
    {
     "ProvName": "Qafsah",
     "zoomlevel": 5.8,
     "X": 8.75927,
     "Y": 34.40761
    },
    {
     "ProvName": "Sidi Bu Zayd",
     "zoomlevel": 5.8,
     "X": 9.531909,
     "Y": 34.859028
    },
    {
     "ProvName": "San Juan",
     "zoomlevel": 5.8,
     "X": -71.286271,
     "Y": 18.87967
    },
    {
     "ProvName": "Safaqis",
     "zoomlevel": 5.8,
     "X": 10.365481,
     "Y": 34.767433
    },
    {
     "ProvName": "Silianah",
     "zoomlevel": 5.8,
     "X": 9.329477,
     "Y": 36.050905
    },
    {
     "ProvName": "al-Mahdiyah",
     "zoomlevel": 5.8,
     "X": 10.62962,
     "Y": 35.324839
    },
    {
     "ProvName": "Västerbotten",
     "zoomlevel": 4,
     "X": 17.835256,
     "Y": 64.869513
    },
    {
     "ProvName": "Gotland",
     "zoomlevel": 5.8,
     "X": 18.538385,
     "Y": 57.50947
    },
    {
     "ProvName": "Stockholm",
     "zoomlevel": 5.8,
     "X": 18.190243,
     "Y": 59.492344
    },
    {
     "ProvName": "Uppsala",
     "zoomlevel": 5.8,
     "X": 17.707481,
     "Y": 60.069284
    },
    {
     "ProvName": "Calarasi",
     "zoomlevel": 5.8,
     "X": 27.063756,
     "Y": 44.324428
    },
    {
     "ProvName": "Pomurska",
     "zoomlevel": 5.8,
     "X": 16.160801,
     "Y": 46.667473
    },
    {
     "ProvName": "Podravska",
     "zoomlevel": 5.8,
     "X": 15.754953,
     "Y": 46.470385
    },
    {
     "ProvName": "St. Kitts",
     "zoomlevel": 5.8,
     "X": -62.757245,
     "Y": 17.332084
    },
    {
     "ProvName": "La Habana",
     "zoomlevel": 5.8,
     "X": -82.307506,
     "Y": 23.080022
    },
    {
     "ProvName": "Matanzas",
     "zoomlevel": 5.8,
     "X": -81.217636,
     "Y": 22.617368
    },
    {
     "ProvName": "Phrae",
     "zoomlevel": 5.8,
     "X": 100.0648,
     "Y": 18.194678
    },
    {
     "ProvName": "al-Munastir",
     "zoomlevel": 5.8,
     "X": 10.765215,
     "Y": 35.605461
    },
    {
     "ProvName": "Villa Clara",
     "zoomlevel": 5.8,
     "X": -79.999395,
     "Y": 22.5437
    },
    {
     "ProvName": "al-Qayrawan",
     "zoomlevel": 5.8,
     "X": 9.863197,
     "Y": 35.606551
    },
    {
     "ProvName": "Susah",
     "zoomlevel": 5.8,
     "X": 10.408148,
     "Y": 35.864002
    },
    {
     "ProvName": "al-Ladhiqiyah",
     "zoomlevel": 5.8,
     "X": 36.02603,
     "Y": 35.56778
    },
    {
     "ProvName": "Pahang Darul Makmur",
     "zoomlevel": 5.8,
     "X": 102.547157,
     "Y": 3.734815
    },
    {
     "ProvName": "Selangor Darul Ehsan",
     "zoomlevel": 5.8,
     "X": 101.504475,
     "Y": 3.275325
    },
    {
     "ProvName": "Gorj",
     "zoomlevel": 5.8,
     "X": 23.327543,
     "Y": 45.00791
    },
    {
     "ProvName": "Tartus",
     "zoomlevel": 5.8,
     "X": 36.071988,
     "Y": 34.957462
    },
    {
     "ProvName": "Mehedinti",
     "zoomlevel": 5.8,
     "X": 22.821124,
     "Y": 44.582689
    },
    {
     "ProvName": "Olt",
     "zoomlevel": 5.8,
     "X": 24.457993,
     "Y": 44.306675
    },
    {
     "ProvName": "Dâmbovita",
     "zoomlevel": 5.8,
     "X": 25.510899,
     "Y": 44.867451
    },
    {
     "ProvName": "Giurgiu",
     "zoomlevel": 5.8,
     "X": 25.917777,
     "Y": 44.179236
    },
    {
     "ProvName": "Ialomita",
     "zoomlevel": 5.8,
     "X": 27.240534,
     "Y": 44.640219
    },
    {
     "ProvName": "Terengganu",
     "zoomlevel": 5.8,
     "X": 102.957303,
     "Y": 4.928501
    },
    {
     "ProvName": "Dayr az-Zawr",
     "zoomlevel": 5.8,
     "X": 40.280505,
     "Y": 35.154879
    },
    {
     "ProvName": "Schaffhausen",
     "zoomlevel": 5.8,
     "X": 8.589047,
     "Y": 47.707881
    },
    {
     "ProvName": "ar-Raqqah",
     "zoomlevel": 5.8,
     "X": 38.937156,
     "Y": 35.983834
    },
    {
     "ProvName": "Aleppo (Halab)",
     "zoomlevel": 5.8,
     "X": 37.599736,
     "Y": 36.232914
    },
    {
     "ProvName": "Hamah",
     "zoomlevel": 5.8,
     "X": 37.158356,
     "Y": 35.224916
    },
    {
     "ProvName": "Hims",
     "zoomlevel": 5.8,
     "X": 38.298716,
     "Y": 34.339154
    },
    {
     "ProvName": "Nevis",
     "zoomlevel": 5.8,
     "X": -62.579945,
     "Y": 17.149433
    },
    {
     "ProvName": "Idlib",
     "zoomlevel": 5.8,
     "X": 36.67911,
     "Y": 35.780314
    },
    {
     "ProvName": "al-Hasakah",
     "zoomlevel": 5.8,
     "X": 40.906514,
     "Y": 36.512292
    },
    {
     "ProvName": "as-Suwayda",
     "zoomlevel": 5.8,
     "X": 36.831119,
     "Y": 32.764816
    },
    {
     "ProvName": "al-Qunaytirah",
     "zoomlevel": 5.8,
     "X": 35.773355,
     "Y": 33.045662
    },
    {
     "ProvName": "Dar`a",
     "zoomlevel": 5.8,
     "X": 36.208799,
     "Y": 32.850043
    },
    {
     "ProvName": "Shamâl Bahr-al-Ghazâl (North B~Ghazal)",
     "zoomlevel": 5.8,
     "X": 27.083529,
     "Y": 8.885204
    },
    {
     "ProvName": "an-Nîl-al-Azraq (Blue Nile)",
     "zoomlevel": 5.8,
     "X": 34.064468,
     "Y": 11.401699
    },
    {
     "ProvName": "Sa'dah",
     "zoomlevel": 5.8,
     "X": 43.923132,
     "Y": 17.07081
    },
    {
     "ProvName": "Brasov",
     "zoomlevel": 5.8,
     "X": 25.30724,
     "Y": 45.758728
    },
    {
     "ProvName": "al-Bahr-al-Ahmar (Red Sea)",
     "zoomlevel": 4.5,
     "X": 35.705482,
     "Y": 19.616605
    },
    {
     "ProvName": "St. David",
     "zoomlevel": 5.8,
     "X": -61.288651,
     "Y": 15.399613
    },
    {
     "ProvName": "al-Hadaydah",
     "zoomlevel": 5.8,
     "X": 43.204156,
     "Y": 14.83903
    },
    {
     "ProvName": "al-Mahwit",
     "zoomlevel": 5.8,
     "X": 43.610552,
     "Y": 15.372633
    },
    {
     "ProvName": "Santo Domingo",
     "zoomlevel": 5.8,
     "X": -69.860757,
     "Y": 18.565319
    },
    {
     "ProvName": "Harghita",
     "zoomlevel": 5.8,
     "X": 25.572313,
     "Y": 46.534463
    },
    {
     "ProvName": "Iasi",
     "zoomlevel": 5.8,
     "X": 27.28839,
     "Y": 47.181291
    },
    {
     "ProvName": "Neamt",
     "zoomlevel": 5.8,
     "X": 26.387863,
     "Y": 46.946048
    },
    {
     "ProvName": "Prahova",
     "zoomlevel": 5.8,
     "X": 26.010787,
     "Y": 45.121609
    },
    {
     "ProvName": "Notranjsko-kraska",
     "zoomlevel": 5.8,
     "X": 14.301317,
     "Y": 45.686685
    },
    {
     "ProvName": "Suceava",
     "zoomlevel": 5.8,
     "X": 25.735692,
     "Y": 47.527993
    },
    {
     "ProvName": "Amran",
     "zoomlevel": 5.8,
     "X": 43.982988,
     "Y": 16.154725
    },
    {
     "ProvName": "Ibb",
     "zoomlevel": 5.8,
     "X": 44.209913,
     "Y": 14.069409
    },
    {
     "ProvName": "Sánchez Ramírez",
     "zoomlevel": 5.8,
     "X": -70.144822,
     "Y": 19.017602
    },
    {
     "ProvName": "Lahij",
     "zoomlevel": 5.8,
     "X": 44.572232,
     "Y": 13.170401
    },
    {
     "ProvName": "Ta'izz",
     "zoomlevel": 5.8,
     "X": 43.786889,
     "Y": 13.40894
    },
    {
     "ProvName": "Genève",
     "zoomlevel": 5.8,
     "X": 6.117097,
     "Y": 46.222264
    },
    {
     "ProvName": "San Pedro de Macorís",
     "zoomlevel": 5.8,
     "X": -69.369089,
     "Y": 18.547299
    },
    {
     "ProvName": "Jura",
     "zoomlevel": 5.8,
     "X": 7.149707,
     "Y": 47.347787
    },
    {
     "ProvName": "Neuchâtel",
     "zoomlevel": 5.8,
     "X": 6.778971,
     "Y": 46.996212
    },
    {
     "ProvName": "Aargau",
     "zoomlevel": 5.8,
     "X": 8.153676,
     "Y": 47.412306
    },
    {
     "ProvName": "Raymah",
     "zoomlevel": 5.8,
     "X": 43.724873,
     "Y": 14.65711
    },
    {
     "ProvName": "Nagasaki",
     "zoomlevel": 5.8,
     "X": 129.613471,
     "Y": 33.233274
    },
    {
     "ProvName": "Luzern",
     "zoomlevel": 5.8,
     "X": 8.107587,
     "Y": 47.067523
    },
    {
     "ProvName": "Nidwalden",
     "zoomlevel": 5.8,
     "X": 8.40035,
     "Y": 46.926829
    },
    {
     "ProvName": "Braila",
     "zoomlevel": 5.8,
     "X": 27.667606,
     "Y": 45.096977
    },
    {
     "ProvName": "Valais",
     "zoomlevel": 5.8,
     "X": 7.584966,
     "Y": 46.209824
    },
    {
     "ProvName": "Bacau",
     "zoomlevel": 5.8,
     "X": 26.789874,
     "Y": 46.407264
    },
    {
     "ProvName": "Buzau",
     "zoomlevel": 5.8,
     "X": 26.741616,
     "Y": 45.257155
    },
    {
     "ProvName": "Galati",
     "zoomlevel": 5.8,
     "X": 27.763561,
     "Y": 45.785709
    },
    {
     "ProvName": "Vaslui",
     "zoomlevel": 5.8,
     "X": 27.78127,
     "Y": 46.517939
    },
    {
     "ProvName": "Vrancea",
     "zoomlevel": 5.8,
     "X": 26.992041,
     "Y": 45.784831
    },
    {
     "ProvName": "Volyn",
     "zoomlevel": 4.3,
     "X": 24.851842,
     "Y": 51.180667
    },
    {
     "ProvName": "Cherkasy",
     "zoomlevel": 4.3,
     "X": 31.365849,
     "Y": 49.260279
    },
    {
     "ProvName": "Kirovohrad",
     "zoomlevel": 4.3,
     "X": 32.07905,
     "Y": 48.468105
    },
    {
     "ProvName": "Odessa",
     "zoomlevel": 5.8,
     "X": 29.857292,
     "Y": 46.733519
    },
    {
     "ProvName": "Vinnytsya",
     "zoomlevel": 4.3,
     "X": 28.689288,
     "Y": 48.905721
    },
    {
     "ProvName": "Falesti",
     "zoomlevel": 5.8,
     "X": 27.746542,
     "Y": 47.56744
    },
    {
     "ProvName": "Sankt Gallen",
     "zoomlevel": 5.8,
     "X": 9.264813,
     "Y": 47.233189
    },
    {
     "ProvName": "Ticino",
     "zoomlevel": 5.8,
     "X": 8.798045,
     "Y": 46.294476
    },
    {
     "ProvName": "Graubünden",
     "zoomlevel": 5.8,
     "X": 9.619422,
     "Y": 46.657291
    },
    {
     "ProvName": "Glodeni",
     "zoomlevel": 5.8,
     "X": 27.526723,
     "Y": 47.73816
    },
    {
     "ProvName": "Schwyz",
     "zoomlevel": 5.8,
     "X": 8.749293,
     "Y": 47.063655
    },
    {
     "ProvName": "Thurgau",
     "zoomlevel": 5.8,
     "X": 9.108923,
     "Y": 47.563517
    },
    {
     "ProvName": "Koroska",
     "zoomlevel": 5.8,
     "X": 15.081128,
     "Y": 46.529916
    },
    {
     "ProvName": "Sîngerei",
     "zoomlevel": 5.8,
     "X": 28.145015,
     "Y": 47.662327
    },
    {
     "ProvName": "Uri",
     "zoomlevel": 5.8,
     "X": 8.625315,
     "Y": 46.775286
    },
    {
     "ProvName": "Zürich",
     "zoomlevel": 5.8,
     "X": 8.646419,
     "Y": 47.417571
    },
    {
     "ProvName": "Zug",
     "zoomlevel": 5.8,
     "X": 8.53084,
     "Y": 47.157688
    },
    {
     "ProvName": "Gävleborg",
     "zoomlevel": 5.8,
     "X": 16.303277,
     "Y": 61.463942
    },
    {
     "ProvName": "Ungheni",
     "zoomlevel": 5.8,
     "X": 27.915385,
     "Y": 47.302087
    },
    {
     "ProvName": "Jönköping",
     "zoomlevel": 5.8,
     "X": 14.445376,
     "Y": 57.513838
    },
    {
     "ProvName": "Kalmar",
     "zoomlevel": 5.8,
     "X": 16.123291,
     "Y": 57.194659
    },
    {
     "ProvName": "Gorenjska",
     "zoomlevel": 5.8,
     "X": 14.139296,
     "Y": 46.301302
    },
    {
     "ProvName": "Dalarna",
     "zoomlevel": 5.8,
     "X": 14.369018,
     "Y": 60.969096
    },
    {
     "ProvName": "Kronoberg",
     "zoomlevel": 5.8,
     "X": 14.589782,
     "Y": 56.805277
    },
    {
     "ProvName": "Orebro",
     "zoomlevel": 5.8,
     "X": 14.993965,
     "Y": 59.371844
    },
    {
     "ProvName": "Södermanland",
     "zoomlevel": 5.8,
     "X": 16.667378,
     "Y": 59.064985
    },
    {
     "ProvName": "Ostergötland",
     "zoomlevel": 5.8,
     "X": 15.671722,
     "Y": 58.368802
    },
    {
     "ProvName": "Cantemir",
     "zoomlevel": 5.8,
     "X": 28.318321,
     "Y": 46.245791
    },
    {
     "ProvName": "Goriska",
     "zoomlevel": 5.8,
     "X": 13.767843,
     "Y": 46.094138
    },
    {
     "ProvName": "Blekinge",
     "zoomlevel": 5.8,
     "X": 15.206428,
     "Y": 56.292745
    },
    {
     "ProvName": "Calarasi",
     "zoomlevel": 5.8,
     "X": 28.327769,
     "Y": 47.301866
    },
    {
     "ProvName": "Arad",
     "zoomlevel": 5.8,
     "X": 21.752074,
     "Y": 46.263149
    },
    {
     "ProvName": "Botosani",
     "zoomlevel": 5.8,
     "X": 26.755497,
     "Y": 47.852395
    },
    {
     "ProvName": "Bihor",
     "zoomlevel": 5.8,
     "X": 22.2006,
     "Y": 46.929827
    },
    {
     "ProvName": "Alba",
     "zoomlevel": 5.8,
     "X": 23.482471,
     "Y": 46.165935
    },
    {
     "ProvName": "Caras-Severin",
     "zoomlevel": 5.8,
     "X": 22.046406,
     "Y": 45.14939
    },
    {
     "ProvName": "Bistrita-Nasaud",
     "zoomlevel": 5.8,
     "X": 24.5301,
     "Y": 47.214182
    },
    {
     "ProvName": "Cimislia",
     "zoomlevel": 5.8,
     "X": 28.753519,
     "Y": 46.602324
    },
    {
     "ProvName": "Timis",
     "zoomlevel": 5.8,
     "X": 21.356635,
     "Y": 45.730056
    },
    {
     "ProvName": "Mykolayiv",
     "zoomlevel": 4.3,
     "X": 31.781349,
     "Y": 47.447071
    },
    {
     "ProvName": "Chernihiv",
     "zoomlevel": 4.3,
     "X": 31.994988,
     "Y": 51.350212
    },
    {
     "ProvName": "Rivne",
     "zoomlevel": 4.3,
     "X": 26.372554,
     "Y": 51.038982
    },
    {
     "ProvName": "Distrito Federal",
     "zoomlevel": 3.38,
     "X": -47.787745,
     "Y": -15.77132
    },
    {
     "ProvName": "Mato Grosso do Sul",
     "zoomlevel": 3.38,
     "X": -54.844271,
     "Y": -20.332512
    },
    {
     "ProvName": "Minas Gerais",
     "zoomlevel": 3.38,
     "X": -44.674119,
     "Y": -18.45044
    },
    {
     "ProvName": "Mato Grosso",
     "zoomlevel": 3.38,
     "X": -55.925778,
     "Y": -12.961061
    },
    {
     "ProvName": "Chernivtsi",
     "zoomlevel": 5.8,
     "X": 25.984275,
     "Y": 48.26935
    },
    {
     "ProvName": "Ivano-Frankivsk",
     "zoomlevel": 5.8,
     "X": 24.614889,
     "Y": 48.691765
    },
    {
     "ProvName": "Khmelnytsky",
     "zoomlevel": 4.3,
     "X": 26.933227,
     "Y": 49.501894
    },
    {
     "ProvName": "Lviv",
     "zoomlevel": 4.3,
     "X": 23.908933,
     "Y": 49.713625
    },
    {
     "ProvName": "Ternopil",
     "zoomlevel": 4.3,
     "X": 25.647547,
     "Y": 49.400326
    },
    {
     "ProvName": "Criuleni",
     "zoomlevel": 5.8,
     "X": 29.029889,
     "Y": 47.157222
    },
    {
     "ProvName": "Zakarpatska",
     "zoomlevel": 5.8,
     "X": 23.27069,
     "Y": 48.401013
    },
    {
     "ProvName": "Floresti",
     "zoomlevel": 5.8,
     "X": 28.376793,
     "Y": 47.886092
    },
    {
     "ProvName": "Cluj",
     "zoomlevel": 5.8,
     "X": 23.539231,
     "Y": 46.796331
    },
    {
     "ProvName": "Hunedoara",
     "zoomlevel": 5.8,
     "X": 22.934158,
     "Y": 45.74713
    },
    {
     "ProvName": "Maramures",
     "zoomlevel": 5.8,
     "X": 23.991334,
     "Y": 47.656591
    },
    {
     "ProvName": "Mures",
     "zoomlevel": 5.8,
     "X": 24.696381,
     "Y": 46.584991
    },
    {
     "ProvName": "Salaj",
     "zoomlevel": 5.8,
     "X": 23.112461,
     "Y": 47.170328
    },
    {
     "ProvName": "Satu Mare",
     "zoomlevel": 5.8,
     "X": 22.893741,
     "Y": 47.688281
    },
    {
     "ProvName": "Arges",
     "zoomlevel": 5.8,
     "X": 24.900484,
     "Y": 45.039214
    },
    {
     "ProvName": "Sibiu",
     "zoomlevel": 5.8,
     "X": 24.250214,
     "Y": 45.846831
    },
    {
     "ProvName": "Vâlcea",
     "zoomlevel": 5.8,
     "X": 24.120689,
     "Y": 45.096469
    },
    {
     "ProvName": "Pará",
     "zoomlevel": 3.38,
     "X": -53.138286,
     "Y": -4.046128
    },
    {
     "ProvName": "Rondônia",
     "zoomlevel": 3.38,
     "X": -62.843549,
     "Y": -10.916895
    },
    {
     "ProvName": "Tocantins",
     "zoomlevel": 3.38,
     "X": -48.327275,
     "Y": -10.140744
    },
    {
     "ProvName": "Alto Paraguay",
     "zoomlevel": 5.8,
     "X": -59.399973,
     "Y": -20.596234
    },
    {
     "ProvName": "Luapula",
     "zoomlevel": 5.8,
     "X": 29.206039,
     "Y": -10.688924
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": 31.157285,
     "Y": -10.490963
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 28.605024,
     "Y": -14.185244
    },
    {
     "ProvName": "Boquerón",
     "zoomlevel": 5.8,
     "X": -61.070444,
     "Y": -21.897041
    },
    {
     "ProvName": "Zhytomyr",
     "zoomlevel": 4.3,
     "X": 28.470745,
     "Y": 50.630009
    },
    {
     "ProvName": "Sumy",
     "zoomlevel": 4.3,
     "X": 34.103868,
     "Y": 51.098021
    },
    {
     "ProvName": "Cordillera",
     "zoomlevel": 5.8,
     "X": -56.922056,
     "Y": -25.225241
    },
    {
     "ProvName": "Vestfirdhir",
     "zoomlevel": 4,
     "X": -22.432455,
     "Y": 65.701116
    },
    {
     "ProvName": "Austurland",
     "zoomlevel": 4,
     "X": -15.385247,
     "Y": 64.925461
    },
    {
     "ProvName": "Tashkent",
     "zoomlevel": 5.8,
     "X": 69.795224,
     "Y": 41.25247
    },
    {
     "ProvName": "Dnipropetrovsk",
     "zoomlevel": 4.3,
     "X": 34.840421,
     "Y": 48.299528
    },
    {
     "ProvName": "Donetsk",
     "zoomlevel": 4.3,
     "X": 37.66582,
     "Y": 48.045304
    },
    {
     "ProvName": "Kharkiv",
     "zoomlevel": 4.3,
     "X": 36.491201,
     "Y": 49.60727
    },
    {
     "ProvName": "Luhansk",
     "zoomlevel": 4.3,
     "X": 39.009277,
     "Y": 48.975093
    },
    {
     "ProvName": "Poltava",
     "zoomlevel": 4.3,
     "X": 33.773482,
     "Y": 49.73288
    },
    {
     "ProvName": "Zaporizhzhya",
     "zoomlevel": 4.3,
     "X": 35.691387,
     "Y": 47.266146
    },
    {
     "ProvName": "Orange Walk",
     "zoomlevel": 5.8,
     "X": -88.819924,
     "Y": 17.763056
    },
    {
     "ProvName": "al-Mahrah",
     "zoomlevel": 4.5,
     "X": 51.598605,
     "Y": 16.695969
    },
    {
     "ProvName": "Limburg",
     "zoomlevel": 5.8,
     "X": 5.919791,
     "Y": 51.196772
    },
    {
     "ProvName": "Phitsanulok",
     "zoomlevel": 5.8,
     "X": 100.529952,
     "Y": 16.970629
    },
    {
     "ProvName": "Concepción",
     "zoomlevel": 5.8,
     "X": -57.10442,
     "Y": -22.837047
    },
    {
     "ProvName": "Nisporeni",
     "zoomlevel": 5.8,
     "X": 28.197062,
     "Y": 47.072776
    },
    {
     "ProvName": "Nordhurland vestra",
     "zoomlevel": 4,
     "X": -19.70117,
     "Y": 65.363671
    },
    {
     "ProvName": "Gelderland",
     "zoomlevel": 5.8,
     "X": 5.937053,
     "Y": 52.063655
    },
    {
     "ProvName": "Groningen",
     "zoomlevel": 5.8,
     "X": 6.732179,
     "Y": 53.219327
    },
    {
     "ProvName": "Overijssel",
     "zoomlevel": 5.8,
     "X": 6.43309,
     "Y": 52.44664
    },
    {
     "ProvName": "Troms",
     "zoomlevel": 4,
     "X": 19.623136,
     "Y": 69.276204
    },
    {
     "ProvName": "Svalbard & Jan Mayen Is",
     "zoomlevel": 2.37,
     "X": 18.485638,
     "Y": 78.866603
    },
    {
     "ProvName": "Flevoland",
     "zoomlevel": 5.8,
     "X": 5.523756,
     "Y": 52.556639
    },
    {
     "ProvName": "Corozal",
     "zoomlevel": 5.8,
     "X": -88.320875,
     "Y": 18.228145
    },
    {
     "ProvName": "Zeeland",
     "zoomlevel": 5.8,
     "X": 3.819935,
     "Y": 51.44838
    },
    {
     "ProvName": "Piemonte",
     "zoomlevel": 5.8,
     "X": 7.910834,
     "Y": 45.062798
    },
    {
     "ProvName": "Valle d'Aosta",
     "zoomlevel": 5.8,
     "X": 7.370436,
     "Y": 45.730477
    },
    {
     "ProvName": "Kelantan",
     "zoomlevel": 5.8,
     "X": 102.033366,
     "Y": 5.286034
    },
    {
     "ProvName": "Melaka",
     "zoomlevel": 5.8,
     "X": 102.310954,
     "Y": 2.32396
    },
    {
     "ProvName": "Cartago",
     "zoomlevel": 5.8,
     "X": -83.681468,
     "Y": 9.808121
    },
    {
     "ProvName": "Heredia",
     "zoomlevel": 5.8,
     "X": -84.011507,
     "Y": 10.42763
    },
    {
     "ProvName": "Atlántico",
     "zoomlevel": 5.8,
     "X": -74.967372,
     "Y": 10.689562
    },
    {
     "ProvName": "Bol?var",
     "zoomlevel": 5.8,
     "X": -74.512858,
     "Y": 8.744273
    },
    {
     "ProvName": "São Tomé",
     "zoomlevel": 5.8,
     "X": 6.608183,
     "Y": 0.235404
    },
    {
     "ProvName": "Limón",
     "zoomlevel": 5.8,
     "X": -83.340211,
     "Y": 9.943061
    },
    {
     "ProvName": "Puntarenas",
     "zoomlevel": 5.8,
     "X": -83.722881,
     "Y": 9.159764
    },
    {
     "ProvName": "Chai Nat",
     "zoomlevel": 5.8,
     "X": 100.02529,
     "Y": 15.136392
    },
    {
     "ProvName": "San José",
     "zoomlevel": 5.8,
     "X": -83.99021,
     "Y": 9.608609
    },
    {
     "ProvName": "Orhei",
     "zoomlevel": 5.8,
     "X": 28.816677,
     "Y": 47.41621
    },
    {
     "ProvName": "Chiriqu?",
     "zoomlevel": 5.8,
     "X": -82.396555,
     "Y": 8.483079
    },
    {
     "ProvName": "Alajuela",
     "zoomlevel": 5.8,
     "X": -84.60241,
     "Y": 10.558393
    },
    {
     "ProvName": "Sucre",
     "zoomlevel": 5.8,
     "X": -75.120469,
     "Y": 9.077672
    },
    {
     "ProvName": "Guanacaste",
     "zoomlevel": 5.8,
     "X": -85.392753,
     "Y": 10.448138
    },
    {
     "ProvName": "Esmeraldas",
     "zoomlevel": 5.8,
     "X": -79.224011,
     "Y": 0.695509
    },
    {
     "ProvName": "Rezina",
     "zoomlevel": 5.8,
     "X": 28.845985,
     "Y": 47.687818
    },
    {
     "ProvName": "Cesar",
     "zoomlevel": 5.8,
     "X": -73.523784,
     "Y": 9.528799
    },
    {
     "ProvName": "Chocó",
     "zoomlevel": 5.8,
     "X": -76.946877,
     "Y": 5.979015
    },
    {
     "ProvName": "Ad Dali",
     "zoomlevel": 5.8,
     "X": 44.788738,
     "Y": 13.879606
    },
    {
     "ProvName": "Magdalena",
     "zoomlevel": 5.8,
     "X": -74.257066,
     "Y": 10.237435
    },
    {
     "ProvName": "Kuna Yala (San Blas)",
     "zoomlevel": 5.8,
     "X": -78.282076,
     "Y": 9.148696
    },
    {
     "ProvName": "al-Jawf",
     "zoomlevel": 5.8,
     "X": 45.648517,
     "Y": 16.605136
    },
    {
     "ProvName": "Soldanesti",
     "zoomlevel": 5.8,
     "X": 28.691855,
     "Y": 47.839186
    },
    {
     "ProvName": "Arauca",
     "zoomlevel": 5.8,
     "X": -70.968861,
     "Y": 6.563615
    },
    {
     "ProvName": "Shabwah",
     "zoomlevel": 5.8,
     "X": 46.946823,
     "Y": 14.756263
    },
    {
     "ProvName": "Harare",
     "zoomlevel": 5.8,
     "X": 31.061693,
     "Y": -17.863502
    },
    {
     "ProvName": "Norte de Santander",
     "zoomlevel": 5.8,
     "X": -72.887175,
     "Y": 8.092249
    },
    {
     "ProvName": "Ma'rib",
     "zoomlevel": 5.8,
     "X": 45.570565,
     "Y": 15.476158
    },
    {
     "ProvName": "Matabeleland North",
     "zoomlevel": 4.8,
     "X": 27.394763,
     "Y": -18.820183
    },
    {
     "ProvName": "Casanare",
     "zoomlevel": 5.8,
     "X": -71.609327,
     "Y": 5.404251
    },
    {
     "ProvName": "Ivanovo",
     "zoomlevel": 4.3,
     "X": 41.709504,
     "Y": 57.016156
    },
    {
     "ProvName": "Kostroma",
     "zoomlevel": 4.3,
     "X": 43.789942,
     "Y": 58.460046
    },
    {
     "ProvName": "Nizhegorod",
     "zoomlevel": 4.3,
     "X": 44.639267,
     "Y": 56.291901
    },
    {
     "ProvName": "Tver'",
     "zoomlevel": 4.3,
     "X": 34.714264,
     "Y": 57.091197
    },
    {
     "ProvName": "Vologda",
     "zoomlevel": 4.3,
     "X": 40.499643,
     "Y": 59.967764
    },
    {
     "ProvName": "Yaroslavl'",
     "zoomlevel": 4.3,
     "X": 39.134951,
     "Y": 57.869244
    },
    {
     "ProvName": "Kaluga",
     "zoomlevel": 4.3,
     "X": 35.437829,
     "Y": 54.367525
    },
    {
     "ProvName": "Kursk",
     "zoomlevel": 4.3,
     "X": 36.075502,
     "Y": 51.675475
    },
    {
     "ProvName": "Lipetsk",
     "zoomlevel": 4.3,
     "X": 39.135485,
     "Y": 52.64586
    },
    {
     "ProvName": "al-Bayda'",
     "zoomlevel": 5.8,
     "X": 45.368533,
     "Y": 14.301239
    },
    {
     "ProvName": "Midlands",
     "zoomlevel": 4.8,
     "X": 29.460695,
     "Y": -18.981433
    },
    {
     "ProvName": "Mashonaland East",
     "zoomlevel": 5.8,
     "X": 31.678607,
     "Y": -18.004433
    },
    {
     "ProvName": "Ra's al-Khaymah",
     "zoomlevel": 5.8,
     "X": 56.035509,
     "Y": 25.447386
    },
    {
     "ProvName": "Umm al-Qaywayn",
     "zoomlevel": 5.8,
     "X": 55.750141,
     "Y": 25.472966
    },
    {
     "ProvName": "Dubayy (Dubai)",
     "zoomlevel": 5.8,
     "X": 55.381577,
     "Y": 24.921001
    },
    {
     "ProvName": "Rennell and Bellona",
     "zoomlevel": 5.8,
     "X": 160.250051,
     "Y": -11.640076
    },
    {
     "ProvName": "Ranong",
     "zoomlevel": 5.8,
     "X": 98.718079,
     "Y": 10.000173
    },
    {
     "ProvName": "Surat Thani",
     "zoomlevel": 5.8,
     "X": 99.087574,
     "Y": 9.045742
    },
    {
     "ProvName": "Sumatera Utara",
     "zoomlevel": 5.8,
     "X": 99.042344,
     "Y": 2.219858
    },
    {
     "ProvName": "Straseni",
     "zoomlevel": 5.8,
     "X": 28.583414,
     "Y": 47.169717
    },
    {
     "ProvName": "Krabi",
     "zoomlevel": 5.8,
     "X": 99.016073,
     "Y": 8.135407
    },
    {
     "ProvName": "Phatthalung",
     "zoomlevel": 5.8,
     "X": 100.032247,
     "Y": 7.512994
    },
    {
     "ProvName": "Songkhla",
     "zoomlevel": 5.8,
     "X": 100.558026,
     "Y": 6.895898
    },
    {
     "ProvName": "Satun",
     "zoomlevel": 5.8,
     "X": 99.936792,
     "Y": 6.831429
    },
    {
     "ProvName": "Trang",
     "zoomlevel": 5.8,
     "X": 99.615331,
     "Y": 7.526044
    },
    {
     "ProvName": "Nakhon Nayok",
     "zoomlevel": 5.8,
     "X": 101.174828,
     "Y": 14.216983
    },
    {
     "ProvName": "Yala",
     "zoomlevel": 5.8,
     "X": 101.224792,
     "Y": 6.183367
    },
    {
     "ProvName": "Al-Fujayrah (Fujairah)",
     "zoomlevel": 5.8,
     "X": 56.197426,
     "Y": 25.361139
    },
    {
     "ProvName": "Chiang Rai",
     "zoomlevel": 5.8,
     "X": 99.866071,
     "Y": 19.844188
    },
    {
     "ProvName": "Chiang Mai",
     "zoomlevel": 5.8,
     "X": 98.73422,
     "Y": 18.790753
    },
    {
     "ProvName": "Ash-Shariqah (Sharjah)",
     "zoomlevel": 5.8,
     "X": 55.814815,
     "Y": 25.136678
    },
    {
     "ProvName": "Ajman (Ajman)",
     "zoomlevel": 5.8,
     "X": 55.786572,
     "Y": 25.132244
    },
    {
     "ProvName": "Abu Dhabi (Abu Zaby)",
     "zoomlevel": 5.8,
     "X": 54.005697,
     "Y": 23.649234
    },
    {
     "ProvName": "Balkan",
     "zoomlevel": 4.5,
     "X": 55.017937,
     "Y": 39.796902
    },
    {
     "ProvName": "Dashhovuse",
     "zoomlevel": 4.5,
     "X": 58.709542,
     "Y": 41.16099
    },
    {
     "ProvName": "Telenesti",
     "zoomlevel": 5.8,
     "X": 28.451333,
     "Y": 47.553499
    },
    {
     "ProvName": "Bukhoro",
     "zoomlevel": 4.5,
     "X": 63.719443,
     "Y": 40.178299
    },
    {
     "ProvName": "Khorazm",
     "zoomlevel": 4.5,
     "X": 61.023722,
     "Y": 41.344263
    },
    {
     "ProvName": "Qoraqalpoghiston",
     "zoomlevel": 4.5,
     "X": 58.81831,
     "Y": 43.421688
    },
    {
     "ProvName": "Phra Nakhon Si Ayutthaya",
     "zoomlevel": 5.8,
     "X": 100.527866,
     "Y": 14.340727
    },
    {
     "ProvName": "Nawoiy",
     "zoomlevel": 4.5,
     "X": 64.359511,
     "Y": 41.975815
    },
    {
     "ProvName": "Pathum Thani",
     "zoomlevel": 5.8,
     "X": 100.679249,
     "Y": 14.061539
    },
    {
     "ProvName": "Samarqand",
     "zoomlevel": 5.8,
     "X": 66.398908,
     "Y": 39.835728
    },
    {
     "ProvName": "Sing Buri",
     "zoomlevel": 5.8,
     "X": 100.352862,
     "Y": 14.921336
    },
    {
     "ProvName": "Leban",
     "zoomlevel": 4.5,
     "X": 63.175396,
     "Y": 38.905284
    },
    {
     "ProvName": "Qashqadaryo",
     "zoomlevel": 5.8,
     "X": 66.095139,
     "Y": 38.842359
    },
    {
     "ProvName": "Mary",
     "zoomlevel": 4.5,
     "X": 62.31735,
     "Y": 37.211844
    },
    {
     "ProvName": "Nakhon Pathom",
     "zoomlevel": 5.8,
     "X": 100.109328,
     "Y": 13.924099
    },
    {
     "ProvName": "Surkhondaryo",
     "zoomlevel": 5.8,
     "X": 67.458419,
     "Y": 38.020806
    },
    {
     "ProvName": "Andijon",
     "zoomlevel": 5.8,
     "X": 72.320298,
     "Y": 40.753675
    },
    {
     "ProvName": "Farghona",
     "zoomlevel": 5.8,
     "X": 71.278892,
     "Y": 40.437224
    },
    {
     "ProvName": "Namangan",
     "zoomlevel": 5.8,
     "X": 71.251857,
     "Y": 41.049509
    },
    {
     "ProvName": "Gorno-Badakhshan",
     "zoomlevel": 5.8,
     "X": 72.881921,
     "Y": 38.107095
    },
    {
     "ProvName": "Khatlon",
     "zoomlevel": 5.8,
     "X": 69.133772,
     "Y": 37.8267
    },
    {
     "ProvName": "Sughd",
     "zoomlevel": 5.8,
     "X": 69.223788,
     "Y": 39.794473
    },
    {
     "ProvName": "Jizzakh",
     "zoomlevel": 5.8,
     "X": 67.64134,
     "Y": 40.37445
    },
    {
     "ProvName": "Samut Songkhram",
     "zoomlevel": 5.8,
     "X": 99.956232,
     "Y": 13.393786
    },
    {
     "ProvName": "Blantyre",
     "zoomlevel": 5.8,
     "X": 34.956018,
     "Y": -15.682484
    },
    {
     "ProvName": "Sirdaryo",
     "zoomlevel": 5.8,
     "X": 68.661972,
     "Y": 40.433249
    },
    {
     "ProvName": "Madhya Pashchimanchal (Mid-Western)",
     "zoomlevel": 5.8,
     "X": 82.273867,
     "Y": 28.953397
    },
    {
     "ProvName": "Mae Hong Son",
     "zoomlevel": 5.8,
     "X": 98.02679,
     "Y": 18.755092
    },
    {
     "ProvName": "Phichit",
     "zoomlevel": 5.8,
     "X": 100.357171,
     "Y": 16.236679
    },
    {
     "ProvName": "Phetchabun",
     "zoomlevel": 5.8,
     "X": 101.146984,
     "Y": 16.269168
    },
    {
     "ProvName": "Chumphon",
     "zoomlevel": 5.8,
     "X": 99.06988,
     "Y": 10.366687
    },
    {
     "ProvName": "Nakhon Si Thammarat",
     "zoomlevel": 5.8,
     "X": 99.778038,
     "Y": 8.372833
    },
    {
     "ProvName": "Phuket",
     "zoomlevel": 5.8,
     "X": 98.341764,
     "Y": 7.974695
    },
    {
     "ProvName": "Sukhothai",
     "zoomlevel": 5.8,
     "X": 99.698732,
     "Y": 17.247893
    },
    {
     "ProvName": "Independencia",
     "zoomlevel": 5.8,
     "X": -71.6293,
     "Y": 18.424001
    },
    {
     "ProvName": "Uttaradit",
     "zoomlevel": 5.8,
     "X": 100.508995,
     "Y": 17.742229
    },
    {
     "ProvName": "Saint Andrew",
     "zoomlevel": 5.8,
     "X": -76.7605,
     "Y": 18.047107
    },
    {
     "ProvName": "Kanchanaburi",
     "zoomlevel": 5.8,
     "X": 99.040348,
     "Y": 14.584595
    },
    {
     "ProvName": "St. Michael",
     "zoomlevel": 5.8,
     "X": -59.602542,
     "Y": 13.119708
    },
    {
     "ProvName": "Kamphaeng Phet",
     "zoomlevel": 5.8,
     "X": 99.502592,
     "Y": 16.329357
    },
    {
     "ProvName": "Amnat Charoen",
     "zoomlevel": 5.8,
     "X": 104.768099,
     "Y": 15.87019
    },
    {
     "ProvName": "Suphan Buri",
     "zoomlevel": 5.8,
     "X": 99.897988,
     "Y": 14.607904
    },
    {
     "ProvName": "Tak",
     "zoomlevel": 5.8,
     "X": 98.796186,
     "Y": 16.697955
    },
    {
     "ProvName": "Managua",
     "zoomlevel": 5.8,
     "X": -86.266324,
     "Y": 12.228385
    },
    {
     "ProvName": "Uthai Thani",
     "zoomlevel": 5.8,
     "X": 99.46013,
     "Y": 15.338882
    },
    {
     "ProvName": "Ang Thong",
     "zoomlevel": 5.8,
     "X": 100.355082,
     "Y": 14.623509
    },
    {
     "ProvName": "Lop Buri",
     "zoomlevel": 5.8,
     "X": 100.914096,
     "Y": 15.07448
    },
    {
     "ProvName": "Elías Piña",
     "zoomlevel": 5.8,
     "X": -71.600289,
     "Y": 19.004707
    },
    {
     "ProvName": "Prachin Buri",
     "zoomlevel": 5.8,
     "X": 101.625058,
     "Y": 14.074864
    },
    {
     "ProvName": "Loei",
     "zoomlevel": 5.8,
     "X": 101.630144,
     "Y": 17.40899
    },
    {
     "ProvName": "Sakon Nakhon",
     "zoomlevel": 5.8,
     "X": 103.82129,
     "Y": 17.388759
    },
    {
     "ProvName": "Udon Thani",
     "zoomlevel": 5.8,
     "X": 102.855665,
     "Y": 17.425352
    },
    {
     "ProvName": "Nakhon Sawan",
     "zoomlevel": 5.8,
     "X": 100.132139,
     "Y": 15.692395
    },
    {
     "ProvName": "Saraburi",
     "zoomlevel": 5.8,
     "X": 100.938885,
     "Y": 14.576426
    },
    {
     "ProvName": "Bangkok Metropolis",
     "zoomlevel": 5.8,
     "X": 100.620064,
     "Y": 13.771288
    },
    {
     "ProvName": "Nonthaburi",
     "zoomlevel": 5.8,
     "X": 100.38903,
     "Y": 13.926683
    },
    {
     "ProvName": "Phetchaburi",
     "zoomlevel": 5.8,
     "X": 99.613405,
     "Y": 12.936947
    },
    {
     "ProvName": "Prachuap Khiri Khan",
     "zoomlevel": 5.8,
     "X": 99.626485,
     "Y": 11.921278
    },
    {
     "ProvName": "Ratchaburi",
     "zoomlevel": 5.8,
     "X": 99.573781,
     "Y": 13.531762
    },
    {
     "ProvName": "Samut Prakan",
     "zoomlevel": 5.8,
     "X": 100.705999,
     "Y": 13.597966
    },
    {
     "ProvName": "Samut Sakhon",
     "zoomlevel": 5.8,
     "X": 100.215839,
     "Y": 13.570713
    },
    {
     "ProvName": "Si Sa Ket",
     "zoomlevel": 5.8,
     "X": 104.378724,
     "Y": 14.857065
    },
    {
     "ProvName": "Pedermales",
     "zoomlevel": 5.8,
     "X": -71.532964,
     "Y": 17.961552
    },
    {
     "ProvName": "Ubon Ratchathani",
     "zoomlevel": 5.8,
     "X": 105.119488,
     "Y": 15.177563
    },
    {
     "ProvName": "Tekirdag",
     "zoomlevel": 5.8,
     "X": 27.395372,
     "Y": 41.093625
    },
    {
     "ProvName": "Yasothon",
     "zoomlevel": 5.8,
     "X": 104.338528,
     "Y": 15.889781
    },
    {
     "ProvName": "Sofiya-Grad",
     "zoomlevel": 5.8,
     "X": 23.37702,
     "Y": 42.672567
    },
    {
     "ProvName": "Chon Buri",
     "zoomlevel": 5.8,
     "X": 101.211148,
     "Y": 13.197178
    },
    {
     "ProvName": "León",
     "zoomlevel": 5.8,
     "X": -86.630642,
     "Y": 12.571252
    },
    {
     "ProvName": "La Rioja",
     "zoomlevel": 5.8,
     "X": -67.200692,
     "Y": -29.6687
    },
    {
     "ProvName": "Chachoengsao",
     "zoomlevel": 5.8,
     "X": 101.44635,
     "Y": 13.603881
    },
    {
     "ProvName": "Carriacou",
     "zoomlevel": 5.8,
     "X": -61.347574,
     "Y": 15.303061
    },
    {
     "ProvName": "West Midlands",
     "zoomlevel": 5.8,
     "X": -1.870677,
     "Y": 52.481776
    },
    {
     "ProvName": "Chanthaburi",
     "zoomlevel": 5.8,
     "X": 102.120012,
     "Y": 12.863265
    },
    {
     "ProvName": "Sa Kaeo",
     "zoomlevel": 5.8,
     "X": 102.293409,
     "Y": 13.77733
    },
    {
     "ProvName": "Rayong",
     "zoomlevel": 5.8,
     "X": 101.422501,
     "Y": 12.851686
    },
    {
     "ProvName": "Trat",
     "zoomlevel": 5.8,
     "X": 102.519144,
     "Y": 12.303375
    },
    {
     "ProvName": "Buri Ram",
     "zoomlevel": 5.8,
     "X": 102.971742,
     "Y": 14.823323
    },
    {
     "ProvName": "Chaiyaphum",
     "zoomlevel": 5.8,
     "X": 101.80253,
     "Y": 16.009493
    },
    {
     "ProvName": "Khon Kaen",
     "zoomlevel": 5.8,
     "X": 102.58781,
     "Y": 16.403804
    },
    {
     "ProvName": "Kalasin",
     "zoomlevel": 5.8,
     "X": 103.628287,
     "Y": 16.631581
    },
    {
     "ProvName": "Maha Sarakham",
     "zoomlevel": 5.8,
     "X": 103.179602,
     "Y": 15.993434
    },
    {
     "ProvName": "Nakhon Ratchasima",
     "zoomlevel": 5.8,
     "X": 102.116949,
     "Y": 14.957709
    },
    {
     "ProvName": "Roi Et",
     "zoomlevel": 5.8,
     "X": 103.826229,
     "Y": 15.923239
    },
    {
     "ProvName": "Azua",
     "zoomlevel": 5.8,
     "X": -70.833821,
     "Y": 18.580414
    },
    {
     "ProvName": "Surin",
     "zoomlevel": 5.8,
     "X": 103.668542,
     "Y": 14.884227
    },
    {
     "ProvName": "La Vega",
     "zoomlevel": 5.8,
     "X": -70.631633,
     "Y": 19.052067
    },
    {
     "ProvName": "Nong Bua Lam Phu",
     "zoomlevel": 5.8,
     "X": 102.297392,
     "Y": 17.17361
    },
    {
     "ProvName": "Monseñor Nouel",
     "zoomlevel": 5.8,
     "X": -70.418377,
     "Y": 18.892624
    },
    {
     "ProvName": "Hwanghae South",
     "zoomlevel": 5.8,
     "X": 125.541906,
     "Y": 38.189295
    },
    {
     "ProvName": "Bomi",
     "zoomlevel": 5.8,
     "X": -10.804853,
     "Y": 6.718197
    },
    {
     "ProvName": "Grand Cape Mount",
     "zoomlevel": 5.8,
     "X": -11.026288,
     "Y": 7.108165
    },
    {
     "ProvName": "Bong",
     "zoomlevel": 5.8,
     "X": -9.667136,
     "Y": 6.936957
    },
    {
     "ProvName": "Riau",
     "zoomlevel": 5.8,
     "X": 101.801391,
     "Y": 0.508046
    },
    {
     "ProvName": "Grand Bassa",
     "zoomlevel": 5.8,
     "X": -9.802425,
     "Y": 6.226699
    },
    {
     "ProvName": "Otdar Mean Cheay",
     "zoomlevel": 5.8,
     "X": 103.537726,
     "Y": 14.196535
    },
    {
     "ProvName": "María Trinidad Sánchez",
     "zoomlevel": 5.8,
     "X": -69.984018,
     "Y": 19.444191
    },
    {
     "ProvName": "Nakhon Phanom",
     "zoomlevel": 5.8,
     "X": 104.434787,
     "Y": 17.372378
    },
    {
     "ProvName": "Narathiwat",
     "zoomlevel": 5.8,
     "X": 101.721444,
     "Y": 6.172126
    },
    {
     "ProvName": "Mukdahan",
     "zoomlevel": 5.8,
     "X": 104.52516,
     "Y": 16.556791
    },
    {
     "ProvName": "Pattani",
     "zoomlevel": 5.8,
     "X": 101.353294,
     "Y": 6.730242
    },
    {
     "ProvName": "St. John",
     "zoomlevel": 5.8,
     "X": -61.449669,
     "Y": 15.566375
    },
    {
     "ProvName": "Bali",
     "zoomlevel": 5.8,
     "X": 115.142257,
     "Y": -8.36373
    },
    {
     "ProvName": "Jawa Timur",
     "zoomlevel": 5.8,
     "X": 112.7371,
     "Y": -7.729661
    },
    {
     "ProvName": "Sulawesi Utara",
     "zoomlevel": 5.8,
     "X": 124.484165,
     "Y": 1.201749
    },
    {
     "ProvName": "Copperbelt",
     "zoomlevel": 5.8,
     "X": 27.846186,
     "Y": -13.123625
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 32.12776,
     "Y": -12.963291
    },
    {
     "ProvName": "Lusaka",
     "zoomlevel": 5.8,
     "X": 29.217055,
     "Y": -15.370015
    },
    {
     "ProvName": "North-Western",
     "zoomlevel": 3.8,
     "X": 25.049707,
     "Y": -13.031303
    },
    {
     "ProvName": "Southern",
     "zoomlevel": 5.8,
     "X": 26.664934,
     "Y": -16.58637
    },
    {
     "ProvName": "Western",
     "zoomlevel": 3.8,
     "X": 23.663299,
     "Y": -15.648105
    },
    {
     "ProvName": "Guelmim-Es-Semara",
     "zoomlevel": 5.8,
     "X": -9.475199,
     "Y": 28.745529
    },
    {
     "ProvName": "Manicaland",
     "zoomlevel": 5.8,
     "X": 32.385762,
     "Y": -19.071177
    },
    {
     "ProvName": "Matabeleland South",
     "zoomlevel": 4.8,
     "X": 28.976452,
     "Y": -21.005905
    },
    {
     "ProvName": "Mashonaland Central",
     "zoomlevel": 5.8,
     "X": 31.188926,
     "Y": -16.711184
    },
    {
     "ProvName": "Montserrado",
     "zoomlevel": 5.8,
     "X": -10.572983,
     "Y": 6.514375
    },
    {
     "ProvName": "Bulawayo",
     "zoomlevel": 4.8,
     "X": 28.548607,
     "Y": -20.14025
    },
    {
     "ProvName": "Masvingo (Victoria)",
     "zoomlevel": 4.8,
     "X": 31.231236,
     "Y": -20.78593
    },
    {
     "ProvName": "Mashonaland West",
     "zoomlevel": 5.8,
     "X": 29.708144,
     "Y": -17.182668
    },
    {
     "ProvName": "Hhohho",
     "zoomlevel": 5.8,
     "X": 31.319159,
     "Y": -26.081816
    },
    {
     "ProvName": "Cova Lima",
     "zoomlevel": 5.8,
     "X": 125.220236,
     "Y": -9.262419
    },
    {
     "ProvName": "Ermera",
     "zoomlevel": 5.8,
     "X": 125.37162,
     "Y": -8.820358
    },
    {
     "ProvName": "Lubombo",
     "zoomlevel": 5.8,
     "X": 31.831727,
     "Y": -26.541819
    },
    {
     "ProvName": "Manzini",
     "zoomlevel": 5.8,
     "X": 31.222934,
     "Y": -26.538121
    },
    {
     "ProvName": "Manatuto",
     "zoomlevel": 5.8,
     "X": 125.966967,
     "Y": -8.718755
    },
    {
     "ProvName": "Manufahi",
     "zoomlevel": 5.8,
     "X": 125.786695,
     "Y": -8.99569
    },
    {
     "ProvName": "Shiselweni",
     "zoomlevel": 5.8,
     "X": 31.410969,
     "Y": -27.059691
    },
    {
     "ProvName": "Maluku Utara",
     "zoomlevel": 5.8,
     "X": 127.540789,
     "Y": 0.220526
    },
    {
     "ProvName": "Sumatera Barat",
     "zoomlevel": 5.8,
     "X": 100.438559,
     "Y": -0.827986
    },
    {
     "ProvName": "Yogyakarta",
     "zoomlevel": 5.8,
     "X": 110.457785,
     "Y": -7.908008
    },
    {
     "ProvName": "Dili",
     "zoomlevel": 5.8,
     "X": 125.628292,
     "Y": -8.438584
    },
    {
     "ProvName": "Liquiçá",
     "zoomlevel": 5.8,
     "X": 125.292456,
     "Y": -8.658055
    },
    {
     "ProvName": "Aileu",
     "zoomlevel": 5.8,
     "X": 125.622187,
     "Y": -8.708242
    },
    {
     "ProvName": "Aqaba",
     "zoomlevel": 5.8,
     "X": 35.319722,
     "Y": 29.797828
    },
    {
     "ProvName": "Margibi",
     "zoomlevel": 5.8,
     "X": -10.216063,
     "Y": 6.510136
    },
    {
     "ProvName": "Ainaro",
     "zoomlevel": 5.8,
     "X": 125.554829,
     "Y": -9.00856
    },
    {
     "ProvName": "Baucau",
     "zoomlevel": 5.8,
     "X": 126.464892,
     "Y": -8.570038
    },
    {
     "ProvName": "Bobonaro",
     "zoomlevel": 5.8,
     "X": 125.169693,
     "Y": -8.978796
    },
    {
     "ProvName": "Eastern Province",
     "zoomlevel": 5.8,
     "X": -10.983559,
     "Y": 8.23955
    },
    {
     "ProvName": "Mafraq",
     "zoomlevel": 5.8,
     "X": 37.920267,
     "Y": 32.377521
    },
    {
     "ProvName": "Nimba",
     "zoomlevel": 5.8,
     "X": -8.766108,
     "Y": 6.833228
    },
    {
     "ProvName": "Amman",
     "zoomlevel": 5.8,
     "X": 36.342825,
     "Y": 31.578278
    },
    {
     "ProvName": "Rivercress",
     "zoomlevel": 5.8,
     "X": -9.384549,
     "Y": 5.876072
    },
    {
     "ProvName": "Viqueque",
     "zoomlevel": 5.8,
     "X": 126.347496,
     "Y": -8.807168
    },
    {
     "ProvName": "Lautém",
     "zoomlevel": 5.8,
     "X": 126.969579,
     "Y": -8.512617
    },
    {
     "ProvName": "Maluku",
     "zoomlevel": 5.8,
     "X": 129.776018,
     "Y": -4.699829
    },
    {
     "ProvName": "Nusa Tenggara Barat",
     "zoomlevel": 5.8,
     "X": 117.509818,
     "Y": -8.605786
    },
    {
     "ProvName": "Sulawesi Tenggara",
     "zoomlevel": 5.8,
     "X": 122.078025,
     "Y": -4.128506
    },
    {
     "ProvName": "Sulawesi Tengah",
     "zoomlevel": 5.8,
     "X": 121.218259,
     "Y": -0.989495
    },
    {
     "ProvName": "Papua",
     "zoomlevel": 5.8,
     "X": 138.6517,
     "Y": -4.640329
    },
    {
     "ProvName": "Nord",
     "zoomlevel": 5.8,
     "X": 164.894692,
     "Y": -20.887204
    },
    {
     "ProvName": "Tabouk",
     "zoomlevel": 4.5,
     "X": 37.292727,
     "Y": 27.38407
    },
    {
     "ProvName": "Irbid",
     "zoomlevel": 5.8,
     "X": 35.790746,
     "Y": 32.512769
    },
    {
     "ProvName": "Ajlun",
     "zoomlevel": 5.8,
     "X": 35.73798,
     "Y": 32.287053
    },
    {
     "ProvName": "Jarash",
     "zoomlevel": 5.8,
     "X": 35.879312,
     "Y": 32.22161
    },
    {
     "ProvName": "Balqa",
     "zoomlevel": 5.8,
     "X": 35.667611,
     "Y": 31.97629
    },
    {
     "ProvName": "Madaba",
     "zoomlevel": 5.8,
     "X": 35.675315,
     "Y": 31.576097
    },
    {
     "ProvName": "Grand Gedeh",
     "zoomlevel": 5.8,
     "X": -8.19208,
     "Y": 5.907549
    },
    {
     "ProvName": "Artibonite",
     "zoomlevel": 5.8,
     "X": -72.568249,
     "Y": 19.332978
    },
    {
     "ProvName": "Centre",
     "zoomlevel": 5.8,
     "X": -71.982226,
     "Y": 19.010158
    },
    {
     "ProvName": "Basse-Kotto",
     "zoomlevel": 5.8,
     "X": 21.364603,
     "Y": 4.895443
    },
    {
     "ProvName": "Nord-Est",
     "zoomlevel": 5.8,
     "X": -71.894396,
     "Y": 19.513134
    },
    {
     "ProvName": "Samaná",
     "zoomlevel": 5.8,
     "X": -69.499811,
     "Y": 19.232989
    },
    {
     "ProvName": "Lobaye",
     "zoomlevel": 5.8,
     "X": 17.623279,
     "Y": 4.169316
    },
    {
     "ProvName": "Nord",
     "zoomlevel": 5.8,
     "X": -72.294994,
     "Y": 19.598571
    },
    {
     "ProvName": "San Cristóbal",
     "zoomlevel": 5.8,
     "X": -70.210056,
     "Y": 18.521464
    },
    {
     "ProvName": "Santo Domingo city",
     "zoomlevel": 5.8,
     "X": -69.945801,
     "Y": 18.482859
    },
    {
     "ProvName": "Diffa",
     "zoomlevel": 3.8,
     "X": 13.200924,
     "Y": 15.866621
    },
    {
     "ProvName": "Saint Thomas",
     "zoomlevel": 5.8,
     "X": -76.45178,
     "Y": 17.947543
    },
    {
     "ProvName": "Santiago Rodríguez",
     "zoomlevel": 5.8,
     "X": -71.310012,
     "Y": 19.383088
    },
    {
     "ProvName": "Valverde",
     "zoomlevel": 5.8,
     "X": -71.034593,
     "Y": 19.581727
    },
    {
     "ProvName": "Ouest",
     "zoomlevel": 5.8,
     "X": -72.439055,
     "Y": 18.580706
    },
    {
     "ProvName": "St. Andrew",
     "zoomlevel": 5.8,
     "X": -61.3547,
     "Y": 15.535797
    },
    {
     "ProvName": "Sud-Est",
     "zoomlevel": 5.8,
     "X": -72.370157,
     "Y": 18.254593
    },
    {
     "ProvName": "Santiago",
     "zoomlevel": 5.8,
     "X": -70.902866,
     "Y": 19.324201
    },
    {
     "ProvName": "Vichada",
     "zoomlevel": 5.8,
     "X": -69.407668,
     "Y": 4.726616
    },
    {
     "ProvName": "Meta",
     "zoomlevel": 5.8,
     "X": -72.937694,
     "Y": 3.354381
    },
    {
     "ProvName": "Vaupes",
     "zoomlevel": 5.8,
     "X": -70.577878,
     "Y": 0.67011
    },
    {
     "ProvName": "Piura",
     "zoomlevel": 5.8,
     "X": -80.356396,
     "Y": -5.142238
    },
    {
     "ProvName": "St. Peter",
     "zoomlevel": 5.8,
     "X": -59.619836,
     "Y": 13.269778
    },
    {
     "ProvName": "St. Philip",
     "zoomlevel": 5.8,
     "X": -59.467331,
     "Y": 13.138202
    },
    {
     "ProvName": "St. Thomas",
     "zoomlevel": 5.8,
     "X": -59.59179,
     "Y": 13.184781
    },
    {
     "ProvName": "French Guiana",
     "zoomlevel": 5.8,
     "X": -53.245894,
     "Y": 3.926297
    },
    {
     "ProvName": "South Western Scotland",
     "zoomlevel": 5.8,
     "X": -4.112564,
     "Y": 55.335842
    },
    {
     "ProvName": "Sverdlovsk",
     "zoomlevel": 4.08,
     "X": 61.530361,
     "Y": 58.594328
    },
    {
     "ProvName": "Udmurt",
     "zoomlevel": 4.08,
     "X": 52.787199,
     "Y": 57.175263
    },
    {
     "ProvName": "Astrakhan'",
     "zoomlevel": 4.5,
     "X": 47.273482,
     "Y": 47.15941
    },
    {
     "ProvName": "Chuvash",
     "zoomlevel": 4.3,
     "X": 47.088046,
     "Y": 55.495571
    },
    {
     "ProvName": "Kalmyk",
     "zoomlevel": 4.5,
     "X": 45.317738,
     "Y": 46.444344
    },
    {
     "ProvName": "Orenburg",
     "zoomlevel": 4.5,
     "X": 55.623617,
     "Y": 51.991677
    },
    {
     "ProvName": "Samara",
     "zoomlevel": 4.3,
     "X": 50.468596,
     "Y": 53.28011
    },
    {
     "ProvName": "Saratov",
     "zoomlevel": 4.3,
     "X": 46.793235,
     "Y": 51.583508
    },
    {
     "ProvName": "Magallanes",
     "zoomlevel": 3.38,
     "X": -71.79992,
     "Y": -52.471259
    },
    {
     "ProvName": "Tarapacá",
     "zoomlevel": 5.8,
     "X": -69.411192,
     "Y": -20.194748
    },
    {
     "ProvName": "Arica and Parinacota",
     "zoomlevel": 5.8,
     "X": -69.639563,
     "Y": -18.486678
    },
    {
     "ProvName": "Ghardaïa",
     "zoomlevel": 3.8,
     "X": 3.117175,
     "Y": 31.162297
    },
    {
     "ProvName": "Antofagasta",
     "zoomlevel": 3.38,
     "X": -69.116575,
     "Y": -23.470317
    },
    {
     "ProvName": "Atacama",
     "zoomlevel": 3.38,
     "X": -69.932028,
     "Y": -27.381669
    },
    {
     "ProvName": "Coquimbo",
     "zoomlevel": 3.38,
     "X": -70.887087,
     "Y": -30.635523
    },
    {
     "ProvName": "Stefan Voda",
     "zoomlevel": 5.8,
     "X": 29.719763,
     "Y": 46.508052
    },
    {
     "ProvName": "Santiago",
     "zoomlevel": 3.38,
     "X": -70.658426,
     "Y": -33.60384
    },
    {
     "ProvName": "Los Ríos",
     "zoomlevel": 3.38,
     "X": -72.60846,
     "Y": -40.067552
    },
    {
     "ProvName": "Valparaíso",
     "zoomlevel": 3.38,
     "X": -71.429575,
     "Y": -32.698954
    },
    {
     "ProvName": "Santa Bárbara",
     "zoomlevel": 5.8,
     "X": -88.349911,
     "Y": 15.099426
    },
    {
     "ProvName": "Araucanía",
     "zoomlevel": 3.38,
     "X": -72.282412,
     "Y": -38.709408
    },
    {
     "ProvName": "Distrito Federal",
     "zoomlevel": 5.8,
     "X": -99.133487,
     "Y": 19.271608
    },
    {
     "ProvName": "Bío-Bío",
     "zoomlevel": 3.38,
     "X": -72.248563,
     "Y": -37.171815
    },
    {
     "ProvName": "Soroca",
     "zoomlevel": 5.8,
     "X": 28.22566,
     "Y": 48.121352
    },
    {
     "ProvName": "Guanajuato",
     "zoomlevel": 5.8,
     "X": -101.025256,
     "Y": 20.893993
    },
    {
     "ProvName": "Guerrero",
     "zoomlevel": 5.8,
     "X": -99.901029,
     "Y": 17.668527
    },
    {
     "ProvName": "Hidalgo",
     "zoomlevel": 5.8,
     "X": -98.869307,
     "Y": 20.475793
    },
    {
     "ProvName": "México",
     "zoomlevel": 5.8,
     "X": -99.637816,
     "Y": 19.365389
    },
    {
     "ProvName": "Morelos",
     "zoomlevel": 5.8,
     "X": -99.066322,
     "Y": 18.754447
    },
    {
     "ProvName": "Yucatán",
     "zoomlevel": 5.8,
     "X": -88.928149,
     "Y": 20.786024
    },
    {
     "ProvName": "Qaasuitsup",
     "zoomlevel": 2.37,
     "X": -53.986921,
     "Y": 75.186077
    },
    {
     "ProvName": "Querétaro",
     "zoomlevel": 5.8,
     "X": -99.864511,
     "Y": 20.825037
    },
    {
     "ProvName": "Veracruz",
     "zoomlevel": 5.8,
     "X": -96.392605,
     "Y": 19.367408
    },
    {
     "ProvName": "Chiapas",
     "zoomlevel": 5.8,
     "X": -92.465955,
     "Y": 16.500435
    },
    {
     "ProvName": "Quintana Roo",
     "zoomlevel": 5.8,
     "X": -88.110438,
     "Y": 19.686095
    },
    {
     "ProvName": "Taféa",
     "zoomlevel": 5.8,
     "X": 169.274842,
     "Y": -19.188747
    },
    {
     "ProvName": "Torba",
     "zoomlevel": 5.8,
     "X": 167.385191,
     "Y": -13.894205
    },
    {
     "ProvName": "Sanma",
     "zoomlevel": 5.8,
     "X": 166.871482,
     "Y": -15.254276
    },
    {
     "ProvName": "El Seíbo",
     "zoomlevel": 5.8,
     "X": -69.05559,
     "Y": 18.819389
    },
    {
     "ProvName": "Malampa",
     "zoomlevel": 5.8,
     "X": 167.649868,
     "Y": -16.263568
    },
    {
     "ProvName": "Penama",
     "zoomlevel": 5.8,
     "X": 168.050763,
     "Y": -15.483576
    },
    {
     "ProvName": "Tumbes",
     "zoomlevel": 5.8,
     "X": -80.573336,
     "Y": -3.846534
    },
    {
     "ProvName": "Shefa",
     "zoomlevel": 5.8,
     "X": 168.343042,
     "Y": -17.344067
    },
    {
     "ProvName": "Lambayeque",
     "zoomlevel": 5.8,
     "X": -79.831537,
     "Y": -6.374802
    },
    {
     "ProvName": "La Altagracia",
     "zoomlevel": 5.8,
     "X": -68.660819,
     "Y": 18.567208
    },
    {
     "ProvName": "Apurimac",
     "zoomlevel": 5.8,
     "X": -72.981556,
     "Y": -14.030975
    },
    {
     "ProvName": "Acre",
     "zoomlevel": 5.8,
     "X": -70.561982,
     "Y": -11.962476
    },
    {
     "ProvName": "La Romana",
     "zoomlevel": 5.8,
     "X": -68.977838,
     "Y": 18.509286
    },
    {
     "ProvName": "Christ Church",
     "zoomlevel": 5.8,
     "X": -59.52948,
     "Y": 13.09096
    },
    {
     "ProvName": "Arequipa",
     "zoomlevel": 5.8,
     "X": -72.457804,
     "Y": -15.852799
    },
    {
     "ProvName": "Cusco",
     "zoomlevel": 5.8,
     "X": -72.178894,
     "Y": -13.170079
    },
    {
     "ProvName": "Puno",
     "zoomlevel": 5.8,
     "X": -69.943697,
     "Y": -14.995694
    },
    {
     "ProvName": "St. Andrew",
     "zoomlevel": 5.8,
     "X": -59.581886,
     "Y": 13.253029
    },
    {
     "ProvName": "Carriacou",
     "zoomlevel": 5.8,
     "X": -59.548349,
     "Y": 13.146131
    },
    {
     "ProvName": "Moquegua",
     "zoomlevel": 5.8,
     "X": -70.846635,
     "Y": -16.853816
    },
    {
     "ProvName": "Tacna",
     "zoomlevel": 5.8,
     "X": -70.304265,
     "Y": -17.647361
    },
    {
     "ProvName": "St. James",
     "zoomlevel": 5.8,
     "X": -59.629121,
     "Y": 13.196774
    },
    {
     "ProvName": "St. John",
     "zoomlevel": 5.8,
     "X": -59.508592,
     "Y": 13.184327
    },
    {
     "ProvName": "Acre",
     "zoomlevel": 5.8,
     "X": -70.47306,
     "Y": -9.298386
    },
    {
     "ProvName": "St. Joseph",
     "zoomlevel": 5.8,
     "X": -59.551456,
     "Y": 13.214051
    },
    {
     "ProvName": "St. Lucy",
     "zoomlevel": 5.8,
     "X": -59.619857,
     "Y": 13.311536
    },
    {
     "ProvName": "Ancash",
     "zoomlevel": 5.8,
     "X": -77.69046,
     "Y": -9.38747
    },
    {
     "ProvName": "Pasco",
     "zoomlevel": 5.8,
     "X": -75.380259,
     "Y": -10.400952
    },
    {
     "ProvName": "Cajamarca",
     "zoomlevel": 5.8,
     "X": -78.762849,
     "Y": -6.448946
    },
    {
     "ProvName": "Huanuco",
     "zoomlevel": 5.8,
     "X": -76.026885,
     "Y": -9.425144
    },
    {
     "ProvName": "Copán",
     "zoomlevel": 5.8,
     "X": -88.900724,
     "Y": 14.905381
    },
    {
     "ProvName": "La Libertad",
     "zoomlevel": 5.8,
     "X": -78.336572,
     "Y": -7.941046
    },
    {
     "ProvName": "Estelí",
     "zoomlevel": 5.8,
     "X": -86.397066,
     "Y": 13.174153
    },
    {
     "ProvName": "San Martín",
     "zoomlevel": 5.8,
     "X": -76.67967,
     "Y": -7.070993
    },
    {
     "ProvName": "Ucayali",
     "zoomlevel": 5.8,
     "X": -73.448798,
     "Y": -9.628058
    },
    {
     "ProvName": "Lima Municipality",
     "zoomlevel": 5.8,
     "X": -76.927102,
     "Y": -12.01686
    },
    {
     "ProvName": "Amazonas",
     "zoomlevel": 5.8,
     "X": -78.05567,
     "Y": -5.062928
    },
    {
     "ProvName": "Loreto",
     "zoomlevel": 3.38,
     "X": -74.426019,
     "Y": -4.095813
    },
    {
     "ProvName": "Ayacucho",
     "zoomlevel": 5.8,
     "X": -74.086568,
     "Y": -14.103392
    },
    {
     "ProvName": "Guairá",
     "zoomlevel": 5.8,
     "X": -56.263088,
     "Y": -25.815663
    },
    {
     "ProvName": "Huancavelica",
     "zoomlevel": 5.8,
     "X": -75.011092,
     "Y": -13.037673
    },
    {
     "ProvName": "Misiones",
     "zoomlevel": 5.8,
     "X": -57.039712,
     "Y": -26.936288
    },
    {
     "ProvName": "Ica",
     "zoomlevel": 5.8,
     "X": -75.58143,
     "Y": -14.239652
    },
    {
     "ProvName": "Saskatchewan",
     "zoomlevel": 3.8,
     "X": -105.899162,
     "Y": 54.418721
    },
    {
     "ProvName": "Alberta",
     "zoomlevel": 3.8,
     "X": -114.509759,
     "Y": 55.167162
    },
    {
     "ProvName": "British Columbia",
     "zoomlevel": 3.8,
     "X": -124.748791,
     "Y": 54.761469
    },
    {
     "ProvName": "Nunavut",
     "zoomlevel": 2.37,
     "X": -88.902478,
     "Y": 71.030767
    },
    {
     "ProvName": "Northwest Territories",
     "zoomlevel": 3.8,
     "X": -119.009171,
     "Y": 66.356236
    },
    {
     "ProvName": "Yukon Territory",
     "zoomlevel": 3.8,
     "X": -135.508883,
     "Y": 63.635888
    },
    {
     "ProvName": "Junin",
     "zoomlevel": 5.8,
     "X": -74.906814,
     "Y": -11.519832
    },
    {
     "ProvName": "Madriz",
     "zoomlevel": 5.8,
     "X": -86.476874,
     "Y": 13.487162
    },
    {
     "ProvName": "Lima",
     "zoomlevel": 5.8,
     "X": -76.604583,
     "Y": -11.771387
    },
    {
     "ProvName": "Amazonas",
     "zoomlevel": 3.38,
     "X": -64.71858,
     "Y": -4.184378
    },
    {
     "ProvName": "Maranhão",
     "zoomlevel": 3.38,
     "X": -45.291458,
     "Y": -5.095949
    },
    {
     "ProvName": "Presidente Hayes",
     "zoomlevel": 5.8,
     "X": -58.667748,
     "Y": -23.629116
    },
    {
     "ProvName": "San Pedro",
     "zoomlevel": 5.8,
     "X": -56.62054,
     "Y": -24.166797
    },
    {
     "ProvName": "Merseyside",
     "zoomlevel": 5.8,
     "X": -2.920528,
     "Y": 53.440931
    },
    {
     "ProvName": "Neembucú",
     "zoomlevel": 5.8,
     "X": -57.885668,
     "Y": -26.762321
    },
    {
     "ProvName": "Paraguarí",
     "zoomlevel": 5.8,
     "X": -57.102175,
     "Y": -26.073575
    },
    {
     "ProvName": "Rio Grande do Sul",
     "zoomlevel": 3.38,
     "X": -53.320185,
     "Y": -29.735794
    },
    {
     "ProvName": "Paraná",
     "zoomlevel": 3.38,
     "X": -51.631761,
     "Y": -24.632231
    },
    {
     "ProvName": "Santa Catarina",
     "zoomlevel": 3.38,
     "X": -50.48623,
     "Y": -27.248202
    },
    {
     "ProvName": "Amambay",
     "zoomlevel": 5.8,
     "X": -56.059343,
     "Y": -22.872687
    },
    {
     "ProvName": "Demerara\/Mahaica",
     "zoomlevel": 5.8,
     "X": -58.113857,
     "Y": 6.496521
    },
    {
     "ProvName": "Alto Paraná",
     "zoomlevel": 5.8,
     "X": -54.951564,
     "Y": -25.378573
    },
    {
     "ProvName": "Aïn Temouchent",
     "zoomlevel": 5.8,
     "X": -1.030812,
     "Y": 35.335098
    },
    {
     "ProvName": "Caaguazú",
     "zoomlevel": 5.8,
     "X": -55.875988,
     "Y": -25.19604
    },
    {
     "ProvName": "Caazapá",
     "zoomlevel": 5.8,
     "X": -56.032398,
     "Y": -26.232832
    },
    {
     "ProvName": "Canindiyú",
     "zoomlevel": 5.8,
     "X": -55.209736,
     "Y": -24.232773
    },
    {
     "ProvName": "Atlántida",
     "zoomlevel": 5.8,
     "X": -87.149703,
     "Y": 15.668726
    },
    {
     "ProvName": "Bingöl",
     "zoomlevel": 5.8,
     "X": 40.703131,
     "Y": 39.06333
    },
    {
     "ProvName": "Itapúa",
     "zoomlevel": 5.8,
     "X": -55.708183,
     "Y": -26.81507
    },
    {
     "ProvName": "Ceará",
     "zoomlevel": 5.8,
     "X": -39.625791,
     "Y": -5.098327
    },
    {
     "ProvName": "Piauí",
     "zoomlevel": 3.38,
     "X": -42.98794,
     "Y": -7.410713
    },
    {
     "ProvName": "Colón",
     "zoomlevel": 5.8,
     "X": -85.604932,
     "Y": 15.648674
    },
    {
     "ProvName": "Alagoas",
     "zoomlevel": 5.8,
     "X": -36.625529,
     "Y": -9.514172
    },
    {
     "ProvName": "Bahia",
     "zoomlevel": 5.8,
     "X": -41.702934,
     "Y": -12.47489
    },
    {
     "ProvName": "Espírito Santo",
     "zoomlevel": 3.38,
     "X": -40.664966,
     "Y": -19.566969
    },
    {
     "ProvName": "Paraíba",
     "zoomlevel": 5.8,
     "X": -36.82485,
     "Y": -7.118391
    },
    {
     "ProvName": "Rio de Janeiro",
     "zoomlevel": 3.38,
     "X": -42.663042,
     "Y": -22.190419
    },
    {
     "ProvName": "Islas de la Bahìa",
     "zoomlevel": 5.8,
     "X": -86.448134,
     "Y": 16.336958
    },
    {
     "ProvName": "Bururi",
     "zoomlevel": 5.8,
     "X": 29.55279,
     "Y": -3.893307
    },
    {
     "ProvName": "Rio Grande do Norte",
     "zoomlevel": 5.8,
     "X": -36.672232,
     "Y": -5.833948
    },
    {
     "ProvName": "Sergipe",
     "zoomlevel": 5.8,
     "X": -37.442768,
     "Y": -10.57794
    },
    {
     "ProvName": "Manitoba",
     "zoomlevel": 3.8,
     "X": -97.437415,
     "Y": 54.920401
    },
    {
     "ProvName": "Granada",
     "zoomlevel": 5.8,
     "X": -85.841109,
     "Y": 11.871559
    },
    {
     "ProvName": "Francisco Morazán",
     "zoomlevel": 5.8,
     "X": -87.178606,
     "Y": 14.292909
    },
    {
     "ProvName": "Intibucá",
     "zoomlevel": 5.8,
     "X": -88.210402,
     "Y": 14.332785
    },
    {
     "ProvName": "Gracias a Dios",
     "zoomlevel": 5.8,
     "X": -84.360803,
     "Y": 15.241642
    },
    {
     "ProvName": "Olancho",
     "zoomlevel": 5.8,
     "X": -85.92878,
     "Y": 14.836412
    },
    {
     "ProvName": "La Paz",
     "zoomlevel": 5.8,
     "X": -87.883188,
     "Y": 14.103447
    },
    {
     "ProvName": "Yoro",
     "zoomlevel": 5.8,
     "X": -87.193234,
     "Y": 15.307475
    },
    {
     "ProvName": "Atlantico Sur",
     "zoomlevel": 5.8,
     "X": -84.218884,
     "Y": 12.329752
    },
    {
     "ProvName": "Valle",
     "zoomlevel": 5.8,
     "X": -87.594103,
     "Y": 13.546788
    },
    {
     "ProvName": "Comayagua",
     "zoomlevel": 5.8,
     "X": -87.631705,
     "Y": 14.626191
    },
    {
     "ProvName": "Cortés",
     "zoomlevel": 5.8,
     "X": -87.991997,
     "Y": 15.406224
    },
    {
     "ProvName": "Lempira",
     "zoomlevel": 5.8,
     "X": -88.595162,
     "Y": 14.408369
    },
    {
     "ProvName": "Ocotepeque",
     "zoomlevel": 5.8,
     "X": -89.047987,
     "Y": 14.491143
    },
    {
     "ProvName": "Carazo",
     "zoomlevel": 5.8,
     "X": -86.257687,
     "Y": 11.748663
    },
    {
     "ProvName": "Makamba",
     "zoomlevel": 5.8,
     "X": 29.71771,
     "Y": -4.24626
    },
    {
     "ProvName": "Jinotega",
     "zoomlevel": 5.8,
     "X": -85.502957,
     "Y": 13.74741
    },
    {
     "ProvName": "Atlantico Norte",
     "zoomlevel": 5.8,
     "X": -84.215341,
     "Y": 13.995285
    },
    {
     "ProvName": "Masaya",
     "zoomlevel": 5.8,
     "X": -86.095121,
     "Y": 12.009778
    },
    {
     "ProvName": "Choluteca",
     "zoomlevel": 5.8,
     "X": -87.114543,
     "Y": 13.352149
    },
    {
     "ProvName": "El Para?so",
     "zoomlevel": 5.8,
     "X": -86.469033,
     "Y": 14.019299
    },
    {
     "ProvName": "Chinandega",
     "zoomlevel": 5.8,
     "X": -87.084883,
     "Y": 12.85127
    },
    {
     "ProvName": "Matagalpa",
     "zoomlevel": 5.8,
     "X": -85.515546,
     "Y": 12.947525
    },
    {
     "ProvName": "Nueva Segovia",
     "zoomlevel": 5.8,
     "X": -86.173607,
     "Y": 13.731417
    },
    {
     "ProvName": "Plateau",
     "zoomlevel": 5.8,
     "X": 2.624991,
     "Y": 7.18692
    },
    {
     "ProvName": "Boaco",
     "zoomlevel": 5.8,
     "X": -85.512614,
     "Y": 12.472121
    },
    {
     "ProvName": "Chontales",
     "zoomlevel": 5.8,
     "X": -85.168684,
     "Y": 12.059294
    },
    {
     "ProvName": "Roraima",
     "zoomlevel": 5.8,
     "X": -61.40579,
     "Y": 2.065531
    },
    {
     "ProvName": "East Berbice\/Corentyne",
     "zoomlevel": 5.8,
     "X": -57.661537,
     "Y": 3.388046
    },
    {
     "ProvName": "Essequibo\/West Demera",
     "zoomlevel": 5.8,
     "X": -58.457517,
     "Y": 6.604357
    },
    {
     "ProvName": "Potaro\/Siparuni Mahdia",
     "zoomlevel": 5.8,
     "X": -59.279738,
     "Y": 4.822626
    },
    {
     "ProvName": "Upper Demerara\/Berbice",
     "zoomlevel": 5.8,
     "X": -58.280134,
     "Y": 5.382364
    },
    {
     "ProvName": "Upper Takutu\/Esseququibo",
     "zoomlevel": 5.8,
     "X": -58.983801,
     "Y": 2.814453
    },
    {
     "ProvName": "Mono",
     "zoomlevel": 5.8,
     "X": 1.827393,
     "Y": 6.522839
    },
    {
     "ProvName": "Barima\/Waini",
     "zoomlevel": 5.8,
     "X": -59.743388,
     "Y": 7.620071
    },
    {
     "ProvName": "Mahaica\/Berbice",
     "zoomlevel": 5.8,
     "X": -57.838216,
     "Y": 6.219835
    },
    {
     "ProvName": "Tizi Ouzou",
     "zoomlevel": 5.8,
     "X": 4.223325,
     "Y": 36.679999
    },
    {
     "ProvName": "Cuyuni\/Mazaruni",
     "zoomlevel": 5.8,
     "X": -59.949543,
     "Y": 6.15562
    },
    {
     "ProvName": "Diyarbakir",
     "zoomlevel": 5.8,
     "X": 40.341739,
     "Y": 38.126268
    },
    {
     "ProvName": "Gharb Dârfûr (West Darfur)",
     "zoomlevel": 5.8,
     "X": 23.236086,
     "Y": 13.414447
    },
    {
     "ProvName": "Sudurnes",
     "zoomlevel": 4,
     "X": -22.149368,
     "Y": 63.973657
    },
    {
     "ProvName": "Vesturland",
     "zoomlevel": 4,
     "X": -21.685493,
     "Y": 64.752141
    },
    {
     "ProvName": "Ouest",
     "zoomlevel": 5.8,
     "X": 10.65636,
     "Y": 5.512817
    },
    {
     "ProvName": "Capital region",
     "zoomlevel": 4,
     "X": -21.545076,
     "Y": 64.2593
    },
    {
     "ProvName": "Connacht",
     "zoomlevel": 5.8,
     "X": -8.858428,
     "Y": 53.746486
    },
    {
     "ProvName": "Perlis",
     "zoomlevel": 5.8,
     "X": 100.080026,
     "Y": 6.445705
    },
    {
     "ProvName": "Sud-Ouest",
     "zoomlevel": 5.8,
     "X": 9.297011,
     "Y": 5.209572
    },
    {
     "ProvName": "Agadez",
     "zoomlevel": 3.8,
     "X": 10.50731,
     "Y": 19.479833
    },
    {
     "ProvName": "Mambéré-Kadéï",
     "zoomlevel": 5.8,
     "X": 15.911519,
     "Y": 4.564589
    },
    {
     "ProvName": "Diourbel",
     "zoomlevel": 5.8,
     "X": -16.185819,
     "Y": 14.7823
    },
    {
     "ProvName": "Sangha-Mbaéré",
     "zoomlevel": 5.8,
     "X": 16.270774,
     "Y": 3.473362
    },
    {
     "ProvName": "Pomeroon\/Supenaam",
     "zoomlevel": 5.8,
     "X": -58.818895,
     "Y": 7.180125
    },
    {
     "ProvName": "Amapá",
     "zoomlevel": 5.8,
     "X": -51.96555,
     "Y": 1.456113
    },
    {
     "ProvName": "Ontario",
     "zoomlevel": 3.8,
     "X": -85.829067,
     "Y": 50.068231
    },
    {
     "ProvName": "Quebec",
     "zoomlevel": 3.8,
     "X": -71.755869,
     "Y": 53.390446
    },
    {
     "ProvName": "New Brunswick",
     "zoomlevel": 5.8,
     "X": -66.377398,
     "Y": 46.629019
    },
    {
     "ProvName": "Nova Scotia",
     "zoomlevel": 5.8,
     "X": -63.311022,
     "Y": 45.153797
    },
    {
     "ProvName": "Newfoundland",
     "zoomlevel": 3.8,
     "X": -60.451754,
     "Y": 52.858039
    },
    {
     "ProvName": "Mus",
     "zoomlevel": 5.8,
     "X": 41.84551,
     "Y": 39.020235
    },
    {
     "ProvName": "Prince Edward Island",
     "zoomlevel": 5.8,
     "X": -63.249553,
     "Y": 46.400688
    },
    {
     "ProvName": "Nordhurland eystra",
     "zoomlevel": 4,
     "X": -17.122921,
     "Y": 65.563368
    },
    {
     "ProvName": "Sudurland",
     "zoomlevel": 4,
     "X": -19.17679,
     "Y": 64.146552
    },
    {
     "ProvName": "P'ing-tung",
     "zoomlevel": 5.8,
     "X": 120.674035,
     "Y": 22.488242
    },
    {
     "ProvName": "Murcia",
     "zoomlevel": 5.8,
     "X": -1.483496,
     "Y": 38.005783
    },
    {
     "ProvName": "Ceuta",
     "zoomlevel": 5.8,
     "X": -5.347443,
     "Y": 35.892499
    },
    {
     "ProvName": "Melilla",
     "zoomlevel": 5.8,
     "X": -2.944692,
     "Y": 35.295775
    },
    {
     "ProvName": "T'ai-nan municipality",
     "zoomlevel": 5.8,
     "X": 120.333507,
     "Y": 23.153981
    },
    {
     "ProvName": "Hsin-chu city",
     "zoomlevel": 5.8,
     "X": 120.952709,
     "Y": 24.782579
    },
    {
     "ProvName": "Azores (Acores)",
     "zoomlevel": 5.8,
     "X": -27.335112,
     "Y": 38.366194
    },
    {
     "ProvName": "Madeira",
     "zoomlevel": 5.8,
     "X": -16.943808,
     "Y": 32.756217
    },
    {
     "ProvName": "Hsin-chu",
     "zoomlevel": 5.8,
     "X": 121.160844,
     "Y": 24.687341
    },
    {
     "ProvName": "Fianarantsoa",
     "zoomlevel": 4.230000000000001,
     "X": 46.879498,
     "Y": -21.850102
    },
    {
     "ProvName": "Mahajanga",
     "zoomlevel": 4.230000000000001,
     "X": 46.687658,
     "Y": -16.547774
    },
    {
     "ProvName": "Toamasina",
     "zoomlevel": 4.230000000000001,
     "X": 48.771816,
     "Y": -17.809023
    },
    {
     "ProvName": "Toliara",
     "zoomlevel": 4.230000000000001,
     "X": 45.025042,
     "Y": -22.593199
    },
    {
     "ProvName": "Asturias",
     "zoomlevel": 5.8,
     "X": -5.980816,
     "Y": 43.306119
    },
    {
     "ProvName": "Galicia",
     "zoomlevel": 5.8,
     "X": -7.908851,
     "Y": 42.76309
    },
    {
     "ProvName": "Miao-li",
     "zoomlevel": 5.8,
     "X": 120.916766,
     "Y": 24.4887
    },
    {
     "ProvName": "La Rioja",
     "zoomlevel": 5.8,
     "X": -2.495569,
     "Y": 42.28048
    },
    {
     "ProvName": "an-Nîl-al-Abyad (White Nile)",
     "zoomlevel": 5.8,
     "X": 32.288081,
     "Y": 13.443696
    },
    {
     "ProvName": "País Vasco",
     "zoomlevel": 5.8,
     "X": -2.610453,
     "Y": 43.063334
    },
    {
     "ProvName": "Sud",
     "zoomlevel": 5.8,
     "X": 11.558989,
     "Y": 2.760624
    },
    {
     "ProvName": "T'ai-pei municipality",
     "zoomlevel": 5.8,
     "X": 121.559465,
     "Y": 25.082205
    },
    {
     "ProvName": "Bitlis",
     "zoomlevel": 5.8,
     "X": 42.394174,
     "Y": 38.544592
    },
    {
     "ProvName": "Nana-Mambéré",
     "zoomlevel": 5.8,
     "X": 15.370873,
     "Y": 5.702248
    },
    {
     "ProvName": "Drenthe",
     "zoomlevel": 5.8,
     "X": 6.617602,
     "Y": 52.86158
    },
    {
     "ProvName": "Ouham-Pendé",
     "zoomlevel": 5.8,
     "X": 16.129536,
     "Y": 6.729579
    },
    {
     "ProvName": "Bamingui-Bangoran",
     "zoomlevel": 5.8,
     "X": 20.577395,
     "Y": 8.418967
    },
    {
     "ProvName": "Nana-Gribizi",
     "zoomlevel": 5.8,
     "X": 19.332828,
     "Y": 7.19119
    },
    {
     "ProvName": "Riga city",
     "zoomlevel": 5.8,
     "X": 24.126577,
     "Y": 56.972631
    },
    {
     "ProvName": "Bakool",
     "zoomlevel": 5.8,
     "X": 43.942324,
     "Y": 4.209007
    },
    {
     "ProvName": "Bay",
     "zoomlevel": 5.8,
     "X": 43.566433,
     "Y": 2.652972
    },
    {
     "ProvName": "Kemo",
     "zoomlevel": 5.8,
     "X": 19.296705,
     "Y": 5.800763
    },
    {
     "ProvName": "Dakar",
     "zoomlevel": 5.8,
     "X": -17.281872,
     "Y": 14.764948
    },
    {
     "ProvName": "Southern Province",
     "zoomlevel": 5.8,
     "X": -12.025331,
     "Y": 7.785268
    },
    {
     "ProvName": "Western Area",
     "zoomlevel": 5.8,
     "X": -13.107909,
     "Y": 8.338115
    },
    {
     "ProvName": "Northern Province",
     "zoomlevel": 5.8,
     "X": -11.989198,
     "Y": 9.137365
    },
    {
     "ProvName": "Luxembourg",
     "zoomlevel": 5.8,
     "X": 6.064088,
     "Y": 49.626797
    },
    {
     "ProvName": "Lombardia",
     "zoomlevel": 5.8,
     "X": 9.773187,
     "Y": 45.622626
    },
    {
     "ProvName": "Møre og Romsdal",
     "zoomlevel": 4,
     "X": 7.695488,
     "Y": 62.6028
    },
    {
     "ProvName": "Sør-Trøndelag",
     "zoomlevel": 4,
     "X": 10.415194,
     "Y": 63.131366
    },
    {
     "ProvName": "Leningrad",
     "zoomlevel": 4.3,
     "X": 31.709501,
     "Y": 60.007141
    },
    {
     "ProvName": "Fatick",
     "zoomlevel": 5.8,
     "X": -16.236612,
     "Y": 14.224689
    },
    {
     "ProvName": "Muslim Mindanao",
     "zoomlevel": 5.8,
     "X": 123.107966,
     "Y": 6.626852
    },
    {
     "ProvName": "Mimaropa",
     "zoomlevel": 5.8,
     "X": 119.899059,
     "Y": 11.346068
    },
    {
     "ProvName": "Western Visayas",
     "zoomlevel": 5.8,
     "X": 122.914779,
     "Y": 10.682586
    },
    {
     "ProvName": "Ngozi",
     "zoomlevel": 5.8,
     "X": 29.921001,
     "Y": -2.862397
    },
    {
     "ProvName": "Louga",
     "zoomlevel": 5.8,
     "X": -15.397413,
     "Y": 15.371906
    },
    {
     "ProvName": "Tombali",
     "zoomlevel": 5.8,
     "X": -15.001247,
     "Y": 11.33221
    },
    {
     "ProvName": "Thiès",
     "zoomlevel": 5.8,
     "X": -16.763176,
     "Y": 14.83635
    },
    {
     "ProvName": "Bissau",
     "zoomlevel": 5.8,
     "X": -15.62271,
     "Y": 11.881744
    },
    {
     "ProvName": "Grand Kru",
     "zoomlevel": 5.8,
     "X": -8.232572,
     "Y": 4.824883
    },
    {
     "ProvName": "Tehran",
     "zoomlevel": 5.8,
     "X": 51.875116,
     "Y": 35.55546
    },
    {
     "ProvName": "Cacheu",
     "zoomlevel": 5.8,
     "X": -16.023355,
     "Y": 12.228297
    },
    {
     "ProvName": "Oio",
     "zoomlevel": 5.8,
     "X": -15.267706,
     "Y": 12.283321
    },
    {
     "ProvName": "Quinara",
     "zoomlevel": 5.8,
     "X": -15.19129,
     "Y": 11.649191
    },
    {
     "ProvName": "Alborz",
     "zoomlevel": 5.8,
     "X": 50.824647,
     "Y": 35.944072
    },
    {
     "ProvName": "Ziguinchor",
     "zoomlevel": 5.8,
     "X": -16.375313,
     "Y": 12.784806
    },
    {
     "ProvName": "Guadalcanal",
     "zoomlevel": 5.8,
     "X": 160.177277,
     "Y": -9.628108
    },
    {
     "ProvName": "Saint Petersburg City",
     "zoomlevel": 4.3,
     "X": 30.185374,
     "Y": 59.899065
    },
    {
     "ProvName": "Bafatá",
     "zoomlevel": 5.8,
     "X": -14.712582,
     "Y": 12.157981
    },
    {
     "ProvName": "Cabañas",
     "zoomlevel": 5.8,
     "X": -88.709366,
     "Y": 13.885081
    },
    {
     "ProvName": "Brest",
     "zoomlevel": 4.3,
     "X": 25.483365,
     "Y": 52.37625
    },
    {
     "ProvName": "Gabú",
     "zoomlevel": 5.8,
     "X": -14.117138,
     "Y": 12.157841
    },
    {
     "ProvName": "Maryland",
     "zoomlevel": 5.8,
     "X": -7.790561,
     "Y": 4.727274
    },
    {
     "ProvName": "Homel (Gomel)",
     "zoomlevel": 4.3,
     "X": 29.652357,
     "Y": 52.291933
    },
    {
     "ProvName": "Mahilyou (Mogilyov)",
     "zoomlevel": 4.3,
     "X": 30.414789,
     "Y": 53.604959
    },
    {
     "ProvName": "Vitebsk",
     "zoomlevel": 4.3,
     "X": 28.903014,
     "Y": 55.214635
    },
    {
     "ProvName": "Bryansk",
     "zoomlevel": 4.3,
     "X": 33.404678,
     "Y": 52.906987
    },
    {
     "ProvName": "Smolensk",
     "zoomlevel": 4.3,
     "X": 32.993037,
     "Y": 54.950849
    },
    {
     "ProvName": "Sinoe",
     "zoomlevel": 5.8,
     "X": -8.84735,
     "Y": 5.374966
    },
    {
     "ProvName": "Al-Qaseem",
     "zoomlevel": 4.5,
     "X": 43.220287,
     "Y": 25.945886
    },
    {
     "ProvName": "Hrodno (Grodno)",
     "zoomlevel": 4.3,
     "X": 25.165803,
     "Y": 53.71587
    },
    {
     "ProvName": "Minsk (Mensk)",
     "zoomlevel": 4.3,
     "X": 27.676717,
     "Y": 53.76571
    },
    {
     "ProvName": "Ouaka",
     "zoomlevel": 5.8,
     "X": 20.749856,
     "Y": 6.126691
    },
    {
     "ProvName": "Ouham",
     "zoomlevel": 5.8,
     "X": 17.88642,
     "Y": 6.920501
    },
    {
     "ProvName": "Janûb Dârfûr (South Darfur)",
     "zoomlevel": 3.8,
     "X": 25.230834,
     "Y": 10.934057
    },
    {
     "ProvName": "al-Buhayrât (Lakes)",
     "zoomlevel": 5.8,
     "X": 29.952625,
     "Y": 6.608183
    },
    {
     "ProvName": "Vakaga",
     "zoomlevel": 5.8,
     "X": 22.508213,
     "Y": 9.806419
    },
    {
     "ProvName": "Emilia-Romagna",
     "zoomlevel": 5.8,
     "X": 11.016049,
     "Y": 44.538289
    },
    {
     "ProvName": "Liguria",
     "zoomlevel": 5.8,
     "X": 8.674666,
     "Y": 44.264504
    },
    {
     "ProvName": "Sardegna",
     "zoomlevel": 5.8,
     "X": 9.02974,
     "Y": 40.090031
    },
    {
     "ProvName": "Toscana",
     "zoomlevel": 5.8,
     "X": 11.124784,
     "Y": 43.453444
    },
    {
     "ProvName": "Baleares",
     "zoomlevel": 5.8,
     "X": 2.907565,
     "Y": 39.582688
    },
    {
     "ProvName": "al-Jazîrah (Gezira)",
     "zoomlevel": 5.8,
     "X": 33.281277,
     "Y": 14.612481
    },
    {
     "ProvName": "Basilicata",
     "zoomlevel": 5.8,
     "X": 16.075418,
     "Y": 40.500936
    },
    {
     "ProvName": "Calabria",
     "zoomlevel": 5.8,
     "X": 16.347118,
     "Y": 39.072431
    },
    {
     "ProvName": "Campania",
     "zoomlevel": 5.8,
     "X": 14.833782,
     "Y": 40.863464
    },
    {
     "ProvName": "Obalno Krasko",
     "zoomlevel": 5.8,
     "X": 13.87674,
     "Y": 45.625799
    },
    {
     "ProvName": "Molise",
     "zoomlevel": 5.8,
     "X": 14.593442,
     "Y": 41.686834
    },
    {
     "ProvName": "New T'ai-pei municipality",
     "zoomlevel": 5.8,
     "X": 121.59,
     "Y": 24.98609
    },
    {
     "ProvName": "Puglia",
     "zoomlevel": 5.8,
     "X": 16.621037,
     "Y": 40.985914
    },
    {
     "ProvName": "Sicilia (Sicily)",
     "zoomlevel": 5.8,
     "X": 14.147421,
     "Y": 37.590738
    },
    {
     "ProvName": "Abruzzi",
     "zoomlevel": 5.8,
     "X": 13.847613,
     "Y": 42.230232
    },
    {
     "ProvName": "Lazio",
     "zoomlevel": 5.8,
     "X": 12.759081,
     "Y": 41.981105
    },
    {
     "ProvName": "Marche",
     "zoomlevel": 5.8,
     "X": 13.104736,
     "Y": 43.370358
    },
    {
     "ProvName": "Umbria",
     "zoomlevel": 5.8,
     "X": 12.488548,
     "Y": 42.964912
    },
    {
     "ProvName": "Kosovo",
     "zoomlevel": 5.8,
     "X": 20.873404,
     "Y": 42.57323
    },
    {
     "ProvName": "al-Qadârif (Gedarif)",
     "zoomlevel": 5.8,
     "X": 35.159595,
     "Y": 14.114183
    },
    {
     "ProvName": "Al-Madinah Al-Monawarah",
     "zoomlevel": 4.5,
     "X": 39.518203,
     "Y": 24.890206
    },
    {
     "ProvName": "Ha'il",
     "zoomlevel": 4.5,
     "X": 41.608274,
     "Y": 27.347623
    },
    {
     "ProvName": "Karak",
     "zoomlevel": 5.8,
     "X": 35.771808,
     "Y": 31.128126
    },
    {
     "ProvName": "Zarqa",
     "zoomlevel": 5.8,
     "X": 36.843928,
     "Y": 31.825057
    },
    {
     "ProvName": "Al-Hudud ash Shamaliyah (Northern)",
     "zoomlevel": 4.5,
     "X": 42.074134,
     "Y": 29.938119
    },
    {
     "ProvName": "Al-Jouf",
     "zoomlevel": 4.5,
     "X": 38.740756,
     "Y": 29.678472
    },
    {
     "ProvName": "Gharb-al-Istiwâ´îyah (West Equatoria)",
     "zoomlevel": 5.8,
     "X": 28.667294,
     "Y": 5.57733
    },
    {
     "ProvName": "T'ao-yuan",
     "zoomlevel": 5.8,
     "X": 121.263083,
     "Y": 24.897864
    },
    {
     "ProvName": "Bahr-al-Jabal (Central Equatoria)",
     "zoomlevel": 5.8,
     "X": 31.23319,
     "Y": 4.781287
    },
    {
     "ProvName": "Haute-Kotto",
     "zoomlevel": 5.8,
     "X": 22.919662,
     "Y": 7.464317
    },
    {
     "ProvName": "Haut-Mbomou",
     "zoomlevel": 5.8,
     "X": 25.580821,
     "Y": 6.301176
    },
    {
     "ProvName": "Mbomou",
     "zoomlevel": 5.8,
     "X": 23.392418,
     "Y": 5.505918
    },
    {
     "ProvName": "A´âlî-an-Nîl (Upper Nile)",
     "zoomlevel": 5.8,
     "X": 32.775649,
     "Y": 9.908454
    },
    {
     "ProvName": "Junqalî (Jungoli)",
     "zoomlevel": 5.8,
     "X": 32.294655,
     "Y": 7.413479
    },
    {
     "ProvName": "al-Wahdah (Unity)",
     "zoomlevel": 5.8,
     "X": 29.923946,
     "Y": 8.889665
    },
    {
     "ProvName": "Warab (Warap)",
     "zoomlevel": 5.8,
     "X": 28.762451,
     "Y": 8.080841
    },
    {
     "ProvName": "Chang-hua",
     "zoomlevel": 5.8,
     "X": 120.481939,
     "Y": 23.959368
    },
    {
     "ProvName": "Gharb Bahr-al-Ghazâl (West Bahr-al-Ghazal)",
     "zoomlevel": 5.8,
     "X": 26.215837,
     "Y": 8.174633
    },
    {
     "ProvName": "Nahr-an-Nil (River Nile)",
     "zoomlevel": 4.5,
     "X": 33.445566,
     "Y": 18.340368
    },
    {
     "ProvName": "Rïga region (Pieriga)",
     "zoomlevel": 5.8,
     "X": 24.075974,
     "Y": 56.920621
    },
    {
     "ProvName": "Kalimantan Barat",
     "zoomlevel": 5.8,
     "X": 111.154765,
     "Y": -0.09475
    },
    {
     "ProvName": "ash-Shamâlîyah (Northern)",
     "zoomlevel": 4.5,
     "X": 29.34705,
     "Y": 19.591278
    },
    {
     "ProvName": "Lampung",
     "zoomlevel": 5.8,
     "X": 105.0306,
     "Y": -4.919254
    },
    {
     "ProvName": "al-Khartûm (Khartoum)",
     "zoomlevel": 3.8,
     "X": 32.785181,
     "Y": 15.844324
    },
    {
     "ProvName": "Sinnâr (Sennar)",
     "zoomlevel": 5.8,
     "X": 34.01392,
     "Y": 13.033496
    },
    {
     "ProvName": "Shamâl Dârfûr (North Darfur)",
     "zoomlevel": 3.8,
     "X": 25.709228,
     "Y": 16.350289
    },
    {
     "ProvName": "Tipaza",
     "zoomlevel": 5.8,
     "X": 2.312062,
     "Y": 36.543176
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 34.568471,
     "Y": 0.500224
    },
    {
     "ProvName": "Sharq-al-Istiwâ'îyah (East Equatoria)",
     "zoomlevel": 5.8,
     "X": 33.368007,
     "Y": 4.90117
    },
    {
     "ProvName": "Kirundo",
     "zoomlevel": 5.8,
     "X": 30.153918,
     "Y": -2.532389
    },
    {
     "ProvName": "North Eastern",
     "zoomlevel": 5.8,
     "X": 40.216813,
     "Y": 1.31973
    },
    {
     "ProvName": "Kgatleng",
     "zoomlevel": 4.8,
     "X": 26.348484,
     "Y": -24.144901
    },
    {
     "ProvName": "Friesland",
     "zoomlevel": 5.8,
     "X": 5.797223,
     "Y": 53.088342
    },
    {
     "ProvName": "Diekirch",
     "zoomlevel": 5.8,
     "X": 5.968986,
     "Y": 49.921397
    },
    {
     "ProvName": "Grevenmacher",
     "zoomlevel": 5.8,
     "X": 6.342429,
     "Y": 49.684377
    },
    {
     "ProvName": "Pashchimanchal (Western)",
     "zoomlevel": 5.8,
     "X": 83.843184,
     "Y": 28.228006
    },
    {
     "ProvName": "Sumatera Selatan",
     "zoomlevel": 5.8,
     "X": 104.18728,
     "Y": -3.230832
    },
    {
     "ProvName": "Pernik",
     "zoomlevel": 5.8,
     "X": 22.846415,
     "Y": 42.624926
    },
    {
     "ProvName": "Bangka-Belitung",
     "zoomlevel": 5.8,
     "X": 106.533124,
     "Y": -2.431365
    },
    {
     "ProvName": "Kweneng",
     "zoomlevel": 4.8,
     "X": 24.685166,
     "Y": -23.862913
    },
    {
     "ProvName": "Santiago del Estero",
     "zoomlevel": 5.8,
     "X": -63.292782,
     "Y": -27.726643
    },
    {
     "ProvName": "South East",
     "zoomlevel": 4.8,
     "X": 25.783993,
     "Y": -24.928989
    },
    {
     "ProvName": "Aust-Agder",
     "zoomlevel": 5.8,
     "X": 7.966618,
     "Y": 58.896197
    },
    {
     "ProvName": "Hordaland",
     "zoomlevel": 5.8,
     "X": 6.307619,
     "Y": 60.344968
    },
    {
     "ProvName": "Rogaland",
     "zoomlevel": 5.8,
     "X": 6.219193,
     "Y": 59.109886
    },
    {
     "ProvName": "Sogn og Fjordane",
     "zoomlevel": 5.8,
     "X": 6.576291,
     "Y": 61.424928
    },
    {
     "ProvName": "Gabrovo",
     "zoomlevel": 5.8,
     "X": 25.233622,
     "Y": 42.932209
    },
    {
     "ProvName": "Vest-Agder",
     "zoomlevel": 5.8,
     "X": 7.199424,
     "Y": 58.498494
    },
    {
     "ProvName": "Chia-i",
     "zoomlevel": 5.8,
     "X": 120.523168,
     "Y": 23.453525
    },
    {
     "ProvName": "Chia-i city",
     "zoomlevel": 5.8,
     "X": 120.441861,
     "Y": 23.482917
    },
    {
     "ProvName": "Akershus",
     "zoomlevel": 5.8,
     "X": 11.212164,
     "Y": 60.039944
    },
    {
     "ProvName": "Buskerud",
     "zoomlevel": 5.8,
     "X": 9.087999,
     "Y": 60.319124
    },
    {
     "ProvName": "Hedmark",
     "zoomlevel": 5.8,
     "X": 11.421437,
     "Y": 61.468881
    },
    {
     "ProvName": "Alytus",
     "zoomlevel": 5.8,
     "X": 24.126007,
     "Y": 54.21665
    },
    {
     "ProvName": "Oppland",
     "zoomlevel": 5.8,
     "X": 9.345356,
     "Y": 61.430384
    },
    {
     "ProvName": "Oslo",
     "zoomlevel": 5.8,
     "X": 10.652325,
     "Y": 59.96926
    },
    {
     "ProvName": "Hua-lien",
     "zoomlevel": 5.8,
     "X": 121.376867,
     "Y": 23.754538
    },
    {
     "ProvName": "Telemark",
     "zoomlevel": 5.8,
     "X": 8.529378,
     "Y": 59.536512
    },
    {
     "ProvName": "Vestfold",
     "zoomlevel": 5.8,
     "X": 10.11719,
     "Y": 59.340011
    },
    {
     "ProvName": "Ostfold",
     "zoomlevel": 5.8,
     "X": 11.303139,
     "Y": 59.380456
    },
    {
     "ProvName": "Nord-Trondelag",
     "zoomlevel": 4,
     "X": 12.295026,
     "Y": 64.282592
    },
    {
     "ProvName": "Banten",
     "zoomlevel": 5.8,
     "X": 106.111098,
     "Y": -6.453538
    },
    {
     "ProvName": "Kurzeme",
     "zoomlevel": 5.8,
     "X": 21.994383,
     "Y": 56.929094
    },
    {
     "ProvName": "Marijampole",
     "zoomlevel": 5.8,
     "X": 23.163159,
     "Y": 54.700987
    },
    {
     "ProvName": "Klaipeda",
     "zoomlevel": 5.8,
     "X": 21.54375,
     "Y": 55.684191
    },
    {
     "ProvName": "Najran",
     "zoomlevel": 4.5,
     "X": 45.831468,
     "Y": 18.287812
    },
    {
     "ProvName": "Southern",
     "zoomlevel": 4.8,
     "X": 24.462346,
     "Y": -24.923917
    },
    {
     "ProvName": "Telsiai",
     "zoomlevel": 5.8,
     "X": 22.130787,
     "Y": 55.988732
    },
    {
     "ProvName": "Spodnjeposavska",
     "zoomlevel": 5.8,
     "X": 15.43866,
     "Y": 45.954942
    },
    {
     "ProvName": "Zasavska",
     "zoomlevel": 5.8,
     "X": 15.012384,
     "Y": 46.136478
    },
    {
     "ProvName": "Friuli-Venezia Giulia",
     "zoomlevel": 5.8,
     "X": 13.049925,
     "Y": 46.160513
    },
    {
     "ProvName": "Trentino-Alto Adige",
     "zoomlevel": 5.8,
     "X": 11.28154,
     "Y": 46.4437
    },
    {
     "ProvName": "Veneto",
     "zoomlevel": 5.8,
     "X": 11.853827,
     "Y": 45.661471
    },
    {
     "ProvName": "T'ai-chung municipality",
     "zoomlevel": 5.8,
     "X": 120.892891,
     "Y": 24.244812
    },
    {
     "ProvName": "Bratislava",
     "zoomlevel": 5.8,
     "X": 17.183017,
     "Y": 48.319757
    },
    {
     "ProvName": "Yun-lin",
     "zoomlevel": 5.8,
     "X": 120.380174,
     "Y": 23.685706
    },
    {
     "ProvName": "Simba (Chimbu)",
     "zoomlevel": 5.8,
     "X": 144.923334,
     "Y": -6.344465
    },
    {
     "ProvName": "Bansk Bystrica",
     "zoomlevel": 5.8,
     "X": 19.506176,
     "Y": 48.514619
    },
    {
     "ProvName": "Northern Territory",
     "zoomlevel": 3.81,
     "X": 133.366551,
     "Y": -19.415442
    },
    {
     "ProvName": "Latgale",
     "zoomlevel": 5.8,
     "X": 27.153674,
     "Y": 56.392318
    },
    {
     "ProvName": "T'ai-tung",
     "zoomlevel": 5.8,
     "X": 121.039701,
     "Y": 22.865944
    },
    {
     "ProvName": "Kaunas",
     "zoomlevel": 5.8,
     "X": 23.882319,
     "Y": 55.083546
    },
    {
     "ProvName": "Panevezys",
     "zoomlevel": 5.8,
     "X": 24.777817,
     "Y": 55.92158
    },
    {
     "ProvName": "Belait",
     "zoomlevel": 5.8,
     "X": 114.501551,
     "Y": 4.366696
    },
    {
     "ProvName": "Brunei and Muara",
     "zoomlevel": 5.8,
     "X": 114.897152,
     "Y": 4.900698
    },
    {
     "ProvName": "Siauliai",
     "zoomlevel": 5.8,
     "X": 23.26555,
     "Y": 55.950618
    },
    {
     "ProvName": "Jakarta Raya",
     "zoomlevel": 5.8,
     "X": 106.849988,
     "Y": -6.209145
    },
    {
     "ProvName": "Temburong",
     "zoomlevel": 5.8,
     "X": 115.166399,
     "Y": 4.595318
    },
    {
     "ProvName": "Tutong",
     "zoomlevel": 5.8,
     "X": 114.687817,
     "Y": 4.604581
    },
    {
     "ProvName": "Taurage",
     "zoomlevel": 5.8,
     "X": 22.51772,
     "Y": 55.327234
    },
    {
     "ProvName": "Talas",
     "zoomlevel": 5.8,
     "X": 72.129518,
     "Y": 42.433915
    },
    {
     "ProvName": "Utena",
     "zoomlevel": 5.8,
     "X": 25.664543,
     "Y": 55.48575
    },
    {
     "ProvName": "Vilnius",
     "zoomlevel": 5.8,
     "X": 25.243681,
     "Y": 54.825912
    },
    {
     "ProvName": "Qacha's Nek",
     "zoomlevel": 5.8,
     "X": 28.694531,
     "Y": -29.971279
    },
    {
     "ProvName": "Kalimantan Timur",
     "zoomlevel": 5.8,
     "X": 116.38435,
     "Y": 1.35462
    },
    {
     "ProvName": "Vidzeme",
     "zoomlevel": 5.8,
     "X": 25.831722,
     "Y": 57.344257
    },
    {
     "ProvName": "Sarawak",
     "zoomlevel": 5.8,
     "X": 113.279826,
     "Y": 2.588038
    },
    {
     "ProvName": "Northern Cape",
     "zoomlevel": 4.8,
     "X": 21.345868,
     "Y": -29.521458
    },
    {
     "ProvName": "Western Cape",
     "zoomlevel": 4.8,
     "X": 20.610695,
     "Y": -33.009468
    },
    {
     "ProvName": "Zemgale",
     "zoomlevel": 5.8,
     "X": 24.695043,
     "Y": 56.485374
    },
    {
     "ProvName": "Coast",
     "zoomlevel": 5.8,
     "X": 39.313372,
     "Y": -2.500416
    },
    {
     "ProvName": "Al-Riyadh",
     "zoomlevel": 4.5,
     "X": 45.549279,
     "Y": 23.074265
    },
    {
     "ProvName": "ash-Sharqiyah (Eastern)",
     "zoomlevel": 4.5,
     "X": 50.144971,
     "Y": 22.922794
    },
    {
     "ProvName": "Ilfov",
     "zoomlevel": 5.8,
     "X": 26.175015,
     "Y": 44.539599
    },
    {
     "ProvName": "Balochistan",
     "zoomlevel": 4.5,
     "X": 65.869533,
     "Y": 28.318454
    },
    {
     "ProvName": "Azad Kashmir",
     "zoomlevel": 5.8,
     "X": 74.021943,
     "Y": 34.119996
    },
    {
     "ProvName": "Islamabad",
     "zoomlevel": 5.8,
     "X": 73.084992,
     "Y": 33.659599
    },
    {
     "ProvName": "Northern Areas",
     "zoomlevel": 5.8,
     "X": 74.958689,
     "Y": 35.797769
    },
    {
     "ProvName": "Federally Administered Tribal Areas",
     "zoomlevel": 5.8,
     "X": 70.39444,
     "Y": 33.151258
    },
    {
     "ProvName": "Punjab",
     "zoomlevel": 5.8,
     "X": 72.13381,
     "Y": 30.821726
    },
    {
     "ProvName": "Sindh",
     "zoomlevel": 4,
     "X": 68.76804,
     "Y": 26.027578
    },
    {
     "ProvName": "Bishkek (Frunze)",
     "zoomlevel": 5.8,
     "X": 74.594338,
     "Y": 42.859342
    },
    {
     "ProvName": "Chüy (Chu)",
     "zoomlevel": 5.8,
     "X": 74.618703,
     "Y": 42.617911
    },
    {
     "ProvName": "Ysyk-Köl",
     "zoomlevel": 5.8,
     "X": 77.931282,
     "Y": 42.163332
    },
    {
     "ProvName": "Naryn",
     "zoomlevel": 5.8,
     "X": 75.642677,
     "Y": 41.364561
    },
    {
     "ProvName": "Batken",
     "zoomlevel": 5.8,
     "X": 70.851787,
     "Y": 39.862899
    },
    {
     "ProvName": "Jalal-Abad",
     "zoomlevel": 5.8,
     "X": 72.465369,
     "Y": 41.571432
    },
    {
     "ProvName": "Osh",
     "zoomlevel": 5.8,
     "X": 73.230875,
     "Y": 40.137499
    },
    {
     "ProvName": "Khyber Pakhtunkhwa",
     "zoomlevel": 5.8,
     "X": 72.077276,
     "Y": 34.483427
    },
    {
     "ProvName": "Sudur Pashchimanchal (Far-Western)",
     "zoomlevel": 5.8,
     "X": 80.916218,
     "Y": 29.316866
    },
    {
     "ProvName": "Eastern Highlands",
     "zoomlevel": 5.8,
     "X": 145.616289,
     "Y": -6.478415
    },
    {
     "ProvName": "Madhyamanchal (Central)",
     "zoomlevel": 5.8,
     "X": 85.445991,
     "Y": 27.491338
    },
    {
     "ProvName": "Purwanchal (Eastern)",
     "zoomlevel": 5.8,
     "X": 87.198692,
     "Y": 27.150742
    },
    {
     "ProvName": "Aceh",
     "zoomlevel": 5.8,
     "X": 96.896159,
     "Y": 4.256935
    },
    {
     "ProvName": "Perak",
     "zoomlevel": 5.8,
     "X": 101.113227,
     "Y": 4.768998
    },
    {
     "ProvName": "Western Highlands",
     "zoomlevel": 5.8,
     "X": 144.419144,
     "Y": -5.793487
    },
    {
     "ProvName": "Thaba-Tseka",
     "zoomlevel": 5.8,
     "X": 28.595698,
     "Y": -29.566212
    },
    {
     "ProvName": "KwaZulu-Natal",
     "zoomlevel": 5.8,
     "X": 30.718809,
     "Y": -28.710272
    },
    {
     "ProvName": "Antananarivo",
     "zoomlevel": 4.230000000000001,
     "X": 46.820478,
     "Y": -18.94711
    },
    {
     "ProvName": "Antsiranana",
     "zoomlevel": 4.230000000000001,
     "X": 49.426919,
     "Y": -13.846944
    },
    {
     "ProvName": "Kedah",
     "zoomlevel": 5.8,
     "X": 100.656651,
     "Y": 5.916197
    },
    {
     "ProvName": "Hiroshima",
     "zoomlevel": 5.8,
     "X": 132.786808,
     "Y": 34.602472
    },
    {
     "ProvName": "Pulau Pinang",
     "zoomlevel": 5.8,
     "X": 100.40521,
     "Y": 5.360402
    },
    {
     "ProvName": "Komárom-Esztergom",
     "zoomlevel": 5.8,
     "X": 18.31566,
     "Y": 47.618372
    },
    {
     "ProvName": "Johor",
     "zoomlevel": 5.8,
     "X": 103.390142,
     "Y": 2.054109
    },
    {
     "ProvName": "Kao-hsiung municipality",
     "zoomlevel": 5.8,
     "X": 120.617324,
     "Y": 22.998764
    },
    {
     "ProvName": "Jawa Barat",
     "zoomlevel": 5.8,
     "X": 107.609099,
     "Y": -6.917457
    },
    {
     "ProvName": "Karonga",
     "zoomlevel": 5.8,
     "X": 34.110254,
     "Y": -10.077519
    },
    {
     "ProvName": "Jawa Tengah",
     "zoomlevel": 5.8,
     "X": 110.211083,
     "Y": -7.269953
    },
    {
     "ProvName": "Kampot",
     "zoomlevel": 5.8,
     "X": 104.313219,
     "Y": 10.801542
    },
    {
     "ProvName": "Bengkulu",
     "zoomlevel": 5.8,
     "X": 102.375674,
     "Y": -3.574826
    },
    {
     "ProvName": "I-lan",
     "zoomlevel": 5.8,
     "X": 121.6352,
     "Y": 24.577073
    },
    {
     "ProvName": "Chi-lung city",
     "zoomlevel": 5.8,
     "X": 121.70787,
     "Y": 25.112677
    },
    {
     "ProvName": "Rió Negro",
     "zoomlevel": 3.38,
     "X": -67.236071,
     "Y": -40.402766
    },
    {
     "ProvName": "San Luis",
     "zoomlevel": 3.38,
     "X": -66.029377,
     "Y": -33.75691
    },
    {
     "ProvName": "Berea",
     "zoomlevel": 5.8,
     "X": 27.922708,
     "Y": -29.178904
    },
    {
     "ProvName": "Córdoba",
     "zoomlevel": 5.8,
     "X": -63.768861,
     "Y": -32.092463
    },
    {
     "ProvName": "Catamarca",
     "zoomlevel": 5.8,
     "X": -66.977565,
     "Y": -27.317137
    },
    {
     "ProvName": "Nan-t'ou",
     "zoomlevel": 5.8,
     "X": 120.986466,
     "Y": 23.848504
    },
    {
     "ProvName": "Kaeb",
     "zoomlevel": 5.8,
     "X": 104.346611,
     "Y": 10.522052
    },
    {
     "ProvName": "Tete",
     "zoomlevel": 5.8,
     "X": 32.741342,
     "Y": -15.521349
    },
    {
     "ProvName": "Ghanzi",
     "zoomlevel": 4.8,
     "X": 22.590321,
     "Y": -22.294139
    },
    {
     "ProvName": "Manica",
     "zoomlevel": 5.8,
     "X": 33.424995,
     "Y": -19.038795
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 36.861642,
     "Y": -0.581049
    },
    {
     "ProvName": "Nairobi",
     "zoomlevel": 5.8,
     "X": 36.884022,
     "Y": -1.274854
    },
    {
     "ProvName": "Nyanza",
     "zoomlevel": 5.8,
     "X": 34.462803,
     "Y": -0.498025
    },
    {
     "ProvName": "Cabo Delgado",
     "zoomlevel": 5.8,
     "X": 39.365384,
     "Y": -12.460303
    },
    {
     "ProvName": "Niassa",
     "zoomlevel": 5.8,
     "X": 36.456192,
     "Y": -13.073317
    },
    {
     "ProvName": "Nampula",
     "zoomlevel": 5.8,
     "X": 39.249876,
     "Y": -14.958842
    },
    {
     "ProvName": "North West",
     "zoomlevel": 4.8,
     "X": 25.336345,
     "Y": -26.317549
    },
    {
     "ProvName": "Quthing",
     "zoomlevel": 5.8,
     "X": 27.965358,
     "Y": -30.351339
    },
    {
     "ProvName": "Maseru",
     "zoomlevel": 5.8,
     "X": 27.797802,
     "Y": -29.556708
    },
    {
     "ProvName": "Mohale's Hoek",
     "zoomlevel": 5.8,
     "X": 27.76084,
     "Y": -30.071202
    },
    {
     "ProvName": "Free State",
     "zoomlevel": 5.8,
     "X": 26.866484,
     "Y": -28.605683
    },
    {
     "ProvName": "Gaza",
     "zoomlevel": 5.8,
     "X": 32.790722,
     "Y": -23.312865
    },
    {
     "ProvName": "Gauteng",
     "zoomlevel": 4.8,
     "X": 28.212807,
     "Y": -26.043104
    },
    {
     "ProvName": "Mpumalanga",
     "zoomlevel": 5.8,
     "X": 30.231934,
     "Y": -25.864789
    },
    {
     "ProvName": "Limpopo",
     "zoomlevel": 4.8,
     "X": 29.305016,
     "Y": -23.738324
    },
    {
     "ProvName": "Butha-Buthe",
     "zoomlevel": 5.8,
     "X": 28.563654,
     "Y": -28.799712
    },
    {
     "ProvName": "Leribe",
     "zoomlevel": 5.8,
     "X": 28.272881,
     "Y": -29.002525
    },
    {
     "ProvName": "Mokhotlong",
     "zoomlevel": 5.8,
     "X": 29.021877,
     "Y": -29.225054
    },
    {
     "ProvName": "Eleuthera",
     "zoomlevel": 5.8,
     "X": -76.335977,
     "Y": 25.106272
    },
    {
     "ProvName": "Kalimantan Selatan",
     "zoomlevel": 5.8,
     "X": 115.431333,
     "Y": -2.975427
    },
    {
     "ProvName": "Nusa Tenggara Timur",
     "zoomlevel": 5.8,
     "X": 122.183962,
     "Y": -9.253981
    },
    {
     "ProvName": "Sulawesi Selatan",
     "zoomlevel": 5.8,
     "X": 120.177509,
     "Y": -3.658362
    },
    {
     "ProvName": "Cat Island",
     "zoomlevel": 5.8,
     "X": -75.499043,
     "Y": 24.367126
    },
    {
     "ProvName": "Sulawesi Barat",
     "zoomlevel": 5.8,
     "X": 119.344382,
     "Y": -2.45984
    },
    {
     "ProvName": "Enga",
     "zoomlevel": 5.8,
     "X": 143.494581,
     "Y": -5.418393
    },
    {
     "ProvName": "Bogotá",
     "zoomlevel": 5.8,
     "X": -74.197386,
     "Y": 4.282637
    },
    {
     "ProvName": "East Sepik",
     "zoomlevel": 5.8,
     "X": 143.164904,
     "Y": -4.29578
    },
    {
     "ProvName": "Sandaun (West Sepik)",
     "zoomlevel": 5.8,
     "X": 141.703446,
     "Y": -3.912456
    },
    {
     "ProvName": "Quindío",
     "zoomlevel": 5.8,
     "X": -75.69083,
     "Y": 4.458943
    },
    {
     "ProvName": "Madang",
     "zoomlevel": 5.8,
     "X": 145.282056,
     "Y": -5.154453
    },
    {
     "ProvName": "Cuscatlán",
     "zoomlevel": 5.8,
     "X": -89.018976,
     "Y": 13.85183
    },
    {
     "ProvName": "Gulf",
     "zoomlevel": 5.8,
     "X": 144.79665,
     "Y": -7.37975
    },
    {
     "ProvName": "Central Islands",
     "zoomlevel": 5.8,
     "X": 159.882903,
     "Y": -9.078868
    },
    {
     "ProvName": "Bougainville",
     "zoomlevel": 5.8,
     "X": 155.265145,
     "Y": -6.152059
    },
    {
     "ProvName": "Southern Highlands",
     "zoomlevel": 5.8,
     "X": 143.288314,
     "Y": -6.170114
    },
    {
     "ProvName": "Namentenga",
     "zoomlevel": 5.8,
     "X": -0.493009,
     "Y": 13.147616
    },
    {
     "ProvName": "Jujuy",
     "zoomlevel": 5.8,
     "X": -65.776931,
     "Y": -23.319057
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 142.045315,
     "Y": -7.425024
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 147.611675,
     "Y": -9.19284
    },
    {
     "ProvName": "East New Britain",
     "zoomlevel": 5.8,
     "X": 151.671309,
     "Y": -5.092188
    },
    {
     "ProvName": "Nord-Ouest",
     "zoomlevel": 5.8,
     "X": -73.039555,
     "Y": 19.817435
    },
    {
     "ProvName": "Manus",
     "zoomlevel": 5.8,
     "X": 146.983305,
     "Y": -2.086722
    },
    {
     "ProvName": "Milne Bay",
     "zoomlevel": 5.8,
     "X": 150.626171,
     "Y": -10.054103
    },
    {
     "ProvName": "Oro (Northern)",
     "zoomlevel": 5.8,
     "X": 148.258173,
     "Y": -8.979376
    },
    {
     "ProvName": "West New Britain",
     "zoomlevel": 5.8,
     "X": 149.882891,
     "Y": -5.75477
    },
    {
     "ProvName": "Morobe",
     "zoomlevel": 5.8,
     "X": 146.842675,
     "Y": -6.83739
    },
    {
     "ProvName": "National Capital District",
     "zoomlevel": 5.8,
     "X": 147.193547,
     "Y": -9.456674
    },
    {
     "ProvName": "New Ireland",
     "zoomlevel": 5.8,
     "X": 151.948289,
     "Y": -3.491394
    },
    {
     "ProvName": "Loyaute",
     "zoomlevel": 5.8,
     "X": 167.437478,
     "Y": -21.101652
    },
    {
     "ProvName": "Malaita",
     "zoomlevel": 5.8,
     "X": 161.028786,
     "Y": -9.004395
    },
    {
     "ProvName": "Sud",
     "zoomlevel": 5.8,
     "X": 166.201664,
     "Y": -21.87568
    },
    {
     "ProvName": "Isabel",
     "zoomlevel": 5.8,
     "X": 159.159154,
     "Y": -8.017409
    },
    {
     "ProvName": "Rhône-Alpes",
     "zoomlevel": 5.8,
     "X": 5.32803,
     "Y": 45.430513
    },
    {
     "ProvName": "Chimborazo",
     "zoomlevel": 5.8,
     "X": -78.725648,
     "Y": -1.917662
    },
    {
     "ProvName": "Azuay",
     "zoomlevel": 5.8,
     "X": -79.169354,
     "Y": -2.998408
    },
    {
     "ProvName": "Cañar",
     "zoomlevel": 5.8,
     "X": -78.9676,
     "Y": -2.503647
    },
    {
     "ProvName": "Al-Uqsur (Luxor)",
     "zoomlevel": 5.8,
     "X": 32.655757,
     "Y": 25.684606
    },
    {
     "ProvName": "Koulpélogo",
     "zoomlevel": 5.8,
     "X": 0.213477,
     "Y": 11.40492
    },
    {
     "ProvName": "Canarias (Canary Islands)",
     "zoomlevel": 5.8,
     "X": -15.674091,
     "Y": 28.337909
    },
    {
     "ProvName": "Cotopaxi",
     "zoomlevel": 5.8,
     "X": -78.856244,
     "Y": -0.859026
    },
    {
     "ProvName": "Los Ríos",
     "zoomlevel": 5.8,
     "X": -79.486518,
     "Y": -1.335482
    },
    {
     "ProvName": "Manabí",
     "zoomlevel": 5.8,
     "X": -80.137256,
     "Y": -0.734042
    },
    {
     "ProvName": "Amazonas",
     "zoomlevel": 5.8,
     "X": -71.501229,
     "Y": -1.529149
    },
    {
     "ProvName": "Morona-Santiago",
     "zoomlevel": 5.8,
     "X": -78.017365,
     "Y": -2.555473
    },
    {
     "ProvName": "Orellana",
     "zoomlevel": 5.8,
     "X": -76.387527,
     "Y": -0.777475
    },
    {
     "ProvName": "La Pampa",
     "zoomlevel": 3.38,
     "X": -65.446956,
     "Y": -37.131371
    },
    {
     "ProvName": "Banjul",
     "zoomlevel": 5.8,
     "X": -16.662363,
     "Y": 13.437132
    },
    {
     "ProvName": "Pastaza",
     "zoomlevel": 5.8,
     "X": -76.888123,
     "Y": -1.707011
    },
    {
     "ProvName": "Napo",
     "zoomlevel": 5.8,
     "X": -78.50366,
     "Y": -1.288198
    },
    {
     "ProvName": "Tungurahua",
     "zoomlevel": 5.8,
     "X": -77.821559,
     "Y": -0.652987
    },
    {
     "ProvName": "Martinique",
     "zoomlevel": 5.8,
     "X": -61.017588,
     "Y": 14.656414
    },
    {
     "ProvName": "Cochabamba",
     "zoomlevel": 5.8,
     "X": -65.616257,
     "Y": -17.206732
    },
    {
     "ProvName": "Chuquisaca",
     "zoomlevel": 5.8,
     "X": -64.317387,
     "Y": -20.034299
    },
    {
     "ProvName": "Beni",
     "zoomlevel": 5.8,
     "X": -65.231364,
     "Y": -13.786767
    },
    {
     "ProvName": "Goi獺s",
     "zoomlevel": 3.38,
     "X": -49.60513,
     "Y": -16.025877
    },
    {
     "ProvName": "Tucumán",
     "zoomlevel": 5.8,
     "X": -65.366223,
     "Y": -26.950654
    },
    {
     "ProvName": "Córdoba",
     "zoomlevel": 5.8,
     "X": -75.800079,
     "Y": 8.355966
    },
    {
     "ProvName": "Chaco",
     "zoomlevel": 5.8,
     "X": -60.760045,
     "Y": -26.394711
    },
    {
     "ProvName": "Formosa",
     "zoomlevel": 5.8,
     "X": -59.933322,
     "Y": -24.896752
    },
    {
     "ProvName": "Corrientes",
     "zoomlevel": 5.8,
     "X": -57.800866,
     "Y": -28.763247
    },
    {
     "ProvName": "Lovech",
     "zoomlevel": 5.8,
     "X": 24.54808,
     "Y": 43.023549
    },
    {
     "ProvName": "Entre Ríos",
     "zoomlevel": 5.8,
     "X": -59.20851,
     "Y": -32.03979
    },
    {
     "ProvName": "Coclé",
     "zoomlevel": 5.8,
     "X": -80.423965,
     "Y": 8.543279
    },
    {
     "ProvName": "Santa Fe",
     "zoomlevel": 5.8,
     "X": -60.950016,
     "Y": -30.700183
    },
    {
     "ProvName": "São Paulo",
     "zoomlevel": 3.38,
     "X": -48.725348,
     "Y": -22.262848
    },
    {
     "ProvName": "Misiones",
     "zoomlevel": 5.8,
     "X": -54.657225,
     "Y": -26.87157
    },
    {
     "ProvName": "Pernambuco",
     "zoomlevel": 5.8,
     "X": -37.994546,
     "Y": -8.330597
    },
    {
     "ProvName": "Antioquia",
     "zoomlevel": 5.8,
     "X": -75.581068,
     "Y": 6.922581
    },
    {
     "ProvName": "Los Santos",
     "zoomlevel": 5.8,
     "X": -80.38614,
     "Y": 7.58583
    },
    {
     "ProvName": "Boyacá",
     "zoomlevel": 5.8,
     "X": -73.107958,
     "Y": 5.771951
    },
    {
     "ProvName": "Santander",
     "zoomlevel": 5.8,
     "X": -73.49058,
     "Y": 6.695703
    },
    {
     "ProvName": "Karaman",
     "zoomlevel": 5.8,
     "X": 33.222907,
     "Y": 37.080667
    },
    {
     "ProvName": "La Guajira",
     "zoomlevel": 5.8,
     "X": -72.4336,
     "Y": 11.491272
    },
    {
     "ProvName": "Sud",
     "zoomlevel": 5.8,
     "X": -73.722808,
     "Y": 18.280828
    },
    {
     "ProvName": "Cienfuegos",
     "zoomlevel": 5.8,
     "X": -80.450048,
     "Y": 22.240792
    },
    {
     "ProvName": "Isla de la Juventud",
     "zoomlevel": 5.8,
     "X": -82.80272,
     "Y": 21.681479
    },
    {
     "ProvName": "Manchester",
     "zoomlevel": 5.8,
     "X": -77.513292,
     "Y": 18.02802
    },
    {
     "ProvName": "Pinar del Río",
     "zoomlevel": 5.8,
     "X": -83.721377,
     "Y": 22.441856
    },
    {
     "ProvName": "Westmoreland",
     "zoomlevel": 5.8,
     "X": -78.099114,
     "Y": 18.239228
    },
    {
     "ProvName": "Kingston",
     "zoomlevel": 5.8,
     "X": -76.761523,
     "Y": 17.978445
    },
    {
     "ProvName": "Sancti Spíritus",
     "zoomlevel": 5.8,
     "X": -79.415939,
     "Y": 21.95536
    },
    {
     "ProvName": "Okayama",
     "zoomlevel": 5.8,
     "X": 133.808349,
     "Y": 34.89718
    },
    {
     "ProvName": "Belize",
     "zoomlevel": 5.8,
     "X": -88.374217,
     "Y": 17.566276
    },
    {
     "ProvName": "Cayo",
     "zoomlevel": 5.8,
     "X": -88.916513,
     "Y": 16.990904
    },
    {
     "ProvName": "San Andrés y Providencia",
     "zoomlevel": 5.8,
     "X": -81.547039,
     "Y": 12.919186
    },
    {
     "ProvName": "Colón",
     "zoomlevel": 5.8,
     "X": -80.002868,
     "Y": 9.178849
    },
    {
     "ProvName": "Herrera",
     "zoomlevel": 5.8,
     "X": -80.695608,
     "Y": 7.871746
    },
    {
     "ProvName": "Ahuachapán",
     "zoomlevel": 5.8,
     "X": -89.902008,
     "Y": 13.862715
    },
    {
     "ProvName": "Veraguas",
     "zoomlevel": 5.8,
     "X": -81.141138,
     "Y": 8.099321
    },
    {
     "ProvName": "La Libertad",
     "zoomlevel": 5.8,
     "X": -89.3509,
     "Y": 13.707619
    },
    {
     "ProvName": "La Paz",
     "zoomlevel": 5.8,
     "X": -88.957014,
     "Y": 13.478005
    },
    {
     "ProvName": "Sonsonate",
     "zoomlevel": 5.8,
     "X": -89.681531,
     "Y": 13.698887
    },
    {
     "ProvName": "San Salvador",
     "zoomlevel": 5.8,
     "X": -89.161393,
     "Y": 13.771759
    },
    {
     "ProvName": "La Unión",
     "zoomlevel": 5.8,
     "X": -87.889925,
     "Y": 13.524287
    },
    {
     "ProvName": "Morazán",
     "zoomlevel": 5.8,
     "X": -88.102648,
     "Y": 13.770306
    },
    {
     "ProvName": "San Miguel",
     "zoomlevel": 5.8,
     "X": -88.251404,
     "Y": 13.548246
    },
    {
     "ProvName": "San Vicente",
     "zoomlevel": 5.8,
     "X": -88.719956,
     "Y": 13.617055
    },
    {
     "ProvName": "Usulután",
     "zoomlevel": 5.8,
     "X": -88.489029,
     "Y": 13.386516
    },
    {
     "ProvName": "Stann Creek",
     "zoomlevel": 5.8,
     "X": -88.464883,
     "Y": 16.832088
    },
    {
     "ProvName": "Portland",
     "zoomlevel": 5.8,
     "X": -76.519291,
     "Y": 18.11746
    },
    {
     "ProvName": "Toledo",
     "zoomlevel": 5.8,
     "X": -88.886874,
     "Y": 16.29867
    },
    {
     "ProvName": "Chalatenango",
     "zoomlevel": 5.8,
     "X": -89.079189,
     "Y": 14.148167
    },
    {
     "ProvName": "Saint Ann",
     "zoomlevel": 5.8,
     "X": -77.265926,
     "Y": 18.315823
    },
    {
     "ProvName": "Santa Ana",
     "zoomlevel": 5.8,
     "X": -89.506796,
     "Y": 14.120896
    },
    {
     "ProvName": "Grande Anse",
     "zoomlevel": 5.8,
     "X": -74.137235,
     "Y": 18.505512
    },
    {
     "ProvName": "Saint Elizabeth",
     "zoomlevel": 5.8,
     "X": -77.750666,
     "Y": 18.050935
    },
    {
     "ProvName": "Saint Catherine",
     "zoomlevel": 5.8,
     "X": -77.020871,
     "Y": 18.045819
    },
    {
     "ProvName": "Shimane",
     "zoomlevel": 5.8,
     "X": 132.552562,
     "Y": 35.063546
    },
    {
     "ProvName": "Nippes",
     "zoomlevel": 5.8,
     "X": -73.393704,
     "Y": 18.432062
    },
    {
     "ProvName": "Ciego de Avila",
     "zoomlevel": 5.8,
     "X": -78.647327,
     "Y": 21.967925
    },
    {
     "ProvName": "Camagüey",
     "zoomlevel": 5.8,
     "X": -77.867013,
     "Y": 21.400888
    },
    {
     "ProvName": "Usak",
     "zoomlevel": 5.8,
     "X": 29.362937,
     "Y": 38.536919
    },
    {
     "ProvName": "Guantánamo",
     "zoomlevel": 5.8,
     "X": -74.909426,
     "Y": 20.208271
    },
    {
     "ProvName": "Carchi",
     "zoomlevel": 5.8,
     "X": -78.041206,
     "Y": 0.743604
    },
    {
     "ProvName": "Nigde",
     "zoomlevel": 5.8,
     "X": 34.702673,
     "Y": 37.929803
    },
    {
     "ProvName": "Granma",
     "zoomlevel": 5.8,
     "X": -76.923707,
     "Y": 20.293943
    },
    {
     "ProvName": "Holgu?n",
     "zoomlevel": 5.8,
     "X": -75.879686,
     "Y": 20.751696
    },
    {
     "ProvName": "Imbabura",
     "zoomlevel": 5.8,
     "X": -78.348198,
     "Y": 0.410695
    },
    {
     "ProvName": "Las Tunas",
     "zoomlevel": 5.8,
     "X": -77.027251,
     "Y": 21.013257
    },
    {
     "ProvName": "Tanger-Tétouan",
     "zoomlevel": 5.8,
     "X": -5.431135,
     "Y": 35.245217
    },
    {
     "ProvName": "Santiago de Cuba",
     "zoomlevel": 5.8,
     "X": -75.962417,
     "Y": 20.187132
    },
    {
     "ProvName": "Clarendon",
     "zoomlevel": 5.8,
     "X": -77.283031,
     "Y": 17.985149
    },
    {
     "ProvName": "Hanover",
     "zoomlevel": 5.8,
     "X": -78.140067,
     "Y": 18.373094
    },
    {
     "ProvName": "Huila",
     "zoomlevel": 5.8,
     "X": -75.616797,
     "Y": 2.541382
    },
    {
     "ProvName": "Tottori",
     "zoomlevel": 5.8,
     "X": 133.851748,
     "Y": 35.350691
    },
    {
     "ProvName": "Saint Mary",
     "zoomlevel": 5.8,
     "X": -76.891874,
     "Y": 18.278957
    },
    {
     "ProvName": "Nariño",
     "zoomlevel": 5.8,
     "X": -77.86886,
     "Y": 1.539915
    },
    {
     "ProvName": "Aksaray",
     "zoomlevel": 5.8,
     "X": 33.858162,
     "Y": 38.382246
    },
    {
     "ProvName": "Putumayo",
     "zoomlevel": 5.8,
     "X": -75.854287,
     "Y": 0.454399
    },
    {
     "ProvName": "Valle de Cauca",
     "zoomlevel": 5.8,
     "X": -76.508576,
     "Y": 3.873606
    },
    {
     "ProvName": "Saint James",
     "zoomlevel": 5.8,
     "X": -77.856795,
     "Y": 18.384222
    },
    {
     "ProvName": "Trelawny",
     "zoomlevel": 5.8,
     "X": -77.613653,
     "Y": 18.355815
    },
    {
     "ProvName": "Sucumbíos",
     "zoomlevel": 5.8,
     "X": -76.586926,
     "Y": -0.005295
    },
    {
     "ProvName": "Guaviare",
     "zoomlevel": 5.8,
     "X": -72.118704,
     "Y": 1.927258
    },
    {
     "ProvName": "Guainia",
     "zoomlevel": 5.8,
     "X": -68.816072,
     "Y": 2.727807
    },
    {
     "ProvName": "St. Luke",
     "zoomlevel": 5.8,
     "X": -61.365706,
     "Y": 15.248328
    },
    {
     "ProvName": "Caldas",
     "zoomlevel": 5.8,
     "X": -75.310882,
     "Y": 5.343992
    },
    {
     "ProvName": "Risaralda",
     "zoomlevel": 5.8,
     "X": -75.838413,
     "Y": 5.082182
    },
    {
     "ProvName": "Cundinamarca",
     "zoomlevel": 5.8,
     "X": -74.105803,
     "Y": 4.822513
    },
    {
     "ProvName": "Tolima",
     "zoomlevel": 5.8,
     "X": -75.261508,
     "Y": 4.035863
    },
    {
     "ProvName": "St. Patrick",
     "zoomlevel": 5.8,
     "X": -61.301513,
     "Y": 15.276923
    },
    {
     "ProvName": "St. Paul",
     "zoomlevel": 5.8,
     "X": -61.368176,
     "Y": 15.362008
    },
    {
     "ProvName": "St. Peter",
     "zoomlevel": 5.8,
     "X": -61.450115,
     "Y": 15.50194
    },
    {
     "ProvName": "Caquetá",
     "zoomlevel": 5.8,
     "X": -73.962085,
     "Y": 0.80567
    },
    {
     "ProvName": "Cauca",
     "zoomlevel": 5.8,
     "X": -76.845319,
     "Y": 2.391964
    },
    {
     "ProvName": "St. Mark",
     "zoomlevel": 5.8,
     "X": -61.36198,
     "Y": 15.22064
    },
    {
     "ProvName": "Faeroe Islands",
     "zoomlevel": 5.8,
     "X": -6.870393,
     "Y": 62.074142
    },
    {
     "ProvName": "Fès-Boulemane",
     "zoomlevel": 5.8,
     "X": -4.188534,
     "Y": 33.443681
    },
    {
     "ProvName": "Taza-Al-Hoceïma-Taounate",
     "zoomlevel": 5.8,
     "X": -4.105563,
     "Y": 34.42307
    },
    {
     "ProvName": "Gharb-Chrarda-Béni Hssen",
     "zoomlevel": 5.8,
     "X": -5.953376,
     "Y": 34.513726
    },
    {
     "ProvName": "Chaouia-Ouardigha",
     "zoomlevel": 5.8,
     "X": -7.187134,
     "Y": 33.039537
    },
    {
     "ProvName": "Grand Casablanca",
     "zoomlevel": 5.8,
     "X": -7.570634,
     "Y": 33.539316
    },
    {
     "ProvName": "Rabat-Salé-Zemmour-Zaer",
     "zoomlevel": 5.8,
     "X": -6.367605,
     "Y": 33.726025
    },
    {
     "ProvName": "Doukala-Abda",
     "zoomlevel": 5.8,
     "X": -8.644657,
     "Y": 32.517994
    },
    {
     "ProvName": "Meknès-Tafilalet",
     "zoomlevel": 5.8,
     "X": -4.852919,
     "Y": 32.186049
    },
    {
     "ProvName": "Bioko Norte",
     "zoomlevel": 5.8,
     "X": 8.806558,
     "Y": 3.663443
    },
    {
     "ProvName": "Tadla-Azilal",
     "zoomlevel": 5.8,
     "X": -6.439737,
     "Y": 32.142802
    },
    {
     "ProvName": "Oriental",
     "zoomlevel": 5.8,
     "X": -2.560145,
     "Y": 33.449704
    },
    {
     "ProvName": "River Gee",
     "zoomlevel": 5.8,
     "X": -7.856535,
     "Y": 5.257235
    },
    {
     "ProvName": "Souss-Massa-Daraâ",
     "zoomlevel": 5.8,
     "X": -7.460766,
     "Y": 30.537225
    },
    {
     "ProvName": "Marrakech-Tensift-Al Haouz",
     "zoomlevel": 5.8,
     "X": -8.371401,
     "Y": 31.628608
    },
    {
     "ProvName": "Gbarpolu",
     "zoomlevel": 5.8,
     "X": -10.452516,
     "Y": 7.186523
    },
    {
     "ProvName": "Equateur",
     "zoomlevel": 3.8,
     "X": 20.605664,
     "Y": 1.046667
    },
    {
     "ProvName": "Lac",
     "zoomlevel": 5.8,
     "X": 14.511211,
     "Y": 13.652124
    },
    {
     "ProvName": "Annobón",
     "zoomlevel": 5.8,
     "X": 5.631537,
     "Y": -1.446364
    },
    {
     "ProvName": "Extrême-Nord",
     "zoomlevel": 5.8,
     "X": 14.511304,
     "Y": 11.064881
    },
    {
     "ProvName": "Wele-Nzas",
     "zoomlevel": 5.8,
     "X": 11.001662,
     "Y": 1.493347
    },
    {
     "ProvName": "Centro-Sur",
     "zoomlevel": 5.8,
     "X": 10.43108,
     "Y": 1.479996
    },
    {
     "ProvName": "Kie-Ntem",
     "zoomlevel": 5.8,
     "X": 10.952023,
     "Y": 1.999009
    },
    {
     "ProvName": "Litoral",
     "zoomlevel": 5.8,
     "X": 9.85275,
     "Y": 1.522673
    },
    {
     "ProvName": "Batha",
     "zoomlevel": 5.8,
     "X": 18.814946,
     "Y": 13.935697
    },
    {
     "ProvName": "Nord-Ouest",
     "zoomlevel": 5.8,
     "X": 10.364435,
     "Y": 6.370166
    },
    {
     "ProvName": "Wadi Fira",
     "zoomlevel": 5.8,
     "X": 21.473106,
     "Y": 15.061989
    },
    {
     "ProvName": "Saga",
     "zoomlevel": 5.8,
     "X": 130.111266,
     "Y": 33.273054
    },
    {
     "ProvName": "Guéra",
     "zoomlevel": 5.8,
     "X": 18.45074,
     "Y": 11.37673
    },
    {
     "ProvName": "Littoral",
     "zoomlevel": 5.8,
     "X": 10.129332,
     "Y": 4.26871
    },
    {
     "ProvName": "Yamaguchi",
     "zoomlevel": 5.8,
     "X": 131.564153,
     "Y": 34.193252
    },
    {
     "ProvName": "Pleven",
     "zoomlevel": 5.8,
     "X": 24.659313,
     "Y": 43.500736
    },
    {
     "ProvName": "Fukuoka",
     "zoomlevel": 5.8,
     "X": 130.661141,
     "Y": 33.519686
    },
    {
     "ProvName": "Bioko Sur",
     "zoomlevel": 5.8,
     "X": 8.646009,
     "Y": 3.406348
    },
    {
     "ProvName": "Centre",
     "zoomlevel": 5.8,
     "X": 11.828957,
     "Y": 4.67073
    },
    {
     "ProvName": "Est",
     "zoomlevel": 5.8,
     "X": 14.208017,
     "Y": 3.797631
    },
    {
     "ProvName": "Durrës",
     "zoomlevel": 5.8,
     "X": 19.626497,
     "Y": 41.447749
    },
    {
     "ProvName": "Adamoua",
     "zoomlevel": 5.8,
     "X": 13.128268,
     "Y": 6.833971
    },
    {
     "ProvName": "National Capital Region",
     "zoomlevel": 5.8,
     "X": 121.048902,
     "Y": 14.56706
    },
    {
     "ProvName": "Nord",
     "zoomlevel": 5.8,
     "X": 13.907578,
     "Y": 8.462576
    },
    {
     "ProvName": "al-Minufiyah (Monufia)",
     "zoomlevel": 5.8,
     "X": 31.001597,
     "Y": 30.490479
    },
    {
     "ProvName": "Logone Occidental",
     "zoomlevel": 5.8,
     "X": 15.887408,
     "Y": 8.753948
    },
    {
     "ProvName": "Logone Oriental",
     "zoomlevel": 5.8,
     "X": 16.377633,
     "Y": 8.194673
    },
    {
     "ProvName": "al-Qahirah (Cairo)",
     "zoomlevel": 5.8,
     "X": 31.607358,
     "Y": 29.998004
    },
    {
     "ProvName": "Tandjilé",
     "zoomlevel": 5.8,
     "X": 16.465276,
     "Y": 9.53346
    },
    {
     "ProvName": "Kukës",
     "zoomlevel": 5.8,
     "X": 20.22624,
     "Y": 42.195142
    },
    {
     "ProvName": "Salamat",
     "zoomlevel": 5.8,
     "X": 20.540475,
     "Y": 10.797956
    },
    {
     "ProvName": "Dubrovnik-Neretva",
     "zoomlevel": 5.8,
     "X": 17.512635,
     "Y": 42.873871
    },
    {
     "ProvName": "Plav",
     "zoomlevel": 5.8,
     "X": 19.917009,
     "Y": 42.588874
    },
    {
     "ProvName": "al-Qalyubiyah (Qalyubia)",
     "zoomlevel": 5.8,
     "X": 31.260959,
     "Y": 30.307426
    },
    {
     "ProvName": "Sibenik-Knin",
     "zoomlevel": 5.8,
     "X": 16.02682,
     "Y": 43.798638
    },
    {
     "ProvName": "Berane",
     "zoomlevel": 5.8,
     "X": 19.916928,
     "Y": 42.853318
    },
    {
     "ProvName": "Bijelo Polje",
     "zoomlevel": 5.8,
     "X": 19.744949,
     "Y": 43.046763
    },
    {
     "ProvName": "Split-Dalmatia",
     "zoomlevel": 5.8,
     "X": 16.703837,
     "Y": 43.492316
    },
    {
     "ProvName": "Zadar",
     "zoomlevel": 5.8,
     "X": 15.754703,
     "Y": 44.273975
    },
    {
     "ProvName": "Kolasin",
     "zoomlevel": 5.8,
     "X": 19.434126,
     "Y": 42.798558
    },
    {
     "ProvName": "Mojkovac",
     "zoomlevel": 5.8,
     "X": 19.508206,
     "Y": 42.967069
    },
    {
     "ProvName": "Fier",
     "zoomlevel": 5.8,
     "X": 19.62307,
     "Y": 40.767645
    },
    {
     "ProvName": "Bar",
     "zoomlevel": 5.8,
     "X": 19.13844,
     "Y": 42.170539
    },
    {
     "ProvName": "Ulcinj",
     "zoomlevel": 5.8,
     "X": 19.275308,
     "Y": 41.99144
    },
    {
     "ProvName": "Shkodër",
     "zoomlevel": 5.8,
     "X": 19.707406,
     "Y": 42.172796
    },
    {
     "ProvName": "Budva",
     "zoomlevel": 5.8,
     "X": 18.886583,
     "Y": 42.282881
    },
    {
     "ProvName": "Danilovgrad",
     "zoomlevel": 5.8,
     "X": 19.121918,
     "Y": 42.606563
    },
    {
     "ProvName": "Cetinje",
     "zoomlevel": 5.8,
     "X": 18.883545,
     "Y": 42.493192
    },
    {
     "ProvName": "Rozaje",
     "zoomlevel": 5.8,
     "X": 20.190429,
     "Y": 42.860711
    },
    {
     "ProvName": "Vlorë",
     "zoomlevel": 5.8,
     "X": 19.795627,
     "Y": 40.158609
    },
    {
     "ProvName": "Herceg Novi",
     "zoomlevel": 5.8,
     "X": 18.543228,
     "Y": 42.484968
    },
    {
     "ProvName": "Kotor",
     "zoomlevel": 5.8,
     "X": 18.676064,
     "Y": 42.490102
    },
    {
     "ProvName": "Andrijevica",
     "zoomlevel": 5.8,
     "X": 19.756174,
     "Y": 42.712769
    },
    {
     "ProvName": "Kumamoto",
     "zoomlevel": 5.8,
     "X": 130.744011,
     "Y": 32.605714
    },
    {
     "ProvName": "Niksic'",
     "zoomlevel": 5.8,
     "X": 18.78237,
     "Y": 42.838725
    },
    {
     "ProvName": "Miyazaki",
     "zoomlevel": 5.8,
     "X": 131.290866,
     "Y": 32.183411
    },
    {
     "ProvName": "Pluzine",
     "zoomlevel": 5.8,
     "X": 18.846957,
     "Y": 43.157461
    },
    {
     "ProvName": "Pljevlja",
     "zoomlevel": 5.8,
     "X": 19.243252,
     "Y": 43.301087
    },
    {
     "ProvName": "Podgorica",
     "zoomlevel": 5.8,
     "X": 19.341555,
     "Y": 42.481583
    },
    {
     "ProvName": "Ehime",
     "zoomlevel": 5.8,
     "X": 132.848449,
     "Y": 33.602445
    },
    {
     "ProvName": "Kagawa",
     "zoomlevel": 5.8,
     "X": 134.007168,
     "Y": 34.234376
    },
    {
     "ProvName": "Kochi",
     "zoomlevel": 5.8,
     "X": 133.356225,
     "Y": 33.40631
    },
    {
     "ProvName": "Oita",
     "zoomlevel": 5.8,
     "X": 131.427987,
     "Y": 33.189898
    },
    {
     "ProvName": "Korçë",
     "zoomlevel": 5.8,
     "X": 20.660891,
     "Y": 40.629137
    },
    {
     "ProvName": "Berat",
     "zoomlevel": 5.8,
     "X": 20.090411,
     "Y": 40.630075
    },
    {
     "ProvName": "Nógrád",
     "zoomlevel": 5.8,
     "X": 19.5209,
     "Y": 47.986967
    },
    {
     "ProvName": "Elbasan",
     "zoomlevel": 5.8,
     "X": 20.188632,
     "Y": 41.049789
    },
    {
     "ProvName": "Gjirokastër",
     "zoomlevel": 5.8,
     "X": 20.167057,
     "Y": 40.21835
    },
    {
     "ProvName": "Montana",
     "zoomlevel": 5.8,
     "X": 23.213012,
     "Y": 43.514997
    },
    {
     "ProvName": "Dibër",
     "zoomlevel": 5.8,
     "X": 20.227161,
     "Y": 41.603644
    },
    {
     "ProvName": "Lezhë",
     "zoomlevel": 5.8,
     "X": 19.84796,
     "Y": 41.799587
    },
    {
     "ProvName": "Tiranë",
     "zoomlevel": 5.8,
     "X": 19.791775,
     "Y": 41.267371
    },
    {
     "ProvName": "al-Gharbiyah (Gharbia)",
     "zoomlevel": 5.8,
     "X": 31.046473,
     "Y": 30.862126
    },
    {
     "ProvName": "al-Ismailiyah (ismailia)",
     "zoomlevel": 5.8,
     "X": 32.313185,
     "Y": 30.583976
    },
    {
     "ProvName": "ash-Sharqiyah (Sharqia)",
     "zoomlevel": 5.8,
     "X": 31.73173,
     "Y": 30.665587
    },
    {
     "ProvName": "as-Suways (Suez)",
     "zoomlevel": 5.8,
     "X": 32.267919,
     "Y": 29.658674
    },
    {
     "ProvName": "Tokushima",
     "zoomlevel": 5.8,
     "X": 134.236069,
     "Y": 33.909537
    },
    {
     "ProvName": "ad-Daqahliyah (Dakahlia)",
     "zoomlevel": 5.8,
     "X": 31.51129,
     "Y": 31.095236
    },
    {
     "ProvName": "Bani Suyayf (Beni Suef)",
     "zoomlevel": 5.8,
     "X": 30.563849,
     "Y": 28.971801
    },
    {
     "ProvName": "Isle of Man",
     "zoomlevel": 5.8,
     "X": -4.534279,
     "Y": 54.228072
    },
    {
     "ProvName": "Gorontalo",
     "zoomlevel": 5.8,
     "X": 122.363507,
     "Y": 0.686948
    },
    {
     "ProvName": "Aichi",
     "zoomlevel": 5.8,
     "X": 137.205707,
     "Y": 35.02482
    },
    {
     "ProvName": "Bur Said (Port Said)",
     "zoomlevel": 5.8,
     "X": 32.421083,
     "Y": 31.128082
    },
    {
     "ProvName": "Dumyat (Damietta)",
     "zoomlevel": 5.8,
     "X": 31.721307,
     "Y": 31.373422
    },
    {
     "ProvName": "Matruh (Matruh)",
     "zoomlevel": 4.5,
     "X": 26.960625,
     "Y": 29.703087
    },
    {
     "ProvName": "Vratsa",
     "zoomlevel": 5.8,
     "X": 23.810719,
     "Y": 43.429455
    },
    {
     "ProvName": "al-Buhayrah (Beheira)",
     "zoomlevel": 5.8,
     "X": 30.298914,
     "Y": 30.623993
    },
    {
     "ProvName": "al-Fayyum (Faiyum)",
     "zoomlevel": 5.8,
     "X": 30.556947,
     "Y": 29.331319
    },
    {
     "ProvName": "al-Iskandariyah (Alexandria)",
     "zoomlevel": 5.8,
     "X": 29.792075,
     "Y": 30.837463
    },
    {
     "ProvName": "al-Jizah (Giza)",
     "zoomlevel": 5.8,
     "X": 29.501133,
     "Y": 28.847929
    },
    {
     "ProvName": "al-Minya (Minya)",
     "zoomlevel": 5.8,
     "X": 30.056165,
     "Y": 28.139682
    },
    {
     "ProvName": "Kafr ash-Shaykh (Kafr el-Sheikh)",
     "zoomlevel": 5.8,
     "X": 30.912927,
     "Y": 31.290337
    },
    {
     "ProvName": "al-Wadi al-Jadid (New Valley)",
     "zoomlevel": 4.5,
     "X": 28.581467,
     "Y": 24.771444
    },
    {
     "ProvName": "Aswan (Aswan)",
     "zoomlevel": 4.5,
     "X": 32.551582,
     "Y": 23.23607
    },
    {
     "ProvName": "Asyut (Asyut)",
     "zoomlevel": 5.8,
     "X": 31.116494,
     "Y": 27.232235
    },
    {
     "ProvName": "Gifu",
     "zoomlevel": 5.8,
     "X": 137.033446,
     "Y": 35.768018
    },
    {
     "ProvName": "Ishikawa",
     "zoomlevel": 5.8,
     "X": 136.770559,
     "Y": 36.773461
    },
    {
     "ProvName": "Mie",
     "zoomlevel": 5.8,
     "X": 136.372735,
     "Y": 34.504381
    },
    {
     "ProvName": "Bremen",
     "zoomlevel": 5.8,
     "X": 8.75304,
     "Y": 53.192643
    },
    {
     "ProvName": "Niedersachsen",
     "zoomlevel": 5.8,
     "X": 9.148715,
     "Y": 52.76376
    },
    {
     "ProvName": "Thüringen",
     "zoomlevel": 5.8,
     "X": 11.023867,
     "Y": 50.896648
    },
    {
     "ProvName": "Nagano",
     "zoomlevel": 5.8,
     "X": 138.023112,
     "Y": 36.12516
    },
    {
     "ProvName": "Sawhaj (Sohag)",
     "zoomlevel": 5.8,
     "X": 31.773803,
     "Y": 26.525239
    },
    {
     "ProvName": "Saint Helena",
     "zoomlevel": 5.8,
     "X": -10.138017,
     "Y": -24.905378
    },
    {
     "ProvName": "Aragatsotn",
     "zoomlevel": 5.8,
     "X": 44.139158,
     "Y": 40.422304
    },
    {
     "ProvName": "Armavir",
     "zoomlevel": 5.8,
     "X": 44.035628,
     "Y": 40.135004
    },
    {
     "ProvName": "Krapina-Zagorje",
     "zoomlevel": 5.8,
     "X": 15.924581,
     "Y": 46.092388
    },
    {
     "ProvName": "Shirak",
     "zoomlevel": 5.8,
     "X": 43.851403,
     "Y": 40.801528
    },
    {
     "ProvName": "al-Bahr al-Ahmar (Red Sea)",
     "zoomlevel": 5.8,
     "X": 33.496163,
     "Y": 25.169059
    },
    {
     "ProvName": "Shamal Sina' (South Sinai)",
     "zoomlevel": 5.8,
     "X": 33.723953,
     "Y": 30.420443
    },
    {
     "ProvName": "Haut-Congo",
     "zoomlevel": 3.8,
     "X": 26.355526,
     "Y": 2.091562
    },
    {
     "ProvName": "Buenas Aires city",
     "zoomlevel": 5.8,
     "X": -58.614478,
     "Y": -34.412699
    },
    {
     "ProvName": "Janub Sina' (North Sinai)",
     "zoomlevel": 5.8,
     "X": 33.802436,
     "Y": 29.014106
    },
    {
     "ProvName": "Debub",
     "zoomlevel": 5.8,
     "X": 38.900471,
     "Y": 14.798938
    },
    {
     "ProvName": "Minsk City",
     "zoomlevel": 4.3,
     "X": 27.604357,
     "Y": 53.8969
    },
    {
     "ProvName": "Gash Barka",
     "zoomlevel": 5.8,
     "X": 37.418643,
     "Y": 15.186477
    },
    {
     "ProvName": "Maekel",
     "zoomlevel": 5.8,
     "X": 38.967002,
     "Y": 15.320939
    },
    {
     "ProvName": "Semenawi Keyh Bahri",
     "zoomlevel": 5.8,
     "X": 39.1005,
     "Y": 16.136417
    },
    {
     "ProvName": "Ameba",
     "zoomlevel": 5.8,
     "X": 37.79838,
     "Y": 16.430458
    },
    {
     "ProvName": "Debubawi Keyh Bahri",
     "zoomlevel": 5.8,
     "X": 41.693146,
     "Y": 13.615992
    },
    {
     "ProvName": "Ali Sabih (Ali-Sabieh)",
     "zoomlevel": 5.8,
     "X": 42.894014,
     "Y": 11.228874
    },
    {
     "ProvName": "Djibouti",
     "zoomlevel": 5.8,
     "X": 43.045843,
     "Y": 11.557745
    },
    {
     "ProvName": "Tadjoura (Tadjourah)",
     "zoomlevel": 5.8,
     "X": 42.522761,
     "Y": 11.999384
    },
    {
     "ProvName": "Nordrhein-Westfalen",
     "zoomlevel": 5.8,
     "X": 7.553515,
     "Y": 51.47361
    },
    {
     "ProvName": "Baden-Württemberg",
     "zoomlevel": 5.8,
     "X": 9.052538,
     "Y": 48.542391
    },
    {
     "ProvName": "Hessen",
     "zoomlevel": 5.8,
     "X": 9.036191,
     "Y": 50.601367
    },
    {
     "ProvName": "Aruba",
     "zoomlevel": 5.8,
     "X": -69.973447,
     "Y": 12.516778
    },
    {
     "ProvName": "Shizuoka",
     "zoomlevel": 5.8,
     "X": 138.318311,
     "Y": 35.004289
    },
    {
     "ProvName": "Arta",
     "zoomlevel": 5.8,
     "X": 42.724668,
     "Y": 11.445266
    },
    {
     "ProvName": "Dikhil",
     "zoomlevel": 5.8,
     "X": 42.120363,
     "Y": 11.366136
    },
    {
     "ProvName": "Obock",
     "zoomlevel": 5.8,
     "X": 43.075358,
     "Y": 12.287997
    },
    {
     "ProvName": "Hamburg",
     "zoomlevel": 5.8,
     "X": 10.030461,
     "Y": 53.544168
    },
    {
     "ProvName": "Schleswig Holstein",
     "zoomlevel": 5.8,
     "X": 9.830662,
     "Y": 54.182446
    },
    {
     "ProvName": "Rheinland-Pfalz",
     "zoomlevel": 5.8,
     "X": 7.44363,
     "Y": 49.906628
    },
    {
     "ProvName": "Saarland",
     "zoomlevel": 5.8,
     "X": 6.941069,
     "Y": 49.377062
    },
    {
     "ProvName": "Gaza Strip",
     "zoomlevel": 5.8,
     "X": 34.351906,
     "Y": 31.389951
    },
    {
     "ProvName": "Karlovac",
     "zoomlevel": 5.8,
     "X": 15.452863,
     "Y": 45.284991
    },
    {
     "ProvName": "Zagreb city",
     "zoomlevel": 5.8,
     "X": 16.020871,
     "Y": 45.738423
    },
    {
     "ProvName": "Bayern",
     "zoomlevel": 5.8,
     "X": 11.410908,
     "Y": 48.941779
    },
    {
     "ProvName": "Lika-Senj",
     "zoomlevel": 5.8,
     "X": 15.231013,
     "Y": 44.72074
    },
    {
     "ProvName": "Berlin",
     "zoomlevel": 5.8,
     "X": 13.404495,
     "Y": 52.500215
    },
    {
     "ProvName": "Primorje-Gorski Kotar",
     "zoomlevel": 5.8,
     "X": 14.643122,
     "Y": 45.237106
    },
    {
     "ProvName": "Sachsen-Anhalt",
     "zoomlevel": 5.8,
     "X": 11.696722,
     "Y": 52.000984
    },
    {
     "ProvName": "Sachsen",
     "zoomlevel": 5.8,
     "X": 13.344929,
     "Y": 51.044935
    },
    {
     "ProvName": "Sisak-Moslavina",
     "zoomlevel": 5.8,
     "X": 16.389499,
     "Y": 45.384636
    },
    {
     "ProvName": "Saint Pierre & Miquelon",
     "zoomlevel": 5.8,
     "X": -56.307097,
     "Y": 46.930191
    },
    {
     "ProvName": "Zagreb",
     "zoomlevel": 5.8,
     "X": 15.992343,
     "Y": 45.80489
    },
    {
     "ProvName": "Ganzourgou",
     "zoomlevel": 5.8,
     "X": -0.764014,
     "Y": 12.232904
    },
    {
     "ProvName": "Istria",
     "zoomlevel": 5.8,
     "X": 13.892614,
     "Y": 45.20485
    },
    {
     "ProvName": "Ocnita",
     "zoomlevel": 5.8,
     "X": 27.528934,
     "Y": 48.371113
    },
    {
     "ProvName": "Toyama",
     "zoomlevel": 5.8,
     "X": 137.236332,
     "Y": 36.628495
    },
    {
     "ProvName": "Hokkaido (Territory)",
     "zoomlevel": 5.8,
     "X": 142.566899,
     "Y": 43.382748
    },
    {
     "ProvName": "Fukui",
     "zoomlevel": 5.8,
     "X": 136.201244,
     "Y": 35.825996
    },
    {
     "ProvName": "Brod-Posavina",
     "zoomlevel": 5.8,
     "X": 17.750843,
     "Y": 45.209609
    },
    {
     "ProvName": "Hyogo",
     "zoomlevel": 5.8,
     "X": 134.823349,
     "Y": 35.034379
    },
    {
     "ProvName": "Praha",
     "zoomlevel": 5.8,
     "X": 14.452957,
     "Y": 50.063984
    },
    {
     "ProvName": "Stredoceský",
     "zoomlevel": 5.8,
     "X": 14.542929,
     "Y": 49.990839
    },
    {
     "ProvName": "Kouritenga",
     "zoomlevel": 5.8,
     "X": -0.292635,
     "Y": 12.168182
    },
    {
     "ProvName": "Osijek-Baranja",
     "zoomlevel": 5.8,
     "X": 18.512613,
     "Y": 45.569031
    },
    {
     "ProvName": "Preah Sihanouk",
     "zoomlevel": 5.8,
     "X": 103.767382,
     "Y": 10.697494
    },
    {
     "ProvName": "Pozega-Slavonija",
     "zoomlevel": 5.8,
     "X": 17.700126,
     "Y": 45.424371
    },
    {
     "ProvName": "Varazdin",
     "zoomlevel": 5.8,
     "X": 16.317493,
     "Y": 46.241327
    },
    {
     "ProvName": "Vukovar-Srijem",
     "zoomlevel": 5.8,
     "X": 18.891517,
     "Y": 45.181301
    },
    {
     "ProvName": "Virovitica-Podravina",
     "zoomlevel": 5.8,
     "X": 17.615474,
     "Y": 45.730732
    },
    {
     "ProvName": "Jersey",
     "zoomlevel": 5.8,
     "X": -2.126824,
     "Y": 49.220805
    },
    {
     "ProvName": "Bjelovar-Bilogora",
     "zoomlevel": 5.8,
     "X": 16.988559,
     "Y": 45.735205
    },
    {
     "ProvName": "Jihomoravský",
     "zoomlevel": 5.8,
     "X": 16.688373,
     "Y": 49.116572
    },
    {
     "ProvName": "Koprivnica-Krizevci",
     "zoomlevel": 5.8,
     "X": 16.817412,
     "Y": 46.088998
    },
    {
     "ProvName": "Medimurje",
     "zoomlevel": 5.8,
     "X": 16.510282,
     "Y": 46.406644
    },
    {
     "ProvName": "Briceni",
     "zoomlevel": 5.8,
     "X": 27.010225,
     "Y": 48.281877
    },
    {
     "ProvName": "Kyoto",
     "zoomlevel": 5.8,
     "X": 135.431651,
     "Y": 35.24457
    },
    {
     "ProvName": "Nara",
     "zoomlevel": 5.8,
     "X": 135.85972,
     "Y": 34.293995
    },
    {
     "ProvName": "Ogooué-Maritime",
     "zoomlevel": 5.8,
     "X": 9.665526,
     "Y": -1.561761
    },
    {
     "ProvName": "Guernsey",
     "zoomlevel": 5.8,
     "X": -2.531014,
     "Y": 49.484318
    },
    {
     "ProvName": "Kgalagadi",
     "zoomlevel": 4.8,
     "X": 21.741861,
     "Y": -24.8544
    },
    {
     "ProvName": "Kotayk",
     "zoomlevel": 5.8,
     "X": 44.692995,
     "Y": 40.380148
    },
    {
     "ProvName": "Western Australia",
     "zoomlevel": 3.81,
     "X": 122.176297,
     "Y": -25.465993
    },
    {
     "ProvName": "Bouenza",
     "zoomlevel": 5.8,
     "X": 13.560085,
     "Y": -4.061198
    },
    {
     "ProvName": "Nahouri",
     "zoomlevel": 5.8,
     "X": -1.206102,
     "Y": 11.198766
    },
    {
     "ProvName": "Haut-Ogooué",
     "zoomlevel": 5.8,
     "X": 13.714903,
     "Y": -1.342975
    },
    {
     "ProvName": "Rîscani",
     "zoomlevel": 5.8,
     "X": 27.538541,
     "Y": 47.916244
    },
    {
     "ProvName": "Pando",
     "zoomlevel": 5.8,
     "X": -67.3458,
     "Y": -11.086641
    },
    {
     "ProvName": "Potosí",
     "zoomlevel": 5.8,
     "X": -66.732593,
     "Y": -20.572162
    },
    {
     "ProvName": "United States Virgin Islands",
     "zoomlevel": 5.8,
     "X": -64.79016,
     "Y": 17.959079
    },
    {
     "ProvName": "Transnistria",
     "zoomlevel": 5.8,
     "X": 29.307288,
     "Y": 47.327383
    },
    {
     "ProvName": "Hîncesti",
     "zoomlevel": 5.8,
     "X": 28.40924,
     "Y": 46.827245
    },
    {
     "ProvName": "Santa Cruz",
     "zoomlevel": 5.8,
     "X": -61.506099,
     "Y": -17.242663
    },
    {
     "ProvName": "Tarija",
     "zoomlevel": 5.8,
     "X": -63.874796,
     "Y": -21.589091
    },
    {
     "ProvName": "al-Dakhiliyah",
     "zoomlevel": 5.8,
     "X": 57.44246,
     "Y": 22.449711
    },
    {
     "ProvName": "Panjshir",
     "zoomlevel": 5.8,
     "X": 69.786125,
     "Y": 35.440906
    },
    {
     "ProvName": "Ogooué-Lolo",
     "zoomlevel": 5.8,
     "X": 12.615601,
     "Y": -0.849703
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 32.238116,
     "Y": 0.13162
    },
    {
     "ProvName": "Leova",
     "zoomlevel": 5.8,
     "X": 28.412904,
     "Y": 46.552627
    },
    {
     "ProvName": "Sabaragamuwa",
     "zoomlevel": 5.8,
     "X": 80.490983,
     "Y": 6.761085
    },
    {
     "ProvName": "Southern",
     "zoomlevel": 5.8,
     "X": 80.722796,
     "Y": 6.222201
    },
    {
     "ProvName": "Laghman",
     "zoomlevel": 5.8,
     "X": 70.145358,
     "Y": 34.761921
    },
    {
     "ProvName": "Uva",
     "zoomlevel": 5.8,
     "X": 81.218518,
     "Y": 6.880588
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 80.063764,
     "Y": 6.834715
    },
    {
     "ProvName": "Järva (Paide)",
     "zoomlevel": 5.8,
     "X": 25.666667,
     "Y": 58.940196
    },
    {
     "ProvName": "Kayah",
     "zoomlevel": 5.8,
     "X": 97.371067,
     "Y": 19.23433
    },
    {
     "ProvName": "Andaman\/Nicobar Islands",
     "zoomlevel": 5.8,
     "X": 92.975454,
     "Y": 11.146737
    },
    {
     "ProvName": "Causeni",
     "zoomlevel": 5.8,
     "X": 29.260922,
     "Y": 46.633581
    },
    {
     "ProvName": "Hiiu",
     "zoomlevel": 5.8,
     "X": 22.618815,
     "Y": 58.893353
    },
    {
     "ProvName": "Harju",
     "zoomlevel": 5.8,
     "X": 24.924352,
     "Y": 59.310963
    },
    {
     "ProvName": "Ida-Viru",
     "zoomlevel": 5.8,
     "X": 27.327194,
     "Y": 59.177848
    },
    {
     "ProvName": "Jõgeva",
     "zoomlevel": 5.8,
     "X": 26.536823,
     "Y": 58.722186
    },
    {
     "ProvName": "Lääne-Viru (Rakvere)",
     "zoomlevel": 5.8,
     "X": 26.355664,
     "Y": 59.266015
    },
    {
     "ProvName": "Tartu",
     "zoomlevel": 5.8,
     "X": 26.829847,
     "Y": 58.392721
    },
    {
     "ProvName": "Lääne (Haapsalu)",
     "zoomlevel": 5.8,
     "X": 23.760446,
     "Y": 58.901347
    },
    {
     "ProvName": "Al-Asimah (Al-Kuwayt)",
     "zoomlevel": 5.8,
     "X": 48.09872,
     "Y": 29.386892
    },
    {
     "ProvName": "al-Farwaniyah",
     "zoomlevel": 5.8,
     "X": 47.938815,
     "Y": 29.259022
    },
    {
     "ProvName": "Pailin",
     "zoomlevel": 5.8,
     "X": 102.620473,
     "Y": 12.87658
    },
    {
     "ProvName": "Shiga",
     "zoomlevel": 5.8,
     "X": 136.122711,
     "Y": 35.201237
    },
    {
     "ProvName": "Rotanak Kiri",
     "zoomlevel": 5.8,
     "X": 107.051547,
     "Y": 13.822455
    },
    {
     "ProvName": "al-Ahmadi",
     "zoomlevel": 5.8,
     "X": 47.929183,
     "Y": 28.828028
    },
    {
     "ProvName": "Mubarak Al-Kabir",
     "zoomlevel": 5.8,
     "X": 48.055218,
     "Y": 29.253858
    },
    {
     "ProvName": "Zoundwéogo",
     "zoomlevel": 5.8,
     "X": -0.973844,
     "Y": 11.556029
    },
    {
     "ProvName": "al-Jahra'",
     "zoomlevel": 5.8,
     "X": 47.441933,
     "Y": 29.541418
    },
    {
     "ProvName": "Ganja-Gazakh",
     "zoomlevel": 5.8,
     "X": 46.053241,
     "Y": 40.741967
    },
    {
     "ProvName": "Hariai",
     "zoomlevel": 5.8,
     "X": 42.175859,
     "Y": 9.291075
    },
    {
     "ProvName": "Tavush",
     "zoomlevel": 5.8,
     "X": 45.119488,
     "Y": 40.899515
    },
    {
     "ProvName": "Ararat",
     "zoomlevel": 5.8,
     "X": 44.788502,
     "Y": 39.945848
    },
    {
     "ProvName": "Gegharkunik",
     "zoomlevel": 5.8,
     "X": 45.33725,
     "Y": 40.292856
    },
    {
     "ProvName": "Lori",
     "zoomlevel": 5.8,
     "X": 44.459717,
     "Y": 40.965388
    },
    {
     "ProvName": "Yerevan",
     "zoomlevel": 5.8,
     "X": 44.536223,
     "Y": 40.147432
    },
    {
     "ProvName": "Yukhari Karabakh",
     "zoomlevel": 5.8,
     "X": 46.988574,
     "Y": 39.778478
    },
    {
     "ProvName": "Kalbajar-Lachin",
     "zoomlevel": 5.8,
     "X": 46.331844,
     "Y": 39.759459
    },
    {
     "ProvName": "Aran",
     "zoomlevel": 5.8,
     "X": 48.12873,
     "Y": 40.021192
    },
    {
     "ProvName": "Baku",
     "zoomlevel": 5.8,
     "X": 49.768193,
     "Y": 40.306101
    },
    {
     "ProvName": "Absheron",
     "zoomlevel": 5.8,
     "X": 49.258619,
     "Y": 40.533101
    },
    {
     "ProvName": "Dakhlik Shirvan",
     "zoomlevel": 5.8,
     "X": 48.480742,
     "Y": 40.640752
    },
    {
     "ProvName": "Lankaran",
     "zoomlevel": 5.8,
     "X": 48.557053,
     "Y": 38.925635
    },
    {
     "ProvName": "Kepulauan Riau",
     "zoomlevel": 5.8,
     "X": 105.531745,
     "Y": 1.54397
    },
    {
     "ProvName": "Barisal",
     "zoomlevel": 5.8,
     "X": 90.336256,
     "Y": 22.449717
    },
    {
     "ProvName": "Muyinga",
     "zoomlevel": 5.8,
     "X": 30.341099,
     "Y": -2.775407
    },
    {
     "ProvName": "Guba-Khachmaz",
     "zoomlevel": 5.8,
     "X": 48.593536,
     "Y": 41.265807
    },
    {
     "ProvName": "Shaki-Zagatala",
     "zoomlevel": 5.8,
     "X": 47.09488,
     "Y": 41.23446
    },
    {
     "ProvName": "Syunik",
     "zoomlevel": 5.8,
     "X": 46.139803,
     "Y": 39.346893
    },
    {
     "ProvName": "Vayots-Dzor",
     "zoomlevel": 5.8,
     "X": 45.441497,
     "Y": 39.751332
    },
    {
     "ProvName": "Wallis & Futuna Islands",
     "zoomlevel": 5.8,
     "X": -177.229018,
     "Y": -13.847131
    },
    {
     "ProvName": "Badghis",
     "zoomlevel": 5.8,
     "X": 63.738111,
     "Y": 35.145955
    },
    {
     "ProvName": "Herat",
     "zoomlevel": 4.5,
     "X": 62.127711,
     "Y": 34.189843
    },
    {
     "ProvName": "Khost",
     "zoomlevel": 5.8,
     "X": 69.833108,
     "Y": 33.358211
    },
    {
     "ProvName": "Shumen",
     "zoomlevel": 5.8,
     "X": 26.983254,
     "Y": 43.294168
    },
    {
     "ProvName": "Bamian",
     "zoomlevel": 5.8,
     "X": 67.237533,
     "Y": 34.803255
    },
    {
     "ProvName": "Dobrich",
     "zoomlevel": 5.8,
     "X": 27.927191,
     "Y": 43.649339
    },
    {
     "ProvName": "Balkh",
     "zoomlevel": 5.8,
     "X": 67.092222,
     "Y": 36.681448
    },
    {
     "ProvName": "Dedza",
     "zoomlevel": 5.8,
     "X": 34.258634,
     "Y": -14.249777
    },
    {
     "ProvName": "Faryab",
     "zoomlevel": 5.8,
     "X": 64.862746,
     "Y": 36.063975
    },
    {
     "ProvName": "La Massana",
     "zoomlevel": 5.8,
     "X": 1.471388,
     "Y": 42.552524
    },
    {
     "ProvName": "Andorra la Vella",
     "zoomlevel": 5.8,
     "X": 1.512499,
     "Y": 42.499898
    },
    {
     "ProvName": "Jowzjan",
     "zoomlevel": 5.8,
     "X": 65.843261,
     "Y": 36.827105
    },
    {
     "ProvName": "Ghowr",
     "zoomlevel": 5.8,
     "X": 64.892311,
     "Y": 34.169275
    },
    {
     "ProvName": "Svay Rieng",
     "zoomlevel": 5.8,
     "X": 105.854853,
     "Y": 11.139591
    },
    {
     "ProvName": "Sant Juli? de Lòria",
     "zoomlevel": 5.8,
     "X": 1.485036,
     "Y": 42.463769
    },
    {
     "ProvName": "Sar-e-Pol",
     "zoomlevel": 5.8,
     "X": 66.147825,
     "Y": 35.742106
    },
    {
     "ProvName": "Farah",
     "zoomlevel": 4.5,
     "X": 62.283463,
     "Y": 32.603118
    },
    {
     "ProvName": "Helmand",
     "zoomlevel": 4.5,
     "X": 64.043673,
     "Y": 31.123355
    },
    {
     "ProvName": "Les Escaldes-Engordany",
     "zoomlevel": 5.8,
     "X": 1.593466,
     "Y": 42.489202
    },
    {
     "ProvName": "Serb Republic",
     "zoomlevel": 5.8,
     "X": 18.075524,
     "Y": 44.257476
    },
    {
     "ProvName": "Nimruz",
     "zoomlevel": 4.5,
     "X": 62.339362,
     "Y": 30.813931
    },
    {
     "ProvName": "Konduz",
     "zoomlevel": 5.8,
     "X": 68.741388,
     "Y": 36.846163
    },
    {
     "ProvName": "Oruzgan",
     "zoomlevel": 5.8,
     "X": 66.045518,
     "Y": 32.855631
    },
    {
     "ProvName": "Encamp",
     "zoomlevel": 5.8,
     "X": 1.64795,
     "Y": 42.531743
    },
    {
     "ProvName": "Daikondi",
     "zoomlevel": 5.8,
     "X": 66.166464,
     "Y": 33.735247
    },
    {
     "ProvName": "Antigua",
     "zoomlevel": 5.8,
     "X": -61.788873,
     "Y": 17.074605
    },
    {
     "ProvName": "Buenos Aires",
     "zoomlevel": 3.38,
     "X": -60.565019,
     "Y": -36.683418
    },
    {
     "ProvName": "Kandahar",
     "zoomlevel": 4.5,
     "X": 65.707537,
     "Y": 31.045299
    },
    {
     "ProvName": "Zabol",
     "zoomlevel": 5.8,
     "X": 67.142214,
     "Y": 32.207418
    },
    {
     "ProvName": "Ghazni",
     "zoomlevel": 5.8,
     "X": 67.807273,
     "Y": 33.316916
    },
    {
     "ProvName": "Anguilla",
     "zoomlevel": 5.8,
     "X": -63.060822,
     "Y": 18.225596
    },
    {
     "ProvName": "Paktika",
     "zoomlevel": 5.8,
     "X": 68.733965,
     "Y": 32.480109
    },
    {
     "ProvName": "Badakhshan",
     "zoomlevel": 5.8,
     "X": 71.441022,
     "Y": 37.035928
    },
    {
     "ProvName": "Nangarhar",
     "zoomlevel": 5.8,
     "X": 70.453989,
     "Y": 34.273036
    },
    {
     "ProvName": "Nurestan",
     "zoomlevel": 5.8,
     "X": 70.777837,
     "Y": 35.409393
    },
    {
     "ProvName": "Konar",
     "zoomlevel": 5.8,
     "X": 71.077804,
     "Y": 34.955903
    },
    {
     "ProvName": "American Samoa",
     "zoomlevel": 5.8,
     "X": -170.397589,
     "Y": -14.254984
    },
    {
     "ProvName": "Takhar",
     "zoomlevel": 5.8,
     "X": 69.771407,
     "Y": 36.702542
    },
    {
     "ProvName": "Kapisa",
     "zoomlevel": 5.8,
     "X": 69.618789,
     "Y": 34.959681
    },
    {
     "ProvName": "Barbuda",
     "zoomlevel": 5.8,
     "X": -61.794516,
     "Y": 17.631703
    },
    {
     "ProvName": "Baghlan",
     "zoomlevel": 5.8,
     "X": 68.910879,
     "Y": 35.798778
    },
    {
     "ProvName": "Kabul",
     "zoomlevel": 5.8,
     "X": 69.322396,
     "Y": 34.553839
    },
    {
     "ProvName": "Lowgar",
     "zoomlevel": 5.8,
     "X": 69.169499,
     "Y": 34.014477
    },
    {
     "ProvName": "Parvan",
     "zoomlevel": 5.8,
     "X": 68.886549,
     "Y": 34.953928
    },
    {
     "ProvName": "Takaev",
     "zoomlevel": 5.8,
     "X": 104.816994,
     "Y": 10.950058
    },
    {
     "ProvName": "Samangan",
     "zoomlevel": 5.8,
     "X": 67.70108,
     "Y": 35.976237
    },
    {
     "ProvName": "Bat Dambang",
     "zoomlevel": 5.8,
     "X": 103.075535,
     "Y": 13.01231
    },
    {
     "ProvName": "Vardak",
     "zoomlevel": 5.8,
     "X": 68.225945,
     "Y": 34.313889
    },
    {
     "ProvName": "Banteay Mean Chey",
     "zoomlevel": 5.8,
     "X": 103.00624,
     "Y": 13.737434
    },
    {
     "ProvName": "Kaoh Kong",
     "zoomlevel": 5.8,
     "X": 103.476159,
     "Y": 11.488839
    },
    {
     "ProvName": "Pousat",
     "zoomlevel": 5.8,
     "X": 103.630793,
     "Y": 12.405084
    },
    {
     "ProvName": "Siem Reab",
     "zoomlevel": 5.8,
     "X": 104.048291,
     "Y": 13.608631
    },
    {
     "ProvName": "Dhaka",
     "zoomlevel": 5.8,
     "X": 90.288174,
     "Y": 24.178123
    },
    {
     "ProvName": "Osaka",
     "zoomlevel": 5.8,
     "X": 135.498748,
     "Y": 34.596981
    },
    {
     "ProvName": "Wakayama",
     "zoomlevel": 5.8,
     "X": 135.501767,
     "Y": 33.900335
    },
    {
     "ProvName": "Chiba",
     "zoomlevel": 5.8,
     "X": 140.202312,
     "Y": 35.507067
    },
    {
     "ProvName": "Ibaraki",
     "zoomlevel": 5.8,
     "X": 140.312865,
     "Y": 36.295185
    },
    {
     "ProvName": "Kanagawa",
     "zoomlevel": 5.8,
     "X": 139.324051,
     "Y": 35.39726
    },
    {
     "ProvName": "Saitama",
     "zoomlevel": 5.8,
     "X": 139.322127,
     "Y": 35.987329
    },
    {
     "ProvName": "Tochigi",
     "zoomlevel": 5.8,
     "X": 139.797146,
     "Y": 36.68429
    },
    {
     "ProvName": "Kigali city",
     "zoomlevel": 5.8,
     "X": 30.12113,
     "Y": -1.934091
    },
    {
     "ProvName": "Tokyo",
     "zoomlevel": 5.8,
     "X": 139.564731,
     "Y": 35.066266
    },
    {
     "ProvName": "Yamanashi",
     "zoomlevel": 5.8,
     "X": 138.592396,
     "Y": 35.599894
    },
    {
     "ProvName": "Akita",
     "zoomlevel": 5.8,
     "X": 140.402984,
     "Y": 39.747416
    },
    {
     "ProvName": "Fukushima",
     "zoomlevel": 5.8,
     "X": 140.213902,
     "Y": 37.372044
    },
    {
     "ProvName": "Aomori",
     "zoomlevel": 5.8,
     "X": 140.837637,
     "Y": 40.782521
    },
    {
     "ProvName": "Yamagata",
     "zoomlevel": 5.8,
     "X": 140.089163,
     "Y": 38.435151
    },
    {
     "ProvName": "Bandundu",
     "zoomlevel": 3.8,
     "X": 18.361276,
     "Y": -4.400298
    },
    {
     "ProvName": "Kasai Occidental",
     "zoomlevel": 3.8,
     "X": 21.622085,
     "Y": -5.41261
    },
    {
     "ProvName": "Iwate",
     "zoomlevel": 5.8,
     "X": 141.358727,
     "Y": 39.593429
    },
    {
     "ProvName": "Mchinji",
     "zoomlevel": 5.8,
     "X": 33.053586,
     "Y": -13.695981
    },
    {
     "ProvName": "Miyagi",
     "zoomlevel": 5.8,
     "X": 140.920232,
     "Y": 38.43968
    },
    {
     "ProvName": "Chitipa",
     "zoomlevel": 5.8,
     "X": 33.490905,
     "Y": -9.960012
    },
    {
     "ProvName": "Niigata",
     "zoomlevel": 5.8,
     "X": 138.90234,
     "Y": 37.51464
    },
    {
     "ProvName": "Bumthang",
     "zoomlevel": 5.8,
     "X": 90.701467,
     "Y": 27.701841
    },
    {
     "ProvName": "Lunda Norte",
     "zoomlevel": 3.8,
     "X": 19.523013,
     "Y": -8.606189
    },
    {
     "ProvName": "Lunda Sul",
     "zoomlevel": 3.8,
     "X": 20.648864,
     "Y": -10.179234
    },
    {
     "ProvName": "Malanje",
     "zoomlevel": 3.8,
     "X": 16.992844,
     "Y": -9.516477
    },
    {
     "ProvName": "Jubbada Hoose",
     "zoomlevel": 5.8,
     "X": 41.78423,
     "Y": 0.08218
    },
    {
     "ProvName": "Bengo",
     "zoomlevel": 5.8,
     "X": 13.880194,
     "Y": -8.980306
    },
    {
     "ProvName": "Peravia",
     "zoomlevel": 5.8,
     "X": -70.37274,
     "Y": 18.333485
    },
    {
     "ProvName": "Ntcheu",
     "zoomlevel": 5.8,
     "X": 34.709296,
     "Y": -14.805744
    },
    {
     "ProvName": "Kuanza Norte",
     "zoomlevel": 5.8,
     "X": 14.939332,
     "Y": -8.898841
    },
    {
     "ProvName": "Kinshasa",
     "zoomlevel": 5.8,
     "X": 15.92091,
     "Y": -4.442958
    },
    {
     "ProvName": "Kuanza Sul",
     "zoomlevel": 3.8,
     "X": 15.037173,
     "Y": -10.825696
    },
    {
     "ProvName": "Chittagong Hill Tracts",
     "zoomlevel": 5.8,
     "X": 91.40778,
     "Y": 22.788119
    },
    {
     "ProvName": "Assam",
     "zoomlevel": 5.8,
     "X": 92.831058,
     "Y": 26.356908
    },
    {
     "ProvName": "Manipur",
     "zoomlevel": 5.8,
     "X": 93.86141,
     "Y": 24.730443
    },
    {
     "ProvName": "Cabinda",
     "zoomlevel": 5.8,
     "X": 12.455482,
     "Y": -5.034772
    },
    {
     "ProvName": "Bié",
     "zoomlevel": 3.8,
     "X": 17.358274,
     "Y": -12.323821
    },
    {
     "ProvName": "Nagaland",
     "zoomlevel": 5.8,
     "X": 94.448211,
     "Y": 26.059832
    },
    {
     "ProvName": "Ntchisi",
     "zoomlevel": 5.8,
     "X": 33.907687,
     "Y": -13.304314
    },
    {
     "ProvName": "Luanda",
     "zoomlevel": 5.8,
     "X": 13.322306,
     "Y": -8.958444
    },
    {
     "ProvName": "Salima",
     "zoomlevel": 5.8,
     "X": 34.512259,
     "Y": -13.716092
    },
    {
     "ProvName": "Balaka",
     "zoomlevel": 5.8,
     "X": 35.081332,
     "Y": -15.029775
    },
    {
     "ProvName": "Uíge",
     "zoomlevel": 5.8,
     "X": 15.469859,
     "Y": -7.02299
    },
    {
     "ProvName": "Zaire",
     "zoomlevel": 5.8,
     "X": 13.560504,
     "Y": -6.601886
    },
    {
     "ProvName": "Huambo",
     "zoomlevel": 3.8,
     "X": 15.741115,
     "Y": -12.567268
    },
    {
     "ProvName": "Bas-Congo",
     "zoomlevel": 5.8,
     "X": 14.317116,
     "Y": -5.274929
    },
    {
     "ProvName": "North Bank",
     "zoomlevel": 5.8,
     "X": -16.033476,
     "Y": 13.506961
    },
    {
     "ProvName": "Benguela",
     "zoomlevel": 3.8,
     "X": 13.978769,
     "Y": -12.932663
    },
    {
     "ProvName": "Kuando Kubango",
     "zoomlevel": 3.8,
     "X": 19.497518,
     "Y": -16.109991
    },
    {
     "ProvName": "Cunene",
     "zoomlevel": 3.8,
     "X": 15.580133,
     "Y": -16.50045
    },
    {
     "ProvName": "Huíla",
     "zoomlevel": 3.8,
     "X": 14.946515,
     "Y": -14.742068
    },
    {
     "ProvName": "Moxico",
     "zoomlevel": 3.8,
     "X": 21.027045,
     "Y": -12.880807
    },
    {
     "ProvName": "Rumphi",
     "zoomlevel": 5.8,
     "X": 33.997216,
     "Y": -10.797349
    },
    {
     "ProvName": "Namibe",
     "zoomlevel": 3.8,
     "X": 12.722724,
     "Y": -15.484409
    },
    {
     "ProvName": "al-Buraymi",
     "zoomlevel": 5.8,
     "X": 55.835099,
     "Y": 23.893558
    },
    {
     "ProvName": "Sud-Kivu",
     "zoomlevel": 5.8,
     "X": 28.245689,
     "Y": -3.21682
    },
    {
     "ProvName": "Maniema",
     "zoomlevel": 3.8,
     "X": 26.409727,
     "Y": -3.096537
    },
    {
     "ProvName": "Kasai Oriental",
     "zoomlevel": 3.8,
     "X": 23.945124,
     "Y": -4.545104
    },
    {
     "ProvName": "Katanga",
     "zoomlevel": 3.8,
     "X": 26.387195,
     "Y": -8.758229
    },
    {
     "ProvName": "Nord-Kivu",
     "zoomlevel": 5.8,
     "X": 28.674969,
     "Y": -0.598268
    },
    {
     "ProvName": "Kasungu",
     "zoomlevel": 5.8,
     "X": 33.382915,
     "Y": -12.978656
    },
    {
     "ProvName": "Machinga",
     "zoomlevel": 5.8,
     "X": 35.566836,
     "Y": -14.935766
    },
    {
     "ProvName": "Sofala",
     "zoomlevel": 5.8,
     "X": 34.677294,
     "Y": -19.050747
    },
    {
     "ProvName": "Zambézia",
     "zoomlevel": 5.8,
     "X": 36.979811,
     "Y": -16.656584
    },
    {
     "ProvName": "Chikwawa",
     "zoomlevel": 5.8,
     "X": 34.696261,
     "Y": -16.166262
    },
    {
     "ProvName": "Mzimba",
     "zoomlevel": 5.8,
     "X": 33.632885,
     "Y": -11.756305
    },
    {
     "ProvName": "Nkhotakota",
     "zoomlevel": 5.8,
     "X": 34.208096,
     "Y": -12.794615
    },
    {
     "ProvName": "Dowa",
     "zoomlevel": 5.8,
     "X": 33.802925,
     "Y": -13.582067
    },
    {
     "ProvName": "Lilongwe",
     "zoomlevel": 5.8,
     "X": 33.683682,
     "Y": -14.015471
    },
    {
     "ProvName": "Mangochi",
     "zoomlevel": 5.8,
     "X": 35.133913,
     "Y": -14.263821
    },
    {
     "ProvName": "San Jose de Ocoa",
     "zoomlevel": 5.8,
     "X": -70.497926,
     "Y": 18.610716
    },
    {
     "ProvName": "Esfahan (Isfahan)",
     "zoomlevel": 4.5,
     "X": 52.464413,
     "Y": 33.181525
    },
    {
     "ProvName": "Chiradzulu",
     "zoomlevel": 5.8,
     "X": 35.223286,
     "Y": -15.752078
    },
    {
     "ProvName": "Thyolo",
     "zoomlevel": 5.8,
     "X": 35.139158,
     "Y": -16.107309
    },
    {
     "ProvName": "Nsanje",
     "zoomlevel": 5.8,
     "X": 35.135952,
     "Y": -16.773331
    },
    {
     "ProvName": "Zomba",
     "zoomlevel": 5.8,
     "X": 35.434806,
     "Y": -15.40766
    },
    {
     "ProvName": "Mulanje",
     "zoomlevel": 5.8,
     "X": 35.499121,
     "Y": -15.946299
    },
    {
     "ProvName": "Phalombe",
     "zoomlevel": 5.8,
     "X": 35.684727,
     "Y": -15.697849
    },
    {
     "ProvName": "Inhambane",
     "zoomlevel": 4.8,
     "X": 34.509498,
     "Y": -22.809776
    },
    {
     "ProvName": "Eastern Cape",
     "zoomlevel": 4.8,
     "X": 26.461846,
     "Y": -32.140368
    },
    {
     "ProvName": "Huehuetenango",
     "zoomlevel": 5.8,
     "X": -91.560167,
     "Y": 15.661974
    },
    {
     "ProvName": "Jambi",
     "zoomlevel": 5.8,
     "X": 102.751704,
     "Y": -1.692849
    },
    {
     "ProvName": "Kalimantan Tengah",
     "zoomlevel": 5.8,
     "X": 113.428637,
     "Y": -1.596634
    },
    {
     "ProvName": "New South Wales",
     "zoomlevel": 3.81,
     "X": 147.016305,
     "Y": -32.169098
    },
    {
     "ProvName": "Papua Barat",
     "zoomlevel": 5.8,
     "X": 132.951214,
     "Y": -2.007517
    },
    {
     "ProvName": "Retalhuleu",
     "zoomlevel": 5.8,
     "X": -91.782619,
     "Y": 14.439316
    },
    {
     "ProvName": "Temotu",
     "zoomlevel": 5.8,
     "X": 166.241936,
     "Y": -10.971346
    },
    {
     "ProvName": "La Paz",
     "zoomlevel": 5.8,
     "X": -68.148135,
     "Y": -15.193685
    },
    {
     "ProvName": "Oruro",
     "zoomlevel": 5.8,
     "X": -67.696046,
     "Y": -18.649002
    },
    {
     "ProvName": "Baja Verapaz",
     "zoomlevel": 5.8,
     "X": -90.418135,
     "Y": 15.105271
    },
    {
     "ProvName": "Petén",
     "zoomlevel": 5.8,
     "X": -90.027158,
     "Y": 16.972055
    },
    {
     "ProvName": "Quetzaltenango",
     "zoomlevel": 5.8,
     "X": -91.72739,
     "Y": 14.804022
    },
    {
     "ProvName": "San Marcos",
     "zoomlevel": 5.8,
     "X": -91.953565,
     "Y": 15.013568
    },
    {
     "ProvName": "Escuintla",
     "zoomlevel": 5.8,
     "X": -90.992157,
     "Y": 14.170893
    },
    {
     "ProvName": "Collines",
     "zoomlevel": 5.8,
     "X": 2.19392,
     "Y": 8.122728
    },
    {
     "ProvName": "Alta Verapaz",
     "zoomlevel": 5.8,
     "X": -90.144333,
     "Y": 15.638542
    },
    {
     "ProvName": "Chimaltenango",
     "zoomlevel": 5.8,
     "X": -90.932629,
     "Y": 14.703265
    },
    {
     "ProvName": "Guatemala",
     "zoomlevel": 5.8,
     "X": -90.492644,
     "Y": 14.637236
    },
    {
     "ProvName": "Suchitepéquez",
     "zoomlevel": 5.8,
     "X": -91.410149,
     "Y": 14.416129
    },
    {
     "ProvName": "Sacatepéquez",
     "zoomlevel": 5.8,
     "X": -90.743425,
     "Y": 14.578174
    },
    {
     "ProvName": "Eastern Scotland",
     "zoomlevel": 5.8,
     "X": -3.382929,
     "Y": 56.190554
    },
    {
     "ProvName": "Atlantique",
     "zoomlevel": 5.8,
     "X": 2.220161,
     "Y": 6.598156
    },
    {
     "ProvName": "Northumberland and Tyne and Wear",
     "zoomlevel": 5.8,
     "X": -2.012806,
     "Y": 55.210121
    },
    {
     "ProvName": "Tees Valley and Durham",
     "zoomlevel": 5.8,
     "X": -1.678507,
     "Y": 54.656684
    },
    {
     "ProvName": "Littoral",
     "zoomlevel": 5.8,
     "X": 2.424118,
     "Y": 6.363659
    },
    {
     "ProvName": "Hampshire and Isle of Wight",
     "zoomlevel": 5.8,
     "X": -1.28477,
     "Y": 51.02845
    },
    {
     "ProvName": "Fars",
     "zoomlevel": 4.5,
     "X": 53.186086,
     "Y": 29.296379
    },
    {
     "ProvName": "El Progreso",
     "zoomlevel": 5.8,
     "X": -90.070196,
     "Y": 14.918823
    },
    {
     "ProvName": "Sololá",
     "zoomlevel": 5.8,
     "X": -91.25508,
     "Y": 14.726641
    },
    {
     "ProvName": "Totonicapán",
     "zoomlevel": 5.8,
     "X": -91.390551,
     "Y": 15.034968
    },
    {
     "ProvName": "Santa Rosa",
     "zoomlevel": 5.8,
     "X": -90.328707,
     "Y": 14.172408
    },
    {
     "ProvName": "Bocas del Toro",
     "zoomlevel": 5.8,
     "X": -82.591835,
     "Y": 9.207318
    },
    {
     "ProvName": "Izabal",
     "zoomlevel": 5.8,
     "X": -89.038495,
     "Y": 15.552561
    },
    {
     "ProvName": "Chiquimula",
     "zoomlevel": 5.8,
     "X": -89.427505,
     "Y": 14.698192
    },
    {
     "ProvName": "Jalapa",
     "zoomlevel": 5.8,
     "X": -89.948711,
     "Y": 14.632776
    },
    {
     "ProvName": "Jutiapa",
     "zoomlevel": 5.8,
     "X": -89.887115,
     "Y": 14.22629
    },
    {
     "ProvName": "Zacapa",
     "zoomlevel": 5.8,
     "X": -89.496894,
     "Y": 15.051418
    },
    {
     "ProvName": "Kachin",
     "zoomlevel": 5.8,
     "X": 97.333766,
     "Y": 26.083344
    },
    {
     "ProvName": "Puerto Plata",
     "zoomlevel": 5.8,
     "X": -70.801315,
     "Y": 19.744351
    },
    {
     "ProvName": "Dajabón",
     "zoomlevel": 5.8,
     "X": -71.601931,
     "Y": 19.438118
    },
    {
     "ProvName": "Arunachal Pradesh",
     "zoomlevel": 5.8,
     "X": 94.649834,
     "Y": 28.048216
    },
    {
     "ProvName": "Espaillat",
     "zoomlevel": 5.8,
     "X": -70.394343,
     "Y": 19.537611
    },
    {
     "ProvName": "Hermanas Mirabal",
     "zoomlevel": 5.8,
     "X": -70.366517,
     "Y": 19.408974
    },
    {
     "ProvName": "Baoruco",
     "zoomlevel": 5.8,
     "X": -71.330339,
     "Y": 18.514024
    },
    {
     "ProvName": "Barahona",
     "zoomlevel": 5.8,
     "X": -71.209967,
     "Y": 18.170798
    },
    {
     "ProvName": "Mizoram",
     "zoomlevel": 5.8,
     "X": 92.818969,
     "Y": 23.292181
    },
    {
     "ProvName": "Monte Cristi",
     "zoomlevel": 5.8,
     "X": -71.444361,
     "Y": 19.722062
    },
    {
     "ProvName": "Tripura",
     "zoomlevel": 5.8,
     "X": 91.728329,
     "Y": 23.755001
    },
    {
     "ProvName": "Sagaing",
     "zoomlevel": 5.8,
     "X": 95.326599,
     "Y": 24.152245
    },
    {
     "ProvName": "Limassol",
     "zoomlevel": 5.8,
     "X": 32.951271,
     "Y": 34.775636
    },
    {
     "ProvName": "Hwanghae North",
     "zoomlevel": 5.8,
     "X": 126.36798,
     "Y": 38.515045
    },
    {
     "ProvName": "Pyongyang City",
     "zoomlevel": 5.8,
     "X": 125.923475,
     "Y": 38.996161
    },
    {
     "ProvName": "Phyongan South (P'yongan)",
     "zoomlevel": 5.8,
     "X": 126.214102,
     "Y": 39.48659
    },
    {
     "ProvName": "North Eastern Scotland",
     "zoomlevel": 5.8,
     "X": -2.610948,
     "Y": 57.242832
    },
    {
     "ProvName": "Kangwon",
     "zoomlevel": 5.8,
     "X": 127.462492,
     "Y": 38.718194
    },
    {
     "ProvName": "Duarte",
     "zoomlevel": 5.8,
     "X": -70.087758,
     "Y": 19.243449
    },
    {
     "ProvName": "Hato Mayor",
     "zoomlevel": 5.8,
     "X": -69.386135,
     "Y": 18.873727
    },
    {
     "ProvName": "Monte Plata",
     "zoomlevel": 5.8,
     "X": -69.805063,
     "Y": 18.832574
    },
    {
     "ProvName": "Berkshire, Buckinghamshire and Oxfordshire",
     "zoomlevel": 5.8,
     "X": -1.087619,
     "Y": 51.715954
    },
    {
     "ProvName": "Gloucestershire, Wiltshire and Bristol\/Bat",
     "zoomlevel": 5.8,
     "X": -2.109195,
     "Y": 51.520908
    },
    {
     "ProvName": "Bedfordshire and Hertfordshire",
     "zoomlevel": 5.8,
     "X": -0.306461,
     "Y": 51.927667
    },
    {
     "ProvName": "Dorset and Somerset",
     "zoomlevel": 5.8,
     "X": -2.661338,
     "Y": 50.973722
    },
    {
     "ProvName": "Couffo",
     "zoomlevel": 5.8,
     "X": 1.773665,
     "Y": 6.99832
    },
    {
     "ProvName": "Devon",
     "zoomlevel": 5.8,
     "X": -3.810307,
     "Y": 50.759329
    },
    {
     "ProvName": "Leicestershire, Rutland and Northamptonshi",
     "zoomlevel": 5.8,
     "X": -0.946424,
     "Y": 52.48463
    },
    {
     "ProvName": "Ouémé",
     "zoomlevel": 5.8,
     "X": 2.539215,
     "Y": 6.629416
    },
    {
     "ProvName": "East Yorkshire and Northern Lincolnshire",
     "zoomlevel": 5.8,
     "X": -0.491656,
     "Y": 53.782057
    },
    {
     "ProvName": "Derbyshire and Nottinghamshire",
     "zoomlevel": 5.8,
     "X": -1.331681,
     "Y": 53.117878
    },
    {
     "ProvName": "Kuna de Madungandi",
     "zoomlevel": 5.8,
     "X": -78.438033,
     "Y": 9.131686
    },
    {
     "ProvName": "Panamá",
     "zoomlevel": 5.8,
     "X": -79.279799,
     "Y": 8.958364
    },
    {
     "ProvName": "Outer London",
     "zoomlevel": 5.8,
     "X": -0.103857,
     "Y": 51.496114
    },
    {
     "ProvName": "Laghouat",
     "zoomlevel": 5.8,
     "X": 2.699189,
     "Y": 33.559921
    },
    {
     "ProvName": "Inner London",
     "zoomlevel": 5.8,
     "X": -0.08623,
     "Y": 51.501489
    },
    {
     "ProvName": "Lincolnshire",
     "zoomlevel": 5.8,
     "X": -0.243862,
     "Y": 53.106924
    },
    {
     "ProvName": "Northern Ireland",
     "zoomlevel": 5.8,
     "X": -6.693925,
     "Y": 54.60873
    },
    {
     "ProvName": "West Wales and The Valleys",
     "zoomlevel": 5.8,
     "X": -4.025703,
     "Y": 52.359652
    },
    {
     "ProvName": "Darién",
     "zoomlevel": 5.8,
     "X": -77.900064,
     "Y": 8.103936
    },
    {
     "ProvName": "Cheshire",
     "zoomlevel": 5.8,
     "X": -2.516713,
     "Y": 53.201636
    },
    {
     "ProvName": "Cornwall and Isles of Scilly",
     "zoomlevel": 5.8,
     "X": -4.829906,
     "Y": 50.403617
    },
    {
     "ProvName": "East Wales",
     "zoomlevel": 5.8,
     "X": -3.28785,
     "Y": 52.303369
    },
    {
     "ProvName": "Kuna de Wargandi",
     "zoomlevel": 5.8,
     "X": -77.969114,
     "Y": 8.893159
    },
    {
     "ProvName": "North Yorkshire",
     "zoomlevel": 5.8,
     "X": -1.400311,
     "Y": 54.181737
    },
    {
     "ProvName": "Oran",
     "zoomlevel": 5.8,
     "X": -0.632,
     "Y": 35.62973
    },
    {
     "ProvName": "Shropshire and Staffordshire",
     "zoomlevel": 5.8,
     "X": -2.407296,
     "Y": 52.73078
    },
    {
     "ProvName": "Lancashire",
     "zoomlevel": 5.8,
     "X": -2.607398,
     "Y": 53.841299
    },
    {
     "ProvName": "Cumbria",
     "zoomlevel": 5.8,
     "X": -2.893814,
     "Y": 54.591965
    },
    {
     "ProvName": "Adrar",
     "zoomlevel": 3.8,
     "X": -0.443113,
     "Y": 25.703621
    },
    {
     "ProvName": "Sidi bel-Abbès",
     "zoomlevel": 5.8,
     "X": -0.565931,
     "Y": 34.789479
    },
    {
     "ProvName": "Tlemcen",
     "zoomlevel": 5.8,
     "X": -1.422487,
     "Y": 34.733634
    },
    {
     "ProvName": "Béchar",
     "zoomlevel": 3.8,
     "X": -2.646541,
     "Y": 30.164465
    },
    {
     "ProvName": "Naâma",
     "zoomlevel": 5.8,
     "X": -0.782543,
     "Y": 33.274436
    },
    {
     "ProvName": "Igdir",
     "zoomlevel": 5.8,
     "X": 43.967222,
     "Y": 39.877925
    },
    {
     "ProvName": "Jagang (Chagang)",
     "zoomlevel": 5.8,
     "X": 126.481522,
     "Y": 40.764694
    },
    {
     "ProvName": "Central River",
     "zoomlevel": 5.8,
     "X": -14.94269,
     "Y": 13.597206
    },
    {
     "ProvName": "Upper River",
     "zoomlevel": 5.8,
     "X": -14.173069,
     "Y": 13.395231
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": -0.977629,
     "Y": 9.35084
    },
    {
     "ProvName": "Skikda",
     "zoomlevel": 5.8,
     "X": 6.812229,
     "Y": 36.781623
    },
    {
     "ProvName": "Tomsk",
     "zoomlevel": 3,
     "X": 82.138002,
     "Y": 58.497429
    },
    {
     "ProvName": "Tindouf",
     "zoomlevel": 3.8,
     "X": -6.101305,
     "Y": 27.659474
    },
    {
     "ProvName": "Upper East",
     "zoomlevel": 5.8,
     "X": -0.811232,
     "Y": 10.777773
    },
    {
     "ProvName": "Annaba",
     "zoomlevel": 5.8,
     "X": 7.530128,
     "Y": 36.859043
    },
    {
     "ProvName": "Upper West",
     "zoomlevel": 5.8,
     "X": -2.202978,
     "Y": 10.422533
    },
    {
     "ProvName": "Ashanti",
     "zoomlevel": 5.8,
     "X": -1.446173,
     "Y": 6.808083
    },
    {
     "ProvName": "Brong-Ahafo",
     "zoomlevel": 5.8,
     "X": -1.660249,
     "Y": 7.709788
    },
    {
     "ProvName": "Ouargla",
     "zoomlevel": 3.8,
     "X": 6.208963,
     "Y": 30.658117
    },
    {
     "ProvName": "et-Tarf",
     "zoomlevel": 5.8,
     "X": 8.117154,
     "Y": 36.722365
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": -1.193959,
     "Y": 5.560054
    },
    {
     "ProvName": "Kilimanjaro",
     "zoomlevel": 5.8,
     "X": 37.641431,
     "Y": -3.765223
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": -0.425572,
     "Y": 6.402724
    },
    {
     "ProvName": "Jijel",
     "zoomlevel": 5.8,
     "X": 5.961282,
     "Y": 36.70152
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": -2.42494,
     "Y": 5.750356
    },
    {
     "ProvName": "Estuaire",
     "zoomlevel": 5.8,
     "X": 10.040858,
     "Y": 0.30508
    },
    {
     "ProvName": "Varna",
     "zoomlevel": 5.8,
     "X": 27.579992,
     "Y": 43.185596
    },
    {
     "ProvName": "Borgou",
     "zoomlevel": 5.8,
     "X": 2.760785,
     "Y": 9.775616
    },
    {
     "ProvName": "Alibori",
     "zoomlevel": 5.8,
     "X": 2.899118,
     "Y": 11.32633
    },
    {
     "ProvName": "Chukot",
     "zoomlevel": 2.37,
     "X": 130.09842,
     "Y": 66.17874
    },
    {
     "ProvName": "Yevrey",
     "zoomlevel": 4.08,
     "X": 132.262586,
     "Y": 48.519606
    },
    {
     "ProvName": "Khabarovsk",
     "zoomlevel": 3,
     "X": 137.320903,
     "Y": 54.823277
    },
    {
     "ProvName": "Magadan",
     "zoomlevel": 2.37,
     "X": 153.981468,
     "Y": 62.70958
    },
    {
     "ProvName": "Sakhalin",
     "zoomlevel": 5.8,
     "X": 143.63308,
     "Y": 49.944946
    },
    {
     "ProvName": "Greater Accra",
     "zoomlevel": 5.8,
     "X": 0.063852,
     "Y": 5.776593
    },
    {
     "ProvName": "Ioba",
     "zoomlevel": 5.8,
     "X": -2.981604,
     "Y": 11.059163
    },
    {
     "ProvName": "Volta",
     "zoomlevel": 5.8,
     "X": 0.400156,
     "Y": 7.235086
    },
    {
     "ProvName": "Utrecht",
     "zoomlevel": 5.8,
     "X": 5.171016,
     "Y": 52.102948
    },
    {
     "ProvName": "Zuid-Holland",
     "zoomlevel": 5.8,
     "X": 4.504898,
     "Y": 51.939312
    },
    {
     "ProvName": "Zou",
     "zoomlevel": 5.8,
     "X": 2.110166,
     "Y": 7.265443
    },
    {
     "ProvName": "Atacora",
     "zoomlevel": 5.8,
     "X": 1.581924,
     "Y": 10.684066
    },
    {
     "ProvName": "Donga",
     "zoomlevel": 5.8,
     "X": 1.787878,
     "Y": 9.336278
    },
    {
     "ProvName": "Kompienga",
     "zoomlevel": 5.8,
     "X": 0.884991,
     "Y": 11.4163
    },
    {
     "ProvName": "Gourma",
     "zoomlevel": 5.8,
     "X": 0.656688,
     "Y": 12.134217
    },
    {
     "ProvName": "Kars",
     "zoomlevel": 5.8,
     "X": 43.056645,
     "Y": 40.430908
    },
    {
     "ProvName": "Cuvette-Ouest",
     "zoomlevel": 5.8,
     "X": 14.618009,
     "Y": 0.078555
    },
    {
     "ProvName": "el-Bayadh",
     "zoomlevel": 3.8,
     "X": 0.9414,
     "Y": 32.570439
    },
    {
     "ProvName": "Ogooué-Ivindo",
     "zoomlevel": 5.8,
     "X": 12.836485,
     "Y": 0.470065
    },
    {
     "ProvName": "el-Oued",
     "zoomlevel": 5.8,
     "X": 6.957199,
     "Y": 33.222403
    },
    {
     "ProvName": "Alger",
     "zoomlevel": 5.8,
     "X": 3.090386,
     "Y": 36.724476
    },
    {
     "ProvName": "Woleu-Ntem",
     "zoomlevel": 5.8,
     "X": 11.953258,
     "Y": 1.409583
    },
    {
     "ProvName": "Boumerdes",
     "zoomlevel": 5.8,
     "X": 3.683181,
     "Y": 36.765528
    },
    {
     "ProvName": "Ardahan",
     "zoomlevel": 5.8,
     "X": 42.793054,
     "Y": 41.091279
    },
    {
     "ProvName": "Illizi",
     "zoomlevel": 3.8,
     "X": 8.353326,
     "Y": 26.79558
    },
    {
     "ProvName": "Tamanrasset",
     "zoomlevel": 3.8,
     "X": 5.116286,
     "Y": 23.973055
    },
    {
     "ProvName": "Ashgabat (Ashkhabad)",
     "zoomlevel": 4.5,
     "X": 58.3761,
     "Y": 37.929755
    },
    {
     "ProvName": "Kherson",
     "zoomlevel": 4.3,
     "X": 33.605852,
     "Y": 46.663831
    },
    {
     "ProvName": "Aïn Defla",
     "zoomlevel": 5.8,
     "X": 2.080172,
     "Y": 36.176066
    },
    {
     "ProvName": "ech-Chleff",
     "zoomlevel": 5.8,
     "X": 1.260469,
     "Y": 36.232577
    },
    {
     "ProvName": "Relizane",
     "zoomlevel": 5.8,
     "X": 0.800795,
     "Y": 35.793638
    },
    {
     "ProvName": "Mascara",
     "zoomlevel": 5.8,
     "X": 0.143033,
     "Y": 35.389594
    },
    {
     "ProvName": "Mostaganem",
     "zoomlevel": 5.8,
     "X": 0.33183,
     "Y": 35.992589
    },
    {
     "ProvName": "Tissemsilt",
     "zoomlevel": 5.8,
     "X": 1.800488,
     "Y": 35.745807
    },
    {
     "ProvName": "Saïda",
     "zoomlevel": 5.8,
     "X": 0.171261,
     "Y": 34.593407
    },
    {
     "ProvName": "Tiaret",
     "zoomlevel": 5.8,
     "X": 1.51563,
     "Y": 34.957859
    },
    {
     "ProvName": "Bordj Bou Arreridj",
     "zoomlevel": 5.8,
     "X": 4.730866,
     "Y": 36.085273
    },
    {
     "ProvName": "Bejaïa",
     "zoomlevel": 5.8,
     "X": 4.846864,
     "Y": 36.570474
    },
    {
     "ProvName": "Pazardzhik",
     "zoomlevel": 5.8,
     "X": 24.145247,
     "Y": 42.152084
    },
    {
     "ProvName": "Blida",
     "zoomlevel": 5.8,
     "X": 2.999735,
     "Y": 36.526746
    },
    {
     "ProvName": "Bouira",
     "zoomlevel": 5.8,
     "X": 3.849002,
     "Y": 36.27712
    },
    {
     "ProvName": "Guelma",
     "zoomlevel": 5.8,
     "X": 7.399147,
     "Y": 36.402211
    },
    {
     "ProvName": "Biskra",
     "zoomlevel": 5.8,
     "X": 5.344496,
     "Y": 34.5022
    },
    {
     "ProvName": "Khenchela",
     "zoomlevel": 5.8,
     "X": 6.999357,
     "Y": 34.974376
    },
    {
     "ProvName": "Djelfa",
     "zoomlevel": 5.8,
     "X": 3.550843,
     "Y": 34.332577
    },
    {
     "ProvName": "Médéa",
     "zoomlevel": 5.8,
     "X": 2.93701,
     "Y": 35.973555
    },
    {
     "ProvName": "M' Sila",
     "zoomlevel": 5.8,
     "X": 4.2764,
     "Y": 35.300692
    },
    {
     "ProvName": "Mila",
     "zoomlevel": 5.8,
     "X": 6.158336,
     "Y": 36.294398
    },
    {
     "ProvName": "Sétif",
     "zoomlevel": 5.8,
     "X": 5.465657,
     "Y": 36.134258
    },
    {
     "ProvName": "Oum el-Bouaghi",
     "zoomlevel": 5.8,
     "X": 7.081928,
     "Y": 35.847475
    },
    {
     "ProvName": "Batna",
     "zoomlevel": 5.8,
     "X": 5.883069,
     "Y": 35.427852
    },
    {
     "ProvName": "Gedo",
     "zoomlevel": 5.8,
     "X": 41.967836,
     "Y": 2.897995
    },
    {
     "ProvName": "Constantine",
     "zoomlevel": 5.8,
     "X": 6.70924,
     "Y": 36.347293
    },
    {
     "ProvName": "Souk Ahras",
     "zoomlevel": 5.8,
     "X": 7.886782,
     "Y": 36.155788
    },
    {
     "ProvName": "Tébessa",
     "zoomlevel": 5.8,
     "X": 7.810035,
     "Y": 35.005875
    },
    {
     "ProvName": "Federation of Bosnia and Herzegovina",
     "zoomlevel": 5.8,
     "X": 17.51668,
     "Y": 44.094432
    },
    {
     "ProvName": "Sliven",
     "zoomlevel": 5.8,
     "X": 26.205228,
     "Y": 42.642981
    },
    {
     "ProvName": "Aydin",
     "zoomlevel": 5.8,
     "X": 28.011818,
     "Y": 37.748755
    },
    {
     "ProvName": "Haskovo",
     "zoomlevel": 5.8,
     "X": 25.829577,
     "Y": 41.891982
    },
    {
     "ProvName": "Stara Zagora",
     "zoomlevel": 5.8,
     "X": 25.522217,
     "Y": 42.429366
    },
    {
     "ProvName": "Izmir",
     "zoomlevel": 5.8,
     "X": 27.314855,
     "Y": 38.499301
    },
    {
     "ProvName": "Plovdiv",
     "zoomlevel": 5.8,
     "X": 24.80641,
     "Y": 42.290072
    },
    {
     "ProvName": "Smoljan",
     "zoomlevel": 5.8,
     "X": 24.667537,
     "Y": 41.651105
    },
    {
     "ProvName": "Kurdzhali",
     "zoomlevel": 5.8,
     "X": 25.528947,
     "Y": 41.527666
    },
    {
     "ProvName": "Balikesir",
     "zoomlevel": 5.8,
     "X": 27.870416,
     "Y": 39.678692
    },
    {
     "ProvName": "Kirklareli",
     "zoomlevel": 5.8,
     "X": 27.418991,
     "Y": 41.683601
    },
    {
     "ProvName": "Canakkale",
     "zoomlevel": 5.8,
     "X": 26.741908,
     "Y": 40.039744
    },
    {
     "ProvName": "Edirne",
     "zoomlevel": 5.8,
     "X": 26.56418,
     "Y": 41.210767
    },
    {
     "ProvName": "Sofiya",
     "zoomlevel": 5.8,
     "X": 23.600492,
     "Y": 42.708333
    },
    {
     "ProvName": "Kärnten",
     "zoomlevel": 5.8,
     "X": 13.91142,
     "Y": 46.772358
    },
    {
     "ProvName": "Veliko Tarnovo",
     "zoomlevel": 5.8,
     "X": 25.622755,
     "Y": 43.192519
    },
    {
     "ProvName": "Oberösterreich",
     "zoomlevel": 5.8,
     "X": 13.956026,
     "Y": 48.142014
    },
    {
     "ProvName": "Salzburg",
     "zoomlevel": 5.8,
     "X": 12.958212,
     "Y": 47.283764
    },
    {
     "ProvName": "Kjustendil",
     "zoomlevel": 5.8,
     "X": 22.874971,
     "Y": 42.261815
    },
    {
     "ProvName": "Tirol",
     "zoomlevel": 5.8,
     "X": 11.299719,
     "Y": 47.246461
    },
    {
     "ProvName": "Vidin",
     "zoomlevel": 5.8,
     "X": 22.698137,
     "Y": 43.803435
    },
    {
     "ProvName": "Niederösterreich",
     "zoomlevel": 5.8,
     "X": 15.74477,
     "Y": 48.274111
    },
    {
     "ProvName": "Central Mindanao (Soccsksargen)",
     "zoomlevel": 5.8,
     "X": 124.751355,
     "Y": 6.757495
    },
    {
     "ProvName": "Eastern Visayas",
     "zoomlevel": 5.8,
     "X": 124.968304,
     "Y": 11.525525
    },
    {
     "ProvName": "Turgovishte",
     "zoomlevel": 5.8,
     "X": 26.350447,
     "Y": 43.246284
    },
    {
     "ProvName": "Caraga",
     "zoomlevel": 5.8,
     "X": 125.797367,
     "Y": 8.789369
    },
    {
     "ProvName": "Burgas",
     "zoomlevel": 5.8,
     "X": 27.302411,
     "Y": 42.500444
    },
    {
     "ProvName": "Jambol",
     "zoomlevel": 5.8,
     "X": 26.603208,
     "Y": 42.255474
    },
    {
     "ProvName": "Razgrad",
     "zoomlevel": 5.8,
     "X": 26.56582,
     "Y": 43.657384
    },
    {
     "ProvName": "Southern Mindanao (Davao)",
     "zoomlevel": 5.8,
     "X": 125.687128,
     "Y": 6.928111
    },
    {
     "ProvName": "Krasnoyarsk",
     "zoomlevel": 2.37,
     "X": 96.00292,
     "Y": 67.469688
    },
    {
     "ProvName": "Irkutsk",
     "zoomlevel": 3,
     "X": 106.360276,
     "Y": 57.093856
    },
    {
     "ProvName": "Tuva",
     "zoomlevel": 4.08,
     "X": 94.787139,
     "Y": 51.577565
    },
    {
     "ProvName": "Buryat",
     "zoomlevel": 3,
     "X": 109.478272,
     "Y": 53.546499
    },
    {
     "ProvName": "Zabaykal'ye",
     "zoomlevel": 3,
     "X": 116.197184,
     "Y": 52.838473
    },
    {
     "ProvName": "Amur",
     "zoomlevel": 3,
     "X": 127.729919,
     "Y": 53.400353
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 178.24127,
     "Y": -17.943466
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 78.35742,
     "Y": -18.362919
    },
    {
     "ProvName": "Silistra",
     "zoomlevel": 5.8,
     "X": 27.019326,
     "Y": 43.948046
    },
    {
     "ProvName": "Chuuk (Truk)",
     "zoomlevel": 5.8,
     "X": 151.635123,
     "Y": 7.310373
    },
    {
     "ProvName": "Ruse",
     "zoomlevel": 5.8,
     "X": 25.953928,
     "Y": 43.673521
    },
    {
     "ProvName": "Bilecik",
     "zoomlevel": 5.8,
     "X": 30.10403,
     "Y": 40.066962
    },
    {
     "ProvName": "Sakarya",
     "zoomlevel": 5.8,
     "X": 30.500292,
     "Y": 40.728815
    },
    {
     "ProvName": "Eskisehir",
     "zoomlevel": 5.8,
     "X": 31.102831,
     "Y": 39.596528
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": 156.221747,
     "Y": -16.612191
    },
    {
     "ProvName": "Pohnpei",
     "zoomlevel": 5.8,
     "X": 157.777676,
     "Y": 7.027422
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 177.763542,
     "Y": -17.731523
    },
    {
     "ProvName": "Yap",
     "zoomlevel": 5.8,
     "X": 138.136351,
     "Y": 9.515023
    },
    {
     "ProvName": "Domagnano",
     "zoomlevel": 5.8,
     "X": 12.469272,
     "Y": 43.954746
    },
    {
     "ProvName": "Moyen-Ogooué",
     "zoomlevel": 5.8,
     "X": 10.572679,
     "Y": -0.443498
    },
    {
     "ProvName": "Kastamonu",
     "zoomlevel": 5.8,
     "X": 33.657497,
     "Y": 41.489616
    },
    {
     "ProvName": "Manisa",
     "zoomlevel": 5.8,
     "X": 28.181461,
     "Y": 38.758277
    },
    {
     "ProvName": "Antalya",
     "zoomlevel": 5.8,
     "X": 30.932253,
     "Y": 36.799273
    },
    {
     "ProvName": "Afyon",
     "zoomlevel": 5.8,
     "X": 30.649127,
     "Y": 38.622159
    },
    {
     "ProvName": "Burdur",
     "zoomlevel": 5.8,
     "X": 30.096146,
     "Y": 37.418876
    },
    {
     "ProvName": "Mugla",
     "zoomlevel": 5.8,
     "X": 28.478944,
     "Y": 37.021881
    },
    {
     "ProvName": "Denizli",
     "zoomlevel": 5.8,
     "X": 29.26649,
     "Y": 37.744337
    },
    {
     "ProvName": "Isparta",
     "zoomlevel": 5.8,
     "X": 30.950605,
     "Y": 37.92482
    },
    {
     "ProvName": "Kütahya",
     "zoomlevel": 5.8,
     "X": 29.574111,
     "Y": 39.2538
    },
    {
     "ProvName": "Adygey",
     "zoomlevel": 5.8,
     "X": 39.973758,
     "Y": 44.567557
    },
    {
     "ProvName": "Adiyaman",
     "zoomlevel": 5.8,
     "X": 38.340632,
     "Y": 37.803835
    },
    {
     "ProvName": "Gros Islet",
     "zoomlevel": 5.8,
     "X": -60.924989,
     "Y": 14.045871
    },
    {
     "ProvName": "Ngounié",
     "zoomlevel": 5.8,
     "X": 11.175921,
     "Y": -1.634005
    },
    {
     "ProvName": "Nyanga",
     "zoomlevel": 5.8,
     "X": 11.033603,
     "Y": -3.016603
    },
    {
     "ProvName": "Karachay-Cherkess",
     "zoomlevel": 5.8,
     "X": 41.739001,
     "Y": 43.75901
    },
    {
     "ProvName": "Giresun",
     "zoomlevel": 5.8,
     "X": 38.591896,
     "Y": 40.577507
    },
    {
     "ProvName": "Elazig",
     "zoomlevel": 5.8,
     "X": 39.433639,
     "Y": 38.68358
    },
    {
     "ProvName": "K.Maras",
     "zoomlevel": 5.8,
     "X": 36.986062,
     "Y": 37.923756
    },
    {
     "ProvName": "Malatya",
     "zoomlevel": 5.8,
     "X": 38.121032,
     "Y": 38.507149
    },
    {
     "ProvName": "Ordu",
     "zoomlevel": 5.8,
     "X": 37.539234,
     "Y": 40.793582
    },
    {
     "ProvName": "Mersin (was: Içel)",
     "zoomlevel": 5.8,
     "X": 33.836785,
     "Y": 36.694425
    },
    {
     "ProvName": "Kirsehir",
     "zoomlevel": 5.8,
     "X": 34.149228,
     "Y": 39.327571
    },
    {
     "ProvName": "Kayseri",
     "zoomlevel": 5.8,
     "X": 35.850651,
     "Y": 38.675398
    },
    {
     "ProvName": "Nevsehir",
     "zoomlevel": 5.8,
     "X": 34.690742,
     "Y": 38.802183
    },
    {
     "ProvName": "Hatay",
     "zoomlevel": 5.8,
     "X": 36.246112,
     "Y": 36.444001
    },
    {
     "ProvName": "Amasya",
     "zoomlevel": 5.8,
     "X": 35.717523,
     "Y": 40.694671
    },
    {
     "ProvName": "Corum",
     "zoomlevel": 5.8,
     "X": 34.651846,
     "Y": 40.561077
    },
    {
     "ProvName": "Jeju",
     "zoomlevel": 5.8,
     "X": 126.559765,
     "Y": 33.378279
    },
    {
     "ProvName": "Sinop",
     "zoomlevel": 5.8,
     "X": 34.880543,
     "Y": 41.627868
    },
    {
     "ProvName": "Sivas",
     "zoomlevel": 5.8,
     "X": 37.346727,
     "Y": 39.585862
    },
    {
     "ProvName": "Samsun",
     "zoomlevel": 5.8,
     "X": 36.023911,
     "Y": 41.212902
    },
    {
     "ProvName": "Pskov",
     "zoomlevel": 5.8,
     "X": 29.236289,
     "Y": 57.224983
    },
    {
     "ProvName": "Southern",
     "zoomlevel": 5.8,
     "X": 29.677525,
     "Y": -2.361989
    },
    {
     "ProvName": "Tokat",
     "zoomlevel": 5.8,
     "X": 36.583776,
     "Y": 40.378075
    },
    {
     "ProvName": "Artvin",
     "zoomlevel": 5.8,
     "X": 41.801475,
     "Y": 41.096909
    },
    {
     "ProvName": "Castries",
     "zoomlevel": 5.8,
     "X": -60.97681,
     "Y": 13.958391
    },
    {
     "ProvName": "Erzurum",
     "zoomlevel": 5.8,
     "X": 41.542707,
     "Y": 40.051727
    },
    {
     "ProvName": "Erzincan",
     "zoomlevel": 5.8,
     "X": 39.315641,
     "Y": 39.674755
    },
    {
     "ProvName": "Rize",
     "zoomlevel": 5.8,
     "X": 40.845404,
     "Y": 40.935
    },
    {
     "ProvName": "Trabzon",
     "zoomlevel": 5.8,
     "X": 39.805843,
     "Y": 40.797709
    },
    {
     "ProvName": "Anse-la-Raye",
     "zoomlevel": 5.8,
     "X": -61.013132,
     "Y": 13.930516
    },
    {
     "ProvName": "Ingush",
     "zoomlevel": 5.8,
     "X": 44.873259,
     "Y": 43.176
    },
    {
     "ProvName": "Kabardin-Balkar",
     "zoomlevel": 5.8,
     "X": 43.397234,
     "Y": 43.485684
    },
    {
     "ProvName": "Canaries",
     "zoomlevel": 5.8,
     "X": -61.041732,
     "Y": 13.907765
    },
    {
     "ProvName": "North Ossetia",
     "zoomlevel": 5.8,
     "X": 44.262908,
     "Y": 43.096534
    },
    {
     "ProvName": "Stavropol'",
     "zoomlevel": 4.5,
     "X": 43.351866,
     "Y": 44.952513
    },
    {
     "ProvName": "Agri",
     "zoomlevel": 5.8,
     "X": 43.216208,
     "Y": 39.561958
    },
    {
     "ProvName": "Wien (Vienna)",
     "zoomlevel": 5.8,
     "X": 16.384135,
     "Y": 48.223186
    },
    {
     "ProvName": "Murmansk",
     "zoomlevel": 4,
     "X": 34.599673,
     "Y": 67.812518
    },
    {
     "ProvName": "Novgorod",
     "zoomlevel": 4.3,
     "X": 32.482794,
     "Y": 58.305706
    },
    {
     "ProvName": "Central Visayas",
     "zoomlevel": 5.8,
     "X": 123.372441,
     "Y": 9.925455
    },
    {
     "ProvName": "Rapla",
     "zoomlevel": 5.8,
     "X": 24.702884,
     "Y": 58.923145
    },
    {
     "ProvName": "Western Mindanao (Zamboanga)",
     "zoomlevel": 5.8,
     "X": 122.865861,
     "Y": 7.845601
    },
    {
     "ProvName": "Savaii",
     "zoomlevel": 5.8,
     "X": -172.437222,
     "Y": -13.630643
    },
    {
     "ProvName": "Pärnu",
     "zoomlevel": 5.8,
     "X": 24.550392,
     "Y": 58.396648
    },
    {
     "ProvName": "Põlva",
     "zoomlevel": 5.8,
     "X": 27.162655,
     "Y": 58.044054
    },
    {
     "ProvName": "Moskva",
     "zoomlevel": 4.3,
     "X": 37.623261,
     "Y": 55.718483
    },
    {
     "ProvName": "Orel",
     "zoomlevel": 4.3,
     "X": 36.4675,
     "Y": 52.77991
    },
    {
     "ProvName": "Rostov",
     "zoomlevel": 4.5,
     "X": 41.308633,
     "Y": 47.7462
    },
    {
     "ProvName": "Tula",
     "zoomlevel": 4.3,
     "X": 37.557978,
     "Y": 53.893324
    },
    {
     "ProvName": "Volgograd",
     "zoomlevel": 4.5,
     "X": 44.150019,
     "Y": 49.61659
    },
    {
     "ProvName": "Belgorod",
     "zoomlevel": 4.3,
     "X": 37.472665,
     "Y": 50.664251
    },
    {
     "ProvName": "Krasnodar",
     "zoomlevel": 5.8,
     "X": 39.465434,
     "Y": 45.260499
    },
    {
     "ProvName": "Mordovia",
     "zoomlevel": 4.3,
     "X": 44.445571,
     "Y": 54.369547
    },
    {
     "ProvName": "Valga",
     "zoomlevel": 5.8,
     "X": 26.143149,
     "Y": 57.933133
    },
    {
     "ProvName": "Viljandi",
     "zoomlevel": 5.8,
     "X": 25.558447,
     "Y": 58.337074
    },
    {
     "ProvName": "Penza",
     "zoomlevel": 4.3,
     "X": 44.638036,
     "Y": 53.192946
    },
    {
     "ProvName": "Ryazan'",
     "zoomlevel": 4.3,
     "X": 40.621075,
     "Y": 54.327986
    },
    {
     "ProvName": "Tambov",
     "zoomlevel": 4.3,
     "X": 41.582101,
     "Y": 52.685809
    },
    {
     "ProvName": "Vladimir",
     "zoomlevel": 4.3,
     "X": 40.660396,
     "Y": 56.011644
    },
    {
     "ProvName": "Voronezh",
     "zoomlevel": 4.3,
     "X": 40.217886,
     "Y": 50.970566
    },
    {
     "ProvName": "Bashkortostan",
     "zoomlevel": 4.08,
     "X": 56.513594,
     "Y": 54.273422
    },
    {
     "ProvName": "Chelyabinsk",
     "zoomlevel": 4.08,
     "X": 60.389994,
     "Y": 54.450582
    },
    {
     "ProvName": "Kurgan",
     "zoomlevel": 4.08,
     "X": 64.803769,
     "Y": 55.44669
    },
    {
     "ProvName": "Nenets",
     "zoomlevel": 2.37,
     "X": 54.917876,
     "Y": 67.885143
    },
    {
     "ProvName": "Yamal-Nenets",
     "zoomlevel": 2.37,
     "X": 74.51158,
     "Y": 67.145513
    },
    {
     "ProvName": "Komi",
     "zoomlevel": 5.8,
     "X": 54.783411,
     "Y": 64.12826
    },
    {
     "ProvName": "Kirov",
     "zoomlevel": 4.08,
     "X": 49.8303,
     "Y": 58.685786
    },
    {
     "ProvName": "Mariy-El",
     "zoomlevel": 4.3,
     "X": 47.939493,
     "Y": 56.581412
    },
    {
     "ProvName": "Tatarstan",
     "zoomlevel": 4.3,
     "X": 50.911622,
     "Y": 55.3594
    },
    {
     "ProvName": "Ul'yanovsk",
     "zoomlevel": 4.3,
     "X": 47.953701,
     "Y": 53.894098
    },
    {
     "ProvName": "Khanty-Mansiy",
     "zoomlevel": 3,
     "X": 70.292243,
     "Y": 61.867108
    },
    {
     "ProvName": "Omsk",
     "zoomlevel": 4.08,
     "X": 73.341611,
     "Y": 56.107788
    },
    {
     "ProvName": "Tyumen'",
     "zoomlevel": 4.08,
     "X": 69.13337,
     "Y": 57.682313
    },
    {
     "ProvName": "Altay",
     "zoomlevel": 4.08,
     "X": 82.607986,
     "Y": 52.60679
    },
    {
     "ProvName": "Gorno-Altay",
     "zoomlevel": 4.08,
     "X": 87.024906,
     "Y": 50.725383
    },
    {
     "ProvName": "Kemerovo",
     "zoomlevel": 4.08,
     "X": 87.215385,
     "Y": 54.794915
    },
    {
     "ProvName": "Khakass",
     "zoomlevel": 4.08,
     "X": 89.854781,
     "Y": 53.365834
    },
    {
     "ProvName": "Novosibirsk",
     "zoomlevel": 4.08,
     "X": 79.758363,
     "Y": 55.28066
    },
    {
     "ProvName": "Võru",
     "zoomlevel": 5.8,
     "X": 26.91095,
     "Y": 57.748156
    },
    {
     "ProvName": "Saare (Kingissepa)",
     "zoomlevel": 5.8,
     "X": 22.53776,
     "Y": 58.392678
    },
    {
     "ProvName": "Karelia",
     "zoomlevel": 4,
     "X": 33.125914,
     "Y": 63.550389
    },
    {
     "ProvName": "Arkhangel'sk",
     "zoomlevel": 2.37,
     "X": 48.379457,
     "Y": 67.845188
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 29.302997,
     "Y": -2.094171
    },
    {
     "ProvName": "Al-Wusta",
     "zoomlevel": 4.5,
     "X": 56.830302,
     "Y": 20.584818
    },
    {
     "ProvName": "Nakhchivan",
     "zoomlevel": 5.8,
     "X": 45.486084,
     "Y": 39.305474
    },
    {
     "ProvName": "ash-Sharqiyah",
     "zoomlevel": 5.8,
     "X": 58.745996,
     "Y": 21.935191
    },
    {
     "ProvName": "Banaadir",
     "zoomlevel": 5.8,
     "X": 45.424302,
     "Y": 2.110218
    },
    {
     "ProvName": "Galguduud",
     "zoomlevel": 5.8,
     "X": 46.762157,
     "Y": 5.122419
    },
    {
     "ProvName": "Hiiraan",
     "zoomlevel": 5.8,
     "X": 45.474371,
     "Y": 4.222148
    },
    {
     "ProvName": "Shabeellaha Dhexe",
     "zoomlevel": 5.8,
     "X": 46.012064,
     "Y": 3.021308
    },
    {
     "ProvName": "al-Batinah",
     "zoomlevel": 5.8,
     "X": 57.058644,
     "Y": 23.919712
    },
    {
     "ProvName": "Zufar (Dhofar)",
     "zoomlevel": 4.5,
     "X": 54.48883,
     "Y": 18.574709
    },
    {
     "ProvName": "Mudug",
     "zoomlevel": 5.8,
     "X": 48.135346,
     "Y": 6.383707
    },
    {
     "ProvName": "Nugaal",
     "zoomlevel": 5.8,
     "X": 48.906245,
     "Y": 8.188034
    },
    {
     "ProvName": "Delhi",
     "zoomlevel": 4,
     "X": 77.107943,
     "Y": 28.660866
    },
    {
     "ProvName": "Himachal Pradesh",
     "zoomlevel": 5.8,
     "X": 77.220805,
     "Y": 31.936291
    },
    {
     "ProvName": "Haryana",
     "zoomlevel": 4,
     "X": 76.336466,
     "Y": 29.208372
    },
    {
     "ProvName": "Jammu and Kashmir",
     "zoomlevel": 5.8,
     "X": 75.079487,
     "Y": 33.557905
    },
    {
     "ProvName": "Khulna",
     "zoomlevel": 5.8,
     "X": 89.285986,
     "Y": 22.912137
    },
    {
     "ProvName": "Soufrière",
     "zoomlevel": 5.8,
     "X": -61.048189,
     "Y": 13.853663
    },
    {
     "ProvName": "Chechnya",
     "zoomlevel": 5.8,
     "X": 45.742349,
     "Y": 43.302348
    },
    {
     "ProvName": "Dagestan",
     "zoomlevel": 5.8,
     "X": 46.870883,
     "Y": 43.016488
    },
    {
     "ProvName": "Choiseul",
     "zoomlevel": 5.8,
     "X": -61.038241,
     "Y": 13.80045
    },
    {
     "ProvName": "Laborie",
     "zoomlevel": 5.8,
     "X": -61.000082,
     "Y": 13.787215
    },
    {
     "ProvName": "Vieux Fort",
     "zoomlevel": 5.8,
     "X": -60.955405,
     "Y": 13.777448
    },
    {
     "ProvName": "Musandam",
     "zoomlevel": 5.8,
     "X": 56.277936,
     "Y": 25.974971
    },
    {
     "ProvName": "Chhukha",
     "zoomlevel": 5.8,
     "X": 89.538616,
     "Y": 26.973764
    },
    {
     "ProvName": "Dagana",
     "zoomlevel": 5.8,
     "X": 89.854924,
     "Y": 27.042976
    },
    {
     "ProvName": "Northern Mindanao",
     "zoomlevel": 5.8,
     "X": 124.593602,
     "Y": 8.124027
    },
    {
     "ProvName": "Masqat",
     "zoomlevel": 5.8,
     "X": 58.709606,
     "Y": 23.236258
    },
    {
     "ProvName": "Chandigarh",
     "zoomlevel": 5.8,
     "X": 76.76838,
     "Y": 30.743535
    },
    {
     "ProvName": "Ha",
     "zoomlevel": 5.8,
     "X": 89.134606,
     "Y": 27.33113
    },
    {
     "ProvName": "Bicol",
     "zoomlevel": 5.8,
     "X": 123.473265,
     "Y": 13.270891
    },
    {
     "ProvName": "Paro",
     "zoomlevel": 5.8,
     "X": 89.347497,
     "Y": 27.491287
    },
    {
     "ProvName": "Gasa",
     "zoomlevel": 5.8,
     "X": 89.91573,
     "Y": 28.036397
    },
    {
     "ProvName": "Micoud",
     "zoomlevel": 5.8,
     "X": -60.931116,
     "Y": 13.843593
    },
    {
     "ProvName": "Dennery",
     "zoomlevel": 5.8,
     "X": -60.922734,
     "Y": 13.928701
    },
    {
     "ProvName": "Saint David",
     "zoomlevel": 5.8,
     "X": -61.209901,
     "Y": 13.303283
    },
    {
     "ProvName": "Samchi",
     "zoomlevel": 5.8,
     "X": 89.05454,
     "Y": 27.037271
    },
    {
     "ProvName": "Thimphu",
     "zoomlevel": 5.8,
     "X": 89.530097,
     "Y": 27.587046
    },
    {
     "ProvName": "Punakha",
     "zoomlevel": 5.8,
     "X": 89.830025,
     "Y": 27.674245
    },
    {
     "ProvName": "Andhra Pradesh",
     "zoomlevel": 4,
     "X": 79.557432,
     "Y": 16.595446
    },
    {
     "ProvName": "Kerala",
     "zoomlevel": 5.8,
     "X": 76.424873,
     "Y": 10.423799
    },
    {
     "ProvName": "Charlotte",
     "zoomlevel": 5.8,
     "X": -61.158707,
     "Y": 13.266573
    },
    {
     "ProvName": "Saint Patrick",
     "zoomlevel": 5.8,
     "X": -61.247278,
     "Y": 13.23129
    },
    {
     "ProvName": "Saint Andrew",
     "zoomlevel": 5.8,
     "X": -61.233502,
     "Y": 13.195301
    },
    {
     "ProvName": "Saint George",
     "zoomlevel": 5.8,
     "X": -61.194872,
     "Y": 13.162964
    },
    {
     "ProvName": "Lakshadweep",
     "zoomlevel": 5.8,
     "X": 72.827589,
     "Y": 10.123906
    },
    {
     "ProvName": "Orissa",
     "zoomlevel": 4,
     "X": 84.414565,
     "Y": 20.517109
    },
    {
     "ProvName": "Dadra and Nagar Haveli",
     "zoomlevel": 4,
     "X": 73.038023,
     "Y": 20.169722
    },
    {
     "ProvName": "Karnataka",
     "zoomlevel": 4,
     "X": 76.155164,
     "Y": 14.719825
    },
    {
     "ProvName": "Maharashtra",
     "zoomlevel": 4,
     "X": 76.108271,
     "Y": 19.46036
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 80.719906,
     "Y": 7.327467
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 81.41572,
     "Y": 7.740014
    },
    {
     "ProvName": "Grenadines",
     "zoomlevel": 5.8,
     "X": -61.283976,
     "Y": 12.868212
    },
    {
     "ProvName": "North Central",
     "zoomlevel": 5.8,
     "X": 80.678531,
     "Y": 8.263643
    },
    {
     "ProvName": "North Western",
     "zoomlevel": 5.8,
     "X": 80.106992,
     "Y": 7.786161
    },
    {
     "ProvName": "Serravalle\/Dogano",
     "zoomlevel": 5.8,
     "X": 12.470765,
     "Y": 43.972526
    },
    {
     "ProvName": "Fiorentino",
     "zoomlevel": 5.8,
     "X": 12.436245,
     "Y": 43.907146
    },
    {
     "ProvName": "Chiesanuova",
     "zoomlevel": 5.8,
     "X": 12.399315,
     "Y": 43.917257
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": 80.344252,
     "Y": 9.129446
    },
    {
     "ProvName": "Chirang",
     "zoomlevel": 5.8,
     "X": 90.13776,
     "Y": 27.011508
    },
    {
     "ProvName": "Acquaviva",
     "zoomlevel": 5.8,
     "X": 12.40662,
     "Y": 43.947105
    },
    {
     "ProvName": "Citt?",
     "zoomlevel": 5.8,
     "X": 12.416569,
     "Y": 43.928911
    },
    {
     "ProvName": "Borgo Maggiore",
     "zoomlevel": 5.8,
     "X": 12.439044,
     "Y": 43.948344
    },
    {
     "ProvName": "Gaylegphug",
     "zoomlevel": 5.8,
     "X": 90.387498,
     "Y": 26.915968
    },
    {
     "ProvName": "Lhuntshi",
     "zoomlevel": 5.8,
     "X": 91.089081,
     "Y": 27.768371
    },
    {
     "ProvName": "Tashi Yangtse",
     "zoomlevel": 5.8,
     "X": 91.478806,
     "Y": 27.691209
    },
    {
     "ProvName": "Shemgang",
     "zoomlevel": 5.8,
     "X": 90.854255,
     "Y": 27.073286
    },
    {
     "ProvName": "Tongsa",
     "zoomlevel": 5.8,
     "X": 90.472116,
     "Y": 27.406539
    },
    {
     "ProvName": "Mongar",
     "zoomlevel": 5.8,
     "X": 91.200236,
     "Y": 27.24925
    },
    {
     "ProvName": "Pema Gatsel",
     "zoomlevel": 5.8,
     "X": 91.350136,
     "Y": 26.99599
    },
    {
     "ProvName": "Wangdi Phodrang",
     "zoomlevel": 5.8,
     "X": 90.124642,
     "Y": 27.531134
    },
    {
     "ProvName": "Samdrup Jongkhar",
     "zoomlevel": 5.8,
     "X": 91.665788,
     "Y": 26.944712
    },
    {
     "ProvName": "Sylhet",
     "zoomlevel": 5.8,
     "X": 91.645599,
     "Y": 24.721171
    },
    {
     "ProvName": "Tashigang",
     "zoomlevel": 5.8,
     "X": 91.711521,
     "Y": 27.256771
    },
    {
     "ProvName": "Meghalaya",
     "zoomlevel": 5.8,
     "X": 91.287044,
     "Y": 25.536174
    },
    {
     "ProvName": "Gyeongsangbuk-do",
     "zoomlevel": 5.8,
     "X": 128.628162,
     "Y": 35.89359
    },
    {
     "ProvName": "Cagayan Valley",
     "zoomlevel": 5.8,
     "X": 121.730039,
     "Y": 17.216444
    },
    {
     "ProvName": "Chungcheongbuk-do",
     "zoomlevel": 5.8,
     "X": 127.809178,
     "Y": 36.705287
    },
    {
     "ProvName": "Cordillera",
     "zoomlevel": 5.8,
     "X": 122.126445,
     "Y": 15.434748
    },
    {
     "ProvName": "Incheon",
     "zoomlevel": 5.8,
     "X": 126.687929,
     "Y": 37.46264
    },
    {
     "ProvName": "Gangwon-do",
     "zoomlevel": 5.8,
     "X": 128.342764,
     "Y": 37.665986
    },
    {
     "ProvName": "Seoul",
     "zoomlevel": 5.8,
     "X": 127.007304,
     "Y": 37.538385
    },
    {
     "ProvName": "Gyeonggi-do",
     "zoomlevel": 5.8,
     "X": 127.152339,
     "Y": 37.520755
    },
    {
     "ProvName": "Jeollabuk-do",
     "zoomlevel": 5.8,
     "X": 127.173739,
     "Y": 35.69247
    },
    {
     "ProvName": "Jeollanam-do",
     "zoomlevel": 5.8,
     "X": 126.917913,
     "Y": 34.892394
    },
    {
     "ProvName": "Gyeongsangnam-do",
     "zoomlevel": 5.8,
     "X": 128.291136,
     "Y": 35.3011
    },
    {
     "ProvName": "Chungcheongnam-do",
     "zoomlevel": 5.8,
     "X": 126.886924,
     "Y": 36.499007
    },
    {
     "ProvName": "Daejeon",
     "zoomlevel": 5.8,
     "X": 127.313358,
     "Y": 36.427285
    },
    {
     "ProvName": "Cankuzo",
     "zoomlevel": 5.8,
     "X": 30.594146,
     "Y": -3.132682
    },
    {
     "ProvName": "Karuzi",
     "zoomlevel": 5.8,
     "X": 30.120032,
     "Y": -3.127363
    },
    {
     "ProvName": "Daegu",
     "zoomlevel": 5.8,
     "X": 128.71526,
     "Y": 36.270292
    },
    {
     "ProvName": "Gwangju",
     "zoomlevel": 5.8,
     "X": 126.919172,
     "Y": 35.205435
    },
    {
     "ProvName": "Busan",
     "zoomlevel": 5.8,
     "X": 129.065366,
     "Y": 35.168072
    },
    {
     "ProvName": "Ulsan",
     "zoomlevel": 5.8,
     "X": 129.23303,
     "Y": 35.514367
    },
    {
     "ProvName": "Ilocos",
     "zoomlevel": 5.8,
     "X": 120.524743,
     "Y": 16.852232
    },
    {
     "ProvName": "Rutana",
     "zoomlevel": 5.8,
     "X": 30.105144,
     "Y": -3.863558
    },
    {
     "ProvName": "Central Luzon",
     "zoomlevel": 5.8,
     "X": 120.830633,
     "Y": 15.398144
    },
    {
     "ProvName": "Calabarzon",
     "zoomlevel": 5.8,
     "X": 121.555382,
     "Y": 14.169994
    },
    {
     "ProvName": "Ruyigi",
     "zoomlevel": 5.8,
     "X": 30.316662,
     "Y": -3.437997
    },
    {
     "ProvName": "Noord-Holland",
     "zoomlevel": 5.8,
     "X": 4.925175,
     "Y": 52.6022
    },
    {
     "ProvName": "Brandenburg",
     "zoomlevel": 5.8,
     "X": 13.392208,
     "Y": 52.46923
    },
    {
     "ProvName": "Mecklenburg-Vorpommern",
     "zoomlevel": 5.8,
     "X": 12.516822,
     "Y": 53.751672
    },
    {
     "ProvName": "Cibitoke",
     "zoomlevel": 5.8,
     "X": 29.219001,
     "Y": -2.825104
    },
    {
     "ProvName": "Gitega",
     "zoomlevel": 5.8,
     "X": 29.929784,
     "Y": -3.499782
    },
    {
     "ProvName": "Kayanza",
     "zoomlevel": 5.8,
     "X": 29.673644,
     "Y": -2.997684
    },
    {
     "ProvName": "Australian Capital Territory",
     "zoomlevel": 3.81,
     "X": 149.006953,
     "Y": -35.497586
    },
    {
     "ProvName": "South Australia",
     "zoomlevel": 3.81,
     "X": 135.827374,
     "Y": -30.106285
    },
    {
     "ProvName": "Victoria",
     "zoomlevel": 3.81,
     "X": 144.30889,
     "Y": -36.856755
    },
    {
     "ProvName": "Queensland",
     "zoomlevel": 3.81,
     "X": 144.55039,
     "Y": -22.572791
    },
    {
     "ProvName": "Rotuma",
     "zoomlevel": 5.8,
     "X": 177.073178,
     "Y": -12.497278
    },
    {
     "ProvName": "Tasmania",
     "zoomlevel": 3.81,
     "X": 146.598069,
     "Y": -41.935298
    },
    {
     "ProvName": "Basse-Normandie",
     "zoomlevel": 5.8,
     "X": -0.52274,
     "Y": 48.929272
    },
    {
     "ProvName": "Bretagne (Brittany)",
     "zoomlevel": 5.8,
     "X": -2.84178,
     "Y": 48.18429
    },
    {
     "ProvName": "Poitou-Charentes",
     "zoomlevel": 5.8,
     "X": -0.081999,
     "Y": 46.165125
    },
    {
     "ProvName": "Pays de la Loire",
     "zoomlevel": 5.8,
     "X": -0.80426,
     "Y": 47.484901
    },
    {
     "ProvName": "Acquitaine",
     "zoomlevel": 5.8,
     "X": -0.229374,
     "Y": 44.347643
    },
    {
     "ProvName": "Kent",
     "zoomlevel": 5.8,
     "X": 0.726061,
     "Y": 51.230566
    },
    {
     "ProvName": "Outer (Coralline) islands",
     "zoomlevel": 5.8,
     "X": 47.131286,
     "Y": -9.229763
    },
    {
     "ProvName": "Corse (Corsica)",
     "zoomlevel": 5.8,
     "X": 9.104149,
     "Y": 42.155973
    },
    {
     "ProvName": "Provence-Alpes-Cote-d'Azur",
     "zoomlevel": 5.8,
     "X": 6.061808,
     "Y": 43.960912
    },
    {
     "ProvName": "Languedoc-Roussillon",
     "zoomlevel": 5.8,
     "X": 3.219618,
     "Y": 43.584056
    },
    {
     "ProvName": "Midi-Pyrenees",
     "zoomlevel": 5.8,
     "X": 1.489896,
     "Y": 43.763697
    },
    {
     "ProvName": "Auvergne",
     "zoomlevel": 5.8,
     "X": 3.173382,
     "Y": 45.654056
    },
    {
     "ProvName": "Bourgogne (Burgundy)",
     "zoomlevel": 5.8,
     "X": 4.150205,
     "Y": 47.246161
    },
    {
     "ProvName": "Centre",
     "zoomlevel": 5.8,
     "X": 1.684971,
     "Y": 47.479547
    },
    {
     "ProvName": "Mahé and satellites",
     "zoomlevel": 5.8,
     "X": 55.47884,
     "Y": -4.662019
    },
    {
     "ProvName": "Haute-Normandie",
     "zoomlevel": 5.8,
     "X": 1.006153,
     "Y": 49.38897
    },
    {
     "ProvName": "Surrey, East and West Sussex",
     "zoomlevel": 5.8,
     "X": -0.220749,
     "Y": 51.039757
    },
    {
     "ProvName": "Silhouette",
     "zoomlevel": 5.8,
     "X": 55.244304,
     "Y": -4.47558
    },
    {
     "ProvName": "La Digue and satellites",
     "zoomlevel": 5.8,
     "X": 55.836365,
     "Y": -4.360736
    },
    {
     "ProvName": "Ile-de-France",
     "zoomlevel": 5.8,
     "X": 2.493695,
     "Y": 48.708923
    },
    {
     "ProvName": "Tombouctou",
     "zoomlevel": 3.8,
     "X": -3.580449,
     "Y": 20.044532
    },
    {
     "ProvName": "Limousin",
     "zoomlevel": 5.8,
     "X": 1.711857,
     "Y": 45.774389
    },
    {
     "ProvName": "Champagne-Ardenne",
     "zoomlevel": 5.8,
     "X": 4.542389,
     "Y": 48.728096
    },
    {
     "ProvName": "Nuevo León",
     "zoomlevel": 5.8,
     "X": -99.96231,
     "Y": 25.571191
    },
    {
     "ProvName": "San Luis Potosí",
     "zoomlevel": 5.8,
     "X": -100.432768,
     "Y": 22.600281
    },
    {
     "ProvName": "Nord-Pas-de-Calais",
     "zoomlevel": 5.8,
     "X": 2.69946,
     "Y": 50.472378
    },
    {
     "ProvName": "Picardie",
     "zoomlevel": 5.8,
     "X": 2.804096,
     "Y": 49.640952
    },
    {
     "ProvName": "Tamaulipas",
     "zoomlevel": 5.8,
     "X": -98.620638,
     "Y": 24.298893
    },
    {
     "ProvName": "Praslin and satellites",
     "zoomlevel": 5.8,
     "X": 55.733452,
     "Y": -4.291167
    },
    {
     "ProvName": "`Eua",
     "zoomlevel": 5.8,
     "X": -174.936937,
     "Y": -21.374633
    },
    {
     "ProvName": "Franche-Comte",
     "zoomlevel": 5.8,
     "X": 6.093124,
     "Y": 47.209913
    },
    {
     "ProvName": "Tongatapu",
     "zoomlevel": 5.8,
     "X": -175.203613,
     "Y": -21.172036
    },
    {
     "ProvName": "Alsace",
     "zoomlevel": 5.8,
     "X": 7.438522,
     "Y": 48.326984
    },
    {
     "ProvName": "Lorraine",
     "zoomlevel": 5.8,
     "X": 6.144916,
     "Y": 48.753675
    },
    {
     "ProvName": "San Salvador",
     "zoomlevel": 5.8,
     "X": -74.487478,
     "Y": 24.049706
    },
    {
     "ProvName": "Kidal",
     "zoomlevel": 3.8,
     "X": 1.149464,
     "Y": 19.437889
    },
    {
     "ProvName": "Gao",
     "zoomlevel": 3.8,
     "X": 1.361535,
     "Y": 16.767488
    },
    {
     "ProvName": "Ais矇n del General",
     "zoomlevel": 3.38,
     "X": -73.245008,
     "Y": -46.44676
    },
    {
     "ProvName": "Aguascalientes",
     "zoomlevel": 5.8,
     "X": -102.36143,
     "Y": 22.023269
    },
    {
     "ProvName": "Libertado General",
     "zoomlevel": 3.38,
     "X": -71.07668,
     "Y": -34.466233
    },
    {
     "ProvName": "Los Lagos",
     "zoomlevel": 3.38,
     "X": -72.903469,
     "Y": -42.01571
    },
    {
     "ProvName": "Maule",
     "zoomlevel": 3.38,
     "X": -71.444927,
     "Y": -35.612766
    },
    {
     "ProvName": "Baja California Norte",
     "zoomlevel": 5.8,
     "X": -115.092056,
     "Y": 30.538811
    },
    {
     "ProvName": "Baja California Sur",
     "zoomlevel": 5.8,
     "X": -112.046319,
     "Y": 25.922359
    },
    {
     "ProvName": "Coahuila",
     "zoomlevel": 5.8,
     "X": -102.03767,
     "Y": 27.314147
    },
    {
     "ProvName": "Chihuahua",
     "zoomlevel": 5.8,
     "X": -106.458884,
     "Y": 28.817323
    },
    {
     "ProvName": "Durango",
     "zoomlevel": 5.8,
     "X": -104.91811,
     "Y": 24.933009
    },
    {
     "ProvName": "Sinaloa",
     "zoomlevel": 5.8,
     "X": -107.483974,
     "Y": 25.024152
    },
    {
     "ProvName": "Sonora",
     "zoomlevel": 5.8,
     "X": -110.816237,
     "Y": 29.692585
    },
    {
     "ProvName": "Zacatecas",
     "zoomlevel": 5.8,
     "X": -102.697354,
     "Y": 23.312565
    },
    {
     "ProvName": "Colima",
     "zoomlevel": 5.8,
     "X": -104.184391,
     "Y": 19.128391
    },
    {
     "ProvName": "Jalisco",
     "zoomlevel": 5.8,
     "X": -103.617782,
     "Y": 20.600059
    },
    {
     "ProvName": "Michoacán",
     "zoomlevel": 5.8,
     "X": -101.885748,
     "Y": 19.208921
    },
    {
     "ProvName": "az-Zahirah",
     "zoomlevel": 5.8,
     "X": 56.104308,
     "Y": 22.908358
    },
    {
     "ProvName": "Greater Manchester",
     "zoomlevel": 5.8,
     "X": -2.281316,
     "Y": 53.515822
    },
    {
     "ProvName": "South Yorkshire",
     "zoomlevel": 5.8,
     "X": -1.321111,
     "Y": 53.476858
    },
    {
     "ProvName": "Nayarit",
     "zoomlevel": 5.8,
     "X": -104.916154,
     "Y": 21.841549
    },
    {
     "ProvName": "Tiris Zemmour",
     "zoomlevel": 3.8,
     "X": -9.682479,
     "Y": 24.191554
    },
    {
     "ProvName": "Campeche",
     "zoomlevel": 5.8,
     "X": -90.297915,
     "Y": 18.841426
    },
    {
     "ProvName": "Oaxaca",
     "zoomlevel": 5.8,
     "X": -96.429197,
     "Y": 16.960298
    },
    {
     "ProvName": "Puebla",
     "zoomlevel": 5.8,
     "X": -97.884624,
     "Y": 19.012364
    },
    {
     "ProvName": "Tabasco",
     "zoomlevel": 5.8,
     "X": -92.581343,
     "Y": 17.949362
    },
    {
     "ProvName": "Tlaxcala",
     "zoomlevel": 5.8,
     "X": -98.159412,
     "Y": 19.423965
    },
    {
     "ProvName": "Sermersooq",
     "zoomlevel": 2.37,
     "X": -38.575082,
     "Y": 67.405338
    },
    {
     "ProvName": "Kujalleq",
     "zoomlevel": 2.37,
     "X": -44.424382,
     "Y": 61.372721
    },
    {
     "ProvName": "Qeqqata",
     "zoomlevel": 2.37,
     "X": -48.763055,
     "Y": 66.434478
    },
    {
     "ProvName": "Northeast Greenland National Park",
     "zoomlevel": 2.37,
     "X": -34.864425,
     "Y": 77.843544
    },
    {
     "ProvName": "Brakna",
     "zoomlevel": 5.8,
     "X": -13.401707,
     "Y": 17.2495
    },
    {
     "ProvName": "Herefordshire, Worcestershire and Warwicks",
     "zoomlevel": 5.8,
     "X": -2.166667,
     "Y": 52.199651
    },
    {
     "ProvName": "West Yorkshire",
     "zoomlevel": 5.8,
     "X": -1.679422,
     "Y": 53.742148
    },
    {
     "ProvName": "Berry Islands",
     "zoomlevel": 5.8,
     "X": -77.857579,
     "Y": 25.66055
    },
    {
     "ProvName": "Dakhlet Nouadhibou",
     "zoomlevel": 5.8,
     "X": -15.98786,
     "Y": 20.833824
    },
    {
     "ProvName": "Inchiri",
     "zoomlevel": 5.8,
     "X": -15.111895,
     "Y": 19.992742
    },
    {
     "ProvName": "Nouakchott",
     "zoomlevel": 5.8,
     "X": -15.909602,
     "Y": 18.14494
    },
    {
     "ProvName": "Trarza",
     "zoomlevel": 5.8,
     "X": -14.851123,
     "Y": 17.919872
    },
    {
     "ProvName": "Assaba (el-Açâba)",
     "zoomlevel": 5.8,
     "X": -11.536791,
     "Y": 16.580939
    },
    {
     "ProvName": "Kohkiluyeh Buyer Ahmadi",
     "zoomlevel": 5.8,
     "X": 50.73426,
     "Y": 30.814478
    },
    {
     "ProvName": "Ha'apai",
     "zoomlevel": 5.8,
     "X": -174.646269,
     "Y": -19.739034
    },
    {
     "ProvName": "Niuas",
     "zoomlevel": 5.8,
     "X": -175.137098,
     "Y": -15.689495
    },
    {
     "ProvName": "Southeastern",
     "zoomlevel": 5.8,
     "X": 22.551836,
     "Y": 41.416123
    },
    {
     "ProvName": "Macedonia and Thrace",
     "zoomlevel": 5.8,
     "X": 23.873469,
     "Y": 40.91
    },
    {
     "ProvName": "Blagoevgrad",
     "zoomlevel": 5.8,
     "X": 23.436232,
     "Y": 41.72275
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 22.496101,
     "Y": 41.826837
    },
    {
     "ProvName": "Lapland",
     "zoomlevel": 4,
     "X": 26.338534,
     "Y": 67.719612
    },
    {
     "ProvName": "Western and Inland Finland",
     "zoomlevel": 4,
     "X": 23.957093,
     "Y": 62.543473
    },
    {
     "ProvName": "Crooked and Long Cay",
     "zoomlevel": 5.8,
     "X": -74.217398,
     "Y": 22.728897
    },
    {
     "ProvName": "Eastern Finland",
     "zoomlevel": 4,
     "X": 28.469026,
     "Y": 62.689985
    },
    {
     "ProvName": "Northern Finland",
     "zoomlevel": 4,
     "X": 27.403051,
     "Y": 64.789482
    },
    {
     "ProvName": "Southern Finland",
     "zoomlevel": 5.8,
     "X": 26.001076,
     "Y": 60.879497
    },
    {
     "ProvName": "Soltüstik Qazaqstan",
     "zoomlevel": 4.08,
     "X": 69.266616,
     "Y": 53.834701
    },
    {
     "ProvName": "Vava'u",
     "zoomlevel": 5.8,
     "X": -174.04734,
     "Y": -18.637823
    },
    {
     "ProvName": "Pavlodar",
     "zoomlevel": 4.08,
     "X": 76.24614,
     "Y": 52.054234
    },
    {
     "ProvName": "Shyghys Qazaqstan",
     "zoomlevel": 5.8,
     "X": 81.521825,
     "Y": 48.782077
    },
    {
     "ProvName": "Inagua, Great and Little",
     "zoomlevel": 5.8,
     "X": -73.331946,
     "Y": 21.105609
    },
    {
     "ProvName": "Spanish Wells",
     "zoomlevel": 5.8,
     "X": -76.780784,
     "Y": 25.545972
    },
    {
     "ProvName": "Harbour Island",
     "zoomlevel": 5.8,
     "X": -76.633042,
     "Y": 25.501621
    },
    {
     "ProvName": "Bayan-?lgiy",
     "zoomlevel": 4.08,
     "X": 89.848471,
     "Y": 48.534981
    },
    {
     "ProvName": "Bushehr",
     "zoomlevel": 5.8,
     "X": 51.379763,
     "Y": 28.853682
    },
    {
     "ProvName": "Grand Bahama",
     "zoomlevel": 5.8,
     "X": -78.426914,
     "Y": 26.644351
    },
    {
     "ProvName": "Acklins",
     "zoomlevel": 5.8,
     "X": -73.988387,
     "Y": 22.486428
    },
    {
     "ProvName": "Andros",
     "zoomlevel": 5.8,
     "X": -77.939672,
     "Y": 24.501481
    },
    {
     "ProvName": "Mayaguana",
     "zoomlevel": 5.8,
     "X": -72.971949,
     "Y": 22.37784
    },
    {
     "ProvName": "Hamgyong South",
     "zoomlevel": 5.8,
     "X": 127.798452,
     "Y": 40.26554
    },
    {
     "ProvName": "Long Island",
     "zoomlevel": 5.8,
     "X": -75.076769,
     "Y": 23.226716
    },
    {
     "ProvName": "Exuma",
     "zoomlevel": 5.8,
     "X": -75.970591,
     "Y": 23.679551
    },
    {
     "ProvName": "New Providence",
     "zoomlevel": 5.8,
     "X": -77.420777,
     "Y": 25.03917
    },
    {
     "ProvName": "Rum Cay",
     "zoomlevel": 5.8,
     "X": -74.869814,
     "Y": 23.694089
    },
    {
     "ProvName": "Guidmaka",
     "zoomlevel": 5.8,
     "X": -12.128896,
     "Y": 15.384635
    },
    {
     "ProvName": "Phyongan North (P'yongan)",
     "zoomlevel": 5.8,
     "X": 125.277537,
     "Y": 40.03935
    },
    {
     "ProvName": "Tagant",
     "zoomlevel": 5.8,
     "X": -10.393024,
     "Y": 18.573464
    },
    {
     "ProvName": "Ryanggang (Yanggang)",
     "zoomlevel": 5.8,
     "X": 128.043685,
     "Y": 41.284491
    },
    {
     "ProvName": "Banwa",
     "zoomlevel": 5.8,
     "X": -4.174894,
     "Y": 12.249701
    },
    {
     "ProvName": "Nayala",
     "zoomlevel": 5.8,
     "X": -3.019267,
     "Y": 12.698543
    },
    {
     "ProvName": "Biminis Islands",
     "zoomlevel": 5.8,
     "X": -79.271745,
     "Y": 25.726426
    },
    {
     "ProvName": "Ragged Island",
     "zoomlevel": 5.8,
     "X": -75.751931,
     "Y": 22.239139
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": 50.480523,
     "Y": 26.162046
    },
    {
     "ProvName": "Muharraq",
     "zoomlevel": 5.8,
     "X": 50.623444,
     "Y": 26.245856
    },
    {
     "ProvName": "Capital",
     "zoomlevel": 5.8,
     "X": 50.560784,
     "Y": 26.218552
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 50.552206,
     "Y": 26.163211
    },
    {
     "ProvName": "Gorgol",
     "zoomlevel": 5.8,
     "X": -12.833586,
     "Y": 16.010535
    },
    {
     "ProvName": "Kayes",
     "zoomlevel": 5.8,
     "X": -10.24377,
     "Y": 13.87429
    },
    {
     "ProvName": "Sikasso",
     "zoomlevel": 5.8,
     "X": -6.577112,
     "Y": 11.406955
    },
    {
     "ProvName": "Adrar",
     "zoomlevel": 3.8,
     "X": -10.218417,
     "Y": 21.013076
    },
    {
     "ProvName": "Hodh ech-Chargui",
     "zoomlevel": 3.8,
     "X": -7.100226,
     "Y": 18.181481
    },
    {
     "ProvName": "Hodh el-Gharbi",
     "zoomlevel": 5.8,
     "X": -9.832091,
     "Y": 16.56796
    },
    {
     "ProvName": "Houet",
     "zoomlevel": 5.8,
     "X": -4.258516,
     "Y": 11.282542
    },
    {
     "ProvName": "Kénédougou",
     "zoomlevel": 5.8,
     "X": -4.975857,
     "Y": 11.435474
    },
    {
     "ProvName": "Kossi",
     "zoomlevel": 5.8,
     "X": -3.883108,
     "Y": 12.923419
    },
    {
     "ProvName": "Balé",
     "zoomlevel": 5.8,
     "X": -3.075121,
     "Y": 11.711362
    },
    {
     "ProvName": "Sourou",
     "zoomlevel": 5.8,
     "X": -3.007504,
     "Y": 13.243813
    },
    {
     "ProvName": "Mouhoun",
     "zoomlevel": 5.8,
     "X": -3.419382,
     "Y": 12.199539
    },
    {
     "ProvName": "Oudalan",
     "zoomlevel": 5.8,
     "X": -0.349909,
     "Y": 14.641499
    },
    {
     "ProvName": "Bam",
     "zoomlevel": 5.8,
     "X": -1.564645,
     "Y": 13.450277
    },
    {
     "ProvName": "Imo",
     "zoomlevel": 5.8,
     "X": 7.047584,
     "Y": 5.550291
    },
    {
     "ProvName": "Soum",
     "zoomlevel": 5.8,
     "X": -1.291588,
     "Y": 14.229009
    },
    {
     "ProvName": "Mopti",
     "zoomlevel": 3.8,
     "X": -3.52617,
     "Y": 14.703543
    },
    {
     "ProvName": "Ségou",
     "zoomlevel": 3.8,
     "X": -5.700466,
     "Y": 13.801119
    },
    {
     "ProvName": "Rivers",
     "zoomlevel": 5.8,
     "X": 6.908564,
     "Y": 4.880006
    },
    {
     "ProvName": "Boulkiemdé",
     "zoomlevel": 5.8,
     "X": -2.141153,
     "Y": 12.30308
    },
    {
     "ProvName": "Bayelsa",
     "zoomlevel": 5.8,
     "X": 6.104223,
     "Y": 4.774502
    },
    {
     "ProvName": "Benue",
     "zoomlevel": 5.8,
     "X": 8.754632,
     "Y": 7.324716
    },
    {
     "ProvName": "Cross River",
     "zoomlevel": 5.8,
     "X": 8.581533,
     "Y": 5.86635
    },
    {
     "ProvName": "Kourwéogo",
     "zoomlevel": 5.8,
     "X": -1.81216,
     "Y": 12.607632
    },
    {
     "ProvName": "Bazèga",
     "zoomlevel": 5.8,
     "X": -1.446251,
     "Y": 11.952921
    },
    {
     "ProvName": "Taraba",
     "zoomlevel": 5.8,
     "X": 10.826604,
     "Y": 8.027725
    },
    {
     "ProvName": "Kadiogo",
     "zoomlevel": 5.8,
     "X": -1.505866,
     "Y": 12.30983
    },
    {
     "ProvName": "Oubritenga",
     "zoomlevel": 5.8,
     "X": -1.305766,
     "Y": 12.622789
    },
    {
     "ProvName": "Kwara",
     "zoomlevel": 5.8,
     "X": 4.372497,
     "Y": 8.984078
    },
    {
     "ProvName": "Lagos",
     "zoomlevel": 5.8,
     "X": 3.552135,
     "Y": 6.522498
    },
    {
     "ProvName": "Niger",
     "zoomlevel": 5.8,
     "X": 5.598439,
     "Y": 9.941302
    },
    {
     "ProvName": "Zondoma",
     "zoomlevel": 5.8,
     "X": -2.366267,
     "Y": 13.168901
    },
    {
     "ProvName": "Ogun",
     "zoomlevel": 5.8,
     "X": 3.461707,
     "Y": 7.000908
    },
    {
     "ProvName": "Ondo",
     "zoomlevel": 5.8,
     "X": 5.159507,
     "Y": 6.911123
    },
    {
     "ProvName": "Kirikkale",
     "zoomlevel": 5.8,
     "X": 33.76359,
     "Y": 39.885442
    },
    {
     "ProvName": "Sanguié",
     "zoomlevel": 5.8,
     "X": -2.605317,
     "Y": 12.203715
    },
    {
     "ProvName": "Passoré",
     "zoomlevel": 5.8,
     "X": -2.156616,
     "Y": 12.891665
    },
    {
     "ProvName": "Sissili",
     "zoomlevel": 5.8,
     "X": -2.233214,
     "Y": 11.293889
    },
    {
     "ProvName": "Ziro",
     "zoomlevel": 5.8,
     "X": -1.870144,
     "Y": 11.613144
    },
    {
     "ProvName": "Loroum",
     "zoomlevel": 5.8,
     "X": -2.153169,
     "Y": 13.924066
    },
    {
     "ProvName": "Yatenga",
     "zoomlevel": 5.8,
     "X": -2.384163,
     "Y": 13.602773
    },
    {
     "ProvName": "Sanmatenga",
     "zoomlevel": 5.8,
     "X": -1.015046,
     "Y": 13.223755
    },
    {
     "ProvName": "Boulgou",
     "zoomlevel": 5.8,
     "X": -0.434898,
     "Y": 11.499978
    },
    {
     "ProvName": "Bougouriba",
     "zoomlevel": 5.8,
     "X": -3.391419,
     "Y": 10.878309
    },
    {
     "ProvName": "Aland (Ahvenanmaa)",
     "zoomlevel": 5.8,
     "X": 20.036654,
     "Y": 60.207522
    },
    {
     "ProvName": "Tuy",
     "zoomlevel": 5.8,
     "X": -3.519381,
     "Y": 11.422001
    },
    {
     "ProvName": "Léraba",
     "zoomlevel": 5.8,
     "X": -5.270152,
     "Y": 10.63045
    },
    {
     "ProvName": "Akwa Ibom",
     "zoomlevel": 5.8,
     "X": 7.840909,
     "Y": 4.917127
    },
    {
     "ProvName": "Dubasari",
     "zoomlevel": 5.8,
     "X": 29.153673,
     "Y": 47.263267
    },
    {
     "ProvName": "Comoé",
     "zoomlevel": 5.8,
     "X": -4.431006,
     "Y": 10.297555
    },
    {
     "ProvName": "Ekiti",
     "zoomlevel": 5.8,
     "X": 5.312723,
     "Y": 7.704264
    },
    {
     "ProvName": "Ialoveni",
     "zoomlevel": 5.8,
     "X": 28.830474,
     "Y": 46.857274
    },
    {
     "ProvName": "Likouala",
     "zoomlevel": 5.8,
     "X": 17.447504,
     "Y": 1.925437
    },
    {
     "ProvName": "Borno",
     "zoomlevel": 5.8,
     "X": 13.17097,
     "Y": 11.890745
    },
    {
     "ProvName": "Abia",
     "zoomlevel": 5.8,
     "X": 7.510382,
     "Y": 5.452131
    },
    {
     "ProvName": "Chisinau city",
     "zoomlevel": 5.8,
     "X": 28.880975,
     "Y": 47.008891
    },
    {
     "ProvName": "Bender",
     "zoomlevel": 5.8,
     "X": 29.404787,
     "Y": 46.848813
    },
    {
     "ProvName": "Vas",
     "zoomlevel": 5.8,
     "X": 16.74104,
     "Y": 47.145424
    },
    {
     "ProvName": "Warminsko-Marzurskie",
     "zoomlevel": 4.3,
     "X": 20.769567,
     "Y": 53.849799
    },
    {
     "ProvName": "Osun",
     "zoomlevel": 5.8,
     "X": 4.535788,
     "Y": 7.534443
    },
    {
     "ProvName": "Pomorskie",
     "zoomlevel": 4.3,
     "X": 18.036663,
     "Y": 54.135695
    },
    {
     "ProvName": "Oyo",
     "zoomlevel": 5.8,
     "X": 3.615069,
     "Y": 8.143492
    },
    {
     "ProvName": "Dolnoslaskie",
     "zoomlevel": 5.8,
     "X": 16.372993,
     "Y": 51.075043
    },
    {
     "ProvName": "Anambra",
     "zoomlevel": 5.8,
     "X": 6.925375,
     "Y": 6.19868
    },
    {
     "ProvName": "Zachodniopomorskie",
     "zoomlevel": 4.3,
     "X": 15.614549,
     "Y": 53.587263
    },
    {
     "ProvName": "Lubuskie",
     "zoomlevel": 4.3,
     "X": 15.341561,
     "Y": 52.201984
    },
    {
     "ProvName": "Bauchi",
     "zoomlevel": 5.8,
     "X": 9.988105,
     "Y": 10.775389
    },
    {
     "ProvName": "Gombe",
     "zoomlevel": 5.8,
     "X": 11.244448,
     "Y": 10.403714
    },
    {
     "ProvName": "Edo",
     "zoomlevel": 5.8,
     "X": 5.911643,
     "Y": 6.626088
    },
    {
     "ProvName": "Delta",
     "zoomlevel": 5.8,
     "X": 5.958731,
     "Y": 5.716498
    },
    {
     "ProvName": "Enugu",
     "zoomlevel": 5.8,
     "X": 7.420878,
     "Y": 6.533172
    },
    {
     "ProvName": "Wielkopolskie",
     "zoomlevel": 4.3,
     "X": 17.247735,
     "Y": 52.283342
    },
    {
     "ProvName": "Kujawsko-pomorskie",
     "zoomlevel": 4.3,
     "X": 18.501075,
     "Y": 53.022306
    },
    {
     "ProvName": "Plateau",
     "zoomlevel": 5.8,
     "X": 9.547111,
     "Y": 9.209684
    },
    {
     "ProvName": "Slaskie",
     "zoomlevel": 5.8,
     "X": 18.995745,
     "Y": 50.309689
    },
    {
     "ProvName": "Lodzkie",
     "zoomlevel": 4.3,
     "X": 19.409032,
     "Y": 51.559415
    },
    {
     "ProvName": "Ebonyi",
     "zoomlevel": 5.8,
     "X": 8.001861,
     "Y": 6.265849
    },
    {
     "ProvName": "Kaduna",
     "zoomlevel": 5.8,
     "X": 7.699741,
     "Y": 10.357498
    },
    {
     "ProvName": "Kogi",
     "zoomlevel": 5.8,
     "X": 6.694707,
     "Y": 7.728423
    },
    {
     "ProvName": "Nassarawa",
     "zoomlevel": 5.8,
     "X": 8.190207,
     "Y": 8.502634
    },
    {
     "ProvName": "Jigawa",
     "zoomlevel": 5.8,
     "X": 9.550348,
     "Y": 12.215763
    },
    {
     "ProvName": "Komondjari",
     "zoomlevel": 5.8,
     "X": 0.739703,
     "Y": 12.736391
    },
    {
     "ProvName": "Chhattisgarh",
     "zoomlevel": 4,
     "X": 82.033369,
     "Y": 21.255903
    },
    {
     "ProvName": "Kano",
     "zoomlevel": 5.8,
     "X": 8.513436,
     "Y": 11.735645
    },
    {
     "ProvName": "Katsina",
     "zoomlevel": 5.8,
     "X": 7.63029,
     "Y": 12.377472
    },
    {
     "ProvName": "Sokoto",
     "zoomlevel": 5.8,
     "X": 5.314122,
     "Y": 13.031735
    },
    {
     "ProvName": "Zamfara",
     "zoomlevel": 5.8,
     "X": 6.258541,
     "Y": 12.091277
    },
    {
     "ProvName": "Yobe",
     "zoomlevel": 5.8,
     "X": 11.431551,
     "Y": 12.303279
    },
    {
     "ProvName": "Gnagna",
     "zoomlevel": 5.8,
     "X": 0.037621,
     "Y": 12.930052
    },
    {
     "ProvName": "Sèno",
     "zoomlevel": 5.8,
     "X": -0.036172,
     "Y": 13.941608
    },
    {
     "ProvName": "Yagha",
     "zoomlevel": 5.8,
     "X": 0.59468,
     "Y": 13.398612
    },
    {
     "ProvName": "Tapoa",
     "zoomlevel": 5.8,
     "X": 1.739318,
     "Y": 12.064858
    },
    {
     "ProvName": "Anenii Noi",
     "zoomlevel": 5.8,
     "X": 29.214684,
     "Y": 46.92844
    },
    {
     "ProvName": "Kebbi",
     "zoomlevel": 5.8,
     "X": 4.495516,
     "Y": 11.764987
    },
    {
     "ProvName": "Sangha",
     "zoomlevel": 5.8,
     "X": 15.389769,
     "Y": 1.379413
    },
    {
     "ProvName": "Adamawa",
     "zoomlevel": 5.8,
     "X": 12.434157,
     "Y": 9.345525
    },
    {
     "ProvName": "Nâlût",
     "zoomlevel": 3.8,
     "X": 10.858126,
     "Y": 30.296875
    },
    {
     "ProvName": "Ngamiland",
     "zoomlevel": 4.8,
     "X": 22.759975,
     "Y": -19.609335
    },
    {
     "ProvName": "Chobe",
     "zoomlevel": 4.8,
     "X": 24.792474,
     "Y": -18.511512
    },
    {
     "ProvName": "Taraclia",
     "zoomlevel": 5.8,
     "X": 28.655901,
     "Y": 45.956874
    },
    {
     "ProvName": "Peloponnese, Western Greece and the Ionian",
     "zoomlevel": 5.8,
     "X": 20.430081,
     "Y": 38.619335
    },
    {
     "ProvName": "Attica",
     "zoomlevel": 5.8,
     "X": 23.601843,
     "Y": 37.84031
    },
    {
     "ProvName": "Thessaly and Continental Greece",
     "zoomlevel": 5.8,
     "X": 22.320832,
     "Y": 38.443885
    },
    {
     "ProvName": "Epirus and Western Macedonia",
     "zoomlevel": 5.8,
     "X": 21.128194,
     "Y": 39.987744
    },
    {
     "ProvName": "Southwestern",
     "zoomlevel": 5.8,
     "X": 20.891652,
     "Y": 41.401468
    },
    {
     "ProvName": "Polog",
     "zoomlevel": 5.8,
     "X": 20.871752,
     "Y": 41.842044
    },
    {
     "ProvName": "Pelagonia",
     "zoomlevel": 5.8,
     "X": 21.393757,
     "Y": 41.165103
    },
    {
     "ProvName": "al-Jufrah",
     "zoomlevel": 3.8,
     "X": 17.103771,
     "Y": 27.915693
    },
    {
     "ProvName": "al-Kufrah",
     "zoomlevel": 3.8,
     "X": 22.245633,
     "Y": 23.757892
    },
    {
     "ProvName": "Skopje",
     "zoomlevel": 5.8,
     "X": 21.444938,
     "Y": 41.946333
    },
    {
     "ProvName": "Northeast",
     "zoomlevel": 5.8,
     "X": 21.982726,
     "Y": 42.156816
    },
    {
     "ProvName": "Vardar",
     "zoomlevel": 5.8,
     "X": 21.9045,
     "Y": 41.543881
    },
    {
     "ProvName": "Wâdî ash-Shâtî",
     "zoomlevel": 3.8,
     "X": 12.727257,
     "Y": 27.959118
    },
    {
     "ProvName": "Bangâzî",
     "zoomlevel": 5.8,
     "X": 20.530329,
     "Y": 31.543698
    },
    {
     "ProvName": "Madhya Pradesh",
     "zoomlevel": 4,
     "X": 78.29278,
     "Y": 23.539092
    },
    {
     "ProvName": "Pondicherry",
     "zoomlevel": 5.8,
     "X": 78.886068,
     "Y": 11.959998
    },
    {
     "ProvName": "Tamil Nadu",
     "zoomlevel": 5.8,
     "X": 78.402316,
     "Y": 11.014667
    },
    {
     "ProvName": "Murzuq (Marzuq)",
     "zoomlevel": 3.8,
     "X": 15.691196,
     "Y": 24.613805
    },
    {
     "ProvName": "Misrâtah",
     "zoomlevel": 5.8,
     "X": 14.570526,
     "Y": 31.533748
    },
    {
     "ProvName": "Sabhâ",
     "zoomlevel": 3.8,
     "X": 15.018209,
     "Y": 27.082608
    },
    {
     "ProvName": "âl-Jifarah",
     "zoomlevel": 5.8,
     "X": 13.023599,
     "Y": 32.460281
    },
    {
     "ProvName": "an-Nuqât al-Hums",
     "zoomlevel": 5.8,
     "X": 11.901644,
     "Y": 32.705396
    },
    {
     "ProvName": "az-Zâwiyah",
     "zoomlevel": 5.8,
     "X": 12.622351,
     "Y": 32.525295
    },
    {
     "ProvName": "Mwanza",
     "zoomlevel": 5.8,
     "X": 34.499453,
     "Y": -15.652253
    },
    {
     "ProvName": "Neno",
     "zoomlevel": 5.8,
     "X": 34.700707,
     "Y": -15.460062
    },
    {
     "ProvName": "Gujarat",
     "zoomlevel": 4,
     "X": 71.558062,
     "Y": 22.71288
    },
    {
     "ProvName": "Goa",
     "zoomlevel": 4,
     "X": 74.045729,
     "Y": 15.352289
    },
    {
     "ProvName": "Karen",
     "zoomlevel": 5.8,
     "X": 97.78517,
     "Y": 17.154582
    },
    {
     "ProvName": "Mandalay",
     "zoomlevel": 5.8,
     "X": 95.995793,
     "Y": 21.203443
    },
    {
     "ProvName": "Yangôn",
     "zoomlevel": 5.8,
     "X": 96.178886,
     "Y": 16.969921
    },
    {
     "ProvName": "Pegu (Bago)",
     "zoomlevel": 5.8,
     "X": 96.200767,
     "Y": 18.276644
    },
    {
     "ProvName": "al-Jabal al-Gharbi",
     "zoomlevel": 3.8,
     "X": 12.983538,
     "Y": 30.388828
    },
    {
     "ProvName": "Tarâbulus (Tripoli)",
     "zoomlevel": 5.8,
     "X": 13.418539,
     "Y": 32.672304
    },
    {
     "ProvName": "al-Marqab",
     "zoomlevel": 5.8,
     "X": 14.054643,
     "Y": 32.330094
    },
    {
     "ProvName": "al-Marj",
     "zoomlevel": 5.8,
     "X": 21.067338,
     "Y": 31.97675
    },
    {
     "ProvName": "al-Jabal al-Ahdar",
     "zoomlevel": 5.8,
     "X": 21.748524,
     "Y": 32.13672
    },
    {
     "ProvName": "al-Wâhât",
     "zoomlevel": 3.8,
     "X": 21.351474,
     "Y": 28.821497
    },
    {
     "ProvName": "Abkhazia",
     "zoomlevel": 5.8,
     "X": 41.172297,
     "Y": 43.095349
    },
    {
     "ProvName": "Sanliurfa",
     "zoomlevel": 5.8,
     "X": 39.10706,
     "Y": 37.250848
    },
    {
     "ProvName": "Mon",
     "zoomlevel": 5.8,
     "X": 97.597535,
     "Y": 16.410711
    },
    {
     "ProvName": "al-Butnân",
     "zoomlevel": 3.8,
     "X": 23.98277,
     "Y": 30.103669
    },
    {
     "ProvName": "Surt",
     "zoomlevel": 3.8,
     "X": 16.849593,
     "Y": 30.182154
    },
    {
     "ProvName": "Darnah",
     "zoomlevel": 5.8,
     "X": 22.542465,
     "Y": 31.90341
    },
    {
     "ProvName": "Aegean Islands",
     "zoomlevel": 5.8,
     "X": 26.234702,
     "Y": 37.639389
    },
    {
     "ProvName": "Sirnak",
     "zoomlevel": 5.8,
     "X": 42.562962,
     "Y": 37.464369
    },
    {
     "ProvName": "Crete",
     "zoomlevel": 5.8,
     "X": 24.846596,
     "Y": 35.231195
    },
    {
     "ProvName": "Ankara",
     "zoomlevel": 5.8,
     "X": 32.648102,
     "Y": 39.778913
    },
    {
     "ProvName": "Cankiri",
     "zoomlevel": 5.8,
     "X": 33.344299,
     "Y": 40.725783
    },
    {
     "ProvName": "Konya",
     "zoomlevel": 5.8,
     "X": 32.618295,
     "Y": 38.047558
    },
    {
     "ProvName": "al-Biqa' (Beqaa)",
     "zoomlevel": 5.8,
     "X": 36.130214,
     "Y": 33.991474
    },
    {
     "ProvName": "ash-Shamal (North Lebanon)",
     "zoomlevel": 5.8,
     "X": 36.019469,
     "Y": 34.403927
    },
    {
     "ProvName": "Bayrut (Beirut)",
     "zoomlevel": 5.8,
     "X": 35.507717,
     "Y": 33.88829
    },
    {
     "ProvName": "Jabal Lubnan (Mount Lebanon)",
     "zoomlevel": 5.8,
     "X": 35.694671,
     "Y": 33.895375
    },
    {
     "ProvName": "Yozgat",
     "zoomlevel": 5.8,
     "X": 35.258366,
     "Y": 39.668178
    },
    {
     "ProvName": "Ajaria",
     "zoomlevel": 5.8,
     "X": 42.074218,
     "Y": 41.64312
    },
    {
     "ProvName": "Guria",
     "zoomlevel": 5.8,
     "X": 42.145928,
     "Y": 41.963875
    },
    {
     "ProvName": "Samegrelo-Zemo Svanteni",
     "zoomlevel": 5.8,
     "X": 42.264751,
     "Y": 42.68937
    },
    {
     "ProvName": "Mazowieckie",
     "zoomlevel": 4.3,
     "X": 21.080609,
     "Y": 52.311783
    },
    {
     "ProvName": "Swietokrzyskie",
     "zoomlevel": 4.3,
     "X": 20.768478,
     "Y": 50.741914
    },
    {
     "ProvName": "Podlaskie",
     "zoomlevel": 4.3,
     "X": 22.883193,
     "Y": 53.279485
    },
    {
     "ProvName": "Lubelskie",
     "zoomlevel": 4.3,
     "X": 22.899494,
     "Y": 51.243228
    },
    {
     "ProvName": "Baranya",
     "zoomlevel": 5.8,
     "X": 18.208706,
     "Y": 46.044492
    },
    {
     "ProvName": "Podkarpackie",
     "zoomlevel": 4.3,
     "X": 22.207975,
     "Y": 49.969751
    },
    {
     "ProvName": "Györ-Moson-Sopron",
     "zoomlevel": 5.8,
     "X": 17.257313,
     "Y": 47.651919
    },
    {
     "ProvName": "Central",
     "zoomlevel": 4.8,
     "X": 26.271678,
     "Y": -21.538485
    },
    {
     "ProvName": "Batman",
     "zoomlevel": 5.8,
     "X": 41.409793,
     "Y": 38.005969
    },
    {
     "ProvName": "Somogy",
     "zoomlevel": 5.8,
     "X": 17.602189,
     "Y": 46.449361
    },
    {
     "ProvName": "Imereti",
     "zoomlevel": 5.8,
     "X": 42.956202,
     "Y": 42.156799
    },
    {
     "ProvName": "Gümüshane",
     "zoomlevel": 5.8,
     "X": 39.377241,
     "Y": 40.316322
    },
    {
     "ProvName": "Bayburt",
     "zoomlevel": 5.8,
     "X": 40.223301,
     "Y": 40.279769
    },
    {
     "ProvName": "Siirt",
     "zoomlevel": 5.8,
     "X": 42.267923,
     "Y": 37.916442
    },
    {
     "ProvName": "Kakheti",
     "zoomlevel": 5.8,
     "X": 45.762679,
     "Y": 41.76213
    },
    {
     "ProvName": "Mtskheta-Mtianeti",
     "zoomlevel": 5.8,
     "X": 44.741435,
     "Y": 42.293488
    },
    {
     "ProvName": "Racha-Lochkhumi-Kvemo Svaneti",
     "zoomlevel": 5.8,
     "X": 43.154184,
     "Y": 42.642332
    },
    {
     "ProvName": "T'bilisi",
     "zoomlevel": 5.8,
     "X": 44.829941,
     "Y": 41.702248
    },
    {
     "ProvName": "Kvemo Kartli",
     "zoomlevel": 5.8,
     "X": 44.508432,
     "Y": 41.491188
    },
    {
     "ProvName": "Samtskhe-Javakheti",
     "zoomlevel": 5.8,
     "X": 43.32304,
     "Y": 41.530478
    },
    {
     "ProvName": "Shida Kartli",
     "zoomlevel": 5.8,
     "X": 44.008542,
     "Y": 42.107498
    },
    {
     "ProvName": "Mardin",
     "zoomlevel": 5.8,
     "X": 40.920457,
     "Y": 37.364668
    },
    {
     "ProvName": "Tunceli",
     "zoomlevel": 5.8,
     "X": 39.482285,
     "Y": 39.195253
    },
    {
     "ProvName": "Dahuk",
     "zoomlevel": 5.8,
     "X": 43.139268,
     "Y": 37.063145
    },
    {
     "ProvName": "Hakkari",
     "zoomlevel": 5.8,
     "X": 44.068361,
     "Y": 37.481242
    },
    {
     "ProvName": "Van",
     "zoomlevel": 5.8,
     "X": 43.587922,
     "Y": 38.520341
    },
    {
     "ProvName": "Qyzylorda",
     "zoomlevel": 4.5,
     "X": 63.670727,
     "Y": 45.161575
    },
    {
     "ProvName": "Atyrau",
     "zoomlevel": 4.5,
     "X": 52.13855,
     "Y": 47.526457
    },
    {
     "ProvName": "at-Ta'mim",
     "zoomlevel": 5.8,
     "X": 44.13756,
     "Y": 35.354533
    },
    {
     "ProvName": "Arbil",
     "zoomlevel": 5.8,
     "X": 44.201209,
     "Y": 36.338016
    },
    {
     "ProvName": "Ninawa",
     "zoomlevel": 5.8,
     "X": 42.474162,
     "Y": 36.023009
    },
    {
     "ProvName": "Salah ad-Din",
     "zoomlevel": 5.8,
     "X": 43.641732,
     "Y": 34.523812
    },
    {
     "ProvName": "Tel Aviv",
     "zoomlevel": 5.8,
     "X": 34.810136,
     "Y": 32.083678
    },
    {
     "ProvName": "Jerusalem (Yerushalayim)",
     "zoomlevel": 5.8,
     "X": 35.00312,
     "Y": 31.744197
    },
    {
     "ProvName": "Southern (Ha Darom)",
     "zoomlevel": 5.8,
     "X": 34.85106,
     "Y": 30.838166
    },
    {
     "ProvName": "Haifa (Hefa)",
     "zoomlevel": 5.8,
     "X": 35.015301,
     "Y": 32.624137
    },
    {
     "ProvName": "Central (Ha Merkaz)",
     "zoomlevel": 5.8,
     "X": 34.874775,
     "Y": 32.05918
    },
    {
     "ProvName": "Southestern Finland",
     "zoomlevel": 5.8,
     "X": 22.391227,
     "Y": 61.025467
    },
    {
     "ProvName": "An-Nabatiyah",
     "zoomlevel": 5.8,
     "X": 35.511195,
     "Y": 33.300455
    },
    {
     "ProvName": "Aqtöbe (Aktyubinsk)",
     "zoomlevel": 4.5,
     "X": 58.567576,
     "Y": 48.589477
    },
    {
     "ProvName": "Qostanay",
     "zoomlevel": 4.08,
     "X": 64.055562,
     "Y": 51.574368
    },
    {
     "ProvName": "Baghdad",
     "zoomlevel": 5.8,
     "X": 44.391116,
     "Y": 33.297568
    },
    {
     "ProvName": "al-Janub (South Lebanon)",
     "zoomlevel": 5.8,
     "X": 35.368052,
     "Y": 33.359736
    },
    {
     "ProvName": "an-Najaf",
     "zoomlevel": 5.8,
     "X": 43.803664,
     "Y": 31.107073
    },
    {
     "ProvName": "Karbala",
     "zoomlevel": 5.8,
     "X": 43.823445,
     "Y": 32.506003
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 33.716011,
     "Y": 0.938756
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": 32.917421,
     "Y": 2.811158
    },
    {
     "ProvName": "Gambella",
     "zoomlevel": 5.8,
     "X": 34.221602,
     "Y": 7.821297
    },
    {
     "ProvName": "Oromiya",
     "zoomlevel": 5.8,
     "X": 38.705305,
     "Y": 7.512321
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 30.73427,
     "Y": 0.4252
    },
    {
     "ProvName": "Amhara",
     "zoomlevel": 5.8,
     "X": 38.047511,
     "Y": 11.582655
    },
    {
     "ProvName": "Dire-Dawa",
     "zoomlevel": 5.8,
     "X": 42.004581,
     "Y": 9.605845
    },
    {
     "ProvName": "Perm'",
     "zoomlevel": 4.08,
     "X": 56.22545,
     "Y": 59.116385
    },
    {
     "ProvName": "Tigray",
     "zoomlevel": 5.8,
     "X": 38.441633,
     "Y": 13.777777
    },
    {
     "ProvName": "Afar",
     "zoomlevel": 5.8,
     "X": 40.755575,
     "Y": 12.031761
    },
    {
     "ProvName": "Southern Nations",
     "zoomlevel": 5.8,
     "X": 36.726167,
     "Y": 6.460305
    },
    {
     "ProvName": "Veszprém",
     "zoomlevel": 5.8,
     "X": 17.620927,
     "Y": 47.106068
    },
    {
     "ProvName": "Benishangul Gumuz",
     "zoomlevel": 5.8,
     "X": 35.462496,
     "Y": 10.565547
    },
    {
     "ProvName": "Addis Ababa",
     "zoomlevel": 5.8,
     "X": 38.786004,
     "Y": 8.977787
    },
    {
     "ProvName": "Somali",
     "zoomlevel": 5.8,
     "X": 43.322275,
     "Y": 6.937571
    },
    {
     "ProvName": "Batys Qazaqstan",
     "zoomlevel": 4.5,
     "X": 50.678365,
     "Y": 49.782043
    },
    {
     "ProvName": "Zala",
     "zoomlevel": 5.8,
     "X": 16.845455,
     "Y": 46.672234
    },
    {
     "ProvName": "Budapest",
     "zoomlevel": 5.8,
     "X": 19.104756,
     "Y": 47.480153
    },
    {
     "ProvName": "Bács-Kiskun",
     "zoomlevel": 5.8,
     "X": 19.374604,
     "Y": 46.572405
    },
    {
     "ProvName": "Fejér",
     "zoomlevel": 5.8,
     "X": 18.542345,
     "Y": 47.1294
    },
    {
     "ProvName": "Pest",
     "zoomlevel": 5.8,
     "X": 19.36372,
     "Y": 47.419095
    },
    {
     "ProvName": "Qaraghandy",
     "zoomlevel": 5.8,
     "X": 71.020081,
     "Y": 48.174726
    },
    {
     "ProvName": "Golestan",
     "zoomlevel": 4.5,
     "X": 55.057552,
     "Y": 37.295835
    },
    {
     "ProvName": "Tolna",
     "zoomlevel": 5.8,
     "X": 18.547776,
     "Y": 46.512196
    },
    {
     "ProvName": "Opolskie",
     "zoomlevel": 5.8,
     "X": 17.87481,
     "Y": 50.616881
    },
    {
     "ProvName": "Borsod-Abaúj-Zemplén",
     "zoomlevel": 5.8,
     "X": 20.966857,
     "Y": 48.195992
    },
    {
     "ProvName": "Szabolcs-Szatmár-Bereg",
     "zoomlevel": 5.8,
     "X": 22.088047,
     "Y": 47.991095
    },
    {
     "ProvName": "Malopolskie",
     "zoomlevel": 5.8,
     "X": 20.307884,
     "Y": 49.839815
    },
    {
     "ProvName": "Békés",
     "zoomlevel": 5.8,
     "X": 21.00578,
     "Y": 46.7402
    },
    {
     "ProvName": "Csongrád",
     "zoomlevel": 5.8,
     "X": 20.235945,
     "Y": 46.423051
    },
    {
     "ProvName": "Hajdú-Bihar",
     "zoomlevel": 5.8,
     "X": 21.454349,
     "Y": 47.48005
    },
    {
     "ProvName": "Heves",
     "zoomlevel": 5.8,
     "X": 20.192982,
     "Y": 47.783764
    },
    {
     "ProvName": "Jász-Nagykun-Szolnok",
     "zoomlevel": 5.8,
     "X": 20.415291,
     "Y": 47.263931
    },
    {
     "ProvName": "Mazandaran",
     "zoomlevel": 5.8,
     "X": 52.362602,
     "Y": 36.380211
    },
    {
     "ProvName": "Semnan",
     "zoomlevel": 4.5,
     "X": 54.655838,
     "Y": 35.471721
    },
    {
     "ProvName": "Yazd",
     "zoomlevel": 4.5,
     "X": 55.603172,
     "Y": 32.565888
    },
    {
     "ProvName": "Chahar Mahall Bakhtiari",
     "zoomlevel": 5.8,
     "X": 50.64896,
     "Y": 31.94555
    },
    {
     "ProvName": "al-Basrah",
     "zoomlevel": 5.8,
     "X": 47.397948,
     "Y": 30.396916
    },
    {
     "ProvName": "Khuzestan",
     "zoomlevel": 5.8,
     "X": 48.959421,
     "Y": 31.495861
    },
    {
     "ProvName": "Lorestan",
     "zoomlevel": 5.8,
     "X": 48.406196,
     "Y": 33.48427
    },
    {
     "ProvName": "Ilam",
     "zoomlevel": 5.8,
     "X": 46.833018,
     "Y": 33.175452
    },
    {
     "ProvName": "Zanjan",
     "zoomlevel": 5.8,
     "X": 48.359389,
     "Y": 36.524134
    },
    {
     "ProvName": "Qazvin",
     "zoomlevel": 5.8,
     "X": 49.725635,
     "Y": 36.092753
    },
    {
     "ProvName": "Mangghystau",
     "zoomlevel": 4.5,
     "X": 53.945025,
     "Y": 44.100985
    },
    {
     "ProvName": "Azarbaijan-e Gharbi (West)",
     "zoomlevel": 5.8,
     "X": 45.257031,
     "Y": 37.726767
    },
    {
     "ProvName": "Azarbaijan-e Sharqi (East)",
     "zoomlevel": 5.8,
     "X": 46.565446,
     "Y": 37.921532
    },
    {
     "ProvName": "Kermanshahan",
     "zoomlevel": 5.8,
     "X": 46.608323,
     "Y": 34.454494
    },
    {
     "ProvName": "Gilan",
     "zoomlevel": 5.8,
     "X": 49.459275,
     "Y": 37.279498
    },
    {
     "ProvName": "Kordestan",
     "zoomlevel": 5.8,
     "X": 46.95545,
     "Y": 35.71831
    },
    {
     "ProvName": "as-Sulaymaniyah",
     "zoomlevel": 5.8,
     "X": 45.303361,
     "Y": 35.537473
    },
    {
     "ProvName": "Diyala",
     "zoomlevel": 5.8,
     "X": 45.057865,
     "Y": 33.902541
    },
    {
     "ProvName": "South Khorasan",
     "zoomlevel": 4.5,
     "X": 59.605511,
     "Y": 32.356998
    },
    {
     "ProvName": "Massachusetts",
     "zoomlevel": 5.8,
     "X": -71.806917,
     "Y": 42.261109
    },
    {
     "ProvName": "Minnesota",
     "zoomlevel": 3.8,
     "X": -94.199114,
     "Y": 46.343405
    },
    {
     "ProvName": "Montana",
     "zoomlevel": 3.8,
     "X": -109.638008,
     "Y": 47.032026
    },
    {
     "ProvName": "North Dakota",
     "zoomlevel": 3.8,
     "X": -100.471353,
     "Y": 47.443668
    },
    {
     "ProvName": "Hawaii",
     "zoomlevel": 5.8,
     "X": -156.345353,
     "Y": 20.260436
    },
    {
     "ProvName": "Idaho",
     "zoomlevel": 3.8,
     "X": -114.651377,
     "Y": 44.391868
    },
    {
     "ProvName": "Washington",
     "zoomlevel": 3.8,
     "X": -120.428721,
     "Y": 47.380035
    },
    {
     "ProvName": "Colorado",
     "zoomlevel": 3.8,
     "X": -105.546755,
     "Y": 38.999144
    },
    {
     "ProvName": "Kaolack",
     "zoomlevel": 5.8,
     "X": -15.940461,
     "Y": 13.881454
    },
    {
     "ProvName": "Arizona",
     "zoomlevel": 3.8,
     "X": -111.661005,
     "Y": 34.291925
    },
    {
     "ProvName": "California",
     "zoomlevel": 3.8,
     "X": -119.603828,
     "Y": 37.24158
    },
    {
     "ProvName": "al-Muthanna",
     "zoomlevel": 5.8,
     "X": 45.373185,
     "Y": 30.183544
    },
    {
     "ProvName": "al-Qadisiyah",
     "zoomlevel": 5.8,
     "X": 45.063962,
     "Y": 31.871639
    },
    {
     "ProvName": "Dhi Qar",
     "zoomlevel": 5.8,
     "X": 46.341146,
     "Y": 31.209439
    },
    {
     "ProvName": "Manubah",
     "zoomlevel": 5.8,
     "X": 9.849403,
     "Y": 36.788466
    },
    {
     "ProvName": "Maysan",
     "zoomlevel": 5.8,
     "X": 47.04497,
     "Y": 31.887587
    },
    {
     "ProvName": "Wasit",
     "zoomlevel": 5.8,
     "X": 45.718819,
     "Y": 32.663929
    },
    {
     "ProvName": "Hormozgan",
     "zoomlevel": 4.5,
     "X": 56.224257,
     "Y": 27.110237
    },
    {
     "ProvName": "Ardabil",
     "zoomlevel": 5.8,
     "X": 47.920674,
     "Y": 38.520857
    },
    {
     "ProvName": "Markazi",
     "zoomlevel": 5.8,
     "X": 49.930843,
     "Y": 34.56784
    },
    {
     "ProvName": "Qom",
     "zoomlevel": 5.8,
     "X": 50.983799,
     "Y": 34.697138
    },
    {
     "ProvName": "Hamadan",
     "zoomlevel": 5.8,
     "X": 48.551267,
     "Y": 34.869605
    },
    {
     "ProvName": "North Khorasan",
     "zoomlevel": 4.5,
     "X": 57.03188,
     "Y": 37.404404
    },
    {
     "ProvName": "Rakhine (Arakan)",
     "zoomlevel": 5.8,
     "X": 93.741045,
     "Y": 19.725116
    },
    {
     "ProvName": "Razavi Khorasan",
     "zoomlevel": 4.5,
     "X": 58.871065,
     "Y": 35.486922
    },
    {
     "ProvName": "Sistan-va Baluchestan",
     "zoomlevel": 4.5,
     "X": 60.671566,
     "Y": 27.808254
    },
    {
     "ProvName": "Kerman",
     "zoomlevel": 4.5,
     "X": 57.277645,
     "Y": 29.575321
    },
    {
     "ProvName": "Punjab",
     "zoomlevel": 5.8,
     "X": 75.404165,
     "Y": 30.848398
    },
    {
     "ProvName": "Rajasthan",
     "zoomlevel": 4,
     "X": 73.834043,
     "Y": 26.592819
    },
    {
     "ProvName": "Zhambyl",
     "zoomlevel": 4.5,
     "X": 72.198547,
     "Y": 44.293466
    },
    {
     "ProvName": "Uttar Pradesh",
     "zoomlevel": 4,
     "X": 80.541935,
     "Y": 26.934737
    },
    {
     "ProvName": "Uttarakhand",
     "zoomlevel": 5.8,
     "X": 79.195631,
     "Y": 30.161274
    },
    {
     "ProvName": "Ongtüstik Qazaqstan",
     "zoomlevel": 4.5,
     "X": 68.50556,
     "Y": 43.207881
    },
    {
     "ProvName": "Rajshahi",
     "zoomlevel": 5.8,
     "X": 89.035905,
     "Y": 25.148976
    },
    {
     "ProvName": "Jharkhand",
     "zoomlevel": 4,
     "X": 85.533386,
     "Y": 23.642013
    },
    {
     "ProvName": "West Bengal",
     "zoomlevel": 5.8,
     "X": 87.972443,
     "Y": 23.805194
    },
    {
     "ProvName": "Bihar",
     "zoomlevel": 4,
     "X": 85.604286,
     "Y": 25.662142
    },
    {
     "ProvName": "Sikkim",
     "zoomlevel": 5.8,
     "X": 88.447827,
     "Y": 27.572152
    },
    {
     "ProvName": "Chin",
     "zoomlevel": 5.8,
     "X": 93.508347,
     "Y": 22.160097
    },
    {
     "ProvName": "Irrawaddy (Ayeyarwady)",
     "zoomlevel": 5.8,
     "X": 95.126675,
     "Y": 16.877852
    },
    {
     "ProvName": "Magwe (Magway)",
     "zoomlevel": 5.8,
     "X": 94.844137,
     "Y": 20.365638
    },
    {
     "ProvName": "Shan",
     "zoomlevel": 5.8,
     "X": 98.117739,
     "Y": 21.71739
    },
    {
     "ProvName": "Tenasserim (Tanintharyi)",
     "zoomlevel": 5.8,
     "X": 98.753522,
     "Y": 12.680031
    },
    {
     "ProvName": "Kaffrine",
     "zoomlevel": 5.8,
     "X": -15.198636,
     "Y": 14.210996
    },
    {
     "ProvName": "Mbeya",
     "zoomlevel": 5.8,
     "X": 33.322279,
     "Y": -8.263163
    },
    {
     "ProvName": "Honiara",
     "zoomlevel": 5.8,
     "X": 159.966012,
     "Y": -9.461471
    },
    {
     "ProvName": "Rukwa",
     "zoomlevel": 5.8,
     "X": 31.341145,
     "Y": -7.0253
    },
    {
     "ProvName": "Zanzibar South and Central",
     "zoomlevel": 5.8,
     "X": 39.41911,
     "Y": -6.235937
    },
    {
     "ProvName": "Awdal",
     "zoomlevel": 5.8,
     "X": 43.362307,
     "Y": 10.575183
    },
    {
     "ProvName": "Karas",
     "zoomlevel": 4.8,
     "X": 17.608384,
     "Y": -26.974064
    },
    {
     "ProvName": "Rio San Juan",
     "zoomlevel": 5.8,
     "X": -84.649248,
     "Y": 11.27514
    },
    {
     "ProvName": "Mayabeque",
     "zoomlevel": 5.8,
     "X": -82.00192,
     "Y": 22.882965
    },
    {
     "ProvName": "Hardap",
     "zoomlevel": 4.8,
     "X": 17.392316,
     "Y": -24.549642
    },
    {
     "ProvName": "Omusati",
     "zoomlevel": 4.8,
     "X": 14.894804,
     "Y": -18.278198
    },
    {
     "ProvName": "Khomas",
     "zoomlevel": 4.8,
     "X": 17.160766,
     "Y": -22.904247
    },
    {
     "ProvName": "Cuvette",
     "zoomlevel": 5.8,
     "X": 16.006762,
     "Y": -0.589218
    },
    {
     "ProvName": "Lékoumou",
     "zoomlevel": 5.8,
     "X": 13.496756,
     "Y": -3.107048
    },
    {
     "ProvName": "Niari",
     "zoomlevel": 5.8,
     "X": 12.449542,
     "Y": -3.120009
    },
    {
     "ProvName": "Plateaux",
     "zoomlevel": 5.8,
     "X": 15.386679,
     "Y": -2.098394
    },
    {
     "ProvName": "Kunene",
     "zoomlevel": 4.8,
     "X": 13.921111,
     "Y": -19.128968
    },
    {
     "ProvName": "Rivas",
     "zoomlevel": 5.8,
     "X": -85.657818,
     "Y": 11.397272
    },
    {
     "ProvName": "Erongo",
     "zoomlevel": 4.8,
     "X": 15.235321,
     "Y": -22.057001
    },
    {
     "ProvName": "Oshana",
     "zoomlevel": 4.8,
     "X": 15.721349,
     "Y": -18.443299
    },
    {
     "ProvName": "Ohangwena",
     "zoomlevel": 4.8,
     "X": 16.807189,
     "Y": -17.585297
    },
    {
     "ProvName": "Otjozondjupa",
     "zoomlevel": 4.8,
     "X": 18.178468,
     "Y": -20.304364
    },
    {
     "ProvName": "Tillabéri",
     "zoomlevel": 5.8,
     "X": 2.181792,
     "Y": 14.179115
    },
    {
     "ProvName": "Marlborough",
     "zoomlevel": 5.8,
     "X": 173.543684,
     "Y": -41.684186
    },
    {
     "ProvName": "Omaheke",
     "zoomlevel": 4.8,
     "X": 19.459879,
     "Y": -21.882467
    },
    {
     "ProvName": "Okavango",
     "zoomlevel": 4.8,
     "X": 19.485933,
     "Y": -18.394217
    },
    {
     "ProvName": "Pemba North",
     "zoomlevel": 5.8,
     "X": 39.774098,
     "Y": -5.047128
    },
    {
     "ProvName": "Oshikoto",
     "zoomlevel": 4.8,
     "X": 17.00107,
     "Y": -18.597059
    },
    {
     "ProvName": "Liambezi",
     "zoomlevel": 4.8,
     "X": 23.247013,
     "Y": -17.917981
    },
    {
     "ProvName": "Mwanza",
     "zoomlevel": 5.8,
     "X": 32.796531,
     "Y": -2.465748
    },
    {
     "ProvName": "Pemba South",
     "zoomlevel": 5.8,
     "X": 39.751012,
     "Y": -5.309269
    },
    {
     "ProvName": "Mara",
     "zoomlevel": 5.8,
     "X": 34.106229,
     "Y": -1.694861
    },
    {
     "ProvName": "Shinyanga",
     "zoomlevel": 5.8,
     "X": 33.33169,
     "Y": -3.407095
    },
    {
     "ProvName": "Dodoma",
     "zoomlevel": 5.8,
     "X": 35.923153,
     "Y": -5.899062
    },
    {
     "ProvName": "Tabora",
     "zoomlevel": 5.8,
     "X": 32.822372,
     "Y": -5.285575
    },
    {
     "ProvName": "Singida",
     "zoomlevel": 5.8,
     "X": 34.493083,
     "Y": -5.749192
    },
    {
     "ProvName": "Kagera",
     "zoomlevel": 5.8,
     "X": 31.47101,
     "Y": -1.96004
    },
    {
     "ProvName": "Arusha",
     "zoomlevel": 5.8,
     "X": 35.932157,
     "Y": -3.013316
    },
    {
     "ProvName": "Kigoma",
     "zoomlevel": 5.8,
     "X": 30.389368,
     "Y": -4.819344
    },
    {
     "ProvName": "Mwaro",
     "zoomlevel": 5.8,
     "X": 29.725215,
     "Y": -3.483463
    },
    {
     "ProvName": "Dar es Salaam",
     "zoomlevel": 5.8,
     "X": 39.264284,
     "Y": -6.881509
    },
    {
     "ProvName": "Morogoro",
     "zoomlevel": 5.8,
     "X": 37.000762,
     "Y": -7.897945
    },
    {
     "ProvName": "Nelson",
     "zoomlevel": 5.8,
     "X": 173.381192,
     "Y": -41.250431
    },
    {
     "ProvName": "Woqooyi Galbeed",
     "zoomlevel": 5.8,
     "X": 44.561735,
     "Y": 9.882848
    },
    {
     "ProvName": "Pwani (Coast)",
     "zoomlevel": 5.8,
     "X": 38.667601,
     "Y": -7.263331
    },
    {
     "ProvName": "Zanzibar North",
     "zoomlevel": 5.8,
     "X": 39.290407,
     "Y": -5.921769
    },
    {
     "ProvName": "Zanzibar West",
     "zoomlevel": 5.8,
     "X": 39.243116,
     "Y": -6.161868
    },
    {
     "ProvName": "Togdheer",
     "zoomlevel": 5.8,
     "X": 45.719635,
     "Y": 9.100023
    },
    {
     "ProvName": "Iringa",
     "zoomlevel": 5.8,
     "X": 35.160698,
     "Y": -8.382783
    },
    {
     "ProvName": "Tanga",
     "zoomlevel": 5.8,
     "X": 38.274415,
     "Y": -5.226311
    },
    {
     "ProvName": "Lindi",
     "zoomlevel": 5.8,
     "X": 38.387965,
     "Y": -9.464197
    },
    {
     "ProvName": "Wyoming",
     "zoomlevel": 3.8,
     "X": -107.552294,
     "Y": 42.999827
    },
    {
     "ProvName": "Mtwara",
     "zoomlevel": 5.8,
     "X": 39.147576,
     "Y": -10.777028
    },
    {
     "ProvName": "Manyara",
     "zoomlevel": 5.8,
     "X": 36.562554,
     "Y": -4.563163
    },
    {
     "ProvName": "Sool",
     "zoomlevel": 5.8,
     "X": 47.476863,
     "Y": 8.943978
    },
    {
     "ProvName": "Ruvuma",
     "zoomlevel": 5.8,
     "X": 36.258254,
     "Y": -10.736295
    },
    {
     "ProvName": "Sanaag",
     "zoomlevel": 5.8,
     "X": 47.638535,
     "Y": 10.311999
    },
    {
     "ProvName": "Gisborne",
     "zoomlevel": 5.8,
     "X": 177.250196,
     "Y": -38.970155
    },
    {
     "ProvName": "Hawkes Bay",
     "zoomlevel": 5.8,
     "X": 176.946647,
     "Y": -39.680454
    },
    {
     "ProvName": "Karabük",
     "zoomlevel": 5.8,
     "X": 32.597614,
     "Y": 41.244039
    },
    {
     "ProvName": "Bartin",
     "zoomlevel": 5.8,
     "X": 32.480168,
     "Y": 41.573052
    },
    {
     "ProvName": "Bay of Plenty",
     "zoomlevel": 5.8,
     "X": 176.774049,
     "Y": -38.224949
    },
    {
     "ProvName": "Canterbury",
     "zoomlevel": 5.8,
     "X": 165.368846,
     "Y": -43.579694
    },
    {
     "ProvName": "Gaziantep",
     "zoomlevel": 5.8,
     "X": 37.358672,
     "Y": 37.094434
    },
    {
     "ProvName": "Tasman",
     "zoomlevel": 5.8,
     "X": 172.649289,
     "Y": -41.445334
    },
    {
     "ProvName": "Northland",
     "zoomlevel": 5.8,
     "X": 173.854742,
     "Y": -35.50754
    },
    {
     "ProvName": "Taranaki",
     "zoomlevel": 5.8,
     "X": 174.470325,
     "Y": -39.309702
    },
    {
     "ProvName": "West Coast",
     "zoomlevel": 5.8,
     "X": 170.925993,
     "Y": -42.77017
    },
    {
     "ProvName": "Kilis",
     "zoomlevel": 5.8,
     "X": 37.121098,
     "Y": 36.790088
    },
    {
     "ProvName": "Otago",
     "zoomlevel": 5.8,
     "X": 169.55422,
     "Y": -45.282616
    },
    {
     "ProvName": "Southland",
     "zoomlevel": 5.8,
     "X": 167.95446,
     "Y": -45.734845
    },
    {
     "ProvName": "Aragón",
     "zoomlevel": 5.8,
     "X": -0.659956,
     "Y": 41.516238
    },
    {
     "ProvName": "Cook Islands",
     "zoomlevel": 5.8,
     "X": -158.781438,
     "Y": -19.818705
    },
    {
     "ProvName": "Navarra",
     "zoomlevel": 5.8,
     "X": -1.642459,
     "Y": 42.669078
    },
    {
     "ProvName": "Curacao",
     "zoomlevel": 5.8,
     "X": -68.970527,
     "Y": 12.193622
    },
    {
     "ProvName": "Paktia",
     "zoomlevel": 5.8,
     "X": 69.386628,
     "Y": 33.626521
    },
    {
     "ProvName": "P'eng-hu",
     "zoomlevel": 5.8,
     "X": 119.573745,
     "Y": 23.586552
    },
    {
     "ProvName": "Chinmen (Kinmen)",
     "zoomlevel": 5.8,
     "X": 118.373673,
     "Y": 24.453469
    },
    {
     "ProvName": "Central Jutland (Midtjylland)",
     "zoomlevel": 5.8,
     "X": 9.394602,
     "Y": 56.247786
    },
    {
     "ProvName": "South Denmark (Syddanmark)",
     "zoomlevel": 5.8,
     "X": 9.444362,
     "Y": 55.354734
    },
    {
     "ProvName": "Cayman Islands",
     "zoomlevel": 5.8,
     "X": -80.870172,
     "Y": 19.433951
    },
    {
     "ProvName": "Falkland Islands",
     "zoomlevel": 5.8,
     "X": -59.3717,
     "Y": -51.732379
    },
    {
     "ProvName": "Guam",
     "zoomlevel": 5.8,
     "X": 144.772216,
     "Y": 13.443634
    },
    {
     "ProvName": "North Jutland (Nordjylland)",
     "zoomlevel": 5.8,
     "X": 9.675967,
     "Y": 57.052184
    },
    {
     "ProvName": "Capital (Hovedstaden)",
     "zoomlevel": 5.8,
     "X": 12.896329,
     "Y": 55.69362
    },
    {
     "ProvName": "Zealand (Sjælland)",
     "zoomlevel": 5.8,
     "X": 11.710599,
     "Y": 55.288369
    },
    {
     "ProvName": "Basel-Landschaft",
     "zoomlevel": 5.8,
     "X": 7.698058,
     "Y": 47.456818
    },
    {
     "ProvName": "Bern",
     "zoomlevel": 5.8,
     "X": 7.626574,
     "Y": 46.824628
    },
    {
     "ProvName": "Basel-Stadt",
     "zoomlevel": 5.8,
     "X": 7.59881,
     "Y": 47.564455
    },
    {
     "ProvName": "Fribourg",
     "zoomlevel": 5.8,
     "X": 7.081527,
     "Y": 46.719285
    },
    {
     "ProvName": "North East",
     "zoomlevel": 4.8,
     "X": 27.560147,
     "Y": -21.0098
    },
    {
     "ProvName": "Vaud",
     "zoomlevel": 5.8,
     "X": 6.655844,
     "Y": 46.571208
    },
    {
     "ProvName": "Santo Antao",
     "zoomlevel": 5.8,
     "X": -25.172351,
     "Y": 17.060835
    },
    {
     "ProvName": "Solothurn",
     "zoomlevel": 5.8,
     "X": 7.640802,
     "Y": 47.304715
    },
    {
     "ProvName": "Obwalden",
     "zoomlevel": 5.8,
     "X": 8.23937,
     "Y": 46.853008
    },
    {
     "ProvName": "Vastra Gotaland",
     "zoomlevel": 5.8,
     "X": 12.882517,
     "Y": 58.315254
    },
    {
     "ProvName": "São Vicente",
     "zoomlevel": 5.8,
     "X": -24.97816,
     "Y": 16.849478
    },
    {
     "ProvName": "Hamilton city",
     "zoomlevel": 5.8,
     "X": -64.790911,
     "Y": 32.289401
    },
    {
     "ProvName": "Skåne",
     "zoomlevel": 5.8,
     "X": 13.606685,
     "Y": 55.962891
    },
    {
     "ProvName": "Valencia",
     "zoomlevel": 5.8,
     "X": -0.554122,
     "Y": 39.408476
    },
    {
     "ProvName": "Savanes",
     "zoomlevel": 5.8,
     "X": -5.546489,
     "Y": 9.563195
    },
    {
     "ProvName": "Marahoué",
     "zoomlevel": 5.8,
     "X": -5.893938,
     "Y": 7.076109
    },
    {
     "ProvName": "Smith's",
     "zoomlevel": 5.8,
     "X": -64.736704,
     "Y": 32.31464
    },
    {
     "ProvName": "Labé",
     "zoomlevel": 5.8,
     "X": -12.030927,
     "Y": 11.749172
    },
    {
     "ProvName": "Kankan",
     "zoomlevel": 5.8,
     "X": -9.330821,
     "Y": 10.596428
    },
    {
     "ProvName": "Fromager",
     "zoomlevel": 5.8,
     "X": -5.859567,
     "Y": 6.219962
    },
    {
     "ProvName": "Mamou",
     "zoomlevel": 5.8,
     "X": -12.129535,
     "Y": 10.648667
    },
    {
     "ProvName": "Boké",
     "zoomlevel": 5.8,
     "X": -13.775439,
     "Y": 11.363101
    },
    {
     "ProvName": "Kindia",
     "zoomlevel": 5.8,
     "X": -13.126205,
     "Y": 10.211145
    },
    {
     "ProvName": "Emberá",
     "zoomlevel": 5.8,
     "X": -77.783203,
     "Y": 8.22417
    },
    {
     "ProvName": "Denguélé",
     "zoomlevel": 5.8,
     "X": -7.393632,
     "Y": 9.629287
    },
    {
     "ProvName": "Nzérékoré",
     "zoomlevel": 5.8,
     "X": -8.92948,
     "Y": 8.440772
    },
    {
     "ProvName": "Faranah",
     "zoomlevel": 5.8,
     "X": -10.662634,
     "Y": 10.505219
    },
    {
     "ProvName": "Lagunes",
     "zoomlevel": 5.8,
     "X": -4.370875,
     "Y": 5.601536
    },
    {
     "ProvName": "Bafing",
     "zoomlevel": 5.8,
     "X": -7.644562,
     "Y": 8.390505
    },
    {
     "ProvName": "São Nicolau",
     "zoomlevel": 5.8,
     "X": -24.260084,
     "Y": 16.604329
    },
    {
     "ProvName": "Sal",
     "zoomlevel": 5.8,
     "X": -22.93383,
     "Y": 16.739117
    },
    {
     "ProvName": "Boa Vista",
     "zoomlevel": 5.8,
     "X": -22.816228,
     "Y": 16.105572
    },
    {
     "ProvName": "Dix-huit Montagnes",
     "zoomlevel": 5.8,
     "X": -7.699971,
     "Y": 7.405633
    },
    {
     "ProvName": "Conakry",
     "zoomlevel": 5.8,
     "X": -13.68216,
     "Y": 9.538087
    },
    {
     "ProvName": "Maio",
     "zoomlevel": 5.8,
     "X": -23.179727,
     "Y": 15.221144
    },
    {
     "ProvName": "Worodougou",
     "zoomlevel": 5.8,
     "X": -6.415232,
     "Y": 8.370813
    },
    {
     "ProvName": "Santiago",
     "zoomlevel": 5.8,
     "X": -23.636206,
     "Y": 15.08164
    },
    {
     "ProvName": "Fogo",
     "zoomlevel": 5.8,
     "X": -24.399416,
     "Y": 14.928691
    },
    {
     "ProvName": "Haut-Sassandra",
     "zoomlevel": 5.8,
     "X": -6.597634,
     "Y": 7.018948
    },
    {
     "ProvName": "Sud-Bandama",
     "zoomlevel": 5.8,
     "X": -5.453755,
     "Y": 5.666204
    },
    {
     "ProvName": "Brava",
     "zoomlevel": 5.8,
     "X": -24.717064,
     "Y": 14.854006
    },
    {
     "ProvName": "Bolu",
     "zoomlevel": 5.8,
     "X": 31.6352,
     "Y": 40.606771
    },
    {
     "ProvName": "Bas-Sassandra",
     "zoomlevel": 5.8,
     "X": -6.761587,
     "Y": 5.352884
    },
    {
     "ProvName": "Zanzan",
     "zoomlevel": 5.8,
     "X": -3.350789,
     "Y": 8.671006
    },
    {
     "ProvName": "Vallée du Bandama",
     "zoomlevel": 5.8,
     "X": -4.96583,
     "Y": 8.247782
    },
    {
     "ProvName": "Agnébi",
     "zoomlevel": 5.8,
     "X": -3.996758,
     "Y": 6.067586
    },
    {
     "ProvName": "Düzce",
     "zoomlevel": 5.8,
     "X": 31.246188,
     "Y": 40.901734
    },
    {
     "ProvName": "N'zi-Comoé",
     "zoomlevel": 5.8,
     "X": -4.231889,
     "Y": 7.093185
    },
    {
     "ProvName": "Borkou",
     "zoomlevel": 3.8,
     "X": 18.566148,
     "Y": 18.375498
    },
    {
     "ProvName": "Mafeteng",
     "zoomlevel": 5.8,
     "X": 27.513834,
     "Y": -29.788751
    },
    {
     "ProvName": "Ngäbe Buglé",
     "zoomlevel": 5.8,
     "X": -81.796612,
     "Y": 8.672874
    },
    {
     "ProvName": "Moyen-Cavally",
     "zoomlevel": 5.8,
     "X": -7.598833,
     "Y": 6.410758
    },
    {
     "ProvName": "Ennedi",
     "zoomlevel": 3.8,
     "X": 22.137123,
     "Y": 18.111837
    },
    {
     "ProvName": "Moyen-Comoé",
     "zoomlevel": 5.8,
     "X": -3.430702,
     "Y": 6.696109
    },
    {
     "ProvName": "Sud-Comoé",
     "zoomlevel": 5.8,
     "X": -3.133561,
     "Y": 5.542112
    },
    {
     "ProvName": "Lacs",
     "zoomlevel": 5.8,
     "X": -5.088036,
     "Y": 6.897359
    },
    {
     "ProvName": "Paphos",
     "zoomlevel": 5.8,
     "X": 32.527358,
     "Y": 34.907776
    },
    {
     "ProvName": "Larnaca",
     "zoomlevel": 5.8,
     "X": 33.478752,
     "Y": 34.896401
    },
    {
     "ProvName": "Nicosia",
     "zoomlevel": 5.8,
     "X": 33.067508,
     "Y": 35.039578
    },
    {
     "ProvName": "Quiché",
     "zoomlevel": 5.8,
     "X": -90.948108,
     "Y": 15.455973
    },
    {
     "ProvName": "Kamchatka",
     "zoomlevel": 2.37,
     "X": 162.997463,
     "Y": 58.952073
    },
    {
     "ProvName": "Abuja",
     "zoomlevel": 5.8,
     "X": 7.142557,
     "Y": 8.861313
    },
    {
     "ProvName": "Kanem",
     "zoomlevel": 5.8,
     "X": 15.250185,
     "Y": 15.245469
    },
    {
     "ProvName": "Al-Anbar",
     "zoomlevel": 5.8,
     "X": 41.621757,
     "Y": 32.968125
    },
    {
     "ProvName": "Babil",
     "zoomlevel": 5.8,
     "X": 44.537512,
     "Y": 32.639464
    },
    {
     "ProvName": "Appenzell Inner-Rhoden",
     "zoomlevel": 5.8,
     "X": 9.402373,
     "Y": 47.320392
    },
    {
     "ProvName": "Brussels",
     "zoomlevel": 5.8,
     "X": 4.370405,
     "Y": 50.836709
    },
    {
     "ProvName": "Noord-Brabant",
     "zoomlevel": 5.8,
     "X": 5.189758,
     "Y": 51.559531
    },
    {
     "ProvName": "San'a'",
     "zoomlevel": 5.8,
     "X": 44.405304,
     "Y": 15.329848
    },
    {
     "ProvName": "Eastern",
     "zoomlevel": 5.8,
     "X": 30.459574,
     "Y": -1.836983
    },
    {
     "ProvName": "Northern",
     "zoomlevel": 5.8,
     "X": 29.881475,
     "Y": -1.607791
    },
    {
     "ProvName": "Hadramawt",
     "zoomlevel": 4.5,
     "X": 49.292823,
     "Y": 16.612032
    },
    {
     "ProvName": "Capital Secretariat",
     "zoomlevel": 5.8,
     "X": 44.23821,
     "Y": 15.462915
    },
    {
     "ProvName": "Kagoshima",
     "zoomlevel": 5.8,
     "X": 130.61757,
     "Y": 31.470814
    },
    {
     "ProvName": "Okinawa",
     "zoomlevel": 5.8,
     "X": 127.673357,
     "Y": 26.644428
    },
    {
     "ProvName": "Gumma",
     "zoomlevel": 5.8,
     "X": 138.960287,
     "Y": 36.497197
    },
    {
     "ProvName": "Daman and Diu",
     "zoomlevel": 4,
     "X": 72.591174,
     "Y": 20.460334
    },
    {
     "ProvName": "Callao",
     "zoomlevel": 5.8,
     "X": -77.134859,
     "Y": -12.046554
    },
    {
     "ProvName": "Hawalli",
     "zoomlevel": 5.8,
     "X": 48.0335,
     "Y": 29.328896
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": 157.256495,
     "Y": -8.150311
    },
    {
     "ProvName": "Choiseul",
     "zoomlevel": 5.8,
     "X": 156.974953,
     "Y": -7.039356
    },
    {
     "ProvName": "Makira-Ulawa",
     "zoomlevel": 5.8,
     "X": 161.840973,
     "Y": -10.548273
    },
    {
     "ProvName": "`Adan",
     "zoomlevel": 5.8,
     "X": 44.857465,
     "Y": 12.826061
    },
    {
     "ProvName": "Abyan",
     "zoomlevel": 5.8,
     "X": 46.229672,
     "Y": 13.719275
    },
    {
     "ProvName": "Nevada",
     "zoomlevel": 3.8,
     "X": -116.651933,
     "Y": 39.354009
    },
    {
     "ProvName": "Kansas",
     "zoomlevel": 3.8,
     "X": -98.380848,
     "Y": 38.484367
    },
    {
     "ProvName": "Missouri",
     "zoomlevel": 3.8,
     "X": -92.484144,
     "Y": 38.370203
    },
    {
     "ProvName": "New Mexico",
     "zoomlevel": 3.8,
     "X": -106.110358,
     "Y": 34.421702
    },
    {
     "ProvName": "Oregon",
     "zoomlevel": 3.8,
     "X": -120.546041,
     "Y": 43.93991
    },
    {
     "ProvName": "Utah",
     "zoomlevel": 3.8,
     "X": -111.674166,
     "Y": 39.326482
    },
    {
     "ProvName": "Illinois",
     "zoomlevel": 3.8,
     "X": -89.155508,
     "Y": 40.125406
    },
    {
     "ProvName": "Arkansas",
     "zoomlevel": 3.8,
     "X": -92.444184,
     "Y": 34.902805
    },
    {
     "ProvName": "Iowa",
     "zoomlevel": 3.8,
     "X": -93.497854,
     "Y": 42.077713
    },
    {
     "ProvName": "Wisconsin",
     "zoomlevel": 3.8,
     "X": -89.736308,
     "Y": 44.644471
    },
    {
     "ProvName": "West Virginia",
     "zoomlevel": 3.8,
     "X": -80.611355,
     "Y": 38.646768
    },
    {
     "ProvName": "Barh el Ghazel",
     "zoomlevel": 5.8,
     "X": 16.851434,
     "Y": 14.586044
    },
    {
     "ProvName": "Nebraska",
     "zoomlevel": 3.8,
     "X": -99.805941,
     "Y": 41.529126
    },
    {
     "ProvName": "Mayo-Kebbi Ouest",
     "zoomlevel": 5.8,
     "X": 14.748599,
     "Y": 9.313863
    },
    {
     "ProvName": "Oklahoma",
     "zoomlevel": 3.8,
     "X": -97.511357,
     "Y": 35.587935
    },
    {
     "ProvName": "South Dakota",
     "zoomlevel": 3.8,
     "X": -100.23374,
     "Y": 44.439422
    },
    {
     "ProvName": "Louisiana",
     "zoomlevel": 3.8,
     "X": -92.019344,
     "Y": 31.080826
    },
    {
     "ProvName": "Texas",
     "zoomlevel": 3.8,
     "X": -99.355809,
     "Y": 31.500508
    },
    {
     "ProvName": "Artemisa",
     "zoomlevel": 5.8,
     "X": -82.68158,
     "Y": 22.858609
    },
    {
     "ProvName": "Connecticut",
     "zoomlevel": 5.8,
     "X": -72.726243,
     "Y": 41.626143
    },
    {
     "ProvName": "New Hampshire",
     "zoomlevel": 5.8,
     "X": -71.578306,
     "Y": 43.689889
    },
    {
     "ProvName": "Rhode Island",
     "zoomlevel": 5.8,
     "X": -71.560998,
     "Y": 41.680255
    },
    {
     "ProvName": "Delaware",
     "zoomlevel": 5.8,
     "X": -75.50518,
     "Y": 38.991823
    },
    {
     "ProvName": "District of Columbia",
     "zoomlevel": 5.8,
     "X": -77.009602,
     "Y": 38.910763
    },
    {
     "ProvName": "Maryland",
     "zoomlevel": 5.8,
     "X": -76.798457,
     "Y": 39.056058
    },
    {
     "ProvName": "Vermont",
     "zoomlevel": 5.8,
     "X": -72.664918,
     "Y": 44.076965
    },
    {
     "ProvName": "Northern Cyprus",
     "zoomlevel": 5.8,
     "X": 33.594655,
     "Y": 35.273876
    },
    {
     "ProvName": "Alabama",
     "zoomlevel": 3.8,
     "X": -86.828726,
     "Y": 32.78918
    },
    {
     "ProvName": "Florida",
     "zoomlevel": 5.8,
     "X": -82.482183,
     "Y": 28.648138
    },
    {
     "ProvName": "Georgia",
     "zoomlevel": 3.8,
     "X": -83.450145,
     "Y": 32.65223
    },
    {
     "ProvName": "Mississippi",
     "zoomlevel": 3.8,
     "X": -89.670393,
     "Y": 32.761123
    },
    {
     "ProvName": "South Carolina",
     "zoomlevel": 3.8,
     "X": -80.900774,
     "Y": 33.918413
    },
    {
     "ProvName": "Indiana",
     "zoomlevel": 3.8,
     "X": -86.284608,
     "Y": 39.918408
    },
    {
     "ProvName": "Kentucky",
     "zoomlevel": 3.8,
     "X": -85.290211,
     "Y": 37.529676
    },
    {
     "ProvName": "North Carolina",
     "zoomlevel": 3.8,
     "X": -79.390154,
     "Y": 35.547241
    },
    {
     "ProvName": "Ohio",
     "zoomlevel": 3.8,
     "X": -82.711453,
     "Y": 40.417419
    },
    {
     "ProvName": "Tennessee",
     "zoomlevel": 3.8,
     "X": -86.34184,
     "Y": 35.846779
    },
    {
     "ProvName": "Virginia",
     "zoomlevel": 3.8,
     "X": -78.831153,
     "Y": 37.519408
    },
    {
     "ProvName": "New Jersey",
     "zoomlevel": 5.8,
     "X": -74.665354,
     "Y": 40.19243
    },
    {
     "ProvName": "New York",
     "zoomlevel": 5.8,
     "X": -75.692044,
     "Y": 42.993148
    },
    {
     "ProvName": "Sandys",
     "zoomlevel": 5.8,
     "X": -64.878852,
     "Y": 32.282495
    },
    {
     "ProvName": "Pennsylvania",
     "zoomlevel": 5.8,
     "X": -77.841405,
     "Y": 40.898536
    },
    {
     "ProvName": "Maine",
     "zoomlevel": 5.8,
     "X": -69.236553,
     "Y": 45.398285
    },
    {
     "ProvName": "Michigan",
     "zoomlevel": 3.8,
     "X": -85.739792,
     "Y": 44.875093
    },
    {
     "ProvName": "Alaska",
     "zoomlevel": 3.8,
     "X": -152.273816,
     "Y": 64.262645
    },
    {
     "ProvName": "West Bank",
     "zoomlevel": 5.8,
     "X": 35.244956,
     "Y": 31.945385
    },
    {
     "ProvName": "Turks & Caicos Islands",
     "zoomlevel": 5.8,
     "X": -71.872606,
     "Y": 21.779877
    },
    {
     "ProvName": "Tuvalu",
     "zoomlevel": 5.8,
     "X": 178.519889,
     "Y": -7.760053
    },
    {
     "ProvName": "Holy See",
     "zoomlevel": 5.8,
     "X": 12.451551,
     "Y": 41.903827
    },
    {
     "ProvName": "British Virgin Islands",
     "zoomlevel": 5.8,
     "X": -64.498928,
     "Y": 18.514114
    },
    {
     "ProvName": "Brcko District",
     "zoomlevel": 5.8,
     "X": 18.752868,
     "Y": 44.814231
    },
    {
     "ProvName": "Southampton",
     "zoomlevel": 5.8,
     "X": -64.861707,
     "Y": 32.239458
    },
    {
     "ProvName": "Warwick",
     "zoomlevel": 5.8,
     "X": -64.815592,
     "Y": 32.254387
    },
    {
     "ProvName": "Guadeloupe",
     "zoomlevel": 5.8,
     "X": -61.607442,
     "Y": 16.305812
    },
    {
     "ProvName": "Mayotte",
     "zoomlevel": 5.8,
     "X": 45.142639,
     "Y": -12.817573
    },
    {
     "ProvName": "Reunion",
     "zoomlevel": 5.8,
     "X": 55.542146,
     "Y": -21.119603
    },
    {
     "ProvName": "Ordino",
     "zoomlevel": 5.8,
     "X": 1.525275,
     "Y": 42.602406
    },
    {
     "ProvName": "Canillo",
     "zoomlevel": 5.8,
     "X": 1.648361,
     "Y": 42.584943
    },
    {
     "ProvName": "Paget",
     "zoomlevel": 5.8,
     "X": -64.784852,
     "Y": 32.274296
    },
    {
     "ProvName": "Liechtenstein",
     "zoomlevel": 5.8,
     "X": 9.5409,
     "Y": 47.138206
    },
    {
     "ProvName": "Monaco",
     "zoomlevel": 5.8,
     "X": 7.398764,
     "Y": 43.746033
    },
    {
     "ProvName": "Northern Mariana Is",
     "zoomlevel": 5.8,
     "X": 145.59262,
     "Y": 16.114807
    },
    {
     "ProvName": "Montserrat",
     "zoomlevel": 5.8,
     "X": -62.18667,
     "Y": 16.737339
    },
    {
     "ProvName": "Niue Island",
     "zoomlevel": 5.8,
     "X": -169.868363,
     "Y": -19.049071
    },
    {
     "ProvName": "Nauru",
     "zoomlevel": 5.8,
     "X": 166.933309,
     "Y": -0.520975
    },
    {
     "ProvName": "Palau",
     "zoomlevel": 5.8,
     "X": 134.338314,
     "Y": 7.173211
    },
    {
     "ProvName": "Devonshire",
     "zoomlevel": 5.8,
     "X": -64.76489,
     "Y": 32.300003
    },
    {
     "ProvName": "Puerto Rico",
     "zoomlevel": 5.8,
     "X": -66.466397,
     "Y": 18.225668
    },
    {
     "ProvName": "Singapore",
     "zoomlevel": 5.8,
     "X": 103.813797,
     "Y": 1.358791
    },
    {
     "ProvName": "Sint Maarten (Dutch)",
     "zoomlevel": 5.8,
     "X": -63.069636,
     "Y": 18.04043
    },
    {
     "ProvName": "Lower River",
     "zoomlevel": 5.8,
     "X": -15.752462,
     "Y": 13.38606
    },
    {
     "ProvName": "Abaco, Great and Little",
     "zoomlevel": 5.8,
     "X": -77.27446,
     "Y": 26.396905
    },
    {
     "ProvName": "Ralik",
     "zoomlevel": 5.8,
     "X": 171.442676,
     "Y": 7.01626
    },
    {
     "ProvName": "Southern",
     "zoomlevel": 5.8,
     "X": 50.555609,
     "Y": 25.992229
    },
    {
     "ProvName": "Chittagong",
     "zoomlevel": 5.8,
     "X": 92.230071,
     "Y": 22.590657
    },
    {
     "ProvName": "Poni",
     "zoomlevel": 5.8,
     "X": -3.347181,
     "Y": 10.291821
    },
    {
     "ProvName": "Noumbiel",
     "zoomlevel": 5.8,
     "X": -2.947959,
     "Y": 9.848202
    },
    {
     "ProvName": "Bujumbura Rural",
     "zoomlevel": 5.8,
     "X": 29.401795,
     "Y": -3.507713
    },
    {
     "ProvName": "Bujumbura Mairie",
     "zoomlevel": 5.8,
     "X": 29.315345,
     "Y": -3.405063
    },
    {
     "ProvName": "Muramvya",
     "zoomlevel": 5.8,
     "X": 29.66265,
     "Y": -3.256298
    },
    {
     "ProvName": "Dushanbe",
     "zoomlevel": 5.8,
     "X": 68.823473,
     "Y": 38.533882
    },
    {
     "ProvName": "Karotegin",
     "zoomlevel": 5.8,
     "X": 70.124785,
     "Y": 38.887439
    },
    {
     "ProvName": "Ombella-Mpoko",
     "zoomlevel": 5.8,
     "X": 17.995218,
     "Y": 5.118691
    },
    {
     "ProvName": "Bangui",
     "zoomlevel": 5.8,
     "X": 18.596662,
     "Y": 4.399472
    },
    {
     "ProvName": "Tibesti",
     "zoomlevel": 3.8,
     "X": 16.613794,
     "Y": 21.125621
    },
    {
     "ProvName": "Anjouan (Nzwani)",
     "zoomlevel": 5.8,
     "X": 44.435318,
     "Y": -12.214922
    },
    {
     "ProvName": "Ouaddaï",
     "zoomlevel": 5.8,
     "X": 21.403947,
     "Y": 12.139555
    },
    {
     "ProvName": "Sila",
     "zoomlevel": 5.8,
     "X": 21.12486,
     "Y": 13.572877
    },
    {
     "ProvName": "Ville de N'Djamena",
     "zoomlevel": 5.8,
     "X": 15.034277,
     "Y": 12.121098
    },
    {
     "ProvName": "Biombo",
     "zoomlevel": 5.8,
     "X": -15.7926,
     "Y": 11.883505
    },
    {
     "ProvName": "Hadjer-Lamis",
     "zoomlevel": 5.8,
     "X": 16.16817,
     "Y": 12.562209
    },
    {
     "ProvName": "Wâdî al-Hayât",
     "zoomlevel": 3.8,
     "X": 12.725189,
     "Y": 26.383226
    },
    {
     "ProvName": "Gât",
     "zoomlevel": 3.8,
     "X": 10.53843,
     "Y": 26.07723
    },
    {
     "ProvName": "Chari-Baguirmi",
     "zoomlevel": 5.8,
     "X": 16.32446,
     "Y": 11.228435
    },
    {
     "ProvName": "Mandoul",
     "zoomlevel": 5.8,
     "X": 17.588015,
     "Y": 8.69154
    },
    {
     "ProvName": "St. George's",
     "zoomlevel": 5.8,
     "X": -64.685188,
     "Y": 32.373662
    },
    {
     "ProvName": "Carriacou",
     "zoomlevel": 5.8,
     "X": -64.68142,
     "Y": 32.397597
    },
    {
     "ProvName": "Hamilton",
     "zoomlevel": 5.8,
     "X": -64.725473,
     "Y": 32.343411
    },
    {
     "ProvName": "Moyen-Chari",
     "zoomlevel": 5.8,
     "X": 18.633532,
     "Y": 9.422065
    },
    {
     "ProvName": "Iles du Vent (Windward Islands)",
     "zoomlevel": 5.8,
     "X": -149.465047,
     "Y": -17.648385
    },
    {
     "ProvName": "Mayo-Kebbi Est",
     "zoomlevel": 5.8,
     "X": 15.543995,
     "Y": 10.189604
    },
    {
     "ProvName": "Grande Comore (Njazidja)",
     "zoomlevel": 5.8,
     "X": 43.340215,
     "Y": -11.65557
    },
    {
     "ProvName": "Mohéli (Mwali)",
     "zoomlevel": 5.8,
     "X": 43.7288,
     "Y": -12.314836
    },
    {
     "ProvName": "Kouilou",
     "zoomlevel": 5.8,
     "X": 11.924505,
     "Y": -4.203401
    },
    {
     "ProvName": "Pool",
     "zoomlevel": 5.8,
     "X": 15.027058,
     "Y": -3.683109
    },
    {
     "ProvName": "Pointe-Noire",
     "zoomlevel": 5.8,
     "X": 11.864592,
     "Y": -4.71219
    },
    {
     "ProvName": "Brazzaville",
     "zoomlevel": 5.8,
     "X": 15.281386,
     "Y": -4.26898
    },
    {
     "ProvName": "Karlovarský",
     "zoomlevel": 5.8,
     "X": 12.714327,
     "Y": 50.184631
    },
    {
     "ProvName": "Plzenský",
     "zoomlevel": 5.8,
     "X": 13.205114,
     "Y": 49.605733
    },
    {
     "ProvName": "?stecký",
     "zoomlevel": 5.8,
     "X": 13.83221,
     "Y": 50.521899
    },
    {
     "ProvName": "Liberecký",
     "zoomlevel": 5.8,
     "X": 15.028603,
     "Y": 50.671977
    },
    {
     "ProvName": "Královéhradecký",
     "zoomlevel": 5.8,
     "X": 15.891596,
     "Y": 50.364113
    },
    {
     "ProvName": "Vysocina",
     "zoomlevel": 5.8,
     "X": 15.658191,
     "Y": 49.4013
    },
    {
     "ProvName": "Iles sous le Vent (Leeward Islands)",
     "zoomlevel": 5.8,
     "X": -151.397693,
     "Y": -16.750206
    },
    {
     "ProvName": "Jihoceský",
     "zoomlevel": 5.8,
     "X": 14.418307,
     "Y": 49.084255
    },
    {
     "ProvName": "Santa Elena",
     "zoomlevel": 5.8,
     "X": -80.528776,
     "Y": -2.066134
    },
    {
     "ProvName": "Pardubický",
     "zoomlevel": 5.8,
     "X": 16.170638,
     "Y": 49.893124
    },
    {
     "ProvName": "Moravskoslezský",
     "zoomlevel": 5.8,
     "X": 17.990915,
     "Y": 49.827704
    },
    {
     "ProvName": "Qina (Qena)",
     "zoomlevel": 5.8,
     "X": 32.557755,
     "Y": 25.86979
    },
    {
     "ProvName": "Olomoucký",
     "zoomlevel": 5.8,
     "X": 17.227422,
     "Y": 49.822075
    },
    {
     "ProvName": "Zlínský",
     "zoomlevel": 5.8,
     "X": 17.777092,
     "Y": 49.240058
    },
    {
     "ProvName": "Western",
     "zoomlevel": 5.8,
     "X": -16.407205,
     "Y": 13.241175
    },
    {
     "ProvName": "Guayas",
     "zoomlevel": 5.8,
     "X": -79.874676,
     "Y": -2.089326
    },
    {
     "ProvName": "Pichincha",
     "zoomlevel": 5.8,
     "X": -78.455432,
     "Y": -0.160445
    },
    {
     "ProvName": "Santo Domingo de los Tsáchilas",
     "zoomlevel": 5.8,
     "X": -79.141178,
     "Y": -0.156054
    },
    {
     "ProvName": "Koulikoro",
     "zoomlevel": 3.8,
     "X": -7.983575,
     "Y": 12.636248
    },
    {
     "ProvName": "Gozo and Comino",
     "zoomlevel": 5.8,
     "X": 14.251936,
     "Y": 36.043995
    },
    {
     "ProvName": "Faetano",
     "zoomlevel": 5.8,
     "X": 12.475007,
     "Y": 43.936131
    },
    {
     "ProvName": "Northern (Ha Zafon)",
     "zoomlevel": 5.8,
     "X": 35.372059,
     "Y": 32.810415
    },
    {
     "ProvName": "Lienchang",
     "zoomlevel": 5.8,
     "X": 120.04007,
     "Y": 26.170294
    },
    {
     "ProvName": "Bolama",
     "zoomlevel": 5.8,
     "X": -15.97178,
     "Y": 11.404086
    },
    {
     "ProvName": "Astana",
     "zoomlevel": 4.08,
     "X": 71.48126,
     "Y": 51.22089
    },
    {
     "ProvName": "Aqmola (Akmola)",
     "zoomlevel": 4.08,
     "X": 69.961357,
     "Y": 51.765309
    },
    {
     "ProvName": "Almaty city",
     "zoomlevel": 5.8,
     "X": 76.936273,
     "Y": 43.286019
    },
    {
     "ProvName": "Nkhata Bay",
     "zoomlevel": 5.8,
     "X": 34.286677,
     "Y": -11.591493
    },
    {
     "ProvName": "Almaty (Alma-Ata)",
     "zoomlevel": 5.8,
     "X": 77.967595,
     "Y": 44.964726
    },
    {
     "ProvName": "Negeri Sembilan",
     "zoomlevel": 5.8,
     "X": 102.209502,
     "Y": 2.775431
    },
    {
     "ProvName": "Kuala Lumpur",
     "zoomlevel": 5.8,
     "X": 101.694791,
     "Y": 3.134653
    },
    {
     "ProvName": "Putrajaya",
     "zoomlevel": 5.8,
     "X": 101.697164,
     "Y": 2.928563
    },
    {
     "ProvName": "Sabah",
     "zoomlevel": 5.8,
     "X": 117.131667,
     "Y": 5.346643
    },
    {
     "ProvName": "Labuan",
     "zoomlevel": 5.8,
     "X": 115.216689,
     "Y": 5.318107
    },
    {
     "ProvName": "Gagauzia",
     "zoomlevel": 5.8,
     "X": 28.631366,
     "Y": 46.097951
    },
    {
     "ProvName": "Bamako",
     "zoomlevel": 3.8,
     "X": -7.64016,
     "Y": 13.611882
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": -57.484245,
     "Y": -25.556363
    },
    {
     "ProvName": "Nong Khai",
     "zoomlevel": 5.8,
     "X": 102.954285,
     "Y": 17.98992
    },
    {
     "ProvName": "Malta Island",
     "zoomlevel": 5.8,
     "X": 14.441855,
     "Y": 35.890381
    },
    {
     "ProvName": "Ratak",
     "zoomlevel": 5.8,
     "X": 168.781778,
     "Y": 7.206538
    },
    {
     "ProvName": "Asunción",
     "zoomlevel": 5.8,
     "X": -57.599101,
     "Y": -25.291864
    },
    {
     "ProvName": "al-Wakrah",
     "zoomlevel": 5.8,
     "X": 51.350244,
     "Y": 24.892605
    },
    {
     "ProvName": "Maputo",
     "zoomlevel": 5.8,
     "X": 32.43771,
     "Y": -25.535616
    },
    {
     "ProvName": "Maputo city",
     "zoomlevel": 5.8,
     "X": 32.57233,
     "Y": -25.954083
    },
    {
     "ProvName": "Bonaire",
     "zoomlevel": 5.8,
     "X": -68.286852,
     "Y": 12.186318
    },
    {
     "ProvName": "Sint Eustatius or Statia",
     "zoomlevel": 5.8,
     "X": -62.971257,
     "Y": 17.493998
    },
    {
     "ProvName": "Saba",
     "zoomlevel": 5.8,
     "X": -63.238008,
     "Y": 17.630531
    },
    {
     "ProvName": "Rason (Najin)",
     "zoomlevel": 5.8,
     "X": 130.43752,
     "Y": 42.360899
    },
    {
     "ProvName": "Manawatu-Wanganui",
     "zoomlevel": 5.8,
     "X": 175.598796,
     "Y": -39.739608
    },
    {
     "ProvName": "Wellington",
     "zoomlevel": 5.8,
     "X": 175.496982,
     "Y": -41.057759
    },
    {
     "ProvName": "Waikato",
     "zoomlevel": 5.8,
     "X": 175.502732,
     "Y": -38.038248
    },
    {
     "ProvName": "ad-Dawhah (Doha)",
     "zoomlevel": 5.8,
     "X": 51.518686,
     "Y": 25.308407
    },
    {
     "ProvName": "al-Daayen",
     "zoomlevel": 5.8,
     "X": 51.44821,
     "Y": 25.508862
    },
    {
     "ProvName": "Auckland",
     "zoomlevel": 5.8,
     "X": 174.762942,
     "Y": -36.715743
    },
    {
     "ProvName": "Hamgyong North",
     "zoomlevel": 5.8,
     "X": 129.507459,
     "Y": 41.794159
    },
    {
     "ProvName": "al-Khawr",
     "zoomlevel": 5.8,
     "X": 51.325981,
     "Y": 25.770189
    },
    {
     "ProvName": "Bung Kan",
     "zoomlevel": 5.8,
     "X": 103.800323,
     "Y": 18.133422
    },
    {
     "ProvName": "Al-Arianah",
     "zoomlevel": 5.8,
     "X": 10.130402,
     "Y": 36.952416
    },
    {
     "ProvName": "Montegiardino",
     "zoomlevel": 5.8,
     "X": 12.465299,
     "Y": 43.912359
    },
    {
     "ProvName": "ar-Rayyan",
     "zoomlevel": 5.8,
     "X": 51.054928,
     "Y": 25.211809
    },
    {
     "ProvName": "Bucharest",
     "zoomlevel": 5.8,
     "X": 26.0965,
     "Y": 44.438426
    },
    {
     "ProvName": "Constanta",
     "zoomlevel": 5.8,
     "X": 28.229861,
     "Y": 44.235691
    },
    {
     "ProvName": "Tulcea",
     "zoomlevel": 5.8,
     "X": 28.853318,
     "Y": 45.061745
    },
    {
     "ProvName": "Saint-Louis",
     "zoomlevel": 5.8,
     "X": -15.048226,
     "Y": 16.206431
    },
    {
     "ProvName": "Adana",
     "zoomlevel": 5.8,
     "X": 35.592561,
     "Y": 37.454153
    },
    {
     "ProvName": "Matam",
     "zoomlevel": 5.8,
     "X": -13.598179,
     "Y": 15.153162
    },
    {
     "ProvName": "Kédougou",
     "zoomlevel": 5.8,
     "X": -12.218538,
     "Y": 12.831991
    },
    {
     "ProvName": "Tambacounda",
     "zoomlevel": 5.8,
     "X": -13.233383,
     "Y": 13.878322
    },
    {
     "ProvName": "Osmaniye",
     "zoomlevel": 5.8,
     "X": 36.261195,
     "Y": 37.294078
    },
    {
     "ProvName": "Kolda",
     "zoomlevel": 5.8,
     "X": -14.422962,
     "Y": 13.030409
    },
    {
     "ProvName": "Sédhiou",
     "zoomlevel": 5.8,
     "X": -15.589332,
     "Y": 12.90475
    },
    {
     "ProvName": "Pembroke",
     "zoomlevel": 5.8,
     "X": -64.801306,
     "Y": 32.295557
    },
    {
     "ProvName": "Dimashq",
     "zoomlevel": 5.8,
     "X": 37.013259,
     "Y": 33.460488
    },
    {
     "ProvName": "Damascus",
     "zoomlevel": 5.8,
     "X": 36.326862,
     "Y": 33.504339
    },
    {
     "ProvName": "Zonguldak",
     "zoomlevel": 5.8,
     "X": 31.861453,
     "Y": 41.271253
    },
    {
     "ProvName": "Istanbul",
     "zoomlevel": 5.8,
     "X": 28.893749,
     "Y": 41.154361
    },
    {
     "ProvName": "Bursa",
     "zoomlevel": 5.8,
     "X": 29.021622,
     "Y": 40.115399
    },
    {
     "ProvName": "Kocaeli",
     "zoomlevel": 5.8,
     "X": 29.922476,
     "Y": 40.877313
    },
    {
     "ProvName": "Yalova",
     "zoomlevel": 5.8,
     "X": 29.189812,
     "Y": 40.60156
    },
    {
     "ProvName": "Ahal",
     "zoomlevel": 4.5,
     "X": 59.12049,
     "Y": 38.537896
    },
    {
     "ProvName": "Crimea (Krym)",
     "zoomlevel": 5.8,
     "X": 34.347392,
     "Y": 45.305433
    },
    {
     "ProvName": "Sevastopol",
     "zoomlevel": 5.8,
     "X": 33.557601,
     "Y": 44.61316
    },
    {
     "ProvName": "Kiev city",
     "zoomlevel": 4.3,
     "X": 30.474781,
     "Y": 50.442246
    },
    {
     "ProvName": "Kyyiv (Kiev)",
     "zoomlevel": 4.3,
     "X": 30.4479,
     "Y": 50.28893
    },
    {
     "ProvName": "Tashkent city",
     "zoomlevel": 5.8,
     "X": 69.23746,
     "Y": 41.259496
    },
    {
     "ProvName": "Oued el Dahab",
     "zoomlevel": 5.8,
     "X": -14.470253,
     "Y": 22.880813
    },
    {
     "ProvName": "Boujdour",
     "zoomlevel": 5.8,
     "X": -13.410203,
     "Y": 25.170528
    },
    {
     "ProvName": "Laayoune",
     "zoomlevel": 5.8,
     "X": -13.101214,
     "Y": 26.684385
    },
    {
     "ProvName": "Es Semara",
     "zoomlevel": 5.8,
     "X": -10.50424,
     "Y": 26.799755
    },
    {
     "ProvName": "Iles Marquises (Marquesas)",
     "zoomlevel": 5.8,
     "X": -139.572207,
     "Y": -9.378115
    },
    {
     "ProvName": "Iles Australes (Tubai Islands)",
     "zoomlevel": 5.8,
     "X": -147.713567,
     "Y": -24.850002
    },
    {
     "ProvName": "Archipelago Tuamotu",
     "zoomlevel": 5.8,
     "X": -142.356685,
     "Y": -17.490635
    },
    {
     "ProvName": "St. Patrick",
     "zoomlevel": 5.8,
     "X": -61.641277,
     "Y": 12.204556
    },
    {
     "ProvName": "St. Andrew",
     "zoomlevel": 5.8,
     "X": -61.649568,
     "Y": 12.118597
    },
    {
     "ProvName": "St. Mark",
     "zoomlevel": 5.8,
     "X": -61.688624,
     "Y": 12.186649
    },
    {
     "ProvName": "St. John",
     "zoomlevel": 5.8,
     "X": -61.713299,
     "Y": 12.139559
    },
    {
     "ProvName": "St. David",
     "zoomlevel": 5.8,
     "X": -61.683288,
     "Y": 12.044136
    },
    {
     "ProvName": "Carriacou",
     "zoomlevel": 5.8,
     "X": -61.628392,
     "Y": 12.216729
    },
    {
     "ProvName": "Carriacou",
     "zoomlevel": 5.8,
     "X": -61.734381,
     "Y": 12.059439
    },
    {
     "ProvName": "Line and Phoenix Group",
     "zoomlevel": 5.8,
     "X": 174.420008,
     "Y": -0.095663
    },
    {
     "ProvName": "Central",
     "zoomlevel": 5.8,
     "X": 73.100033,
     "Y": 2.945737
    },
    {
     "ProvName": "Gilberts Group",
     "zoomlevel": 5.8,
     "X": -157.963582,
     "Y": 1.199894
    },
    {
     "ProvName": "South",
     "zoomlevel": 5.8,
     "X": 73.187557,
     "Y": -0.586834
    },
    {
     "ProvName": "Upper South",
     "zoomlevel": 5.8,
     "X": 73.218507,
     "Y": 0.390321
    },
    {
     "ProvName": "Savanne",
     "zoomlevel": 5.8,
     "X": 57.488518,
     "Y": -20.467006
    },
    {
     "ProvName": "Upper North",
     "zoomlevel": 5.8,
     "X": 73.12238,
     "Y": 6.729057
    },
    {
     "ProvName": "Grand Port",
     "zoomlevel": 5.8,
     "X": 57.642005,
     "Y": -20.401365
    },
    {
     "ProvName": "Flacq",
     "zoomlevel": 5.8,
     "X": 57.708548,
     "Y": -20.234713
    },
    {
     "ProvName": "Kosrae",
     "zoomlevel": 5.8,
     "X": 162.984733,
     "Y": 5.318713
    },
    {
     "ProvName": "North",
     "zoomlevel": 5.8,
     "X": 73.281903,
     "Y": 5.531232
    },
    {
     "ProvName": "Rivière du Rampart",
     "zoomlevel": 5.8,
     "X": 57.648158,
     "Y": -20.065676
    },
    {
     "ProvName": "Pamplemousses",
     "zoomlevel": 5.8,
     "X": 57.562547,
     "Y": -20.113505
    },
    {
     "ProvName": "Port Louis",
     "zoomlevel": 5.8,
     "X": 57.502905,
     "Y": -20.173828
    },
    {
     "ProvName": "Black River",
     "zoomlevel": 5.8,
     "X": 57.400016,
     "Y": -20.33273
    },
    {
     "ProvName": "Plaines Wilhems",
     "zoomlevel": 5.8,
     "X": 57.488638,
     "Y": -20.33061
    },
    {
     "ProvName": "North Central",
     "zoomlevel": 5.8,
     "X": 73.356012,
     "Y": 3.405992
    },
    {
     "ProvName": "South Central",
     "zoomlevel": 5.8,
     "X": 73.403393,
     "Y": 2.129711
    },
    {
     "ProvName": "Male",
     "zoomlevel": 5.8,
     "X": 73.503561,
     "Y": 4.193801
    },
    {
     "ProvName": "Moka",
     "zoomlevel": 5.8,
     "X": 57.569834,
     "Y": -20.262315
    },
    {
     "ProvName": "Cahul (Kachul)",
     "zoomlevel": 5.8,
     "X": 28.285213,
     "Y": 45.833805
    },
    {
     "ProvName": "Basarabeasca",
     "zoomlevel": 5.8,
     "X": 28.905726,
     "Y": 46.423346
    },
    {
     "ProvName": "Tokelau Islands",
     "zoomlevel": 5.8,
     "X": -171.834547,
     "Y": -9.063645
    },
    {
     "ProvName": "Omnogovi",
     "zoomlevel": 4.08,
     "X": 104.112909,
     "Y": 43.27497
    },
    {
     "ProvName": "Dundgovi",
     "zoomlevel": 4.08,
     "X": 106.284775,
     "Y": 45.522653
    },
    {
     "ProvName": "Selenge",
     "zoomlevel": 4.08,
     "X": 106.203609,
     "Y": 49.464962
    },
    {
     "ProvName": "Ovörhangay",
     "zoomlevel": 4.08,
     "X": 102.707042,
     "Y": 45.835085
    },
    {
     "ProvName": "Hentiy",
     "zoomlevel": 4.08,
     "X": 110.444303,
     "Y": 47.902275
    },
    {
     "ProvName": "Arhangay",
     "zoomlevel": 4.08,
     "X": 101.010231,
     "Y": 47.881914
    },
    {
     "ProvName": "Bayanhongor",
     "zoomlevel": 4.08,
     "X": 99.519947,
     "Y": 45.253383
    },
    {
     "ProvName": "Dzavhan",
     "zoomlevel": 4.08,
     "X": 96.430721,
     "Y": 48.298129
    },
    {
     "ProvName": "Govi-Altay",
     "zoomlevel": 4.08,
     "X": 95.929039,
     "Y": 45.344877
    },
    {
     "ProvName": "Hovd",
     "zoomlevel": 4.08,
     "X": 92.27537,
     "Y": 46.895207
    },
    {
     "ProvName": "Hövsgöl",
     "zoomlevel": 4.08,
     "X": 99.913155,
     "Y": 50.229811
    },
    {
     "ProvName": "Uvs",
     "zoomlevel": 4.08,
     "X": 92.941713,
     "Y": 49.625877
    },
    {
     "ProvName": "Bulgan",
     "zoomlevel": 4.08,
     "X": 103.397065,
     "Y": 48.948192
    },
    {
     "ProvName": "Orhan",
     "zoomlevel": 4.08,
     "X": 104.299857,
     "Y": 49.024337
    },
    {
     "ProvName": "Darhan",
     "zoomlevel": 4.08,
     "X": 106.29431,
     "Y": 49.373074
    },
    {
     "ProvName": "Ulaanbaatar",
     "zoomlevel": 4.08,
     "X": 106.950664,
     "Y": 47.934849
    },
    {
     "ProvName": "Dornod",
     "zoomlevel": 4.08,
     "X": 115.4553,
     "Y": 48.153727
    },
    {
     "ProvName": "Suhbaatar",
     "zoomlevel": 4.08,
     "X": 113.531495,
     "Y": 46.224464
    },
    {
     "ProvName": "Dornogovi",
     "zoomlevel": 4.08,
     "X": 109.79283,
     "Y": 44.44115
    },
    {
     "ProvName": "Govi-Sumber",
     "zoomlevel": 4.08,
     "X": 108.589962,
     "Y": 46.55788
    },
    {
     "ProvName": "Töv",
     "zoomlevel": 4.08,
     "X": 106.582274,
     "Y": 47.663164
    },
    {
     "ProvName": "Add, Houaphan",
     "zoomlevel": 5.8,
     "X": 103.883095,
     "Y": 20.728032
    },
    {
     "ProvName": "Anouvong, Xaisomboon",
     "zoomlevel": 5.8,
     "X": 103.024668,
     "Y": 18.885132
    },
    {
     "ProvName": "Atsaphangthong, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.320635,
     "Y": 16.703011
    },
    {
     "ProvName": "Atsaphone, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.388904,
     "Y": 16.944183
    },
    {
     "ProvName": "Bachiangchaleunsook, Champasack",
     "zoomlevel": 5.8,
     "X": 105.967173,
     "Y": 15.253764
    },
    {
     "ProvName": "Beng, Oudomxai",
     "zoomlevel": 5.8,
     "X": 101.713317,
     "Y": 20.360174
    },
    {
     "ProvName": "Bolikhanh, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 103.776672,
     "Y": 18.670846
    },
    {
     "ProvName": "Boon Neua, Phongsaly",
     "zoomlevel": 5.8,
     "X": 101.874559,
     "Y": 21.684773
    },
    {
     "ProvName": "Boontay, Phongsaly",
     "zoomlevel": 5.8,
     "X": 102.005542,
     "Y": 21.357376
    },
    {
     "ProvName": "Botene, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.101982,
     "Y": 17.685555
    },
    {
     "ProvName": "Bualapha, Khammouan",
     "zoomlevel": 5.8,
     "X": 105.93944,
     "Y": 17.300719
    },
    {
     "ProvName": "Champasack, Champasack",
     "zoomlevel": 5.8,
     "X": 105.756427,
     "Y": 14.851357
    },
    {
     "ProvName": "Champhone, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.209543,
     "Y": 16.493049
    },
    {
     "ProvName": "Chanthabuly, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.608578,
     "Y": 18.001311
    },
    {
     "ProvName": "Chomphet, Louangphabang",
     "zoomlevel": 5.8,
     "X": 101.947706,
     "Y": 19.880669
    },
    {
     "ProvName": "Dakcheung, Sekong",
     "zoomlevel": 5.8,
     "X": 107.314133,
     "Y": 15.400574
    },
    {
     "ProvName": "Feuang, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.083034,
     "Y": 18.639892
    },
    {
     "ProvName": "Hadxaifong, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.730363,
     "Y": 17.91663
    },
    {
     "ProvName": "Hiem, Houaphan",
     "zoomlevel": 5.8,
     "X": 103.311956,
     "Y": 20.067778
    },
    {
     "ProvName": "Hinboon, Khammouan",
     "zoomlevel": 5.8,
     "X": 104.589858,
     "Y": 17.787526
    },
    {
     "ProvName": "Hinherb, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.279814,
     "Y": 18.635096
    },
    {
     "ProvName": "Home, Xaisomboon",
     "zoomlevel": 5.8,
     "X": 103.328062,
     "Y": 18.691088
    },
    {
     "ProvName": "Hongsa, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.491039,
     "Y": 19.714552
    },
    {
     "ProvName": "Hoon, Oudomxai",
     "zoomlevel": 5.8,
     "X": 101.434983,
     "Y": 20.088294
    },
    {
     "ProvName": "Huameuang, Houaphan",
     "zoomlevel": 5.8,
     "X": 103.783689,
     "Y": 20.086686
    },
    {
     "ProvName": "Huoixai, Bokeo",
     "zoomlevel": 5.8,
     "X": 100.630705,
     "Y": 20.390407
    },
    {
     "ProvName": "Kaleum, Sekong",
     "zoomlevel": 5.8,
     "X": 107.025308,
     "Y": 15.864294
    },
    {
     "ProvName": "Kasy, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.162812,
     "Y": 19.143414
    },
    {
     "ProvName": "Kaysone Phomvihane, Savannakhet",
     "zoomlevel": 5.8,
     "X": 104.85546,
     "Y": 16.584115
    },
    {
     "ProvName": "Kenethao, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.314357,
     "Y": 17.85757
    },
    {
     "ProvName": "Keo Oudom, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.564111,
     "Y": 18.564608
    },
    {
     "ProvName": "Kham, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.640893,
     "Y": 19.761229
    },
    {
     "ProvName": "Khamkeuth, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 104.908333,
     "Y": 18.208478
    },
    {
     "ProvName": "Khong, Champasack",
     "zoomlevel": 5.8,
     "X": 105.964976,
     "Y": 14.201124
    },
    {
     "ProvName": "Khongxedone, Salavan",
     "zoomlevel": 5.8,
     "X": 105.772737,
     "Y": 15.545247
    },
    {
     "ProvName": "Khop, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 100.561634,
     "Y": 19.675261
    },
    {
     "ProvName": "Khoune, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.499171,
     "Y": 19.281838
    },
    {
     "ProvName": "Khounkham, Khammouan",
     "zoomlevel": 5.8,
     "X": 104.565022,
     "Y": 18.05831
    },
    {
     "ProvName": "Khua, Phongsaly",
     "zoomlevel": 5.8,
     "X": 102.380595,
     "Y": 21.059725
    },
    {
     "ProvName": "Kuan, Houaphan",
     "zoomlevel": 5.8,
     "X": 104.460159,
     "Y": 19.785767
    },
    {
     "ProvName": "La, Oudomxai",
     "zoomlevel": 5.8,
     "X": 102.140225,
     "Y": 20.919361
    },
    {
     "ProvName": "Lakhonepheng, Salavan",
     "zoomlevel": 5.8,
     "X": 105.599849,
     "Y": 15.828702
    },
    {
     "ProvName": "Lamarm, Sekong",
     "zoomlevel": 5.8,
     "X": 106.801879,
     "Y": 15.412731
    },
    {
     "ProvName": "Lao Ngarm, Salavan",
     "zoomlevel": 5.8,
     "X": 106.141879,
     "Y": 15.481074
    },
    {
     "ProvName": "Long, Louangnamtha",
     "zoomlevel": 5.8,
     "X": 100.830028,
     "Y": 20.994197
    },
    {
     "ProvName": "Longcheng, Xaisomboon",
     "zoomlevel": 5.8,
     "X": 102.817384,
     "Y": 19.092086
    },
    {
     "ProvName": "Longsane, Xaisomboon",
     "zoomlevel": 5.8,
     "X": 102.892909,
     "Y": 18.624644
    },
    {
     "ProvName": "Luangprabang, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.14378,
     "Y": 19.826288
    },
    {
     "ProvName": "Mad, Vientiane",
     "zoomlevel": 5.8,
     "X": 101.884774,
     "Y": 18.682508
    },
    {
     "ProvName": "Mahaxay, Khammouan",
     "zoomlevel": 5.8,
     "X": 105.303923,
     "Y": 17.363789
    },
    {
     "ProvName": "May, Phongsaly",
     "zoomlevel": 5.8,
     "X": 102.730567,
     "Y": 21.377609
    },
    {
     "ProvName": "Mayparkngum, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.972555,
     "Y": 18.132841
    },
    {
     "ProvName": "Meun, Vientiane",
     "zoomlevel": 5.8,
     "X": 101.896699,
     "Y": 18.246427
    },
    {
     "ProvName": "Meung, Bokeo",
     "zoomlevel": 5.8,
     "X": 100.528653,
     "Y": 20.677062
    },
    {
     "ProvName": "Moonlapamok, Champasack",
     "zoomlevel": 5.8,
     "X": 105.562192,
     "Y": 14.302458
    },
    {
     "ProvName": "Mork, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.99727,
     "Y": 19.070801
    },
    {
     "ProvName": "Nakay, Khammouan",
     "zoomlevel": 5.8,
     "X": 105.279777,
     "Y": 17.872913
    },
    {
     "ProvName": "Nalae, Louangnamtha",
     "zoomlevel": 5.8,
     "X": 101.324479,
     "Y": 20.505367
    },
    {
     "ProvName": "Nambak, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.391172,
     "Y": 20.58481
    },
    {
     "ProvName": "Namor, Oudomxai",
     "zoomlevel": 5.8,
     "X": 101.72326,
     "Y": 20.905464
    },
    {
     "ProvName": "Namtha, Louangnamtha",
     "zoomlevel": 5.8,
     "X": 101.43796,
     "Y": 21.020028
    },
    {
     "ProvName": "Nan, Louangphabang",
     "zoomlevel": 5.8,
     "X": 101.935001,
     "Y": 19.391114
    },
    {
     "ProvName": "Naxaithong, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.431202,
     "Y": 18.169115
    },
    {
     "ProvName": "Nga, Oudomxai",
     "zoomlevel": 5.8,
     "X": 101.944176,
     "Y": 20.183888
    },
    {
     "ProvName": "Ngeun, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.133278,
     "Y": 19.726516
    },
    {
     "ProvName": "Ngoi, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.676197,
     "Y": 20.621401
    },
    {
     "ProvName": "Nhommalath, Khammouan",
     "zoomlevel": 5.8,
     "X": 105.264148,
     "Y": 17.562487
    },
    {
     "ProvName": "Nhot Ou, Phongsaly",
     "zoomlevel": 5.8,
     "X": 101.870182,
     "Y": 22.204148
    },
    {
     "ProvName": "Nong, Savannakhet",
     "zoomlevel": 5.8,
     "X": 106.483,
     "Y": 16.406627
    },
    {
     "ProvName": "Nongbok, Khammouan",
     "zoomlevel": 5.8,
     "X": 104.82299,
     "Y": 17.065864
    },
    {
     "ProvName": "Nonghed, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.931539,
     "Y": 19.588113
    },
    {
     "ProvName": "Outhoomphone, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.036236,
     "Y": 16.760398
    },
    {
     "ProvName": "Pak Xeng, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.71493,
     "Y": 20.178336
    },
    {
     "ProvName": "Pakbeng, Oudomxai",
     "zoomlevel": 5.8,
     "X": 101.07303,
     "Y": 19.9607
    },
    {
     "ProvName": "Pakkading, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 104.18826,
     "Y": 18.261366
    },
    {
     "ProvName": "Pakse, Champasack",
     "zoomlevel": 5.8,
     "X": 105.822554,
     "Y": 15.135334
    },
    {
     "ProvName": "Paksxong, Champasack",
     "zoomlevel": 5.8,
     "X": 106.4394,
     "Y": 15.096816
    },
    {
     "ProvName": "Paktha, Bokeo",
     "zoomlevel": 5.8,
     "X": 100.618726,
     "Y": 19.962409
    },
    {
     "ProvName": "Pakxane, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 103.73347,
     "Y": 18.420287
    },
    {
     "ProvName": "Park Ou, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.323359,
     "Y": 20.173585
    },
    {
     "ProvName": "Parklai, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.499128,
     "Y": 18.430881
    },
    {
     "ProvName": "Pathoomphone, Champasack",
     "zoomlevel": 5.8,
     "X": 106.068852,
     "Y": 14.732759
    },
    {
     "ProvName": "Pek, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.268295,
     "Y": 19.534732
    },
    {
     "ProvName": "Pha Oudom, Bokeo",
     "zoomlevel": 5.8,
     "X": 100.915489,
     "Y": 20.198543
    },
    {
     "ProvName": "Phalanxay, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.600299,
     "Y": 16.701292
    },
    {
     "ProvName": "Phaxay, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.084377,
     "Y": 19.258598
    },
    {
     "ProvName": "Phiang, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.454428,
     "Y": 18.885421
    },
    {
     "ProvName": "Phine, Savannakhet",
     "zoomlevel": 5.8,
     "X": 106.027312,
     "Y": 16.444068
    },
    {
     "ProvName": "Phongsaly, Phongsaly",
     "zoomlevel": 5.8,
     "X": 102.184215,
     "Y": 21.856443
    },
    {
     "ProvName": "Phonhong, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.386501,
     "Y": 18.426213
    },
    {
     "ProvName": "Phonthong, Louangphabang",
     "zoomlevel": 5.8,
     "X": 103.031859,
     "Y": 20.829306
    },
    {
     "ProvName": "Phonthong, Champasack",
     "zoomlevel": 5.8,
     "X": 105.649512,
     "Y": 15.108303
    },
    {
     "ProvName": "Phonxay, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.696585,
     "Y": 19.891963
    },
    {
     "ProvName": "Phookood, Xiengkhouang",
     "zoomlevel": 5.8,
     "X": 103.001016,
     "Y": 19.628125
    },
    {
     "ProvName": "Phoukhoune, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.587843,
     "Y": 19.498656
    },
    {
     "ProvName": "Phouvong, Attapeu",
     "zoomlevel": 5.8,
     "X": 106.990458,
     "Y": 14.548398
    },
    {
     "ProvName": "Samakkhixay, Attapeu",
     "zoomlevel": 5.8,
     "X": 106.792903,
     "Y": 14.930878
    },
    {
     "ProvName": "Samphanh, Phongsaly",
     "zoomlevel": 5.8,
     "X": 102.422483,
     "Y": 21.575667
    },
    {
     "ProvName": "Samuoi, Salavan",
     "zoomlevel": 5.8,
     "X": 106.894663,
     "Y": 16.325968
    },
    {
     "ProvName": "Sanamxay, Attapeu",
     "zoomlevel": 5.8,
     "X": 106.438699,
     "Y": 14.7158
    },
    {
     "ProvName": "Sanasomboon, Champasack",
     "zoomlevel": 5.8,
     "X": 105.737582,
     "Y": 15.344741
    },
    {
     "ProvName": "Sangthong, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.169402,
     "Y": 18.270651
    },
    {
     "ProvName": "Sanxay, Attapeu",
     "zoomlevel": 5.8,
     "X": 107.205469,
     "Y": 15.062906
    },
    {
     "ProvName": "Saravane, Salavan",
     "zoomlevel": 5.8,
     "X": 106.395376,
     "Y": 15.701992
    },
    {
     "ProvName": "Sepone, Savannakhet",
     "zoomlevel": 5.8,
     "X": 106.340212,
     "Y": 16.774796
    },
    {
     "ProvName": "Sikhottabong, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.496311,
     "Y": 18.002911
    },
    {
     "ProvName": "Sing, Louangnamtha",
     "zoomlevel": 5.8,
     "X": 101.093513,
     "Y": 21.261498
    },
    {
     "ProvName": "Sisattanak, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.630951,
     "Y": 17.93406
    },
    {
     "ProvName": "Songkhone, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.312414,
     "Y": 16.153455
    },
    {
     "ProvName": "Sopbao, Houaphan",
     "zoomlevel": 5.8,
     "X": 104.387427,
     "Y": 20.641791
    },
    {
     "ProvName": "Sukhuma, Champasack",
     "zoomlevel": 5.8,
     "X": 105.678436,
     "Y": 14.630444
    },
    {
     "ProvName": "Ta Oi, Salavan",
     "zoomlevel": 5.8,
     "X": 106.694203,
     "Y": 16.079642
    },
    {
     "ProvName": "Thakhek, Khammouan",
     "zoomlevel": 5.8,
     "X": 104.86969,
     "Y": 17.411146
    },
    {
     "ProvName": "Thapangthong, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.805347,
     "Y": 16.090566
    },
    {
     "ProvName": "Thaphabath, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 103.130095,
     "Y": 18.397659
    },
    {
     "ProvName": "Thateng, Sekong",
     "zoomlevel": 5.8,
     "X": 106.471618,
     "Y": 15.42349
    },
    {
     "ProvName": "Thathom, Xaisomboon",
     "zoomlevel": 5.8,
     "X": 103.601699,
     "Y": 18.994018
    },
    {
     "ProvName": "Thongmyxay, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.227054,
     "Y": 18.453151
    },
    {
     "ProvName": "Thoulakhom, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.692383,
     "Y": 18.356426
    },
    {
     "ProvName": "Tonpheung, Bokeo",
     "zoomlevel": 5.8,
     "X": 100.248433,
     "Y": 20.474144
    },
    {
     "ProvName": "Toomlarn, Salavan",
     "zoomlevel": 5.8,
     "X": 106.244001,
     "Y": 16.027141
    },
    {
     "ProvName": "Vangvieng, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.46163,
     "Y": 18.942749
    },
    {
     "ProvName": "Vapy, Salavan",
     "zoomlevel": 5.8,
     "X": 105.987504,
     "Y": 15.78068
    },
    {
     "ProvName": "Viengkham, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.997297,
     "Y": 20.373129
    },
    {
     "ProvName": "Viengkham, Vientiane",
     "zoomlevel": 5.8,
     "X": 102.522363,
     "Y": 18.419691
    },
    {
     "ProvName": "Viengphoukha, Louangnamtha",
     "zoomlevel": 5.8,
     "X": 101.0681,
     "Y": 20.664303
    },
    {
     "ProvName": "Viengthong, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 104.39652,
     "Y": 18.674158
    },
    {
     "ProvName": "Viengxay, Houaphan",
     "zoomlevel": 5.8,
     "X": 104.390072,
     "Y": 20.351175
    },
    {
     "ProvName": "Vilabuly, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.93563,
     "Y": 16.937916
    },
    {
     "ProvName": "Xamneua, Houaphan",
     "zoomlevel": 5.8,
     "X": 103.938194,
     "Y": 20.379103
    },
    {
     "ProvName": "Xamtay, Houaphan",
     "zoomlevel": 5.8,
     "X": 104.581778,
     "Y": 20.015204
    },
    {
     "ProvName": "Xanakharm, Vientiane",
     "zoomlevel": 5.8,
     "X": 101.591316,
     "Y": 18.123197
    },
    {
     "ProvName": "Xay, Oudomxai",
     "zoomlevel": 5.8,
     "X": 101.955506,
     "Y": 20.66863
    },
    {
     "ProvName": "Xayabury, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.672495,
     "Y": 19.308963
    },
    {
     "ProvName": "Xaybuathong, Khammouan",
     "zoomlevel": 5.8,
     "X": 105.55009,
     "Y": 17.17699
    },
    {
     "ProvName": "Xaybuly, Savannakhet",
     "zoomlevel": 5.8,
     "X": 104.925709,
     "Y": 16.945613
    },
    {
     "ProvName": "Xaychamphone, Bolikhamxai",
     "zoomlevel": 5.8,
     "X": 104.883774,
     "Y": 18.576987
    },
    {
     "ProvName": "Xayphoothong, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.017721,
     "Y": 16.349568
    },
    {
     "ProvName": "Xaysathan, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 101.361714,
     "Y": 19.398129
    },
    {
     "ProvName": "Xaysetha, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.693449,
     "Y": 17.977242
    },
    {
     "ProvName": "Xaysetha, Attapeu",
     "zoomlevel": 5.8,
     "X": 107.082216,
     "Y": 14.866554
    },
    {
     "ProvName": "Xaythany, Vientiane Capital",
     "zoomlevel": 5.8,
     "X": 102.744221,
     "Y": 18.145476
    },
    {
     "ProvName": "Xebangfay, Khammouan",
     "zoomlevel": 5.8,
     "X": 105.116728,
     "Y": 17.176595
    },
    {
     "ProvName": "Xieng Ngeun, Louangphabang",
     "zoomlevel": 5.8,
     "X": 102.246757,
     "Y": 19.618372
    },
    {
     "ProvName": "Xienghone, Xaignabouly",
     "zoomlevel": 5.8,
     "X": 100.83056,
     "Y": 19.71214
    },
    {
     "ProvName": "Xiengkhor, Houaphan",
     "zoomlevel": 5.8,
     "X": 104.185967,
     "Y": 20.824097
    },
    {
     "ProvName": "Xon, Houaphan",
     "zoomlevel": 5.8,
     "X": 103.400518,
     "Y": 20.528812
    },
    {
     "ProvName": "Xonbuly, Savannakhet",
     "zoomlevel": 5.8,
     "X": 105.550313,
     "Y": 16.389135
    },
    {
     "ProvName": "Soc Trang",
     "zoomlevel": 5.8,
     "X": 105.931129,
     "Y": 9.532704
    },
    {
     "ProvName": "Tra Vinh",
     "zoomlevel": 5.8,
     "X": 106.313165,
     "Y": 9.791687
    },
    {
     "ProvName": "Vinh Long",
     "zoomlevel": 5.8,
     "X": 105.989769,
     "Y": 10.09946
    },
    {
     "ProvName": "Ha Noi",
     "zoomlevel": 5.8,
     "X": 105.695586,
     "Y": 20.989258
    },
    {
     "ProvName": "Bac Ninh",
     "zoomlevel": 5.8,
     "X": 106.117617,
     "Y": 21.104057
    },
    {
     "ProvName": "Vinh Phuc",
     "zoomlevel": 5.8,
     "X": 105.584168,
     "Y": 21.33441
    },
    {
     "ProvName": "Nam Dinh",
     "zoomlevel": 5.8,
     "X": 106.20746,
     "Y": 20.270665
    },
    {
     "ProvName": "Phu Tho",
     "zoomlevel": 5.8,
     "X": 105.118576,
     "Y": 21.312715
    },
    {
     "ProvName": "Bac Giang",
     "zoomlevel": 5.8,
     "X": 106.495889,
     "Y": 21.361089
    },
    {
     "ProvName": "Ben Tre",
     "zoomlevel": 5.8,
     "X": 106.288255,
     "Y": 10.403862
    },
    {
     "ProvName": "Tay Ninh",
     "zoomlevel": 5.8,
     "X": 106.151719,
     "Y": 11.398811
    },
    {
     "ProvName": "Thai Nguyen",
     "zoomlevel": 5.8,
     "X": 105.83901,
     "Y": 21.682499
    },
    {
     "ProvName": "Hoa Binh",
     "zoomlevel": 5.8,
     "X": 105.34221,
     "Y": 20.688528
    },
    {
     "ProvName": "Hau Giang",
     "zoomlevel": 5.8,
     "X": 105.638664,
     "Y": 9.791153
    },
    {
     "ProvName": "Can Tho",
     "zoomlevel": 5.8,
     "X": 105.530046,
     "Y": 10.119509
    },
    {
     "ProvName": "Hai Duong",
     "zoomlevel": 5.8,
     "X": 106.366631,
     "Y": 20.935244
    },
    {
     "ProvName": "Hung Yen",
     "zoomlevel": 5.8,
     "X": 106.057613,
     "Y": 20.825283
    },
    {
     "ProvName": "Bac Kan",
     "zoomlevel": 5.8,
     "X": 105.851187,
     "Y": 22.242521
    },
    {
     "ProvName": "Lang Son",
     "zoomlevel": 5.8,
     "X": 106.609665,
     "Y": 21.837127
    },
    {
     "ProvName": "Son La",
     "zoomlevel": 5.8,
     "X": 104.088591,
     "Y": 21.186585
    },
    {
     "ProvName": "Thanh Hoa",
     "zoomlevel": 5.8,
     "X": 105.331688,
     "Y": 20.049116
    },
    {
     "ProvName": "Tuyen Quang",
     "zoomlevel": 5.8,
     "X": 105.277404,
     "Y": 22.097169
    },
    {
     "ProvName": "Yen Bai",
     "zoomlevel": 5.8,
     "X": 104.583301,
     "Y": 21.773012
    },
    {
     "ProvName": "Thai Binh",
     "zoomlevel": 5.8,
     "X": 106.380721,
     "Y": 20.51151
    },
    {
     "ProvName": "Da Nang",
     "zoomlevel": 5.8,
     "X": 108.086656,
     "Y": 16.102412
    },
    {
     "ProvName": "Ninh Binh",
     "zoomlevel": 5.8,
     "X": 105.89929,
     "Y": 20.233149
    },
    {
     "ProvName": "Ha Nam",
     "zoomlevel": 5.8,
     "X": 105.960573,
     "Y": 20.537589
    },
    {
     "ProvName": "Ha Tinh",
     "zoomlevel": 5.8,
     "X": 105.722976,
     "Y": 18.288318
    },
    {
     "ProvName": "Nghe An",
     "zoomlevel": 5.8,
     "X": 104.931583,
     "Y": 19.23884
    },
    {
     "ProvName": "Quang Binh",
     "zoomlevel": 5.8,
     "X": 106.279146,
     "Y": 17.528121
    },
    {
     "ProvName": "Gia Lai",
     "zoomlevel": 5.8,
     "X": 108.23273,
     "Y": 13.792467
    },
    {
     "ProvName": "Phu Yen",
     "zoomlevel": 5.8,
     "X": 109.061406,
     "Y": 13.160152
    },
    {
     "ProvName": "Khanh Hoa",
     "zoomlevel": 5.8,
     "X": 109.039298,
     "Y": 12.343948
    },
    {
     "ProvName": "Quang Ninh",
     "zoomlevel": 5.8,
     "X": 107.245799,
     "Y": 21.241189
    },
    {
     "ProvName": "Binh Duong",
     "zoomlevel": 5.8,
     "X": 106.647997,
     "Y": 11.210334
    },
    {
     "ProvName": "Lam Dong",
     "zoomlevel": 5.8,
     "X": 108.104283,
     "Y": 11.731718
    },
    {
     "ProvName": "Ninh Thuan",
     "zoomlevel": 5.8,
     "X": 108.877654,
     "Y": 11.718544
    },
    {
     "ProvName": "An Giang",
     "zoomlevel": 5.8,
     "X": 105.183634,
     "Y": 10.51902
    },
    {
     "ProvName": "Binh Phuoc",
     "zoomlevel": 5.8,
     "X": 106.906932,
     "Y": 11.748469
    },
    {
     "ProvName": "Binh Dinh",
     "zoomlevel": 5.8,
     "X": 108.949767,
     "Y": 14.119107
    },
    {
     "ProvName": "Kon Tum",
     "zoomlevel": 5.8,
     "X": 107.885229,
     "Y": 14.662687
    },
    {
     "ProvName": "Quang Nam",
     "zoomlevel": 5.8,
     "X": 107.943104,
     "Y": 15.622412
    },
    {
     "ProvName": "Quang Ngai",
     "zoomlevel": 5.8,
     "X": 108.678602,
     "Y": 15.020558
    },
    {
     "ProvName": "Quang Tri",
     "zoomlevel": 5.8,
     "X": 106.932853,
     "Y": 16.735647
    },
    {
     "ProvName": "Thua Thien Hue",
     "zoomlevel": 5.8,
     "X": 107.501331,
     "Y": 16.332187
    },
    {
     "ProvName": "Ba Ria-Vung Tau",
     "zoomlevel": 5.8,
     "X": 107.301902,
     "Y": 10.587333
    },
    {
     "ProvName": "Dong Thap",
     "zoomlevel": 5.8,
     "X": 105.625181,
     "Y": 10.559294
    },
    {
     "ProvName": "Binh Thuan",
     "zoomlevel": 5.8,
     "X": 108.06934,
     "Y": 11.109568
    },
    {
     "ProvName": "Dong Nai",
     "zoomlevel": 5.8,
     "X": 107.20121,
     "Y": 11.058947
    },
    {
     "ProvName": "Ho Chi Minh City",
     "zoomlevel": 5.8,
     "X": 106.679166,
     "Y": 10.780043
    },
    {
     "ProvName": "Kien Giang",
     "zoomlevel": 5.8,
     "X": 104.961119,
     "Y": 9.998864
    },
    {
     "ProvName": "Long An",
     "zoomlevel": 5.8,
     "X": 106.187769,
     "Y": 10.729953
    },
    {
     "ProvName": "Bac Lieu",
     "zoomlevel": 5.8,
     "X": 105.50819,
     "Y": 9.326435
    },
    {
     "ProvName": "Ca Mau",
     "zoomlevel": 5.8,
     "X": 105.062256,
     "Y": 9.052961
    },
    {
     "ProvName": "Hai Phong",
     "zoomlevel": 5.8,
     "X": 106.611709,
     "Y": 20.791225
    },
    {
     "ProvName": "Cao Bang",
     "zoomlevel": 5.8,
     "X": 106.070487,
     "Y": 22.734416
    },
    {
     "ProvName": "Ha Giang",
     "zoomlevel": 5.8,
     "X": 104.984591,
     "Y": 22.759632
    },
    {
     "ProvName": "Tien Giang",
     "zoomlevel": 5.8,
     "X": 106.469529,
     "Y": 10.12062
    },
    {
     "ProvName": "Dien Bien",
     "zoomlevel": 5.8,
     "X": 103.012289,
     "Y": 21.708315
    },
    {
     "ProvName": "Lai Chau",
     "zoomlevel": 5.8,
     "X": 103.203381,
     "Y": 22.313311
    },
    {
     "ProvName": "Lao Cai",
     "zoomlevel": 5.8,
     "X": 104.130226,
     "Y": 22.366149
    },
    {
     "ProvName": "Dak Lak",
     "zoomlevel": 5.8,
     "X": 108.196921,
     "Y": 12.813863
    },
    {
     "ProvName": "Dak Nong",
     "zoomlevel": 5.8,
     "X": 107.687549,
     "Y": 12.223868
    },
    {
     "ProvName": "Ladakh",
     "zoomlevel": 5.8,
     "X": 77.613148,
     "Y": 33.896513
    },
    {
     "ProvName": "Dolj",
     "zoomlevel": 5.8,
     "X": 23.638431,
     "Y": 44.159443
    },
    {
     "ProvName": "Phangnga",
     "zoomlevel": 5.8,
     "X": 98.41929,
     "Y": 8.677546
    },
    {
     "ProvName": "Lofa",
     "zoomlevel": 5.8,
     "X": -9.988542,
     "Y": 7.835607
    },
    {
     "ProvName": "Highlands and Islands",
     "zoomlevel": 5.8,
     "X": -4.774574,
     "Y": 57.47887
    },
    {
     "ProvName": "Primor'ye",
     "zoomlevel": 5.8,
     "X": 134.704111,
     "Y": 45.165235
    }
   ]